PJQ.collections.budget = PJQ.collections.budget ? PJQ.collections.budget : {};
PJQ.models.budget = PJQ.models.budget ? PJQ.models.budget : {};
PJQ.views.budget = PJQ.views.budget ? PJQ.views.budget : {};

PJQ.constants.budget = {
	accountingMethod: {
		AMOUNT: 0,
		UNIT_QUANTITY: 1
	},
};

PJQ.modules.budget = {
	routes: [
		{
			route: "budget",
			name: 'budget',
			callback: function () {
				PJQ.app.initNavigator({
					activeItem: "budget"
				});
			}
		},
		{
			route: 'projects/:projectId/budget',
			name: 'budget',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "budget");
			}
		},
		{
			route: 'projects/:projectId/costcodes',
			name: 'budget',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "costcodes");
			}
		},
		{
			route: 'projects/:projectId/subjobs',
			name: 'budget',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "subjobs");
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.budget.routes);

PJQ.collections.budget = PJQ.collections.budget ? PJQ.collections.budget : {};
PJQ.models.budget = PJQ.models.budget ? PJQ.models.budget : {};
PJQ.views.budget = PJQ.views.budget ? PJQ.views.budget : {};

PJQ.helpers.costCodes = {
    getDivisionSortValue: function (division) {
        if (_.size(division) === 0 || division.toLowerCase() === 'no division') {
            return -1;
        }

        let numsOnly = PJQ.helpers.formatHelpers.numbersOnly(division);
        if (_.size(numsOnly) > 0) {
            let num = parseInt(numsOnly);
            if (!isNaN(num)) {
                return num;
            }
        }
        return division;
    },
    sortDivisions: function (divisions) {
        return _.sortBy(divisions, function (division) {
            return PJQ.helpers.costCodes.getDivisionSortValue(division.name);
        })
    }
}

PJQ.helpers.erp = {
    renderERPButtons: function ($el, options) {
        options = _.defaults(options, {
            pushSupported: false,
            canPush: options.pushSupported === true,
            canPushChanges: options.pushSupported === true,
            disablePushReason: null,
            pullSupported: false,
            canPull: options.pullSupported === true,
            disablePullReason: null,
            canUnlink: options.unlinkSupported === true,
            canLink: options.linkSupported === true,
            canReleaseRetainage: options.canReleaseRetainage === true,
            lastSync: options.lastSync
        });

        let html = '';
        options.isStale = options.status === PJQ.constants.integrations.erp.syncStatuses.STALE;
        options.isPending = options.status === PJQ.constants.integrations.erp.syncStatuses.PENDING;
        options.isReviewing = options.status === PJQ.constants.integrations.erp.syncStatuses.REVIEWING;
        options.isApproved = options.status === PJQ.constants.integrations.erp.syncStatuses.APPROVED;
        options.isFailed = options.status === PJQ.constants.integrations.erp.syncStatuses.FAILED;
        options.isSynced = options.status === PJQ.constants.integrations.erp.syncStatuses.SYNCED;
        options.isRejected = options.status === PJQ.constants.integrations.erp.syncStatuses.REJECTED;
        if (options.isSynced) {
            options.canPush = false;
            options.disablePushReason = "No changes to sync";
        } else if (options.isApproved) {
            options.canPush = false;
            options.canPull = false;
            options.disablePushReason = "Approved - Sync to ERP system in process";
            options.disablePullReason = "Approved - Sync to ERP system in process";
        }

        if (options.pushSupported) {
            if (options.isReviewing) {
                html += `<button type="button" class="btn btn-outline-dark btn-undo-push-erp" title="Undo and remove from ERP Approval">
                    <i class='fal fa-rotate-left mr-1'></i>Undo Push to ERP
                </button>`;
            } else if ((options.canPushChanges && (options.isSynced || options.isStale)) || ((options.isRejected || options.isFailed || options.isPending) && options.pushSupported)) {
                html += `<button type="button" class="btn btn-outline-dark btn-push-erp"
                    <%= canPush ? '' : 'disabled' %>
					title='<%= !canPush && _.size(disablePushReason) > 0 ? disablePushReason : 'Send to your ERP system' %>'>
                    <i class='fal fa-arrow-up-to-line mr-1'></i><%= isStale || isSynced ? 'Push Changes to ERP' : 'Push to ERP' %>
                </button>`;
            }
        }

        if (options.pullSupported && (options.canPull || options.status == null || options.isSynced)) {
            html += `<button type="button" class="btn btn-outline-dark btn-pull-erp" 
                    <%= canPull ? '' : 'disabled' %>
					title='<%= !canPull && _.size(disablePullReason) > 0 ? disablePullReason : 'Refresh from your ERP system' %>'>
                    <i class='fal fa-arrow-down-to-line mr-1'></i>Pull from ERP
                </button>`;
        }

        if (options.canReleaseRetainage && options.isSynced) {
            html += `<button type="button" class="btn btn-outline-dark btn-release-erp-retainage" title="Release retainage for this invoice in your ERP system">
                    <i class='fal fa-arrow-up-to-line mr-1'></i>Release ERP Retainage</button>`;
        }

        if (options.canLink && options.isPending) {
            html += `<button type="button" class="btn btn-outline-dark btn-link-erp" title="Link to your ERP system">
                    <i class='fal fa-link mr-1'></i>Link to ERP
                    </button>`;
        } else if (options.canUnlink && (options.isSynced || options.isStale)) {
            html += `<button type="button" class="btn btn-outline-danger btn-unlink-erp" title="Unlink from your ERP system">
                    <i class='fal fa-link-slash mr-1'></i>Unlink from ERP
                    </button>`;
        }

        if (options.lastSync != null) {
            html += `<span class="ml-2 text-muted"><strong>Last Sync: </strong>${PJQ.helpers.dateHelpers.getDateString(new Date(options.lastSync), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME)}</span>`;
        }

        if (_.size(html) > 0) {
            $el.html(PJQ.templating.TemplateRenderer.parseMarkup(html, options));
        } else {
            $el.empty();
        }

        return {
            pulling: (isPulling) => {
                if (isPulling) {
                    this.pullingLoader = new PJQ.Loader($el.find('.btn-pull-erp'), {
                        loadingText: null
                    });
                } else if (this.pullingLoader) {
                    this.pullingLoader.remove();
                    this.pullingLoader = null;
                }
            },
            pushing: (isPushing) => {
                if (isPushing) {
                    this.pushingLoader = new PJQ.Loader($el.find('.btn-push-erp'), {
                        loadingText: null
                    });
                } else if (this.pushingLoader) {
                    this.pushingLoader.remove();
                    this.pushingLoader = null;
                }
            },
            unlinking: (isUnlinking) => {
                if (isUnlinking) {
                    this.unlinkLoader = new PJQ.Loader($el.find('.btn-unlinking-erp'), {
                        loadingText: null
                    });
                } else if (this.unlinkLoader) {
                    this.unlinkLoader.remove();
                    this.unlinkLoader = null;
                }
            }
        };
    },
    getERPIcon: function (status) {
        let iconClass = '',
            colorClass = '';
        switch (status) {
            case PJQ.constants.integrations.erp.syncStatuses.REVIEWING:
                iconClass = 'fa-clock';
                colorClass = 'text-primary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.REJECTED:
                iconClass = 'fa-triangle-exclamation';
                colorClass = 'text-warning';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.APPROVED:
                iconClass = 'fa-link-simple';
                colorClass = 'text-purple';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.SYNCED:
                iconClass = 'fa-link-simple';
                colorClass = 'text-success';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.FAILED:
                iconClass = 'fa-link-simple-slash';
                colorClass = 'text-danger';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.STALE:
                iconClass = 'fa-link-simple';
                colorClass = 'text-secondary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.PENDING:
            default:
                return '';
        }
        return '<i class="fas ' + iconClass + ' fs-14 ' + colorClass + '" title="' + PJQ.constants.integrations.erp.syncStatusDescriptions[status] + '"></i>';
    },
    getERPBadge: function (status, externalObject, options) {
        let badgeClass = '',
            badgeIcon = '';
        switch (status) {
            case PJQ.constants.integrations.erp.syncStatuses.REVIEWING:
                badgeIcon = 'fa-clock';
                badgeClass = 'badge-primary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.REJECTED:
                badgeIcon = 'fa-triangle-exclamation';
                badgeClass = 'badge-danger';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.APPROVED:
                badgeIcon = 'fa-link-simple';
                badgeClass = 'badge-purple';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.SYNCED:
                badgeIcon = 'fa-link-simple';
                badgeClass = 'badge-success';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.FAILED:
                badgeIcon = 'fa-link-simple-slash';
                badgeClass = 'badge-danger';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.STALE:
                badgeIcon = 'fa-link-simple';
                badgeClass = 'badge-secondary';
                break;
            case PJQ.constants.integrations.erp.syncStatuses.PENDING:
            default:
                return '';
        }

        let text = '',
            appendText = '',
            title = PJQ.constants.integrations.erp.syncStatusDescriptions[status];
        if (externalObject != null) {
            if (externalObject.data != null && _.size(externalObject.data.externalNumber) > 0) {
                text = '<span class="font-weight-light ml-2 fs-13 lh-14"><span class="font-weight-medium mr-1"></span>' + externalObject.data.externalNumber + '</span>'
            }

            if (externalObject.status === PJQ.constants.integrations.erp.syncStatuses.REJECTED && _.size(externalObject.rejectReason) > 0) {
                title = externalObject.rejectReason;
            } else if (externalObject.status === PJQ.constants.integrations.erp.syncStatuses.FAILED && _.size(externalObject.error) > 0) {
                title = externalObject.error;
            }
        }
        return '<span title="' + title + '" data-toggle="tooltip" data-placement="bottom" class="badge badge-erp ' + badgeClass + '"><i class="far fs-14 text-white ' + badgeIcon + '"></i>' + text + '</span>' + appendText;
    }
};

PJQ.modules.budget = {
    routes: [
        {
            route: "budget",
            name: 'budget',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "budget"
                });
            }
        },
        {
            route: 'projects/:projectId/budget',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "budget");
            }
        },
        {
            route: 'projects/:projectId/costcodes',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "costcodes");
            }
        },
        {
            route: 'projects/:projectId/subjobs',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "subjobs");
            }
        }
    ]
};

PJQ.constants.budgetHelpers = {
    columnTypes: {
        SOURCE: 'source',
        CALCULATED: 'calculated'
    },
    columnFormats: {
        MONEY: 'money',
        PERCENT: 'percent',
        INTEGER: 'int'
    },
    getColumnSources: function () {
        let def = PJQ.constants.budgetHelpers.columnSources;
        if (PJQ.app.session.erpIntegration != null) {
            return _.union(def, _.map(PJQ.app.session.erpIntegration.getBudgetColumns(), function (col) {
                return _.extend(col, {isErp: true});
            }));
        }
        return def;
    },
    columnSources: [
        {
            name: 'Description',
            source: 'Description',
            canCalculate: false,
            format: 'string'
        },
        {
            name: 'Budgeted Hours',
            source: 'BudgetedHours',
            canCalculate: true,
            format: 'time'
        },
        {
            name: 'Original Budget',
            source: 'BudgetedCost',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Budget Modifications',
            source: 'BudgetModification',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Revised Budget',
            source: 'RevisedBudget',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Pending Budget Changes',
            source: 'PendingBudgetChanges',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Projected Budget',
            source: 'ProjectedBudget',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Contracts',
            source: 'PrimeContractValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Contract Change Orders',
            source: 'PrimeContractChangeOrderValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Committed Costs',
            source: 'CommittedCosts',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Pending Cost Changes',
            source: 'PendingCosts',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Commitments',
            source: 'CommitmentValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Commitment Change Orders',
            source: 'CommitmentChangeOrderValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Direct Costs',
            source: 'DirectCostValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Payable Invoices',
            source: 'PayableInvoiceValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Payable Invoice Payments',
            source: 'PayablePayments',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Receivable Invoices',
            source: 'ReceivableInvoiceValues',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Receivable Invoice Payments',
            source: 'ReceivablePayments',
            canCalculate: true,
            isSource: true,
            format: 'money'
        },
        {
            name: 'Time Cards',
            source: 'TimeCardValues',
            canCalculate: true,
            isSource: true,
            format: 'decimal'
        },
        {
            name: 'Projected Costs',
            source: 'ProjectedCosts',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Forecast To Complete',
            source: 'ForecastToComplete',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Notes',
            source: 'Notes',
            canCalculate: false,
            format: 'string'
        },
        {
            name: 'Unit Price',
            source: 'UnitPrice',
            canCalculate: true,
            format: 'money'
        },
        {
            name: 'Quantity',
            source: 'Quantity',
            canCalculate: true,
            format: 'integer',
        }
    ]
}

PJQ.app.addRoutes(PJQ.modules.budget.routes);

PJQ.views.budget.AddBudgetLineItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-add-line-items'),
        width: '90%',
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {
        'click .go-to-cost-codes': 'goToCostCodes',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: async function () {
        this.collection = new PJQ.collections.budget.LineItems();
        this.accountingMethod = 0;
        this.options.project = PJQ.app.session.project;

        this.isFetched = false;
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            collection: this.collection,
            costCodes: this.costCodes != null ? this.costCodes.models : [],
            costTypes: this.costTypes != null ? this.costTypes.models : [],
            unitsOfMeasure: this.unitsOfMeasure != null ? this.unitsOfMeasure.models : [],
            accountingMethod: this.accountingMethod
        }
    },
    afterRender: function () {
        this.renderLineItemsView();
    },
    renderLineItemsView: function () {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }
        
        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.line-items-view'),
            collection: this.collection,
            lineItemModel: PJQ.models.budget.LineItem,
            accountingMethod: 0,
            canEdit: true,
            canDelete: true,
            canChangeAccountingMethod: true,
            isBudget: true,
            onAccountingMethodChanged: _.bind(function (value) {

            }, this),
            onLineItemAdd: _.bind(function () {

            }, this),
            onLineItemDelete: _.bind(function () {

            }, this)
        });
    },
    importLineItems: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    if (this.options.budget != null && _.size(file.uploadId) > 0) {
                        this.options.budget.processImport(file.uploadId, _.bind(function (data) {
                            this.fileUploader.remove();
                            loader.remove();
                            this.fileUploader = null;
                            this.collection.add(data);
                            this.renderLineItems();
                        }, this));
                    }
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
    },
    goToCostCodes: function () {
        PJQ.app.router.navigate("projects/" + (this.options.project.id).toString() + "/costcodes", {
            trigger: true
        });
        this.removeModal();
    },
    save: function () {
        if (this.lineItemsView.validate()) {
            this.options.budget.addLineItems(this.collection.models, _.bind(function () {
                this.options.onSave(this.collection.models);
                this.removeModal();
            }, this));
        }
    },
    cancel: function () {
        if (_.size(this.collection.models) > 0) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});


PJQ.views.budget.EditLineItemBudgetModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-line-item-budget'),
        maxWidth: 600,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {
        'focus .input-dollars-full,.input-percent,.input-hours': 'selectInput',
        'keyup .input-quantity, .input-unit-price': 'calculateUnitTotal',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.project.fetchSubJobs(_.bind(function (subJobs) {
            this.subJobs = subJobs;
            PJQ.app.session.project.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
                    this.costTypes = costTypes;
                    PJQ.app.session.project.fetchUnitsOfMeasure(_.bind(function (unitsOfMeasure) {
                        this.unitsOfMeasure = unitsOfMeasure;

                        this.isFetched = true;
                        this.render();
                    }, this));
                }, this));
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            budget: this.options.budget,
            subJobs: this.subJobs != null ? this.subJobs : [],
            costCodes: this.costCodes != null ? this.costCodes : [],
            costTypes: this.costTypes != null ? this.costTypes : [],
            unitsOfMeasure: this.unitsOfMeasure != null ? this.unitsOfMeasure.models : [],
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            useDecimalPercentFields: true,
        });

        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-hours'), 1);

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-accounting-method'),
            defaultValue: this.model.get('accountingMethod'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.setAccountingMethod(value);
            }, this)
        });

        this.unitOfMeasureSelector = new PJQ.inputs.Selectpicker({
            el: this.$('.select-unit-of-measure'),
            defaultValue: this.model.get('unitId'),
            isIntChoices: true,
            hideDisabled: true
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-quantity'), 2);
        this.calculateUnitTotal();
    },
    selectInput: function (e) {
        let el = $(e.currentTarget)[0];
        if (this.focusInput !== el) {
            this.focusInput = el;
            setTimeout(_.bind(function () {
                this.focusInput.select();
            }, this), 100);
        }
    },
    calculateUnitTotal: function () {
        let unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price').parent()),
            quantity = parseFloat(this.$('.input-quantity').val());
        this.$('.unit-total').html(PJQ.helpers.formatHelpers.formatCurrency(quantity * unitPrice));
    },
    setAccountingMethod: function (method) {
        this.model.set('accountingMethod', method);
        this.render();
    },
    save: function () {
        if (this.model.get('accountingMethod') === 0) {
            let budgetedCost = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-budgeted-cost'));
            this.model.set('budgetedCost', budgetedCost != null ? budgetedCost : 0);
        } else {
            let quantity = this.$('.input-quantity').val(),
                unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price'));
            this.model.set({
                unitId: this.unitOfMeasureSelector.getValue(),
                quantity: _.size(quantity) > 0 ? parseFloat(quantity) : 0,
                unitPrice: unitPrice != null ? unitPrice : 0
            })
        }

        let $hours = this.$('.input-budgeted-hours'),
            sHours = $hours.val().replace(',', '');
        this.model.set('budgetedHours', Math.ceil(parseFloat(sHours) * 60));

        this.model.save(null, {
            success: _.bind(function () {
                this.options.onSave(this.model);
                this.removeModal();
            }, this)
        }, this);
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    }
});

// Models
PJQ.models.budget.BaseLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    getTaxAmount: function () {
        let taxRate = this.get('taxRate'),
            taxable = this.get('amount') + this.get('markupAmount');
        return Math.round(taxable * (taxRate / 10000));
    },
    getUnRoundedTaxAmount: function () {
        let taxRate = this.get('taxRate'),
            taxable = this.get('amount') + this.get('markupAmount');
        return taxable * (taxRate / 10000);
    },
    resetMarkup: function () {
        this.set({
            markupAmount: 0,
            verticalMarkupAmount: 0,
            horizontalMarkupAmount: 0,
            markupValues: null
        });
    },
    getMarkupAmount: function (financialMarkups, options = {}) {
        let values = this.get('markupValues');
        if (financialMarkups != null) {
            values = {};

            let markupVals = financialMarkups.getMarkups([this]),
                hAmount = 0,
                vAmount = 0;
            _.each(markupVals, (mVal) => {
                values[mVal.cid] = {
                    amount: mVal.amount,
                    isVertical: mVal.isVertical
                };
                if (mVal.isApplied || this.markup || this.get('appliedMarkupId') > 0) {
                    vAmount += 0;
                    hAmount += 0;
                } else if (mVal.isVertical) {
                    vAmount += mVal.amount
                } else {
                    hAmount += mVal.amount;
                }
            });

            this.set({
                markupAmount: vAmount + hAmount,
                verticalMarkupAmount: vAmount,
                horizontalMarkupAmount: hAmount,
                markupValues: values
            });
        } else if (this.get('markupAmount') == null) {
            this.set({
                markupAmount: 0,
                verticalMarkupAmount: 0,
                horizontalMarkupAmount: 0
            });
        }

        if (options.cid != null) {
            let val = values[options.cid];
            if (val == null) {
                return 0;
            }
            return val.amount;
        }

        let result = null;
        if (options.vertical) {
            result = this.get('verticalMarkupAmount');
        } else if (options.horizontal) {
            result = this.get('horizontalMarkupAmount');
        }
        return result ?? this.get('markupAmount');
    },
    getAmountRemaining: function (financialMarkups, options = {}) {
        return this.getGrandTotal(financialMarkups, options) - this.get('progressAmount') - this.get('progressTaxAmount')
            - this.get('materialsStored') + this.getRetainage() - this.getRetainageReleased();
    },
    getSubTotal: function (financialMarkups, options = {}) {
        if (options == null) {
            options = {};
        }

        let result;
        if ((this.markup || this.get('appliedMarkupId') > 0) && !options.totalMarkups) {
            result = 0;
            if (_.size(options.lineItems?.models) > 0) {
                let markup = this.markup ? this.markup : financialMarkups.findWhere({id: this.get('appliedMarkupId')}),
                    markupCostCodes = markup?.get('costCodeIds') ?? [],
                    markupCostTypes = markup?.get('costTypeIds') ?? [];
                let filteredLineItems = _.filter(options.lineItems.models, (li) => {
                    return li.markup == null && financialMarkups.findWhere({lineItemId: li.id}) == null &&
                        (_.size(markupCostCodes) === 0 || markupCostCodes.includes(li.get('costCodeId'))) &&
                        (_.size(markupCostTypes) === 0 || markupCostTypes.includes(li.get('costTypeId')));
                });

                let totalAmount = 0,
                    totalRevenue = 0;
                _.each(filteredLineItems, (li) => {
                    let isAppliedLI = li.markup != null || li.get('appliedMarkupId') != null;
                    if (isAppliedLI) {
                        return;
                    }

                    let liAmount = li.get('amount') ?? 0,
                        liRevenue = li.get('revenue') ?? 0;
                    totalAmount += ((markup?.get('percent') ?? 0) / 10000) * liAmount;
                    totalRevenue += ((markup?.get('percent') ?? 0) / 10000) * liRevenue;
                });

                let isCR = this instanceof PJQ.models.changeRequests.ChangeRequestLineItem;
                result = isCR && !options.costs ? totalRevenue : totalAmount;
                this.set({
                    amount: !isCR ? totalAmount : 0,
                    revenue: totalRevenue,
                    unitPrice: totalAmount
                }, {silent: true});
            }
        } else if (this instanceof PJQ.models.changeRequests.ChangeRequestLineItem && !options.costs) {
            result = this.get('revenue') ?? 0;
        } else {
            result = this.get('amount') ?? 0;
        }
        let markupAmount = this.getMarkupAmount(financialMarkups, {
            horizontal: options.totalMarkups !== true,
            isAppliedLineItem: options.isAppliedLineItem
        });
        return result + markupAmount;
    },
    getRetainage: function () {
        return this.get('workRetainage') + this.get('materialRetainage');
    },
    getRetainageReleased: function () {
        return this.get('workRetainageReleased') + this.get('materialRetainageReleased');
    },
    getGrandTotal: function (financialMarkups, options = {}) {
        return this.getSubTotal(financialMarkups, options) + (this.get('taxAmount') ?? 0);
    }
});

PJQ.models.budget.LineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.get('budgetId')
            },
            {
                endpoint: 'lineitems',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model) {
            if (model.amount != null && model.budgetedCost == null) {
                model.budgetedCost = model.amount;
            }
        }
        return model;
    },
    erpSyncStatus: function () {
        let exObj = this.get('externalObject'),
            status = exObj != null && typeof exObj.status === 'number' ? exObj.status : 0;
        if (status !== PJQ.constants.integrations.erp.syncStatuses.SYNCED) {
            return status;
        }

        return _.size(exObj.lastSync) === 0 || new Date(this.get('modifiedOn')) > new Date(exObj.lastSync) ? PJQ.constants.integrations.erp.syncStatuses.STALE : status;
    },
});

PJQ.models.budget.ForecastLineItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.options.budgetId
            },
            {
                endpoint: 'lineitems',
                value: this.get('lineItemId')
            },
            {
                endpoint: 'forecast'
            }
        ]);
    }
});

PJQ.models.budget.Budget = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'budgets'
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.lineItems = new PJQ.collections.budget.LineItems(model.lineItems, {
            budgetId: model.id
        });
        return model;
    },
    addLineItems: function (lineItems, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.id
                },
                {
                    endpoint: 'lineitems'
                }
            ]),
            isAPIv2: true,
            data: lineItems
        }).post().done(_.bind(function (data) {
            PJQ.notifications.notify.successNotify({
                message: 'Budget line items added'
            });
            this.lineItems.add(data, {merge: true});
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            PJQ.notifications.notify.errorNotify({
                message: 'Failed to add budget line items'
            });
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    processImport: function (uploadId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id,
                },
                {
                    endpoint: 'budgets'
                },
                {
                    endpoint: 'lineitems'
                },
                {
                    endpoint: 'import',
                    value: uploadId
                }
            ]),
            isAPIv2: true
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    },
    fetchForView: function (viewId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.id
                },
                {
                    endpoint: 'views',
                    value: viewId
                }
            ]),
            isAPIv2: true
        }).get().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    },
    updateLocked: function (isLocked, callback) {
        let startLocked = this.get('isLocked');
        if (startLocked !== isLocked) {
            this.set('isLocked', isLocked);
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'budgets',
                        value: this.get('id')
                    }
                ]),
                isAPIv2: true,
                data: this.toJSON()
            }).patch().done(_.bind(_.bind(function (data) {
                PJQ.notifications.notify.successNotify({
                    message: 'Budget locked'
                });
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this))).fail(_.bind(function () {
                this.set('isLocked', startLocked);
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to lock budget'
                });
                if (typeof callback === 'function') {
                    callback(false);
                }
            }, this));
        }
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            default:
                return '';
        }
    },
});

PJQ.models.budget.BudgetModification = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.get('budgetId')
            },
            {
                endpoint: 'modifications'
            }
        ]);
    }
});

PJQ.models.budget.SubJob = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'subjobs',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'subjobs',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.CostCode = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.get('projectId') > 0 && !(this.id > 0)) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'costcodes',
                    value: this.id
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'costcodes',
                value: this.id
            }
        ]);
    },
    getDisplayName: function () {
        let name = this.get('name');
        if (_.size(name) > 0) {
            return this.get('code') + ' - ' + name
        }
        return this.get('code');
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            callback(null, err);
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalId', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    }
});

PJQ.models.budget.TaxCode = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'taxcodes',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.CostType = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'costtypes',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.UnitOfMeasure = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'unitsofmeasure',
                value: this.id
            }
        ]);
    }
});

PJQ.models.budget.BillingPeriodSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'projectId',
    endpoint: function () {
        let params = []
        if (this.get('allowAutomate')) {
            params.push({
                parameter: 'allowAutomate',
                value: true
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'billingperiods'
            },
            {
                endpoint: 'settings'
            }
        ], params);
    },
    parse: function (model) {
        if (model) {
            this.billingPeriods = new PJQ.collections.budget.BillingPeriods(model.billingPeriods);
        }
        return model;
    },
    afterSave: function () {
        this.isFetched = false;
    }
});

PJQ.models.budget.BillingPeriod = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId') ? this.get('projectId') : this.options.projectId
            },
            {
                endpoint: 'billingperiods',
                value: this.id
            }
        ]);
    },
    // openPeriod: function (callback) {
    //     new PJQ.ajax.Request({
    //         endpoint: this.endpoint() + '/open',
    //         isAPIv2: true
    //     }).put().done(_.bind(function (res) {
    //         PJQ.notifications.notify.successNotify({
    //             message: 'Billing period opened'
    //         });
    //         if (typeof callback === 'function') {
    //             callback(res);
    //         }
    //     }, this)).fail(_.bind(function (xhr, err, result) {
    //         PJQ.notifications.notify.errorNotify({
    //             message: 'Failed to open billing period'
    //         });
    //     }, this));
    // },
    // closePeriod: function (callback) {
    //     new PJQ.ajax.Request({
    //         endpoint: this.endpoint() + '/close',
    //         isAPIv2: true
    //     }).put().done(_.bind(function (res) {
    //         PJQ.notifications.notify.successNotify({
    //             message: 'Billing period closed'
    //         });
    //         if (typeof callback === 'function') {
    //             callback(res);
    //         }
    //     }, this)).fail(_.bind(function (xhr, err, result) {
    //         PJQ.notifications.notify.errorNotify({
    //             message: 'Failed to close billing period'
    //         });
    //     }, this));
    // }
});

PJQ.models.budget.BudgetView = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings',
                value: 'budgets'
            },
            {
                endpoint: 'views',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.columns) {
            this.columns = new PJQ.collections.budget.ViewColumns(model.columns);
        }

        return model;
    },
    beforeSave: function () {
        _.each(this.columns.models, function (column) {
            if (column.get('type') === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
                let options = {
                    sources: column.calculations.toJSON()
                }
                column.set('options', options);
            }
        })
        this.set('columns', this.columns.toJSON());
    }
});

PJQ.models.budget.ViewColumn = PJQ.models.BaseModel.extend({
    parse: function (model) {
        if (!model)
            return;

        if (model.options) {
            if (model.options.sources && model.type === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
                this.calculations = new PJQ.collections.budget.ViewColumnCalculations(model.options.sources);
            } else {
                this.calculations = new PJQ.collections.budget.ViewColumnCalculations();
            }
        }

        return model;
    }
});

PJQ.models.budget.ViewColumnCalculation = PJQ.models.BaseModel.extend();

// Collections
PJQ.collections.budget.TaxCodes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.TaxCode,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'taxcodes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'taxcodes'
                }
            ]);
        }
    }
});

PJQ.collections.budget.SubJobs = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.SubJob,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'subjobs'
            }
        ]);
    },
});

PJQ.collections.budget.CostTypes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.CostType,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'costtypes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'costtypes'
                }
            ]);
        }
    }
});

PJQ.collections.budget.CostCodes = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.CostCode,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'costcodes'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'costcodes'
                }
            ]);
        }
    },
    hasDivisions: function () {
        return null != _.find(this.models, function (costCode) {
            return _.size(costCode.get('division')) > 0;
        })
    },
    getForDivision: function (division) {
        let dSearch = (_.size(division) === 0 || division.toLowerCase() === 'no division') ? '' : division,
            empty = _.size(dSearch) === 0;
        return _.filter(this.models, (c) => {
            let div = c.get('division');
            return (empty && _.size(div) === 0) || div === dSearch;
        });
    },
    getDivisions: function () {
        return _.uniq(_.map(this.models, function (costCode) {
            return costCode.get('division') ?? '';
        }));
    },
    processImport: function (uploadId, projectId, callback) {
        let endpointArr = [];
        if (projectId > 0) {
            endpointArr.push({
                endpoint: 'projects',
                value: projectId
            });
        }

        endpointArr.push(...[
            {
                endpoint: 'costcodes'
            },
            {
                endpoint: 'import',
                value: uploadId
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr),
            isAPIv2: true
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    },
    saveBulk: function (costCodes, subJobId, callback) {
        if (_.size(costCodes) > 0) {
            let params = [];
            if (subJobId > 0) {
                params.push({
                    parameter: 'subJobId',
                    value: subJobId
                })
            }

            let endpointArr = [];
            if (this.options.projectId > 0) {
                endpointArr.push({
                    endpoint: 'projects',
                    value: this.options.projectId
                });
            }

            endpointArr.push(...[
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'bulk'
                }
            ]);
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, params),
                isAPIv2: true,
                data: {
                    costCodes: costCodes
                }
            }).post().done(_.bind(function (data) {
                this.add(data);
                if (typeof callback === 'function') {
                    callback(data);
                }
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        }
    },
    pushERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (PJQ.helpers.objectHelpers.refinedType(res) === 'array') {
                _.each(res, function (cc) {
                    let model = this.get(cc.id);
                    if (model != null) {
                        model.set('externalObject', cc.externalObject, {silent: true});
                    }
                }, this)
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(false, err);
            }
        }, this));
    },
    deleteAll: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint(),
            isAPIv2: true
        }).delete().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(false, err);
            }
        }, this));
    }
});

PJQ.collections.budget.UnitsOfMeasure = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.UnitOfMeasure,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'unitsofmeasure'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'unitsofmeasure'
                }
            ]);
        }
    }
});

PJQ.collections.budget.BillingPeriods = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.BillingPeriod
});

PJQ.collections.budget.LineItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.LineItem
});

PJQ.collections.budget.BudgetModifications = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.budget.BudgetModification,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'budgets',
                value: this.options.budgetId
            },
            {
                endpoint: 'modifications'
            }
        ]);
    }
});

PJQ.collections.budget.ViewColumns = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.ViewColumn
});

PJQ.collections.budget.ViewColumnCalculations = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.ViewColumnCalculation
});

PJQ.collections.budget.ForecastLineItems = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.ForecastLineItem
});

PJQ.collections.budget.BudgetViews = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.budget.BudgetView,
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings',
                value: 'budgets'
            },
            {
                endpoint: 'views'
            }
        ]);
    }
});

PJQ.collections.budget.Snapshots = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'budgets'
            },
            {
                endpoint: 'snapshots'
            }
        ]);
    }
});

PJQ.views.budget.AddBudgetModificationsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-add-budget-modifications'),
        subTemplates: {
            modification: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'add-budget-modification')
        },
        maxWidth: 800,
        isShowCloseButton: true,
        onSave: _.noop
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-add-modification': 'addModification'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.budget = this.options.budget;

        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        this.collection = new PJQ.collections.budget.BudgetModifications();
        this.isFetched = true;
        this.render();
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.lineItemChoices = _.sortBy(_.map(this.budget.lineItems.models, (item) => {
            let costCode = this.costCodes.get(item.get('costCodeId')),
                costType = this.costTypes.get(item.get('costTypeId'));
            return {
                id: item.id,
                costCode: costCode,
                costType: costType,
                name: '<strong>' + costCode.getDisplayName() + '</strong> - ' + costType.get('name')
            };
        }), (choice) => {
            return choice.costCode.getDisplayName() + ' ' + choice.costType.get('name');
        });

        if (_.size(this.collection.models) === 0) {
            this.addModification();
        }
    },
    addModification: function () {
        let model = new PJQ.models.budget.BudgetModification({
            budgetId: this.budget.id,
            fromLineItemId: null,
            toLineItemId: null,
            amount: 0,
            notes: ''
        });

        this.collection.add(model);
        this.renderModification(model);
    },
    renderModification: function (model) {
        this.renderSubTemplate(true, this.options.subTemplates.modification, this.$('.budget-modifications'), {
            model: model,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            lineItems: this.budget.lineItems.models
        }, _.bind(function (el) {
            PJQ.helpers.inputHelpers.inputMaskCurrency(el.find('.input-dollars-full'), 2);
            new PJQ.Binder(el, model, {
                watchElements: [
                    'input'
                ]
            });

            model.fromSelect = new PJQ.inputs.Selectpicker({
                el: el.find('.line-item-from'),
                choices: this.lineItemChoices,
                noneSelectedText: 'Select Line Item',
                isLiveSearch: true,
                onChange: _.bind(function (value) {
                    model.set('fromLineItemId', value);
                }, this),
                defaultValue: null
            });

            model.toSelect = new PJQ.inputs.Selectpicker({
                el: el.find('.line-item-to'),
                choices: this.lineItemChoices,
                isLiveSearch: true,
                noneSelectedText: 'Select Line Item',
                onChange: _.bind(function (value) {
                    model.set('toLineItemId', value);
                }, this),
                defaultValue: null
            });
        }, this));
    },
    save: function () {
        let fnRender = _.bind(function () {
            if (typeof this.options.onSave === 'function') {
                this.options.onSave(this.collection.models);
            }
            this.removeModal();
        }, this)

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.budget.id
                },
                {
                    endpoint: 'modifications'
                }
            ]),
            isAPIv2: true,
            data: this.collection.models
        }).post().done(_.bind(_.bind(function () {
            fnRender();
        }, this)));
    }
});

PJQ.views.budget.ViewBudgetModificationsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-view-budget-modifications'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        lineItem: null
    },
    events: {},
    beforeModalCreated: function () {
        this.collection = new PJQ.collections.budget.BudgetModifications(null, {
            budgetId: this.options.budget.id
        });
        this.collection.fetch({
            success: _.bind(function () {
                PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
                    this.costTypes = costTypes;
                    PJQ.app.session.project.fetchCostCodes(_.bind(function (costCodes) {
                        this.costCodes = costCodes;
                        this.render();
                    }, this));
                }, this));
            }, this)
        });
    },
    renderData: function () {
        return {}
    },
    afterRender: function () {
        if (this.collection != null && this.collection.isFetched) {
            let fnLineItemRow = _.bind(function (data, type, row) {
                let lineItem = this.options.budget.lineItems.get(data);
                if (lineItem != null) {
                    let costCode = this.costCodes.get(lineItem.get('costCodeId'));
                    let costType = this.costTypes.get(lineItem.get('costTypeId'));

                    return costCode.get('name') + ' - ' + costType.get('code');
                }
                return 'N/A';
            }, this);

            let filteredData = this.options.lineItem != null ? _.filter(this.collection.models, function (model) {
                return model.get('fromLineItemId') === this.options.lineItem.id || model.get('toLineItemId') === this.options.lineItem.id
            }, this) : this.collection.models;
            new PJQ.views.dataTables.DataTable({
                el: this.$('.modifications-table'),
                data: filteredData,
                rowId: "id",
                paging: _.size(filteredData) > 10,
                order: [0, 'asc'],
                language: {
                    zeroRecords: 'This line item has no budget modifications'
                },
                columns: [
                    {
                        "data": "attributes.fromLineItemId",
                        "title": "From",
                        "minWidth": 200,
                        "render": fnLineItemRow
                    },
                    {
                        "data": "attributes.toLineItemId",
                        "title": "To",
                        "minWidth": 200,
                        "render": fnLineItemRow
                    },
                    {
                        "data": "attributes.amount",
                        "title": "Amount",
                        "width": 150,
                        "render": _.bind(function (data, type, row) {
                            let extraClasses = '';
                            if (this.options.lineItem != null) {
                                if ((row.get('fromLineItemId') === this.options.lineItem.id && row.get('amount') < 0)
                                    || (row.get('toLineItemId') === this.options.lineItem.id && row.get('amount') > 0)) {
                                    extraClasses = 'text-success';
                                } else {
                                    extraClasses = 'text-danger';
                                }
                            }
                            return '<span class="' + extraClasses + '">' + PJQ.helpers.formatHelpers.formatCurrency(data) + '</span>';
                        }, this)
                    },
                    {
                        "data": "attributes.notes",
                        "title": "Notes"
                    }
                ]
            })
        }
    }
});
PJQ.views.budget.BudgetsViewsEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-view-editor'),
        subTemplates: {
            columns: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'column-editor-columns'),
            columnEditorEmpty: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'view-column-editor-empty')
        },
        maxWidth: '900',
        maxHeight: '600',
        onSave: null,
        onDelete: null
    },
    events: {
        'click .btn-create-view': 'createView',
        'click .budget-view-option': 'changeTemplate',
        'click .btn-return': 'viewBudgetViews',
        'click .btn-save': 'saveView',
        'click .btn-edit-columns': 'configureColumns',
        'click .btn-cancel': 'cancelColumnEdit',
        'click .budget-view-column': 'editColumnClicked',
        'click .btn-delete-column': 'deleteColumn',
        'click .create-source': 'createSourceColumn',
        'click .create-calculated': 'createCalculatedColumn',
        'click .edit-view': 'editViewClicked',
        'click .delete-view': 'deleteViewClicked',
        'click .set-default-view': 'defaultViewClicked'
    },
    modes: {
        CREATE: 'CREATE',
        EDIT: 'EDIT',
        VIEW: 'VIEW'
    },
    beforeModalCreated: function () {
        let blankView = new PJQ.models.budget.BudgetView({
            name: "Blank View",
            description: 'Blank view with minimum amount of columns.',
            companyId: -1,
            columns: []
        });

        this.budgetViews = new PJQ.collections.budget.BudgetViews();
        this.mode = this.options.mode ? this.options.mode : this.modes.VIEW;
        if (!this.budgetViews.isFetched) {
            this.budgetViews.fetch({
                success: _.bind(function () {
                    this.budgetViews.add(blankView);
                    this.render();
                }, this)
            })
        } else {
            this.render();
        }
    },
    renderData: function () {
        return {
            budgetViews: this.budgetViews,
            budgetView: this.budgetView,
            mode: this.mode,
            modes: this.modes,
            template: this.template
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.budgetView, {
            watchElements: [
                'input'
            ]
        });

        if (this.mode === this.modes.VIEW) {
            this.renderViewMode();
        } else if (this.mode === this.modes.EDIT) {
            this.renderEditMode();
        } else if (this.mode === this.modes.CREATE) {
            this.renderCreateMode();
        }
    },
    renderEditMode: function () {
        this.renderColumns();
        this.renderColumnConfiguration()
    },
    renderCreateMode: function () {
        this.templateColumnTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.views-columns-table'),
            data: this.template.get('columns'),
            rowId: "cid",
            isHideSearch: true,
            paging: false,
            order: [0, 'asc'],
            language: {
                zeroRecords: 'No columns'
            },
            scrollY: "40vh",
            scrollX: true,
            scrollCollapse: true,
            columns: [
                {
                    "data": "name",
                    "title": "Column Name",
                    "width": "50%"
                },
                {
                    "data": "type",
                    "title": "Type",
                    "width": "50%"
                }
            ]
        })
    },
    renderViewMode: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.views-table'),
            data: _.filter(this.budgetViews.models, function (model) {
                if (model.get('companyId') !== -1) {
                    return model;
                }
            }),
            rowId: "cid",
            isHideSearch: true,
            paging: false,
            order: [1, 'asc'],
            language: {
                zeroRecords: 'No custom views exist. Press "Create View" to get started.'
            },
            scrollY: "40vh",
            scrollX: true,
            scrollCollapse: true,
            onRowDoubleClick: _.bind(function (row) {
                this.editView(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit View',
                        isShown: _.bind(function (row) {
                            return true;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.editView(row.data());
                        }, this)
                    },
                    {
                        name: 'Set as Default View',
                        isShown: _.bind(function (row) {
                            return !row.get('isDefault');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.setViewIsDefault(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete View',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return !row.get('isDefault');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteView(row.data());
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": null,
                    "title": '',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let icons = [];

                        if (row.get('isDefault')) {
                            icons.push("<i class='fal fa-crown fs-18' title='Default View'></i>");
                        }

                        return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                    }, this)
                },
                {
                    "data": "attributes.name",
                    "title": "Name"
                },
                {
                    "data": "attributes.description",
                    "title": "Description"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "160px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover" style="min-width:120px;">';
                        if (!row.get('isDefault')) {
                            html += '<button type="button" class="btn btn-success set-default-view ht-30p wd-35p ml-1 fs-14" title="Set as Default View"><span class="fal fa-crown"></span></button>' +
                                '<button type="button" class="btn btn-info edit-view ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>' +
                                '<button type="button" class="btn btn-danger delete-view ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                        } else {
                            html += '<button type="button" class="btn btn-info edit-view ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button></div>'
                        }
                        return html;
                    }, this)
                }
            ]
        });
    },
    setModalWidth: function (width) {
        this.options.maxWidth = width;
        this.$('.modal-dialog').animate({
            maxWidth: width
        }, 200);
    },
    createView: function () {
        this.budgetView = new PJQ.models.budget.BudgetView({
            name: "",
            description: "",
            isDefault: false
        });
        this.mode = this.modes.CREATE;
        this.template = this.budgetViews.models[0];
        this.render();
        this.setModalWidth(1000);
    },
    defaultViewClicked: function (e) {
        let target = $(e.currentTarget),
            view = this.dataTable.getRow(target.closest('tr')).data();
        this.setViewIsDefault(view);
    },
    setViewIsDefault: function (view, isDefault = true) {
        let currentDefault = _.find(this.budgetViews.models, function (model) {
            return model.get('isDefault');
        }, this)

        if (currentDefault != null) {
            currentDefault.set('isDefault', false);
        }
        view.set('isDefault', isDefault);
        view.save(null, {
            success: _.bind(function () {
                this.dataTable.refresh();
                PJQ.notifications.notify.successNotify({
                    message: 'Default View Changed'
                });
            }, this)
        })
    },
    editViewClicked: function (e) {
        let target = $(e.currentTarget),
            view = this.dataTable.getRow(target.closest('tr')).data();
        this.editView(view);
    },
    editView: function (view) {
        this.mode = this.modes.EDIT;
        this.budgetView = view;
        let fnRender = _.bind(function () {
            this.render();
            this.setModalWidth(1000);
        }, this)
        if (!this.budgetView.isNew() && !this.budgetView.isFetched) {
            this.budgetView.fetch({
                success: _.bind(function () {
                    fnRender();
                }, this)
            })
        } else {
            fnRender();
        }
    },
    viewBudgetViews: function () {
        if (this.budgetView != null && this.budgetView.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveView()
                }, this),
                onDontSave: _.bind(function () {
                    this.budgetView.restore();
                    this.budgetView = null;
                    this.mode = this.modes.VIEW;
                    this.render();
                    this.setModalWidth(900);
                }, this)
            });
        } else {
            this.mode = this.modes.VIEW;
            this.render();
            this.setModalWidth(900);
        }

    },
    changeTemplate: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid');
        this.template = this.budgetViews.get(cid);
        this.render();
    },
    saveView: function () {
        if (this.validate()) {
            if (this.mode === this.modes.CREATE && this.template != null) {
                this.budgetView.columns = new PJQ.collections.budget.ViewColumns(this.template.columns.models);
                this.mode = this.modes.EDIT;
                this.render();
            } else {
                let isNew = this.budgetView.isNew();
                this.budgetView.save(null, {
                    success: _.bind(function () {
                        if (isNew) {
                            this.budgetViews.add(this.budgetView);
                        }
                        this.mode = this.modes.VIEW;
                        this.render();
                        this.setModalWidth(900);
                        PJQ.notifications.notify.successNotify({
                            message: "View successfully saved"
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.budgetView, this.budgetViews);
                        }
                    }, this)
                })
            }
        }
    },
    deleteViewClicked: function (e) {
        let target = $(e.currentTarget),
            view = this.dataTable.getRow(target.closest('tr')).data();
        this.deleteView(view);
    },
    deleteView: function (view) {
        this.budgetViews.remove(view);
        view.destroy({
            success: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(view, this.budgetViews);
                }
            }, this)
        });
        this.render();
    },
    columnsSorted: function () {
        this.budgetView.columns.models = _.map(this.$('.budget-view-column'), function (el) {
            return this.budgetView.columns.get($(el).data('cid'));
        }, this);

        this.render();
    },
    cancelColumnEdit: function () {
        let columnsChanged = false;
        _.each(this.budgetView.columns.models, function (model) {
            if (model.hasChanged()) {
                columnsChanged = true;
            }
        }, this)
        if (columnsChanged) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveView()
                }, this),
                onDontSave: _.bind(function () {
                    this.mode = this.modes.EDIT;
                    _.each(this.budgetView.columns.models, function (model) {
                        if (model.hasChanged()) {
                            model.restore();
                        }
                    }, this)
                    this.render();
                }, this)
            });
        } else {
            this.mode = this.modes.EDIT;
            this.render();
        }
    },
    deleteColumn: function (e) {
        e.stopPropagation();

        let $target = $(e.currentTarget),
            $item = $target.closest('.budget-list-item'),
            cid = $target.closest('.budget-list-item').data('cid');
        this.budgetView.columns.remove(cid);
        $item.remove();
    },
    editColumnClicked: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            column = this.budgetView.columns.get(cid);

        this.$('.selected-list-item').removeClass('selected-list-item');
        $target.addClass('selected-list-item');

        this.editColumn(column);
    },
    editColumn: function (column) {
        // this.$('.selected-list-item').removeClass('selected-list-item');
        // $target.addClass('selected-list-item');
        this.renderColumnConfiguration(column);
    },
    renderColumns: function () {
        this.renderSubTemplate(false, this.options.subTemplates.columns, this.$('.select-budget-columns'), {
            budgetView: this.budgetView
        }, _.bind(function (el) {
            this.columnsSortable = new PJQ.Sortable(this.$('.modal-content'), {
                items: '.budget-view-column',
                connectWith: '.budget-view-column',
                onStop: _.bind(function () {
                    this.columnsSorted();
                }, this)
            });
        }, this));
    },
    renderColumnConfiguration: function (column) {
        if (this.columnEditor) {
            this.columnEditor.remove()
        }

        let $editor = this.$('.column-config');
        if (column == null) {
            this.renderSubTemplate(true, this.options.subTemplates.columnEditorEmpty, $editor);
            return;
        }

        let $menuItem = $('.budget-list-item[data-cid="' + column.cid + '"] .column-name');
        this.columnEditor = new PJQ.views.budget.ViewColumnEditor({
            el: $editor,
            column: column,
            budgetView: this.budgetView,
            onNameChange: function () {
                $menuItem.text(column.get('name'));
            }
        })
    },
    createSourceColumn: function () {
        let column = new PJQ.models.budget.ViewColumn({
            type: PJQ.constants.budgetHelpers.columnTypes.SOURCE,
            name: '',
            format: null,
            options: {}
        });
        this.budgetView.columns.add(column);
        this.editColumn(column);
        this.renderColumns();
    },
    createCalculatedColumn: function () {
        let column = new PJQ.models.budget.ViewColumn({
            type: PJQ.constants.budgetHelpers.columnTypes.CALCULATED,
            name: '',
            format: PJQ.constants.budgetHelpers.columnFormats.MONEY,
            options: {}
        })
        this.budgetView.columns.add(column);
        this.editColumn(column);
        this.renderColumns();
    },
    validate: function () {
        let isValid = true;
        if (this.mode === this.modes.EDIT) {
            _.each(this.budgetView.columns.models, function (model) {
                let $menuItem = $('.budget-list-item[data-cid="' + model.cid + '"]');
                $menuItem.removeClass('budget-list-item-error')
                let markInvalid = _.bind(function (model) {
                    $menuItem.addClass('budget-list-item-error')
                }, this)
                if (model.get('type') === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
                    _.each(model.calculations.models, function (calc, index) {
                        if (calc.get('source') == null) {
                            isValid = false;
                            markInvalid(model);
                        }

                        if (index > 0 && calc.get('operator') == null) {
                            isValid = false;
                            markInvalid(model);
                        }
                    }, this)
                } else if (model.get('source') == null) {
                    isValid = false;
                    markInvalid(model);
                }

                if (_.size(model.get('format')) === 0 &&
                    model.get('source') !== "GroupName" &&
                    model.get('source') !== "CostTypeId" &&
                    model.get('source') !== "Notes") {
                    isValid = false;
                    markInvalid(model);
                }
            }, this)
        }
        return isValid;
    }
});

PJQ.views.budget.ViewColumnEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'view-column-editor'),
        subTemplates: {
            calculation: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'view-calculation')
        },
        onNameChange: null
    },
    events: {
        'keyup .view-name': 'nameChanged',
        'click .btn-add-calculation': 'addCalculation',
        'click .btn-remove-calculation': 'deleteCalculation'
    },
    beforeFirstRender: function () {
        this.column = this.options.column;
        this.budgetView = this.options.budgetView;

        this.isFetched = false;
        PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
            this.erpIntegration = erp;
            this.isFetched = true;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            column: this.column,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.column, {
            watchElements: [
                'input'
            ]
        });

        if (_.size(this.column.get('name')) === 0) {
            this.$('.view-name').focus();
        }

        if (_.size(this.column.get('format')) === 0) {
            this.column.set('format', 'money');
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-format'),
            defaultValue: this.column.get('format'),
            onChange: _.bind(function (value) {
                this.column.set('format', value);
            }, this)
        });

        if (this.column.get('type') === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
            this.renderCalculations();
        } else if (this.column.get('type') === PJQ.constants.budgetHelpers.columnTypes.SOURCE) {
            let source = this.column.get('source'),
                choices = _.map(PJQ.constants.budgetHelpers.getColumnSources(), function (source) {
                    return {
                        id: source.source,
                        name: source.name + (source.isErp ? ('<span class="fs-10 pl-2 text-primary font-weight-bold">ERP</span>') : '')
                    };
                });
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-source'),
                defaultValue: source,
                choices: choices,
                onChange: _.bind(function (value) {
                    let colSource = _.find(PJQ.constants.budgetHelpers.getColumnSources(), function (src) {
                        return src.source === value;
                    });
                    if (_.size(this.column.get('name')) === 0) {
                        this.column.set('name', colSource.name);
                        this.$('.view-name', colSource.name);
                        this.nameChanged();
                    }

                    this.column.set({
                        source: value,
                        format: colSource.format,
                        options: {}
                    });
                    this.render();
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.source-status-filter'),
                noneSelectedText: 'No Status Filters',
                isMultiple: true,
                defaultValue: this.column.get('options') != null ? _.map(this.column.get('options').statuses, function (value) {
                    return value.toString();
                }) : null,
                onChange: _.bind(function (value) {
                    let statuses = _.map(value, function (id) {
                            return parseInt(id);
                        }, this),
                        options = {
                            "statuses": statuses
                        }
                    this.column.set('options', options);
                }, this),
                title: 'No Filters'
            });
        }
    },
    nameChanged: function () {
        if (typeof this.options.onNameChange === 'function') {
            this.options.onNameChange(this.column);
        }
    },
    renderCalculations: function () {
        this.$('.calculation-container').empty();

        if (_.size(this.column.calculations.models) === 0) {
            this.addCalculation();
        } else {
            _.each(this.column.calculations.models, function (model) {
                this.renderCalculation(model);
            }, this)
        }
    },
    renderCalculation: function (calculation) {
        this.renderSubTemplate(true, this.options.subTemplates.calculation, this.$('.calculation-container'), {
            model: calculation
        }, _.bind(function (el) {
            let $calc = $(el);
            new PJQ.Binder($calc, calculation, {
                watchElements: [
                    'input'
                ]
            });

            new PJQ.inputs.Selectpicker({
                el: $calc.find('.operator'),
                noneSelectedText: null,
                defaultValue: calculation.get('operator'),
                onChange: _.bind(function (value) {
                    calculation.set('operator', value);
                }, this),
                title: 'Select Operator'
            });

            let choices = _.map(PJQ.constants.budgetHelpers.getColumnSources(), function (source) {
                return {
                    id: source.source,
                    name: source.name + (source.isErp ? ('<span class="fs-10 pl-2 text-primary font-weight-bold">ERP</span>') : '')
                };
            });
            new PJQ.inputs.Selectpicker({
                el: $calc.find('.select-source'),
                noneSelectedText: null,
                choices: choices,
                defaultValue: calculation.get('source'),
                onChange: _.bind(function (value) {
                    calculation.set('source', value);
                    this.render();
                }, this),
                title: 'Select Column'
            });

            if (calculation.get('source') === "PrimeContractValues" || calculation.get('source') === "PrimeContractChangeOrderValues"
                || calculation.get('source') === "CommitmentValues" || calculation.get('source') === "CommitmentChangeOrderValues"
                || calculation.get('source') === "DirectCostValues" || calculation.get('source') === "PayableInvoiceValues"
                || calculation.get('source') === "ReceivableInvoiceValues") {
                new PJQ.inputs.Selectpicker({
                    el: $calc.find('.select-source-filter'),
                    noneSelectedText: 'No Status Filters',
                    isMultiple: true,
                    defaultValue: calculation.get('options') != null ? _.map(calculation.get('options').statuses, function (value) {
                        return value.toString();
                    }) : null,
                    onChange: _.bind(function (value) {
                        let statuses = _.map(value, function (id) {
                                return parseInt(id);
                            }, this),
                            options = {
                                "statuses": statuses
                            }
                        calculation.set('options', options);
                    }, this),
                    title: 'No Filters'
                });
            }

        }, this));
    },
    addCalculation: function () {
        let calculation = new PJQ.models.budget.ViewColumnCalculation({
            source: null
        });
        if (_.size(this.column.calculations.models) === 0) {
            let calculations = [calculation];
            calculations.push(new PJQ.models.budget.ViewColumnCalculation({
                source: null
            }));

            this.column.calculations.add(calculations);
            this.renderCalculations();
        } else {
            this.column.calculations.add(calculation);
            this.renderCalculations();
        }
    },
    deleteCalculation: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            calculation = this.column.calculations.get(cid);

        this.column.calculations.remove(calculation);
        this.renderCalculations();
    }
});

PJQ.views.budget.BulkEditLineItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-bulk-edit-line-items'),
        maxWidth: 400,
        onSave: null
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        if(_.size(this.options.lineItems) === 0){
            return;
        }

        this.model = new PJQ.models.BaseModel();
    },
    renderData: function () {
        return {
            lineItems: this.options.lineItems,
            model: this.model,
            enableStoredMaterials: this.options.enableStoredMaterials,
            enableRetainage: this.options.enableRetainage
        }
    },
    afterRender: function() {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            onChange: ($el, attribute, value) => {
                if(_.size($el.val()) > 0){
                    this.model.set(attribute, value);
                }
                else{
                    this.model.unset(attribute);
                }
            }
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
    },
    save: function() {
        _.each(this.options.lineItems, (lineItem) => {
            _.each(this.model.attributes, (value, key) => {
                lineItem.set(key, value/100)
            });
        });

        if(typeof this.options.onSave === 'function'){
            this.options.onSave();
        }
        this.removeModal();
    }
});
PJQ.collections.changeRequests = PJQ.collections.changeRequests ? PJQ.collections.changeRequests : {};
PJQ.models.changeRequests = PJQ.models.changeRequests ? PJQ.models.changeRequests : {};
PJQ.views.changeRequests = PJQ.views.changeRequests ? PJQ.views.changeRequests : {};

PJQ.modules.changeRequests = {
    routes: [
        {
            route: 'projects/:projectId/changerequests',
            name: 'changerequests',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests");
            }
        },
        {
            route: 'projects/:projectId/changerequests/:changeRequestId',
            name: 'changerequest',
            callback: function (projectId, changeRequestId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    changeRequestId: parseInt(changeRequestId)
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/rfq',
            name: 'rfq1',
            callback: function (projectId, changeRequestId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    view: 'rfq'
                });
            }
        },
        {
            route: 'projects/:projectId/rfq/:rfqId',
            name: 'rfq2',
            callback: function (projectId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    view: 'rfq',
                    rfqId: parseInt(rfqId),
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/rfq/:rfqId',
            name: 'rfq3',
            callback: function (projectId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    rfqId: parseInt(rfqId),
                    view: 'rfq'
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/:changeRequestId/rfq/:rfqId',
            name: 'rfq4',
            callback: function (projectId, changeRequestId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    changeRequestId: parseInt(changeRequestId),
                    rfqId: parseInt(rfqId),
                    view: 'rfq'
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.changeRequests.routes);
PJQ.views.changeRequests.ChangeRequestDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Change Requests have been created yet',
            zeroRecords: "No Change Requests matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-change-requests')
        },
        toggleRowClass: '.toggle-row',
        onViewChangeRequest: null,
        scrollX: true,
        // scrollY: 'auto',
        enableColumnResize: false
    },
    events: {
        'click .btn-view-change-request': 'viewChangeRequestClicked',
        'click .btn-view-prime-contract': 'viewPrimeContractClicked',
        'click .btn-view-pcco': 'viewPrimeContractChangeOrderClicked',
        'click .btn-view-commitment': 'viewCommitmentClicked',
        'click .btn-view-cco': 'viewCommitmentChangeOrderClicked',
        'click .select-line-item': 'selectLineItem',
        'click .select-all-line-items': 'selectAllLineItems',
        'click .btn-new-pcco': 'newContractChangeOrder',
        'click .btn-new-cco': 'newCommitmentChangeOrder',
        'click .btn-new-commitment': 'newCommitment',
        'click .btn-send-rfq': 'sendRFQs',
        'click .btn-existing-cco': 'addToExistingCommitmentChangeOrder',
        'click .btn-existing-pcco': 'addToExistingContractChangeOrder',
        'click .btn-existing-commitment': 'addToExistingCommitment'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
        this.options.project = this.options.project ?? PJQ.app.session.project;

        this.canAddCommitments = this.options.project.hasPermission('commitments.canAdd');
        this.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.canAddCommitmentChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.canAddContractChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.canAdd');
        this.canViewPrimeContracts = this.options.project.hasPermission('primeContracts.canView');

        if (this.options.companySettings.get('enableStandardListView')) {
            this.options.rowCallback = (row, data, index) => {
                $(row).addClass('section-row');
            };
        }
    },
    afterDataTableRender: function () {
        this.disableColumnReorder();
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter = this.options.userSettings.get('defaultStatusFilter');
        return defaultFilter;
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function () {
        let filterChoices = [];

        filterChoices.push({
            id: PJQ.constants.changeRequests.filterType.STATUS_FILTER,
            name: 'Status',
            choices: _.map(PJQ.constants.changeRequests.changeRequestStatus, (choice) => {
                return {
                    id: choice,
                    name: PJQ.constants.changeRequests.changeRequestStatusNames[choice]
                };
            })
        });

        if (this.options.companySettings.get('enableStandardListView')) {
            filterChoices.push({
                id: PJQ.constants.changeRequests.filterType.OTHER_FILTER,
                name: '',
                choices: [
                    {
                        id: -1,
                        name: 'Cost Not Attached'
                    },
                    {
                        id: -2,
                        name: 'Revenue Not Attached'
                    }
                ]
            });
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.change-requests-filter'),
            defaultValue: this.getDefaultFilter(),
            choices: filterChoices,
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            noneSelectedText: 'No Filters',
            onChange: (value) => {
                let statusFilter = null,
                    otherFilter = null;
                _.each(value, (filter, key) => {
                    if (key === PJQ.constants.changeRequests.filterType.STATUS_FILTER) {
                        statusFilter = filter;
                    } else if (key === PJQ.constants.changeRequests.filterType.OTHER_FILTER) {
                        otherFilter = filter;
                    }
                });

                this.setFilter(PJQ.constants.changeRequests.filterType.STATUS_FILTER, statusFilter);
                this.setFilter(PJQ.constants.changeRequests.filterType.OTHER_FILTER, otherFilter);
            }
        });

    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.changeRequests.filterType.STATUS_FILTER),
            otherFilter = this.getFilter(PJQ.constants.changeRequests.filterType.OTHER_FILTER);
        if (_.size(statusFilter) === 0 && _.size(otherFilter) === 0) {
            return this.options.data;
        }

        let res = _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });

        if (_.size(otherFilter) > 0) {
            let costNotAttached = _.contains(otherFilter, -1),
                revenueNotAttached = _.contains(otherFilter, -2);
            res = _.filter(res, function (row) {
                if (costNotAttached) {
                    return _.find(row.lineItems.models, (lineItem) => {
                        return row.canAttachLineItemCost(lineItem);
                    });
                }

                if (revenueNotAttached) {
                    return _.find(row.lineItems.models, (lineItem) => {
                        return row.canAttachLineItemRevenue(lineItem);
                    });
                }

                return false;
            });
        }

        return res;
    },
    createdRow(row, data, index) {
        // if (this.options.companySettings.get('enableStandardListView')) {
        //     let $secondCell = $('td', row).eq(1);
        //     $secondCell.attr('colspan', 6);
        //     $('td', row).slice(2, 7).remove();
        // }
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [];

        if (this.options.companySettings.get('enableStandardListView')) {
            if (!includeAllColumns) {
                columns.push({
                    "columnData": "",
                    "data": "",
                    "orderable": false,
                    "title": this.options.data.some(item => _.size(item.lineItems.models) > 0) ? `<i class="fal ${(_.size(this.expandedItems) > 0 || (this.options.expandAll && this.expandedItems == null) ? 'fa-minus-circle' : 'fa-plus-circle')} toggle-all-rows" style="cursor: pointer"></i>` : '',
                    "width": "20px",
                    "render": _.bind(function (data, type, row) {
                        let isSelected = this.options.selectedLineItems && _.size(row.lineItems) > 0 ? _.every(row.lineItems.models, item => _.contains(this.options.selectedLineItems, item.cid)) : false,
                            toggleRow = '',
                            checkbox = '',
                            erpIcon = PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());

                        if (_.size(row.lineItems.models) > 0) {
                            toggleRow += `<i class="fal fa-plus-circle toggle-row mr-2" data-type="" data-id="${row.id}" style="cursor: pointer"></i>`;
                            if (row.lineItems.some(item => item.get('appliedMarkupId') == null || item.get('appliedMarkupId') === 0)) {
                                checkbox += `<div class="text-align-center ${_.size(erpIcon) > 0 ? 'mr-2' : ''}">
                                                    <div class="pretty p-default p-smooth fs-18 m-0">
                                                        <input type="checkbox" ${isSelected ? ' checked ' : ''} class="select-all-line-items" ${1 !== 1 ? 'disabled' : ''}/>
                                                        <div class="state p-primary">
                                                            <label class="wd-0">&nbsp;</label>
                                                        </div>
                                                    </div>
                                                </div>`;
                            } else {
                                checkbox += '<div style="width: 18px;"></div>';
                            }
                        }

                        return `<div class="text-align-center d-flex ht-30p align-items-center justify-content-center">${toggleRow}${checkbox}${erpIcon}</div>`;
                    }, this)
                });
            }
            columns.push(
                {
                    "columnData": "id",
                    "data": "id",
                    "title": "Title",
                    "width": '100px',
                    "render": _.bind(function (data, type, row) {
                        let title = `<div class="font-weight-bold">${row.get('number')} ${_.size(row.get('title')) > 0 ? ` - ${row.get('title')}` : ''}</div>`;
                        return '<div class="no-wrap wd-100p" style="width:100px;"><a class="btn-view-change-request" href="javascript:void(0)" data-id="' + title + '</a></div>';
                    }, this)
                },
                {
                    "columnData": "costCodeId",
                    "data": "costCodeId",
                    "title": "Budget Code",
                    "render": _.bind(function (data, type, row) {
                        return ``;
                    }, this)
                },
                {
                    "columnData": "description",
                    "data": "description",
                    "title": "Description",
                    "render": _.bind(function (data, type, row) {
                        return ""
                    }, this)
                },
                {
                    "columnData": "vendor",
                    "data": "vendor",
                    "title": "Company",
                    "render": _.bind(function (data, type, row) {
                        return ""
                    }, this)
                },
                {
                    "columnData": "commitmentId",
                    "data": "commitmentId",
                    "title": "Commitment",
                    "render": _.bind(function (data, type, row) {
                        return ""
                    }, this)
                },
                {
                    "columnData": "primeContractId",
                    "data": "primeContractId",
                    "title": "Contract",
                    "render": _.bind(function (data, type, row) {
                        let primeContractId = row.get('primeContractId');
                        return primeContractId && this.canViewPrimeContracts ? `<a class="btn-view-prime-contract" href="javascript:void(0)" data-id="${primeContractId}">${row.get('primeContractNumber')}</a>` : '';
                    }, this)
                },
                {
                    "columnData": "scope",
                    "data": "scope",
                    "title": "Scope",
                    "width": "100px",
                    "render": (data, type, row) => {
                        return PJQ.constants.changeRequests.scopeNames[row.get('scope')];
                    }
                },
                {
                    "columnData": "status",
                    "data": "statusId",
                    "title": "Status",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.changeRequests.changeRequestStatusNames[row.get('statusId')]
                    }, this)
                },
                {
                    "columnData": "totalAmount",
                    "data": "totalAmount",
                    "title": "Cost",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    }, this)
                },
                {
                    "columnData": "totalRevenue",
                    "data": "totalRevenue",
                    "title": "Revenue",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue'));
                    }, this)
                },
                {
                    "columnData": "markupAmount",
                    "data": "markupAmount",
                    "title": "Markup",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('markupAmount'));
                    }, this)
                },
                {
                    "columnData": "taxAmount",
                    "data": "taxAmount",
                    "title": "Tax",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                    }, this)
                },
                {
                    "columnData": "amount",
                    "data": "amount",
                    "title": "Total",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                },
                {
                    "columnData": "",
                    "data": "",
                    "title": "Over/Under",
                    "render": _.bind(function (data, type, row) {
                        let value = (row.get('revenue') + row.get('markupAmount')) - row.get('amount');
                        if (type === 'sort' || type === 'type') {
                            return value;
                        }

                        return `<span class="${value < 0 ? 'text-danger' : ''}">${PJQ.helpers.formatHelpers.formatCurrency(value)}</span>`
                    }, this)
                },
                {
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover" style="min-width:40px;"><button type="button" class="btn btn-info btn-view-change-request ml-1" title="View change request"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "40px",
                    "className": "text-center",
                    "visible": true
                }
            );
        } else {
            let includeColumns = ['status', 'primeContract', 'client.companyName', 'number', 'title', 'description', 'scope', 'createdOn', 'amount', 'revenue', 'markupAmount', 'taxAmount', 'overUnder', 'grandTotal'];

            if (this.options.customFields) {
                _.each(this.options.customFields.models, _.bind(function (customField) {
                    includeColumns.push('fieldValue' + customField.get('fieldNumber'));
                }, this));
            }

            if (!includeAllColumns) {
                if (this.options.settings && _.size(this.options.settings.columns) > 0)
                    includeColumns = this.options.settings.columns;
                else
                    includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

                columns.push(
                    {
                        "columnData": "childData",
                        "data": null,
                        "title": "",
                        "width": "40px",
                        "orderable": false,
                        "searchable": false,
                        "defaultContent": '',
                        "render": function (data, type, row) {
                            let toggle = '',
                                erpIcon = '';
                            erpIcon += PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                            toggle += `<i class="fal fa-plus-circle toggle-row ${_.size(erpIcon) > 0 ? 'mr-2' : ''}" data-type="" data-id="${row.id}" style="cursor: pointer"></i>`;

                            return `<div class="text-align-center d-flex">${erpIcon}</div>`;
                        }
                    });
            }

            _.each(includeColumns, _.bind(function (columnName) {
                switch (columnName) {
                    case 'status':
                        columns.push({
                            "columnData": "status",
                            "data": "attributes.statusId",
                            "title": "Status",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.constants.changeRequests.changeRequestStatusNames[row.get('statusId')]
                            }, this)
                        });
                        break;
                    case 'primeContract':
                        columns.push({
                            "columnData": "primeContract",
                            "title": "Contract",
                            "data": "attributes.primeContractNumber",
                            "orderable": true,
                            "render": _.bind(function (data, type, row) {
                                if (type === 'sort' || type === 'type') {
                                    return row.get('primeContractNumber');
                                }

                                if (this.canViewPrimeContracts) {
                                    return '<a class="btn-view-prime-contract" href="javascript:void(0)" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                                }
                                return data;
                            }, this)
                        },);
                        break;
                    case 'number':
                        columns.push({
                            "columnData": "number",
                            "data": "attributes.number",
                            "title": "Number",
                            "render": _.bind(function (data, type, row) {
                                return '<a class="btn-view-change-request" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                            }, this)
                        });
                        break;
                    case 'title':
                        columns.push({
                            "columnData": "title",
                            "data": "attributes.title",
                            "title": "Title"
                        });
                        break;
                    case 'description':
                        columns.push({
                            "columnData": "description",
                            "data": "attributes.description",
                            "title": "Description"
                        });
                        break;
                    case 'createdOn':
                        columns.push({
                            "columnData": "createdOn",
                            "data": "attributes.createdOn",
                            "title": 'Created',
                            "width": '90px',
                            "render": _.bind(function (data, type, row) {
                                if (_.size(data) === 0) {
                                    return '';
                                } else if (type === 'sort' || type === 'type') {
                                    return data ? new Date(data) : null;
                                }
                                return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }, this)
                        });
                        break;
                    case 'client.companyName':
                        columns.push({
                            "columnData": "client.companyName",
                            "title": "Client",
                            "titleSettings": "Client",
                            "render": _.bind(function (data, type, row) {
                                return row.get('client') ? row.get('client').companyName : 'N/A';
                            }, this)
                        });
                        break;
                    case 'scope':
                        columns.push({
                            "columnData": "scope",
                            "data": "attributes.scope",
                            "title": "Scope",
                            "width": "100px",
                            "render": (data, type, row) => {
                                return PJQ.constants.changeRequests.scopeNames[data] ?? '';
                            }
                        });
                        break;
                    case 'amount':
                        columns.push({
                            "columnData": "amount",
                            "data": "attributes.amount",
                            "width": "10%",
                            "title": "Cost",
                            "className": "text-align-right",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                            }, this)
                        });
                        break;
                    case 'revenue':
                        columns.push({
                            "columnData": "revenue",
                            "data": "attributes.revenue",
                            "width": "10%",
                            "title": "Revenue",
                            "className": "text-align-right",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue'));
                            }, this)
                        });
                        break;
                    case 'taxAmount':
                        columns.push({
                            "columnData": "taxAmount",
                            "data": "attributes.taxAmount",
                            "title": "Tax",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            }, this)
                        });
                        break;
                    case 'markupAmount':
                        columns.push({
                            "columnData": "markupAmount",
                            "data": "attributes.markupAmount",
                            "title": "Markup",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            }, this)
                        });
                        break;
                    case 'overUnder':
                        columns.push({
                            "columnData": "overUnder",
                            "data": "",
                            "title": "Over/Under",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                let value = row.get('revenue') - row.get('amount');
                                return PJQ.helpers.formatHelpers.formatCurrency(value);
                            }, this)
                        });
                        break;
                    case 'grandTotal':
                        columns.push({
                            "columnData": "grandTotal",
                            "data": "attributes.amount",
                            "title": "Grand Total",
                            "width": "100px",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                            }, this)
                        });
                        break;
                    default:
                        if (columnName.startsWith('fieldValue')) {
                            _.each(this.options.customFields.models, function (customField) {
                                if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                    columns.push({
                                        "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                        "title": customField.get('name'),
                                        "render": function (data, type, row) {
                                            let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                            fieldValue = (fieldValue !== null) ? fieldValue : '';
                                            switch (customField.get('fieldTypeId')) {
                                                case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                    if (fieldValue != null)
                                                        fieldValue = fieldValue ? 'Yes' : 'No';
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.CHOICE:
                                                    let choices = [];
                                                    // convert single choice value into array so that the logic below can work for both types.
                                                    if (typeof fieldValue === 'number')
                                                        fieldValue = [fieldValue];

                                                    _.each(customField.choices.models, _.bind(function (choice) {
                                                        if (_.find(fieldValue, function (value) {
                                                            return value === choice.get('id');
                                                        }))
                                                            choices.push(choice.get('name'));
                                                    }, this));

                                                    fieldValue = choices.join((', '));
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.DATE:
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case PJQ.constants.commitments.customFieldType.DATETIME:
                                                    if (fieldValue) {
                                                        if (type !== 'sort' && type !== 'type')
                                                            fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                                                    }
                                                    if (fieldValue === undefined)
                                                        fieldValue = '';

                                                    break;
                                                case PJQ.constants.commitments.customFieldType.INTEGER:
                                                    if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                        fieldValue = parseInt(fieldValue).toLocaleString();
                                                    }
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.MONEY:
                                                    if (type === 'sort' || type === 'type') {
                                                        if (fieldValue && fieldValue !== '$')
                                                            fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                        else
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                    }
                                                    break;
                                                case PJQ.constants.commitments.customFieldType.PERCENT:
                                                    if (type === 'sort' || type === 'type') {
                                                        if (fieldValue && fieldValue !== '$')
                                                            fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                        else
                                                            fieldValue = 0;
                                                    } else {
                                                        fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                    }

                                                    break;
                                            }

                                            return fieldValue;
                                        }
                                    });
                                }
                            });
                        }
                        break;
                }
            }, this));

            if (!includeAllColumns) {
                columns.push({
                    "title": '',
                    "render": _.bind(function (data, type, row) {
                        return '<div class="show-on-row-hover" style="min-width:40px;"><button type="button" class="btn btn-info btn-view-change-request ml-1" title="View change request"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                    }, this),
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "40px",
                    "className": "text-center",
                    "visible": true
                });
            }
        }

        return columns;
    },
    getLineItemColumns: function () {
        return [
            {
                "columnData": "",
                "data": "",
                "title": "",
                "width": "20px",
                "render": _.bind(function (data, type, row) {
                    let isSelected = this.options.selectedLineItems ? _.contains(this.options.selectedLineItems, row.cid) : false;

                    if (row.get('appliedMarkupId') > 0) {
                        return '';
                    } else {
                        return `<div class="d-flex text-align-center align-items-center justify-content-center">
                                <div class="mr-2" style="width: 14px;"></div>
                                <div>
                                    <div class="pretty p-default p-smooth fs-18 m-0">
                                        <input type="checkbox" ${isSelected ? ' checked ' : ''} class="select-line-item" ${1 !== 1 ? 'disabled' : ''}/>
                                        <div class="state p-primary">
                                            <label class="wd-0">&nbsp;</label>
                                        </div>
                                    </div>
                                </div>
                            </div>`;
                    }
                }, this)
            },
            {
                "columnData": "changeRequestId",
                "data": "changeRequestId",
                "title": "Change Request",
                "render": _.bind(function (data, type, row) {
                    return ``;
                }, this)
            },
            {
                "columnData": "costCodeId",
                "data": "costCodeId",
                "title": "Budget Code",
                "width": "200px",
                "render": _.bind(function (data, type, row) {
                    let costCode = this.options.costCodes?.get(row.get('costCodeId')),
                        costType = this.options.costTypes?.get(row.get('costTypeId'));
                    return '<div style="width:200px">' + (costCode?.getDisplayName() ?? "") + '</div><div class="fs-13 text-muted">' + (costType?.get('name') ?? "") + '</div>';
                }, this)
            },
            {
                "columnData": "description",
                "data": "description",
                "title": "Description",
                "render": _.bind(function (data, type, row) {
                    return row.get('description');
                }, this)
            },
            {
                "columnData": "vendor",
                "data": "vendor",
                "title": "Company",
                "render": _.bind(function (data, type, row) {
                    let vendor = row.get('vendor');
                    return `${vendor?.companyName ?? ""}`
                }, this)
            },
            {
                "columnData": "commitmentId",
                "data": "commitmentId",
                "title": "Commitment",
                "render": _.bind(function (data, type, row) {
                    let commitmentId = row.get('commitmentId'),
                        ccoId = row.get('ccoId'),
                        html = '';

                    if (row.get('costLineItemId') > 0) {
                        html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a committed cost line item"></i>'
                    }

                    if (row.get('costLineItemId') > 0 || !this.options.canEdit) {
                        if (commitmentId > 0) {
                            html += '<div class="wd-150p"><a class="btn-view-commitment" href="javascript:void(0)" data-id="' + commitmentId + '">' + row.get('commitmentNumber') + '</a></div>';
                        } else if (ccoId > 0) {
                            html += '<div class="wd-150p"><a class="btn-view-cco" href="javascript:void(0)" data-id="' + ccoId + '" data-type="cco">' + row.get('ccoNumber') + '</a></div>';
                        }
                    }
                    return '<div class="d-flex">' + html + '</div>';
                }, this)
            },
            {
                "columnData": "primeContractId",
                "data": "primeContractId",
                "title": "Contract",
                "render": _.bind(function (data, type, row) {
                    let pccoId = row.get('pccoId'),
                        html = '';

                    if (row.get('revenueLineItemId') > 0) {
                        html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a contract change order line item"></i>'
                    }

                    if (row.get('revenueLineItemId') > 0 && pccoId > 0) {
                        if (pccoId > 0) {
                            html += '<div class="wd-150p"><a class="btn-view-pcco" href="javascript:void(0)" data-id="' + pccoId + '" data-type="pcco">' + row.get('pccoNumber') + '</a></div>';
                        }
                    }
                    return '<div class="d-flex">' + html + '</div>';
                }, this)
            },
            {
                "columnData": "scope",
                "data": "scope",
                "title": "",
                "render": _.bind(function (data, type, row) {
                    return '';
                }, this)
            },
            {
                "columnData": "statusId",
                "data": "statusId",
                "title": "Status",
                "render": _.bind(function (data, type, row) {
                    return '';
                }, this)
            },
            {
                "columnData": "amount",
                "data": "amount",
                "title": "Cost",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                }, this)
            },
            {
                "columnData": "revenue",
                "data": "revenue",
                "visible": false,
                "title": "Revenue",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue'));
                }, this)
            },
            {
                "columnData": "markupAmount",
                "data": "markupAmount",
                "title": "Markup",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('markupAmount'));
                }, this)
            },
            {
                "columnData": "taxAmount",
                "data": "taxAmount",
                "title": "Tax",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                }, this)
            },
            {
                "columnData": "amount",
                "data": "amount",
                "title": "Subtotal",
                "render": _.bind(function (data, type, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal(null, {costs: this.changeRequest.get('scope') === PJQ.constants.changeRequests.scope.INTERNAL}));
                }, this)
            },
            {
                "columnData": "",
                "data": "",
                "title": "Over/Under",
                "render": _.bind(function (data, type, row) {
                    let value = row.get('revenue') - row.get('amount');
                    return PJQ.helpers.formatHelpers.formatCurrency(value);
                }, this)
            },
            {
                "columnData": "",
                "data": "",
                "title": "",
                "render": (data, type, row) => {
                    return '';
                }
            }
        ]
    },
    toggleAllChildRows: function (e) {
        let self = this,
            expand = _.size(this.options.expandedRowIds) === 0;
        this.dataTable.rows().every(function () {
            let changeRequest = this.data();
            if (_.size(changeRequest.lineItems) > 0) {
                self.toggleChildRow(this, expand);
            }
        });
        this.renderToggleAllIcon();
    },
    selectLineItem: function (e) {
        if (this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        let $target = $(e.currentTarget),
            row = $target.closest('tr'),
            cid = row.data('row-id'),
            parentCid = row.data('parent-id'),
            parentRow = this.$(`tr#${parentCid}`),
            $selectAllToggle = parentRow.find('.select-all-line-items'),
            changeRequest = _.find(this.options.data, function (cr) {
                return cr.cid === parentCid;
            }),
            isChecked = $target.prop('checked');

        if (_.size(cid) > 0) {
            if (isChecked) {
                this.options.selectedLineItems.push(cid);
            } else {
                this.options.selectedLineItems = _.reject(this.options.selectedLineItems, function (sCid) {
                    return sCid === cid;
                });
            }
        }

        $selectAllToggle.prop('checked', _.every(changeRequest.lineItems.models, item => _.contains(this.options.selectedLineItems, item.cid)));
        this.updateBulkActionsButton();
    },
    selectAllLineItems: function (e) {
        let $target = $(e.currentTarget),
            parentCid = $target.closest('tr').attr('id'),
            changeRequest = _.find(this.options.data, function (cr) {
                return cr.cid === parentCid;
            });

        if (this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        let nonAppliedLines = _.filter(changeRequest.lineItems.models, function (li) {
            return li.get('appliedMarkupId') == null || li.get('appliedMarkupId') === 0;
        });

        let nonAppliedCids = _.map(nonAppliedLines, 'cid');

        if ($target.prop('checked')) {
            this.options.selectedLineItems = _.union(this.options.selectedLineItems, nonAppliedCids);
        } else {
            this.options.selectedLineItems = _.difference(this.options.selectedLineItems, nonAppliedCids);
        }

        this.$(`tr#${parentCid}`).find('.select-line-item').prop('checked', $target.prop('checked'));
        this.$(`tr[data-parent-id="${changeRequest.cid}"]`).each((index, tr) => {
            $(tr).find('.select-line-item').prop('checked', $target.prop('checked'));
        });

        this.updateBulkActionsButton();
    },
    updateBulkActionsButton: function () {
        let bulkActionsButton = this.$('.btn-bulk-actions'),
            contractsSubmenu = this.$('.contracts-submenu'),
            commitmentsSubmenu = this.$('.commitments-submenu'),
            addCCOButton = this.$('.btn-add-cco'),
            addSubcontractButtons = this.$('.btn-new-commitment'),
            sendRFQButton = this.$('.btn-send-rfq');

        let changeRequests = _.uniq(_.map(this.options.selectedLineItems, (cid) => {
            return _.find(this.options.data, (cr) => {
                return _.some(cr.lineItems.models, (item) => item.cid === cid);
            });
        }));
        changeRequests = _.compact(changeRequests);

        if (_.size(this.options.selectedLineItems) > 0) {
            bulkActionsButton.removeClass('disabled');
        } else {
            bulkActionsButton.addClass('disabled');
            return;
        }

        let canSendRFQ = !_.some(changeRequests, (cr) => !cr.canSendRFQ()),
            allPrimeContractIdsMatch = _.every(changeRequests, (cr, index, array) =>
                cr.get('primeContractId') === array[0].get('primeContractId')
            ),
            canAttachCosts = true,
            canAttachRevenue = allPrimeContractIdsMatch;
        if (_.size(this.options.selectedLineItems) > 0) {
            this.$('.btn-create-new').removeClass('disabled');

            _.each(changeRequests, (changeRequest) => {
                _.each(changeRequest.lineItems.get(this.options.selectedLineItems), (lineItem) => {
                    if (!changeRequest.canAttachLineItemCost(lineItem)) {
                        canAttachCosts = false;
                    }

                    if (!changeRequest.canAttachLineItemRevenue(lineItem)) {
                        canAttachRevenue = false;
                    }
                });
            });
        }

        if (!canAttachRevenue || !this.canAddContractChangeOrders) {
            contractsSubmenu.addClass('disabled');
        } else {
            contractsSubmenu.removeClass('disabled');
        }

        if (!canAttachCosts) {
            commitmentsSubmenu.addClass('disabled');
        } else {
            commitmentsSubmenu.removeClass('disabled');
        }

        if (!this.canAddCommitments) {
            addSubcontractButtons.addClass('hidden');
        } else {
            addSubcontractButtons.removeClass('hidden');
        }

        if (!this.canAddCommitmentChangeOrders) {
            addCCOButton.addClass('hidden');
        } else {
            addCCOButton.removeClass('hidden');
        }

        if (!canSendRFQ) {
            sendRFQButton.addClass('disabled');
        } else {
            sendRFQButton.removeClass('disabled');
        }
    },
    newCommitment: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentType = $(e.currentTarget).hasClass('new-po') ? PJQ.constants.commitments.commitmentType.PURCHASE_ORDER : PJQ.constants.commitments.commitmentType.SUBCONTRACT,
            lineItems = [],
            selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
            })),
            vendors = [],
            vendorIds = [];
        _.each(selLineItems, function (lineItem) {
            if (lineItem.get('costLineItemId') == null) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    changeRequestLineItemId: lineItem.id
                }));

                let liVendor = lineItem.get('vendor');
                if (vendors == null) {
                    return;
                } else if (liVendor && vendorIds.indexOf(liVendor.id) === -1) {
                    vendors.length > 0 ? null : vendors.push(liVendor);
                }
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.commitments.CommitmentEditModal({
                model: null,
                fromChangeRequest: this.model,
                contractedContact: vendors.length > 0 ? vendors[0] : null,
                commitmentType: commitmentType,
                lineItems: lineItems,
                onSave: _.bind(function (commitment) {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                }, this),
            });
        }
    },
    newCommitmentChangeOrder: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            filterStatuses: PJQ.constants.commitments.commitmentStatus.APPROVED,
            headerSubText: 'Select the Commitment you would like to create a Change Order for.',
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                        return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                    })),
                    lineItems = [];

                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        lineItems.push(_.extend(lineItem.attributes, {
                            id: null,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                if (_.size(lineItems) > 0) {
                    new PJQ.views.commitments.ChangeOrderEditModal({
                        commitment: commitment,
                        lineItems: lineItems,
                        onSave: _.bind(function (changeOrder) {
                            if (typeof this.options.onCreateFromLineItems === 'function') {
                                this.options.onCreateFromLineItems();
                            }
                        }, this),
                    });
                }
            }
        });
    },
    getSelectedCommitmentIds: async function () {
        let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
            return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
        }));

        return _.uniq(_.map(selLineItems, (item) => item.get('commitmentId')));
    },
    sendRFQs: async function (e) {
        let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
            })),
            changeRequests = _.uniq(_.map(this.options.selectedLineItems, (cid) => {
                return _.find(this.options.data, (cr) => {
                    return _.some(cr.lineItems.models, (item) => item.cid === cid);
                });
            })),
            projectCommitments = new PJQ.collections.commitments.Commitments([], {
                projectId: this.options.project.id,
                withLineItems: true
            });

        await projectCommitments.fetch();
        changeRequests = _.compact(changeRequests);

        let fnSendRFQ = (lineItems) => {
            new PJQ.views.rfq.RFQBatchModal({
                changeRequests: changeRequests,
                project: this.options.project,
                lineItems: lineItems,
                projectCommitments: projectCommitments
            });
        };

        let lineItemCt = _.size(selLineItems),
            rfqItemsCt = _.filter(selLineItems, (lineItem) => {
                return lineItem.get('rfqId') > 0;
            }).length;
        if (rfqItemsCt > 0) {
            if (rfqItemsCt === lineItemCt) {
                new PJQ.views.modals.YesNo({
                    header: "Send New RFQs?",
                    body: "All of the selected line items are already associated with RFQs. Would you like to create them again?",
                    onYes: () => {
                        fnSendRFQ(selLineItems);
                    }
                });
            } else {
                new PJQ.views.BaseModal({
                    header: "Send RFQs",
                    body: "Some of the selected line items are already associated with RFQs. Please choose from the options below.",
                    isShowOkButton: true,
                    okButtonText: "Create All (" + lineItemCt + ")",
                    onOk: () => {
                        fnSendRFQ(selLineItems);
                    },
                    isShowSecondaryButton: true,
                    secondaryButtonColorClass: 'primary',
                    secondaryButtonText: "Create Missing (" + rfqItemsCt + ")",
                    onSecondary: () => {
                        fnSendRFQ(_.filter(selLineItems, (lineItem) => {
                            return !(lineItem.get('rfqId') > 0);
                        }));
                    }
                });
            }
        } else {
            fnSendRFQ(selLineItems);
        }
    },
    newContractChangeOrder: async function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let lineItems = [],
            selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
            })),
            changeRequestId = selLineItems[0].get('changeRequestId'),
            changeRequest = _.find(this.options.data, (cr) => cr.id === changeRequestId),
            primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: changeRequest.get('primeContractId')
            });
        await primeContract.fetch();

        let erpIntegration = await PJQ.app.session.fetchERPIntegration(),
            reqLinkedItem = erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM),
            clearDescription = reqLinkedItem
                && !erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM);
        _.each(selLineItems, function (lineItem) {
            if (!lineItem.get('revenueLineItemId')) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    description: clearDescription || (reqLinkedItem && _.indexOf(lineItem.get('description'), '-') === -1) ? '' : lineItem.get('description'),
                    amount: lineItem.get('revenue'),
                    changeRequestLineItemId: lineItem.id
                }));
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.primeContracts.ChangeOrderEditModal({
                primeContract: primeContract,
                lineItems: lineItems,
                onSave: (commitment) => {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                },
            });
        }
    },
    addToExistingCommitment: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            headerSubText: 'Select the Commitment you would like to add these line items to',
            filterStatuses: [
                PJQ.constants.commitments.commitmentStatus.DRAFT,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING,
                PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID,
                PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE,
                PJQ.constants.commitments.commitmentStatus.SUBMITTED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PARTIALLY_RECEIVED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_RECEIVED
            ],
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                    return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                }));
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        commitment.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            commitmentId: commitment.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.CommitmentEditModal({
                    model: commitment,
                    fetch: false,
                    onSave: _.bind(function (commitment) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    addToExistingCommitmentChangeOrder: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.commitments.SelectCommitmentChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Commitment Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.commitments.changeOrderStatus.DRAFT,
                PJQ.constants.commitments.changeOrderStatus.NO_CHARGE,
                PJQ.constants.commitments.changeOrderStatus.IN_REVIEW,
                PJQ.constants.commitments.changeOrderStatus.NOT_PRICING,
                PJQ.constants.commitments.changeOrderStatus.PRICING,
                PJQ.constants.commitments.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                    return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                }));
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    addToExistingContractChangeOrder: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.primeContracts.SelectChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Contract Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                PJQ.constants.primeContracts.changeOrderStatus.NO_CHARGE,
                PJQ.constants.primeContracts.changeOrderStatus.IN_REVIEW,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = _.flatten(_.map(this.options.data, (cr) => {
                    return _.filter(cr.lineItems.models, (item) => _.contains(this.options.selectedLineItems, item.cid));
                }));
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('revenueLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    viewCommitmentClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewCommitment(id);
    },
    viewCommitment: function (commitmentId) {
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: commitmentId
            })
        });
    },
    viewCommitmentChangeOrderClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewCommitmentChangeOrder(id);
    },
    viewCommitmentChangeOrder: function (changeOrderId) {
        new PJQ.views.commitments.ChangeOrderEditModal({
            model: new PJQ.models.commitments.ChangeOrder({
                id: changeOrderId
            })
        });
    },
    getRowChildData: function (row) {
        this.changeRequest = row.data();
        let fnReturnData = (lineItems) => {
            return _.sortBy(_.filter(lineItems, (item) => !item.get('delete')), function (model) {
                return model.get('id');
            });
        }

        let otherFilter = this.getFilter(PJQ.constants.changeRequests.filterType.OTHER_FILTER),
            costNotAttached = _.contains(otherFilter, -1),
            revenueNotAttached = _.contains(otherFilter, -2);
        return _.sortBy(_.filter(this.changeRequest.lineItems.models, (item) => {
            if (item.get('delete')) {
                return false;
            }

            if (costNotAttached) {
                return this.changeRequest.canAttachLineItemCost(item);
            } else if (revenueNotAttached) {
                return this.changeRequest.canAttachLineItemRevenue(item);
            }
            return true;
        }), function (model) {
            return model.get('id');
        });
    },
    getRowChildColumns: function (row) {
        return this.getLineItemColumns();
    },
    onChildRowToggle: function (row) {
        let $row = $(row.node());
        let $icon = $row.find('.toggle-row');
    },
    preserveScrollRender: function () {
        let scrollTop = $(window).scrollTop();
        this.render();
        $(window).scrollTop(scrollTop);
    },
    viewChangeRequestClicked: function (e) {
        if (typeof (this.options.onViewChangeRequest) === 'function') {
            let row = this.getRow((e.currentTarget).closest('tr')),
                invoice = row.data();
            if (invoice != null) {
                this.options.onViewChangeRequest(invoice);
            }
        }
    },
    viewPrimeContractClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewPrimeContract(id);
    },
    viewPrimeContract: function (primeContractId) {
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: primeContractId
            })
        });
    },
    viewPrimeContractChangeOrderClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.viewPrimeContractChangeOrder(id);
    },
    viewPrimeContractChangeOrder: function (changeOrderId) {
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            model: new PJQ.models.primeContracts.ChangeOrder({
                id: changeOrderId
            })
        });
    }
});
PJQ.views.changeRequests.ChangeRequestEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-change-request-edit'),
        width: '95%',
        maxWidth: 1800,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-prime-contract': 'viewPrimeContract',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-close': 'close',
        'click .btn-submit': 'submitChangeRequest',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveChangeRequest',
        'click .btn-delete': 'deleteChangeRequest',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportClicked',
        'click .btn-export-costs': 'exportCosts',
        'click .btn-export-revenue': 'exportRevenue',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-view-rfq': 'viewRFQClicked'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.settings = await PJQ.app.session.fetchChangeRequestSettings();
        this.customFields = await this.options.project.fetchChangeRequestCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.options.primeContract == null) {
            this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            });
        }

        if (!this.options.primeContract.isFetched) {
            await this.options.primeContract.fetch();
        }

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            let markups = this.options.primeContract.markupItems.toJSON();
            _.each(markups, (markup) => {
                markup.void = false;
            })

            this.model = new PJQ.models.changeRequests.ChangeRequest({
                description: '',
                primeContractId: this.options.primeContract.id,
                primeContractNumber: this.options.primeContract.get('number'),
                client: this.options.primeContract.client,
                clientId: this.options.primeContract.get('clientId'),
                accountingMethod: this.options.primeContract.get('accountingMethod'),
                projectId: this.options.primeContract.get('projectId'),
                statusId: PJQ.constants.changeRequests.changeRequestStatus.DRAFT,
                customFieldValues: customFieldValues,
                markupItems: markups
            });

            if (_.size(this.model.markupItems.models) > 0) {
                _.each(this.model.markupItems.models, (markupItem) => {
                    let isApplied = markupItem.get('appliedCostCodeId') > 0 && markupItem.get('appliedCostTypeId') > 0;

                    if (isApplied) {
                        let lineItem = new PJQ.models.changeRequests.ChangeRequestLineItem({
                            costCodeId: markupItem.get('appliedCostCodeId'),
                            costTypeId: markupItem.get('appliedCostTypeId'),
                            amount: 0,
                            revenue: 0,
                            description: markupItem.get('name')
                        });
                        markupItem.lineItem = lineItem;
                        lineItem.markup = markupItem;
                        this.model.lineItems.add(lineItem);
                    }
                });
            }
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.options.canAdd = this.options.project.hasPermission('changeRequests.canAdd');
        this.options.canEdit = this.options.project.hasPermission('changeRequests.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canViewPrimeContracts = this.options.project.hasPermission('primeContracts.canView');
        this.options.canViewRFQs = this.options.project.hasPermission('changeRequests.canViewRFQs');
        this.options.isAdmin = this.options.project.hasPermission('changeRequests.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        if (!this.isFetched || this.model.isNew()) {
            return;
        }

        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.changeRequests.changeRequestStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status === PJQ.constants.changeRequests.changeRequestStatus.APPROVED
            || status === PJQ.constants.changeRequests.changeRequestStatus.VOID) {
            this.options.canEditLineItems = false;
            this.options.canEdit = PJQ.app.session.project.hasPermission('changeRequests.canEdit');
            this.options.canDelete = false;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('changeRequests.canEdit');
            this.options.canEditLineItems = this.options.canEdit;
            this.options.canDelete = this.options.isAdmin;
        }

        let hasAssignedItems = _.some(this.model.lineItems.models, (lineItem) => {
            return lineItem.get('revenueLineItemId') > 0;
        });
        if (hasAssignedItems) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.changeRequests.changeRequestStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (this.model.isERPSynced()) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.FAILED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.commitments.commitmentStatus.APPROVED);
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            customFields: this.customFields,
            erpIntegration: this.erpIntegration,
            canAdd: this.options.canAdd,
            canEditLineItems: this.options.canEditLineItems,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewPrimeContracts: this.options.canViewPrimeContracts,
            canViewRFQs: this.options.canViewRFQs,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this)
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();
        this.renderMarkups();
        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'CR_General',
        LINEITEMS: 'CR_LineItems',
        MARKUPS: 'CR_Markups',
        RFQ: 'CR_RFQ'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.GENERAL:
            case this.views.LINEITEMS:
            case this.views.MARKUPS:
                break;
            case this.views.RFQ:
                this.renderRFQ();
                break;
            default:
                view = this.views.GENERAL;
                break;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        let choices = _.map(PJQ.constants.changeRequests.changeRequestStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.changeRequests.changeRequestStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: _.bind(function (value) {
                let newStatus = value,
                    oldStatus = this.model.get('statusId');
                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.model.save(null, {
                        success: _.bind(function () {
                            this.model.dirtyAttributes = {};
                            if (typeof this.options.onSave === 'function')
                                this.options.onSave(this.model, false);
                            this.render();
                            PJQ.notifications.notify.successNotify({
                                message: 'Change Request saved successfully'
                            });
                        }, this)
                    })
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-revenue-source'),
            choices: [
                {
                    id: PJQ.constants.changeRequests.revenueSource.COST,
                    name: PJQ.constants.changeRequests.revenueSourceNames[PJQ.constants.changeRequests.revenueSource.COST]
                },
                {
                    id: PJQ.constants.changeRequests.revenueSource.MANUAL,
                    name: PJQ.constants.changeRequests.revenueSourceNames[PJQ.constants.changeRequests.revenueSource.MANUAL]
                }
            ],
            isIntChoices: true,
            defaultValue: this.model.get('revenueSource') ?? PJQ.constants.changeRequests.revenueSource.COST,
            canEdit: this.options.canEdit,
            onChange: (value) => {
                this.model.set({
                    revenueSource: value
                });
                this.refreshLineItems()
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-scope'),
            choices: [
                {
                    id: PJQ.constants.changeRequests.scope.OWNER_CHANGE,
                    name: PJQ.constants.changeRequests.scopeNames[PJQ.constants.changeRequests.scope.OWNER_CHANGE]
                },
                {
                    id: PJQ.constants.changeRequests.scope.INTERNAL,
                    name: PJQ.constants.changeRequests.scopeNames[PJQ.constants.changeRequests.scope.INTERNAL]
                }
            ],
            isIntChoices: true,
            defaultValue: this.model.get('scope') ?? PJQ.constants.changeRequests.scope.OWNER_CHANGE,
            canEdit: this.options.canEdit,
            onChange: (value) => {
                this.model.set({
                    revenueSource: PJQ.constants.changeRequests.revenueSource.MANUAL,
                    scope: value
                });
                this.model.set('scope', value);

                if (value === PJQ.constants.changeRequests.scope.INTERNAL) {
                    _.each(this.model.lineItems.models, (lineItem) => {
                        lineItem.set('revenue', 0);
                    });
                } else {
                    _.each(this.model.lineItems.models, (lineItem) => {
                        lineItem.set('revenue', lineItem.get('amount'));
                    });
                }
                this.refreshLineItems()
            }
        });

        this.contractCompanyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.client'),
            selectedContact: this.model.client,
            canEdit: false,
            displayContactsBlock: true
        });

        if (_.size(this.customFields) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.change-request-custom-fields'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.cr-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    refreshLineItems: function () {
        if (this.lineItemsView != null) {
            this.lineItemsView.options.showRevenue = this.model.get('scope') !== PJQ.constants.changeRequests.scope.INTERNAL;
            this.lineItemsView.options.showMarkup = this.lineItemsView.options.showRevenue;
            this.lineItemsView.options.copyCostToRevenue = this.model.get('revenueSource') !== PJQ.constants.changeRequests.revenueSource.MANUAL && this.lineItemsView.options.showRevenue;
            this.lineItemsView.renderLineItemsTable();
        }
    },
    renderLineItems() {
        if (this.lineItemsView) {
            this.lineItemsView.remove();
        }

        let showRevenue = this.model.get('scope') !== PJQ.constants.changeRequests.scope.INTERNAL,
            showMarkup = showRevenue;
        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.cr-line-items'),
            model: this.model,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.changeRequests.ChangeRequestLineItem,
            changeRequest: this.model,
            canEdit: this.options.canEditLineItems,
            canApplyChangeRequestCosts: this.options.isAdmin,
            canApplyChangeRequestRevenue: this.options.isAdmin && this.model.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.APPROVED,
            canSendRFQ: this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.APPROVED
                && this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.REJECTED
                && this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.VOID,
            canDelete: this.options.canEditLineItems,
            primeContract: this.options.primeContract,
            accountingMethod: this.model.get('accountingMethod'),
            showRevenue: showRevenue,
            showMarkup: showMarkup,
            copyCostToRevenue: showRevenue && this.model.get('revenueSource') !== PJQ.constants.changeRequests.revenueSource.MANUAL,
            canChangeAccountingMethod: this.options.canEditLineItems,
            financialMarkups: this.model.markupItems,
            enableSelection: true,
            showSubTotal: true,
            showGrandTotal: true,
            onCreateFromLineItems: () => {
                this.removeModal();
            },
            onLineItemChange: () => {
                this.model.isDirty = true;
            },
            onLineItemAdd: () => {
                this.model.isDirty = true;
                this.updateCounts();
            },
            onLineItemDelete: () => {
                this.model.isDirty = true;
                this.updateCounts();
            },
            onChangeOrderView: () => {
                this.removeModal();
            },
            onCommitmentView: () => {
                this.removeModal();
            },
            onSendRFQ: (data) => {
                let fnSendRFQ = (lineItems) => {
                        new PJQ.views.rfq.RFQBatchModal({
                            changeRequest: this.model,
                            project: this.options.project,
                            lineItems: lineItems,
                            projectCommitments: data.projectCommitments,
                            onSave: (res) => {
                                this.model.rfq.add(res.requests);
                                this.activateView(this.views.RFQ);
                            }
                        });
                    },
                    lineItems = this.model.lineItems.get(data.selectedIds);

                let lineItemCt = _.size(lineItems),
                    rfqItemsCt = _.filter(lineItems, (lineItem) => {
                        return lineItem.get('rfqId') > 0;
                    }).length;
                if (rfqItemsCt > 0) {
                    if (rfqItemsCt === lineItemCt) {
                        new PJQ.views.modals.YesNo({
                            header: "Send New RFQs?",
                            body: "All of the selected line items are already associated with RFQs. Would you like to create them again?",
                            onYes: () => {
                                fnSendRFQ(lineItems);
                            }
                        });
                    } else {
                        new PJQ.views.BaseModal({
                            header: "Send RFQs",
                            body: "Some of the selected line items are already associated with RFQs. Please choose from the options below.",
                            isShowOkButton: true,
                            okButtonText: "Create All (" + lineItemCt + ")",
                            onOk: () => {
                                fnSendRFQ(lineItems);
                            },
                            isShowSecondaryButton: true,
                            secondaryButtonColorClass: 'primary',
                            secondaryButtonText: "Create Missing (" + rfqItemsCt + ")",
                            onSecondary: () => {
                                fnSendRFQ(_.filter(lineItems, (lineItem) => {
                                    return !(lineItem.get('rfqId') > 0);
                                }));
                            }
                        });
                    }
                } else {
                    fnSendRFQ(lineItems);
                }
            }
        });
    },
    viewPrimeContract: function () {
        this.removeModal();
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: this.model.get('primeContractId')
            })
        });
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.cr-markups'),
            collection: this.model.markupItems,
            canEdit: false,
            defaultToAppliedMarkups: this.settings.get('defaultToAppliedMarkups'),
        });
    },
    renderRFQ: function () {
        if (this.model.isNew() || !this.options.canViewRFQs) {
            return;
        }

        this.model.fetchRFQs().then(() => {
            this.rfqDataTable = new PJQ.views.dataTables.DataTable({
                el: this.$('.cco-rfq'),
                data: this.model.rfq.models,
                isHideSearch: true,
                language: {
                    emptyTable: 'No RFQs have been created yet',
                    zeroRecords: "No RFQs matched the search criteria"
                },
                paging: false,
                order: [],
                columns: [
                    {
                        "columnData": "",
                        "data": null,
                        "title": "",
                        "width": "20px",
                        "orderable": false,
                        "searchable": false,
                        "defaultContent": '',
                        "render": function (data, type, row) {
                            let exObj = row.get('externalObject');
                            if (exObj == null) {
                                return '';
                            }

                            return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                        }
                    },
                    {
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, type, row) => {
                            return '<a class="btn-view-rfq" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }
                    },
                    {
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    },
                    {
                        "columnData": "scope",
                        "data": "attributes.scope",
                        "title": "Scope"
                    },
                    {
                        "columnData": "lastSentOn",
                        "data": "attributes.lastSentOn",
                        "title": 'Sent On',
                        "width": '90px',
                        "render": (data, type, row) => {
                            if (_.size(data) === 0) {
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }
                    },
                    {
                        "columnData": "dueDate",
                        "data": "attributes.dueDate",
                        "title": 'Due',
                        "width": '90px',
                        "render": (data, type, row) => {
                            if (_.size(data) === 0) {
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE);
                        }
                    },
                    {
                        "columnData": "contractedContact",
                        "title": "Company",
                        "titleSettings": "Company",
                        "render": (data, type, row) => {
                            return row.contractedContact?.get('companyName') ?? '';
                        }
                    },
                    {
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Quote",
                        "className": "text-align-right",
                        "render": (data, type, row) => {
                            if (row.get('responseOn') == null) {
                                return '';
                            } else if (row.get('hasCostImpact') === false) {
                                return 'No Impact';
                            }

                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }
                    },
                    {
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.rfq.rfqStatusNames[row.get('statusId')]
                        }, this)
                    },
                    {
                        "title": '',
                        "orderable": false,
                        "searchable": false,
                        resizable: false,
                        "width": "40px",
                        "className": "text-center",
                        "visible": true,
                        "render": _.bind(function (data, type, row) {
                            return '<div class="show-on-row-hover" style="min-width:40px;"><button type="button" class="btn btn-info btn-view-rfq ml-1" title="View RFQ"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                        }, this)
                    }],
                dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'View',
                            onClick: _.bind(function (row) {
                                this.viewRFQ(row.data());
                            }, this),
                            isShown: _.bind(function (row) {
                                return true;
                            }, this)
                        }
                    ]
                },
                onRowDoubleClick: _.bind(function (row) {
                    let rfq = row.data();
                    if (rfq != null) {
                        rfq.fetch({
                            success: _.bind(function () {
                                this.viewRFQ(rfq);
                            }, this)
                        });
                    }
                }, this)
            });
        })
    },
    viewRFQ: function (rfq) {
        isNew = rfq == null;
        new PJQ.views.rfq.RFQEditModal({
            model: rfq,
            changeRequest: this.model,
            onSave: _.bind(function (rfq) {
                if (isNew) {
                    this.model.rfq.add(rfq);
                    this.rfqDataTable.addRow(rfq);
                    isNew = false;

                    if (typeof this.options.onRFQAdd === 'function') {
                        this.options.onRFQAdd(rfq);
                    }
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function (rfq) {
                this.model.rfq.remove(rfq);
                this.rfqDataTable.render();
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    newRFQ: function () {
        this.viewRFQ();
    },
    viewRFQClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.rfqDataTable.getRow(target.closest('tr'));
        this.viewRFQ(row.data());
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || (this.model.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.APPROVED)) {
            $erp.remove();
            return;
        }

        let canPush = this.commitment != null && this.commitment.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.SYNCED && this.model && _.size(this.model.lineItems) > 0;
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: !this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CHANGE_REQUESTS),
            canPush: canPush,
            disablePushReason: canPush ? '' : this.model && _.size(this.model.lineItems) === 0 ? 'No line items exist for this change request' : 'The contract for this change request is not synced',
            status: this.model.erpSyncStatus()
        });
    },
    pushERP: function (callback) {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_CHANGE_REQUESTS)) {
            this.erpIntegration.pushChangeRequest(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Request pushed to ERP'
                });

                if (callback && typeof callback === 'function') {
                    callback();
                } else {
                    this.render();
                }
            }, this));
        }
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Request removed from ERP approval'
                });
                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.erpIntegration.unlinkChangeRequest(this.model, _.bind(function (success) {
                if (success) {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Change Request unlinked from ERP'
                    });
                    this.render();
                }
            }, this));
        }
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    exportRevenue: function () {
        this.export(true, false);
    },
    exportCosts: function () {
        this.export(false, true);
    },
    exportClicked: function () {
        this.export();
    },
    export: function (withRevenue = true, withCosts = true) {
        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'changerequests',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ], [{
                parameter: 'showCosts',
                value: withCosts
            }, {
                parameter: 'showRevenue',
                value: withRevenue
            }]), {isAPIv2: true});
        };

        if (this.options.canEdit) {
            this.save(callback);
        } else {
            callback();
        }
    },
    saveEmail: function () {
        this.save(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Change Request saved successfully'
            });

            this.email();
        }, this));
    },
    savePush: function () {
        this.save(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Change Request saved successfully'
            });

            this.pushERP(() => {
                this.removeModal()
            });
        }, this));
    },
    submitChangeRequest: function () {
        this.model.submit(null, _.bind(function (result) {
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'Change Request submitted successfully'
                });

                this.removeModal();
            }
        }, this));
    },
    saveChangeRequest: function () {
        this.save(() => {
            PJQ.notifications.notify.successNotify({
                message: 'Change Request saved successfully'
            });

            this.removeModal();
        });
    },
    validate: function () {
        let isValid = true;

        if (this.customFieldsForm != null && !this.customFieldsForm.validate())
            isValid = false;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), true);
        if ((!this.model.isNew() || this.checkFieldRequired('number')) && _.size(this.model.get('number')) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-number'), false);
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.change-request-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;

            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate())
            return;

        let newMarkupLines = this.model.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.model.lineItems.remove(newMarkupLines);

        this.model.save({
            customFields: this.customFieldsForm != null ? this.customFieldsForm.getChanged() : null,
            lineItems: this.model.lineItems.toJSON(),
            markupItems: this.model.markupItems.toJSON()
        }, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('changeRequestChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    deleteChangeRequest: function () {
        let changeRequestId = this.model.id,
            hasAssociatedLineItems = _.size(_.filter(this.model.lineItems.models, function (lineItem) {
                return lineItem.get('ccoId') || lineItem.get('pccoId') || lineItem.get('commitmentId');
            }, this)) > 0;
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: hasAssociatedLineItems ? "This Change Request has line items that are associated with other line items. Deleting it will also delete all associated line items. Are you sure you want to delete this Change Request?" : "Are you sure you want to delete this Change Request?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Change Request deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(changeRequestId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Change Request has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Change Request",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Change Request email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveChangeRequest();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.changeRequests.ChangeRequestsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-requests-list'),
        subTemplates: {
            totals: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-requests-totals')
        },
        changeRequestId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-add-change-request': 'addChangeRequest',
        'click .btn-delete-change-request': 'deleteChangeRequestClicked',
        'click .btn-export': 'exportChangeRequestList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.changeRequests.ChangeRequests(null, {
                projectId: this.options.project.get('projectId'),
                groupId: this.options.groupId ? this.options.groupId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchChangeRequestCustomFields();
        this.userSettings = await PJQ.app.session.fetchChangeRequestUserSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.settings = await this.options.project.fetchChangeRequestSettings();

        if (this.settings.get('enableStandardListView')) {
            this.subJobs = await this.options.project.fetchSubJobs();
            this.costCodes = await this.options.project.fetchCostCodes();
            this.costTypes = await this.options.project.fetchCostTypes();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
        this.options.canAdd = PJQ.app.session.project.hasPermission('changeRequests.canAdd');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader,
            canAdd: this.options.canAdd
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('changeRequestChanged');
        PJQ.app.session.project.on('changeRequestChanged', function (changeRequest) {
            this.collection.add(changeRequest);
            this.render();
        }, this);

        if (this.options.rfqId > 0) {
            let rfq = new PJQ.models.rfq.RFQ({
                id: this.options.rfqId
            });

            rfq.fetch({
                success: _.bind(function () {
                    this.viewRFQ(rfq);
                }, this)
            });
        } else if (this.options.changeRequestId > 0) {
            let initChangeRequest = this.collection.get(this.options.changeRequestId);
            if (initChangeRequest != null) {
                this.viewChangeRequest(initChangeRequest);
                this.options.changeRequestId = null;
            }
        }
        this.renderStats();
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        if (this.collection == null || !this.collection.isFetched) {
            $totals.empty();
            return;
        }

        totals = this.collection.getTotalAmountsByStatus();
        this.renderSubTemplate(false, this.options.subTemplates.totals, $totals, {
            pending: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PENDING.name],
            projected: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PROJECTED.name],
            approved: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.APPROVED.name]
        });
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.changeRequests.ChangeRequestDataTable({
            el: this.$('.change-requests-data'),
            rowId: "cid",
            data: this.collection.models,
            orderCookie: PJQ.constants.cookies.CHANGE_REQUEST_ORDER_COOKIE,
            isAdmin: this.options.isAdmin,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            subJobs: this.subJobs,
            companySettings: this.settings,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin,
                    canAdd: this.options.canAdd,
                    isStandardListView: this.settings.get('enableStandardListView'),
                };
            }, this),
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.changeRequests.view.CHANGE_REQUESTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: () => {
                this.userSettings.save();
            },
            onViewChangeRequest: (changeRequest) => {
                this.viewChangeRequest(changeRequest);
            },
            onRowDoubleClick: (row) => {
                if (row.data() && _.size(row.data()) > 0) {
                    this.viewChangeRequest(row.data());
                }
            },
            onCreateFromLineItems: async (lineItems) => {
                await this.collection.fetch();
                this.dataTable.resetData(this.collection.models);
            },
            contextMenuOptions: {
                selector: 'tr[id]:not(.child-row)',
                actions: [
                    {
                        name: 'View',
                        onClick: (row) => {
                            this.viewChangeRequest(row.data());
                        }
                    }
                ]
            }
        });
    },
    exportChangeRequestList: function (e) {
        if (this.options.project == null) {
            return;
        }

        let type = 'excel',
            orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.CHANGE_REQUEST_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            columns = this.userSettings.getSettings(PJQ.constants.changeRequests.view.CHANGE_REQUESTS).columns;

        // There is an extra column in the datatable for icons. Subtract 1 to get the correct order.
        if(order != null && Array.isArray(order[0]) && typeof order[0][0] === 'number'){
            order[0][0] = order[0][0] - 1;
        }

        // Some of the columns have different names than the report center definitions. This will change them to the correct names.
        let changeTerms = {
            "createdOn": "created",
            "client.companyName": "client",
            "primeContract": "contract",
            "amount": "cost"
        };
        columns = _.map(columns, column => changeTerms[column] || column);

        let report = new PJQ.models.reports.NewReport({
            type: PJQ.constants.reports.reportTypes.CHANGE_REQUEST.type,
            projectId: this.options.project ? this.options.project.id : null,
            options: {
                columns: columns,
                columnOrder: order
            }
        });
        report.export({format: type}).then(() => {

        });
    },
    viewChangeRequestClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewChangeRequest(row.data());
    },
    viewRFQ(rfq) {
        new PJQ.views.rfq.RFQEditModal({
            model: rfq,
            project: this.options.project
        });
    },
    viewChangeRequest: function (changeRequest, primeContract) {
        let isNew = primeContract != null;
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            model: changeRequest,
            primeContract: primeContract,
            onSave: _.bind(function (changeRequest) {
                if (isNew) {
                    this.collection.add(changeRequest);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (changeRequest) {
                this.collection.remove(changeRequest);
                this.renderView();
            }, this)
        });
    },
    addChangeRequest: function () {
        new PJQ.views.primeContracts.SelectPrimeContractsModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Contract you would like to create a Change Request for.',
            filterStatuses: PJQ.constants.primeContracts.primeContractStatus.APPROVED,
            onSave: _.bind(function (contract) {
                this.viewChangeRequest(null, contract);
            }, this)
        });
    },
    deleteChangeRequestClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChangeRequest(row);
    },
    deleteChangeRequest: function (row) {
        if (row != null) {
            let changeRequest = row.data();
            if (changeRequest != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Change Request",
                    body: "Are you sure you want to delete this Change Request?",
                    onDelete: _.bind(function () {
                        changeRequest.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(changeRequest);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.changeRequests.ChangeRequestSettingsModal({
            changeRequestsView: this,
            settings: this.settings,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    }
});

PJQ.views.changeRequests.SelectChangeRequestsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-select-change-requests'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {
        "change .select-change-request": "selectChangeRequest",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
        this.selectedChangeRequests = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.changeRequests.ChangeRequests(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (this.collection.isFetched) {
            this.render();
        } else {
            this.collection.fetch({
                success: _.bind(function () {
                    this.changeRequests = this.collection.models;

                    if (this.options.primeContractId) {
                        this.changeRequests = _.filter(this.changeRequests, function (model) {
                            return model.get('primeContractId') === this.options.primeContractId
                        }, this);
                    }

                    if (this.options.filterStatuses) {
                        this.changeRequests = _.filter(this.changeRequests, function (model) {
                            let statusId = model.get('statusId');

                            if (_.isArray(this.options.filterStatuses)) {
                                return _.includes(this.options.filterStatuses, statusId);
                            } else if (_.isNumber(this.options.filterStatuses)) {
                                return this.options.filterStatuses === statusId;
                            }

                            return false;

                        }, this);
                    }
                    this.render();
                }, this)
            });
        }

    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.change-requests-table'),
            data: this.changeRequests,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-change-request"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.client.companyName",
                    "title": "Client",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(data);
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectChangeRequest: function (e) {
        let target = $(e.currentTarget),
            changeRequest = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-change-request').not(target).text('Select').prop('checked', false);
            if (changeRequest.get('isSelected')) {
                changeRequest.set('isSelected', false);
                this.selectedChangeRequest = null;
            } else {
                changeRequest.set('isSelected', true);
                this.selectedChangeRequest = changeRequest;
                this.collection.get(changeRequest.id);
                _.each(this.collection.models, _.bind(function (dtChangeRequest) {
                    if (changeRequest.id !== dtChangeRequest.id)
                        dtChangeRequest.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeRequest == null);

            if (typeof this.options.onChangeRequestSelected === 'function') {
                this.options.onChangeRequestSelected(this.selectedChangeRequest);
            }
        } else {
            if (changeRequest.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                changeRequest.set('isSelected', false);
                this.selectedChangeRequests = _.reject(this.selectedChangeRequests, function (selChangeRequest) {
                    return selChangeRequest.id === changeRequest.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                changeRequest.set('isSelected', true);
                this.selectedChangeRequests.push(changeRequest);
            }
            this.$('.btn-save').attr('disabled', this.selectedChangeRequests == null);

            if (typeof this.options.onChangeRequestSelected === 'function') {
                this.options.onChangeRequestSelected(this.selectedChangeRequests);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedChangeRequest ? this.selectedChangeRequest : this.selectedChangeRequests);
            this.removeModal();
        }
    }
});
PJQ.views.changeRequests.ChangeRequestManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-request-management'),
        subTemplates: {
            changeRequestTotals: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-requests-totals')
        },
        changeRequestId: null,
        rfqId: null,
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
        'click .btn-settings': 'settings'
    },
    beforeFirstRender: function () {
        this.options.canViewChangeRequests = PJQ.app.session.project.hasPermission('changeRequests.canView');
        this.options.canViewRFQs = PJQ.app.session.project.hasPermission('changeRequests.canViewRFQs');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            changeRequests: this.changeRequests,
            rfqs: this.rfqs,
            canViewChangeRequests: this.options.canViewChangeRequests,
            canViewRFQs: this.options.canViewRFQs,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        this.changeRequestsView = null;
        this.rfqView = null;

        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.changeRequestId > 0 && this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        } else if (this.options.rfqId > 0 && this.options.canViewRFQs) {
            this.activateTab('rfq');
        } else if (this.options.canViewChangeRequests) {
            this.activateTab('changerequests');
        } else {
            this.activateTab('rfq');
        }
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        switch (this.activeView) {
            case 'changerequests':
                if (this.changeRequestsView == null || this.changeRequestsView.collection == null || !this.changeRequestsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeRequestsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.changeRequestTotals, $totals, {
                    pending: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.PROJECTED.name],
                    approved: totals[PJQ.constants.changeRequests.changeRequestStatusBuckets.APPROVED.name]
                });
                break;
            default:
                $totals.empty();
                return;
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;
        switch (tab ? tab.toLowerCase() : null) {
            case 'rfq':
                tab = 'RFQ_List';
                this.renderRFQView();
                break;
            default:
                tab = 'CR_List';
                this.renderChangeRequestsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;

        this.renderStats();
    },
    tabActivated: function (e) {
        if (this.isActivating) {
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#CR_List':
                vw = 'changerequests';
                this.$('.btn-settings').show();
                break;
            case '#RFQ_List':
                vw = 'rfq';
                this.$('.btn-settings').hide();
                break;
        }
        this.activateTab(vw);
    },
    renderChangeRequestsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/changerequests', {
            trigger: false
        });
        if (this.changeRequestsView == null && this.options.canViewChangeRequests) {
            let fnRender = () => {
                this.changeRequestsView = new PJQ.views.changeRequests.ChangeRequestsList({
                    el: this.$('.change-requests-pane'),
                    project: PJQ.app.session.project,
                    changeRequestId: this.options.changeRequestId,
                    collection: this.changeRequests,
                    hideHeader: true,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.changeRequestId = null;
            };

            if (this.changeRequests == null) {
                this.changeRequests = new PJQ.collections.changeRequests.ChangeRequests(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeRequests.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderRFQView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/changerequests/rfq', {
            trigger: false
        });
        if (this.rfqView == null) {
            let fnRender = () => {
                this.rfqView = new PJQ.views.rfq.RFQList({
                    el: this.$('.rfq-pane'),
                    project: PJQ.app.session.project,
                    rfqId: this.options.rfqId,
                    collection: this.rfqs,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.rfqId = null;
            };

            if (this.rfqs == null) {
                this.rfqs = new PJQ.collections.rfq.RFQs(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.rfqs.fetch({
                    success: () => {
                        fnRender();
                    }
                });
            } else {
                fnRender();
            }
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#CR_List':
                if (this.changeRequestsView != null) {
                    this.changeRequestsView.editSettings();
                }
                break;
        }
    },
    updateTotalsCount: function () {
        let $changeRequestsSpan = this.$('.commitments-total'),
            $rfqSpan = this.$('.rfq-total');

        $changeRequestsSpan.text(_.size(this.changeRequests.models));
        $rfqSpan.text(_.size(this.rfq.models));
    }
});
//Models
PJQ.models.changeRequests.ChangeRequest = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'changerequests',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.primeContract) {
            this.primeContract = model.primeContract;
        }

        this.lineItems = new PJQ.collections.changeRequests.ChangeRequestLineItems(model.lineItems);
        this.attachments = new PJQ.collections.changeRequests.ChangeRequestAttachments(model.attachments);
        this.rfq = new PJQ.collections.rfq.RFQs(model.rfq, {
            projectId: model.projectId,
            changeRequestId: model.id
        });

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model && model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        } else {
            this.client = null;
        }

        return model;
    },
    fetchRFQs(callback) {
        return new Promise((resolve, reject) => {
            if (this.rfq != null && this.rfq.isFetched) {
                if (typeof callback === 'function') {
                    callback(this.rfq);
                }
                resolve(this.rfq);
                return;
            }

            this.rfq = new PJQ.collections.rfq.RFQs([], {
                projectId: this.get('projectId'),
                changeRequestId: this.id
            });
            this.rfq.fetch({
                success: () => {
                    if (typeof callback === 'function') {
                        callback(this.rfq);
                    }
                    resolve(this.rfq);
                },
                error: () => {
                    if (typeof callback === 'function') {
                        callback(this.rfq);
                    }
                    reject(new Error("Failed to fetch change request rfqs"));
                }
            })
        });
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                // TODO: QBO Integration URL
                return 'https://app.sandbox.qbo.intuit.com/app/purchaseorder?txnId=' + externalId;
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function (markups, costOnly) {
        if (costOnly) {
            return this.get('amount') + this.get('markupAmount');
        }

        return this.get('revenue') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        let costsOnly = this.get('scope') === PJQ.constants.changeRequests.scope.INTERNAL;
        return this.getSubTotal(null, costsOnly) + this.get('taxAmount');
    },
    canAttachLineItemCost: function (lineItem) {
        if (this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.VOID
            || this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.REJECTED) {
            return false;
        }

        return !(lineItem.get('costLineItemId') > 0);
    },
    canAttachLineItemRevenue: function (lineItem) {
        if (this.get('statusId') !== PJQ.constants.changeRequests.changeRequestStatus.APPROVED
            || this.get('scope') === PJQ.constants.changeRequests.scope.INTERNAL) {
            return false;
        }

        return !(lineItem.get('revenueLineItemId') > 0);
    },
    canSendRFQ: function () {
        return this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.APPROVED
            || this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.REJECTED
            || this.get('statusId') === PJQ.constants.changeRequests.changeRequestStatus.VOID;
    }
});

PJQ.models.changeRequests.ChangeRequestLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.changeRequests.ChangeRequestAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.changeRequests.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.changeRequests.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.changeRequests.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'changerequests'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'settings'
            }
        ]);
    },
    parseNumberFormat: function (numberFormat, project, additionalData) {
        let result = '';

        _.each(numberFormat, _.bind(function (token) {
            if (token.isText)
                result += token.label;
            else if (token.token === 'today')
                result += this.parseDateFormatToken(new Date(), token.dateFormatId);
            else if (token.token === 'project.projectId')
                result += project.get('projectId').toString();
            else if (token.token === 'project.startDate')
                result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false), token.dateFormatId);
            else if (token.token === 'counter')
                result += additionalData.counter.toString().padStart(4, '0');
            else if (token.token.startsWith('fieldValue')) {
                let fieldNumber = parseInt(token.token.substr(10));
                _.each(PJQ.app.session.project.customFields.models, _.bind(function (customField) {
                    if (customField.get('fieldNumber') === fieldNumber) {
                        _.each(PJQ.app.session.project.get('customFields'), _.bind(function (fieldValue) {
                            if (fieldValue.fieldNumber === fieldNumber) {
                                switch (customField.get('fieldType')) {
                                    case PJQ.constants.customFields.fieldTypes.TEXT:
                                    case PJQ.constants.customFields.fieldTypes.INT:
                                        result += fieldValue.value.toString();
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                                        _.each(customField.get('choices'), _.bind(function (choice) {
                                            if (choice.id === fieldValue.value)
                                                result += choice.choiceName;
                                        }, this));
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATE:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, false), token.dateFormatId);
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, true), token.dateFormatId);
                                        break;
                                }
                            }
                        }, this));
                    }
                }, this));
            }
        }, this));

        return result.replaceAll(' ', '');
    },
    parseDateFormatToken: function (input, dateFormatId) {
        let result = null;

        switch (dateFormatId) {
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.DD:
                result = input.getDate().toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MM:
                result = (input.getMonth() + 1).toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YY:
                result = input.getFullYear().toString().substr(2);
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YYYY:
                result = input.getFullYear().toString();
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MMDDYYYY:
                result = PJQ.helpers.dateHelpers.getDateString(input, PJQ.helpers.dateHelpers.dateFormats.URL_DATE, false).replaceAll('-', '');
                break;
        }

        return result;
    }
});

PJQ.models.changeRequests.ChangeRequestUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

//Collections
PJQ.collections.changeRequests.ChangeRequests = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.ChangeRequest,
    endpoint: function () {
        let params = [];
        if (this.options.groupId && this.options.costTypeId) {
            params.push({
                parameter: 'groupId',
                value: this.options.groupId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'changerequests'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.changeRequests.changeRequestStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (changeRequest) {
                if (bucket.statuses.indexOf(changeRequest.get('statusId')) !== -1) {
                    total += changeRequest.get('totalAmount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.changeRequests.ChangeRequestLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.ChangeRequestLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests',
                value: this.options.changeRequestId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.changeRequests.ChangeRequestAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.ChangeRequestAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests',
                value: this.options.changeRequestId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.changeRequests.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.CustomField,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'changerequests'
            },
            {
                endpoint: 'customfields'
            }
        ], params);
    }
});

PJQ.collections.changeRequests.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.changeRequests.CustomFieldChoice
});
PJQ.views.changeRequests.ChangeRequestSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-change-request-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.changeRequestsView.userSettings;
        this.customFields = this.options.changeRequestsView.customFields;
    },
    beforeRender: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.options.settings = this.options.settings ? this.options.settings : await this.options.project.fetchChangeRequestSettings();
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.changeRequestsView.dataTable.getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings,
            settings: this.options.settings
        }
    },
    afterRender: function () {
        let defaultFilter = {};
        defaultFilter = this.userSettings.get('defaultStatusFilter');

        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            isGrouped: false,
            defaultValue: defaultFilter,
            onHide: _.bind(function () {
                this.options.defaultStatusFilter = this.defaultFilterSelectPicker.getValue();
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.changeRequests.view.CHANGE_REQUESTS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.changeRequests.ChangeRequestUserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        this.rowsPerPage.setValue(this.currentView.rowsPerPage);

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        }
                        else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    },
});
PJQ.views.budget.ProjectCostCodeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'project-cost-code-settings')
    },
    events: {},
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.options.project != null) {
            this.budget = await this.options.project.fetchBudget();
            this.subJobs = await this.options.project.fetchSubJobs();
            this.costCodes = await this.options.project.fetchCostCodes();

            await this.options.project.fetchERPObject();
        } else {
            this.costCodes = await PJQ.app.session.fetchCostCodes();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            budget: this.budget,
            isFetched: this.isFetched,
            enableSubJobs: _.size(this.subJobs) > 0 || this.options.enableSubJobs
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.views.budget.CostCodeSettings({
            el: this.$('.cost-codes-outer'),
            project: this.options.project,
            enableSubJobs: this.options.enableSubJobs,
            enableSubJobsChanged: (enableSubJobs) => {
                this.options.enableSubJobs = enableSubJobs;
                this.render();
            },
            onPullERP: () => {
                this.render();
            }
        });

        if (_.size(this.subJobs) > 0 || this.options.enableSubJobs) {
            new PJQ.views.budget.SubJobSettings({
                el: this.$('.sub-jobs-outer'),
                project: this.options.project
            });
        }
    }
});

PJQ.views.budget.CostCodeSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-cost-code-settings'),
        maxWidth: 800,
        pickerOptions: {},
        onPullERP: null
    },
    events: {
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            project: this.options.project,
            subJob: this.options.subJob
        };
    },
    afterRender: function () {
        new PJQ.views.budget.CostCodeSettings({
            el: this.$('.cost-code-settings'),
            project: this.options.project,
            subJob: this.options.subJob,
            onPullERP: this.options.onPullERP
        });
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.budget.CostCodeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-code-settings'),
        enableSubJobsChanged: null,
        onPullERP: null
    },
    events: {
        'click .btn-import-cost-codes': 'importClicked',
        'click .btn-add-cost-code': 'addClicked',
        'click .btn-add-standard': 'addStandard',
        'click .btn-edit-cost-code': 'editClicked',
        'click .btn-delete-cost-code': 'deleteClicked',
        'click .btn-delete-all': 'deleteAll',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-pull-erp': 'pullERP',
        'change .cb-enable-sub-jobs': 'enableSubJobsChanged'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project != null ? this.options.project : PJQ.app.session.project;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.options.project != null) {
            this.budget = await this.options.project.fetchBudget();
            this.subJobs = await this.options.project.fetchSubJobs();
            this.allCostCodes = await this.options.project.fetchCostCodes();

            if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
                await this.options.project.fetchERPObject();
            }
        } else {
            this.allCostCodes = await PJQ.app.session.fetchCostCodes();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return false;
        }

        if (this.costCodes == null) {
            let cc;
            if (this.options.subJob != null) {
                cc = this.allCostCodes.where({subJobId: this.options.subJob.id});
            } else {
                cc = this.allCostCodes.where({subJobId: null});
            }
            this.costCodes = new PJQ.collections.budget.CostCodes(cc, {
                projectId: this.options.project ? this.options.project.id : null,
                subJobId: this.options.subJob ? this.options.subJob.id : null
            });
        }
    },
    renderData: function () {
        return {
            project: this.options.project,
            subJobs: this.subJobs,
            subJob: this.options.subJob,
            costCodes: this.costCodes,
            isFetched: this.isFetched,
            erpIntegration: this.erpIntegration,
            enableSubJobs: this.options.enableSubJobs,
            budget: this.budget
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderCostCodeTable();
        this.renderERP();
    },
    renderCostCodeTable: function () {
        let hasDivisions = this.costCodes.hasDivisions(),
            data;
        if (hasDivisions) {
            let divisionNames = this.costCodes.getDivisions().sort(PJQ.helpers.sortHelpers.sortAlphaNum);
            data = _.map(divisionNames, (division, i) => {
                return {
                    cid: PJQ.helpers.guid(),
                    division: _.size(division) > 0 ? division : 'No Division',
                    isFetched: true,
                    sortOrder: i
                };
            })
        } else {
            data = this.costCodes.models;
        }

        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTable({
            el: this.$(".cost-codes-table"),
            data: data,
            afterDataTableRender: _.bind(function () {
                // if (hasDivisions && this.dataTable && this.dataTable.dataTable) {
                //     let self = this;
                //     this.dataTable.dataTable.row().$('.toggle-row').each(function () {
                //         self.dataTable.childRowToggle({currentTarget: this});
                //     });
                // }
            }, this),
            getRowChildTable: _.bind(function (childOpts) {
                if (!hasDivisions) {
                    return null;
                }
                return this.getDataTable(childOpts)
            }, this),
            getRowChildData: _.bind(function (row) {
                if (!hasDivisions) {
                    return null;
                }

                let costCode = row.data();
                return _.sortBy(this.costCodes.getForDivision(costCode.division), function (costCode) {
                    return costCode.get('code');
                });
            }, this),
            language: {
                zeroRecords: 'Click "Add Cost Code" to create a new Cost Code'
            }
        });
    },
    getDataTable: function (dtOptions) {
        let columns,
            hasDivisions = this.costCodes.hasDivisions();
        if (dtOptions.parentData == null && hasDivisions) {
            dtOptions = _.defaults(dtOptions, {
                order: [1, 'asc'],
                isChildTables: true
            });
            columns = [
                {
                    "width": "15px",
                    "columnData": "division",
                    "data": null,
                    "title": "",
                    "className": "dt-center",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return '<i class="fal fa-plus-circle toggle-row" data-id="' + data.id + '"></i>';
                    }
                },
                {
                    "title": "Division",
                    "data": "division",
                    "orderable": true,
                    "render": function (data, type, row) {
                        if (type === 'sort' || type === 'type') {
                            return row.sortOrder;
                        }
                        return data;
                    }
                }
            ];
        } else {
            dtOptions = _.defaults(dtOptions, {
                order: [1, 'asc'],
                onRowDoubleClick: _.bind(function (row) {
                    this.editCostCode(row.data());
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            onClick: (row) => {
                                this.editCostCode(row.data());
                            }
                        },
                        {
                            name: 'Delete',
                            isDanger: true,
                            isShown: (row) => {
                                return null == this.budget.lineItems.findWhere({costCodeId: row.data().id});
                            },
                            onClick: (row) => {
                                this.deleteCostCode(row.data());
                            }
                        }
                    ]
                },
            });
            columns = [
                {
                    "width": "15px",
                    "columnData": "division",
                    "data": null,
                    "title": "",
                    "className": "dt-center",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (row.isERPSynced()) {
                            return '<div class="ml-1">' + PJQ.helpers.erp.getERPIcon(row.erpSyncStatus()) + '</div>';
                        }
                        return '';
                    }
                },
                {
                    "title": "Code",
                    "data": "attributes.code",
                    "width": "100px",
                    "render": (data, type, model) => {
                        if (type === 'sort' || type === 'type') {
                            return PJQ.helpers.costCodes.getDivisionSortValue(data);
                        }
                        return '<a class="btn-edit-cost-code" href="javascript:void(0)">' + data + '</a>';
                    }
                },
                {
                    "title": "Name",
                    "data": "attributes.name"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": (data, type, model) => {
                        let canDelete = null == this.budget || null == this.budget.lineItems.findWhere({costCodeId: model.id}),
                            res = '<div class="text-align-right show-on-row-hover" style="width:80px;"><button type="button" class="btn btn-info btn-edit-cost-code"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-cost-code ml-1"><span class="fal fa-trash"></span></button>';
                        } else {
                            res += '<button type="button" disabled class="btn btn-danger ml-1" title="This cost code has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ];
        }

        dtOptions.rowId = "cid";
        dtOptions.paging = false;
        dtOptions.columns = columns;
        return new PJQ.views.dataTables.DataTable(dtOptions);
    },
    importClicked: function () {
        new PJQ.views.budget.UploadCostCodesModal({
            costCodes: this.costCodes,
            project: this.options.project,
            subJob: this.options.subJob,
            onSave: _.bind(function (costCodes) {
                this.costCodes.add(costCodes);
                this.render();
            }, this)
        });
    },
    enableSubJobsChanged: function (e) {
        this.options.enableSubJobs = $(e.currentTarget).prop('checked');
        if (typeof this.options.enableSubJobsChanged === 'function') {
            this.options.enableSubJobsChanged(this.options.enableSubJobs);
        }
    },
    renderERP: function () {
        if (this.erpIntegration == null || (this.options.project != null && !this.options.project.isERPSynced())) {
            return;
        }

        let hasStaleCostCodes = null != _.find(this.costCodes.models, function (costCode) {
                return costCode.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.PENDING
                    || costCode.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.STALE;
            }),
            pushSupported,
            pullSupported,
            status;
        if (this.options.project) {
            let projectSyncStatus = this.options.project.erpSyncStatus(),
                isProjectReviewing = projectSyncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING;
            status = hasStaleCostCodes && !isProjectReviewing ? PJQ.constants.integrations.erp.syncStatuses.STALE : projectSyncStatus;
            pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES);
            pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PROJECT_COST_CODES);
        } else {
            pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMPANY_COST_CODES);
            status = pushSupported && hasStaleCostCodes ? PJQ.constants.integrations.erp.syncStatuses.STALE : PJQ.constants.integrations.erp.syncStatuses.SYNCED;
            // We've changed how cost codes are handled. You now pull cost codes from ERP Admin.
            pullSupported = false;
        }
        this.erpButtons = PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            canPush: hasStaleCostCodes,
            disablePushReason: !hasStaleCostCodes ? 'All cost code changes have been pushed to ERP' : '',
            pullSupported: pullSupported,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pushERP: function () {
        if ((this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES))
            || (this.options.project == null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMPANY_COST_CODES))) {
            this.erpButtons?.pushing(true);
            this.erpIntegration.pushCostCodes({
                project: this.options.project
            }, (res, err) => {
                this.erpButtons?.pushing(false);
                if (res == null) {
                    return;
                }
                this.allCostCodes.reset(res);
                this.costCodes = null;
                PJQ.notifications.notify.successNotify({
                    message: this.options.project ? 'Project Cost Codes pushed for ERP approval' : 'Cost Codes successfully pushed to ERP'
                });
                this.render();
            });
        }
    },
    undoPushERP: function () {
        if (this.options.project.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.options.project, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Project Cost Codes successfully removed from ERP approval'
                });
                this.render();
            }, this));
        }
    },
    pullERP: function () {
        if ((this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PROJECT_COST_CODES))
            || (this.options.project == null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_COST_CODES))) {
            this.erpButtons?.pulling(true);
            this.erpIntegration.pullCostCodes(this.options.project, (newCostCodes, err) => {
                this.erpButtons?.pulling(false);
                if (newCostCodes == null) {
                    return;
                }

                this.allCostCodes.reset(newCostCodes);
                this.costCodes = null;
                PJQ.notifications.notify.successNotify({
                    message: _.size(newCostCodes).toString() + ' Cost Codes pulled from ERP'
                });
                if (typeof this.options.onPullERP === 'function') {
                    this.options.onPullERP();
                } else {
                    this.render();
                }
            });
        }
    },
    addStandard: function () {
        new PJQ.views.budget.CostCodePickerModal({
            title: 'Add Cost Codes To Project',
            pickerOptions: {
                showDisabledAsSelected: true,
                isCostCodeDisabled: _.bind(function (costCode) {
                    return null != _.find(this.costCodes.models, function (pCostCode) {
                        return pCostCode.get('code').toLowerCase() === costCode.get('code').toLowerCase();
                    })
                }, this)
            },
            onSave: _.bind(function (newCostCodes) {
                if (_.size(newCostCodes) > 0) {
                    this.costCodes.saveBulk(newCostCodes, this.options.subJob ? this.options.subJob.id : null, _.bind(function (savedCostCodes) {
                        if (savedCostCodes) {
                            if (this.options.project) {
                                this.options.project.costCodes.add(savedCostCodes);
                            }
                            this.render();
                            PJQ.notifications.notify.successNotify({
                                message: _.size(savedCostCodes).toString() + ' Company Cost Codes added to project'
                            });
                        } else {
                            // todo: error
                        }
                    }, this));
                }
            }, this)
        });
    },
    addClicked: function () {
        this.editCostCode(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let costCode = this.costCodes.get(id);
            if (costCode != null) {
                this.editCostCode(costCode);
            }
        }
    },
    editCostCode: function (costCode) {
        new PJQ.views.budget.EditCostCodeModal({
            model: costCode,
            project: this.options.project,
            subJob: this.options.subJob,
            onSave: _.bind(function (costCode) {
                this.costCodes.add(costCode);
                if (this.options.project) {
                    this.options.project.costCodes.add(costCode);
                }
                this.render();
            }, this),
            // onClose: _.bind(function (costCode) {
            //     this.dataTable.refresh();
            // }, this),
            onDelete: _.bind(function (costCode) {
                if (costCode.id > 0) {
                    this.deleteCostCode(costCode);
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('tr').attr('id'),
            costCode = this.costCodes.get(cid);
        this.deleteCostCode(costCode);
    },
    deleteAll: function () {
        let msg,
            ct = _.size(this.costCodes.models);
        if (ct === 0) {
            return;
        }

        if (this.options.project != null) {
            msg = 'Are you sure you want to delete all Cost Codes from this project? This will only delete cost codes which are not on the budget.';
        } else {
            msg = 'Are you sure you want to delete all <strong>' + ct + '</strong> Company Cost Codes?';
        }
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: msg,
            onDelete: _.bind(function () {
                this.costCodes.deleteAll(_.bind(function (result) {
                    if (this.options.project != null) {
                        this.options.project.costCodes.reset(result);
                        this.costCodes.reset(result);
                    } else {
                        this.costCodes.reset([]);
                    }
                    PJQ.notifications.notify.successNotify({
                        message: (ct - _.size(this.costCodes.models)).toString() + ' Cost Codes deleted'
                    });
                    this.render();
                }, this));
            }, this)
        });
    },
    deleteCostCode: function (costCode) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Cost Code?",
            onDelete: _.bind(function () {
                costCode.destroy({
                    notify: false,
                    success: _.bind(function () {
                        if (this.options.project) {
                            this.options.project.costCodes.remove(costCode);
                        }
                        this.costCodes.remove(costCode);
                        this.render();
                    }, this),
                    error: function (model, xhr) {
                        if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_code_with_line_item') {
                            PJQ.notifications.notify.warningNotify({
                                message: 'This cost code cannot be deleted because it is being used on budget line items.'
                            });
                        }
                    }
                });
            }, this)
        });
    }
});

PJQ.views.budget.EditCostCodeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-cost-code'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete',
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent'
    },
    beforeModalCreated: async function () {
        if (this.model == null) {
            this.model = new PJQ.models.budget.CostCode({
                projectId: this.options.project ? this.options.project.id : null,
                subJobId: this.options.subJob ? this.options.subJob.id : null
            });
        }

        let fnRender = _.bind(function () {
            PJQ.app.session.fetchCostTypes(_.bind(function (costTypes) {
                this.costTypes = costTypes;
                this.isFetched = true;
                this.render();
            }, this));
        }, this);

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if(this.erpIntegration != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.DISABLE_EDIT_COST_CODE_TYPE_FILTER)) {
            this.options.disableEditingCostTypeFilter = true;
        }

        if (this.options.project != null) {
            if(this.erpIntegration != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PROJECT_COST_CODES) && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES)) {
                this.options.disableEditingCostCodeName = true;
            }

            this.options.project.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                fnRender();
            }, this));
        } else {
            if(this.erpIntegration != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_COST_CODES) && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COMPANY_COST_CODES)) {
                this.options.disableEditingCostCodeName = true;
            }

            PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                fnRender();
            }, this));
        }
    },
    renderData: function () {
        return {
            model: this.model,
            costTypes: this.costTypes,
            isFetched: this.isFetched,
            disableEditingCostCodeName: this.options.disableEditingCostCodeName
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'select'
            ]
        });

        let divisions = this.costCodes.getDivisions();
        new PJQ.inputs.AutocompleteInput({
            el: this.$('.input-division'),
            source: divisions
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-types'),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'All Cost Types',
            isDisabled: this.options.disableEditingCostTypeFilter,
            defaultValue: this.model.get('costTypeIds')
        });
    },
    formatPercent: function (e) {
        let val = $(e.currentTarget).val();
        if (val !== "") {
            $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent(val));
        }
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let $code = this.$('.input-code'),
            code = $code.val(),
            subJobId = this.model.get('subJobId'),
            isCodeValid = true,
            errorText = '';
        if (_.size(code) === 0) {
            isCodeValid = false;
        } else if (null != _.find(this.costCodes.models, _.bind(function (cc) {
            return cc.id !== this.model.id && (subJobId == null || subJobId === cc.get('subJobId')) && cc.get('code').toLowerCase() === code.toLowerCase();
        }, this))) {
            isCodeValid = false;
            errorText = 'This code already exists'
        }
        PJQ.helpers.inputHelpers.setInputError($code, isCodeValid, {
            errorText: errorText
        });
        return isCodeValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.costCodes.add(this.model);
                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Cost Code saved'
                    });
                }, this)
            });
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Cost Code?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.budget.UploadCostCodesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-upload-cost-codes'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save-new': 'saveNew',
        'click .btn-save-all': 'saveAll'
    },
    renderData: function () {
        return {
            data: this.data,
            isSaving: this.isSaving
        };
    },
    saveNew: function () {
        this.save(_.filter(this.data, function (dt) {
            return !(dt.id > 0);
        }))
    },
    saveAll: function () {
        this.save(this.data);
    },
    save: function (costCodes) {
        this.isSaving = true;
        this.render();
        this.$('.import-loading').removeClass('hidden');
        this.options.costCodes.saveBulk(costCodes, this.options.subJob ? this.options.subJob.id : null, (savedCostCodes) => {
            this.isSaving = false;
            if (savedCostCodes) {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(savedCostCodes);
                }
                this.removeModal();
                PJQ.notifications.notify.successNotify({
                    message: _.size(savedCostCodes).toString() + ' Cost Codes imported'
                });
            } else {
                // todo: error
            }
        });
    },
    afterRender: function () {
        if (this.data == null) {
            let $uploader = this.$('.template-uploader');
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'costcodes'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onDrop: _.bind(function () {
                    this.$('.import-processing').removeClass('hidden');
                    this.$('.btn-close').prop('disabled', true);
                }, this),
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    if (this.options.costCodes != null && _.size(file.uploadId) > 0) {
                        this.options.costCodes.processImport(file.uploadId, this.options.project ? this.options.project.id : null, (data) => {
                            this.fileUploader.remove();
                            loader.remove();
                            this.fileUploader = null;
                            this.data = data;
                            this.render();
                        });
                    }
                }, this)
            });
        }
    }
});

PJQ.views.budget.CostCodePickerModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-cost-code-picker'),
        maxWidth: 600,
        pickerOptions: {}
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    beforeModalCreated: function () {
        this.selectedCostCodes = [];
    },
    afterRender: function () {
        new PJQ.views.budget.CostCodePicker(_.defaults(this.options.pickerOptions, {
            el: this.$('.cc-picker'),
            costCodes: this.options.costCodes,
            onSelectionChanged: _.bind(function (costCodes) {
                this.selectedCostCodes = costCodes;
            }, this)
        }));
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
        this.removeModal();
    },
    save: function () {
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.selectedCostCodes);
        }
        this.removeModal();
    }
});

PJQ.views.budget.CostCodePicker = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-code-picker-container'),
        subTemplates: {
            picker: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-code-picker')
        },
        costCodes: null,
        selectedCostCodeIds: null,
        selectecCostCodeCodes: null,
        disabledCostCodeIds: null,
        onSelectionChanged: null,
        isCostCodeDisabled: null,
        showDisabledAsSelected: false
    },
    events: {
        "keyup .input-search": "renderCostCodes",
        "click .btn-clear-filters": "clearFilters",
        "click .cost-codes-all-select": "selectAll",
        "click .division-select": "selectDivision",
        "click .cost-code-select": "selectionChanged",
        "click .division-expand": "expandDivisionClicked"
    },
    beforeFirstRender: function () {
        this.selectedCostCodeIds = [];
        if (_.size(this.options.selectedCostCodeIds) > 0) {
            this.selectedCostCodeIds = this.options.selectedCostCodeIds;
        }

        this.isFetched = false;
        if (this.options.costCodes == null) {
            PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                this.isFetched = true;
                this.render();
            }, this));
        } else {
            this.costCodes = this.options.costCodes;
            this.isFetched = true;
        }
    },
    renderData: function () {
        return {
            costCodes: this.costCodes,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }
        this.renderCostCodes();
    },
    renderCostCodes: function () {
        let searchFilter = this.$('.input-search').val().toLowerCase(),
            costCodes = [],
            $clearFilters = this.$('.btn-clear-filters');
        if (_.size(searchFilter) > 0) {
            $clearFilters.prop('disabled', false);
            _.each(this.costCodes.models, _.bind(function (costCode) {
                if (costCode.getDisplayName().toLowerCase().indexOf(searchFilter) > -1) {
                    costCodes.push(costCode);
                }
            }, this));
        } else {
            $clearFilters.prop('disabled', true);
            costCodes = this.costCodes.models;
        }

        let divisions = null;
        if (this.costCodes.hasDivisions()) {
            divisions = {};
            _.each(costCodes, function (costCode) {
                let division = _.size(costCode.get('division')) > 0 ? costCode.get('division') : 'No Division';
                if (divisions[division] != null) {
                    divisions[division].costCodes.push(costCode);
                } else {
                    divisions[division] = {
                        name: division,
                        costCodes: [costCode]
                    }
                }
            });
        }
        this.renderSubTemplate(false, this.options.subTemplates.picker, this.$('.cost-codes-container'), {
            isCostCodeDisabled: this.isCostCodeDisabled,
            isCostCodeSelected: this.isCostCodeSelected,
            costCodes: costCodes,
            divisions: divisions,
            selectedCostCodeIds: this.selectedCostCodeIds,
            isFetched: this.isFetched,
            options: this.options
        }, _.bind(function () {
            this.setDisabledDivisions();
            this.setSelectedDivisions();
            this.isRendered = true;
        }, this));
    },
    setSelectedDivisions: function () {
        let self = this;
        this.$('.division-select').each(function () {
            $(this).prop('checked', _.size(self.getDivisionCostCodesContainer($(this)).find('.cost-code-select').not(':checked')) === 0);
        });
        this.$('.cost-codes-all-select').prop('checked', !(this.$('.cost-code-select:not(:checked)').length > 0));
    },
    setDisabledDivisions: function () {
        let self = this;
        this.$('.division-select').each(function () {
            $(this).prop('disabled', _.size(self.getDivisionCostCodesContainer($(this)).find('.cost-code-select').not(':disabled')) === 0);
        });
        this.$('.cost-codes-all-select').prop('disabled', !(this.$('.cost-code-select:not(:disabled)').length > 0));
    },
    clearFilters: function () {
        this.$('.input-search').val('');
        this.renderCostCodes();
    },
    selectAll: function (override) {
        if (typeof override === 'boolean')
            this.$('.cost-codes-all-select').prop('checked', override);

        let checkboxes = this.$('.cost-code-select:not(:disabled)');
        if (this.$('.cost-codes-all-select').prop('checked')) {
            checkboxes.prop('checked', true);
        } else {
            checkboxes.prop('checked', false);
        }
        this.selectionChanged();
    },
    getDivisionCostCodesContainer: function ($element) {
        return $element.closest('.division-outer').find('.division-cost-codes');
    },
    selectDivision: function (e) {
        let $costCodes = this.getDivisionCostCodesContainer($(e.currentTarget)),
            isChecked = $(e.currentTarget).is(':checked');
        $costCodes.find('.cost-code-select,.division-select').not(':disabled').prop('checked', isChecked);
        this.selectionChanged();
    },
    selectionChanged: function () {
        let checkboxes = this.$('.cost-code-select:checked').not(':disabled');
        this.selectedCostCodeIds = _.map(checkboxes, function (cb) {
            return $(cb).data('id');
        });

        this.setSelectedDivisions();
        if (typeof this.options.onSelectionChanged === 'function') {
            this.options.onSelectionChanged(this.costCodes.get(this.selectedCostCodeIds));
        }
    },
    expandDivisionClicked: function (e) {
        this.expandDivision(this.getDivisionCostCodesContainer($(e.currentTarget)));
    },
    expandDivision: function (container) {
        let icon = container.siblings('i.division-expand');
        if (container.hasClass('hidden')) {
            container.removeClass('hidden');
            icon.removeClass('fa-chevron-right text-primary').addClass('fa-chevron-down text-muted');
        } else {
            container.addClass('hidden');
            icon.removeClass('fa-chevron-down text-muted').addClass('fa-chevron-right text-primary');
        }
    },
    isCostCodeSelected: function (costCode) {
        return this.selectedCostCodeIds.indexOf(costCode.id) !== -1;
    },
    isCostCodeDisabled: function (costCode) {
        if (typeof this.options.isCostCodeDisabled === 'function') {
            return this.options.isCostCodeDisabled(costCode);
        }
        return false;
    },
    showError: function (errorText) {
        this.hideError();
        this.errorAlert = new PJQ.Alert(this.$el, {
            type: 'danger',
            extraClasses: ['mt-1, mb-1'],
            text: errorText,
            isPrepend: true
        });
    },
    hideError: function () {
        if (this.errorAlert) {
            this.errorAlert.destroy();
        }
    }
});
PJQ.views.budget.CostTypeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'cost-type-settings')
    },
    events: {
        'click .btn-add-cost-type': 'addClicked',
        'click .btn-edit-cost-type': 'editClicked',
        'click .btn-delete-cost-type': 'deleteClicked',
        'click .btn-delete-all': 'deleteAll',
        'click .btn-push-erp': 'pushERP',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.options.project != null) {
            this.budget = await this.options.project.fetchBudget();
            this.costTypes = await this.options.project.fetchCostTypes();

            if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
                await this.options.project.fetchERPObject();
            }
        } else {
            this.costTypes = await PJQ.app.session.fetchCostTypes();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            project: this.options.project,
            costTypes: this.costTypes,
            isFetched: this.isFetched,
            erpIntegration: this.erpIntegration,
            budget: this.budget
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.stopListening(this.costTypes);
        this.listenTo(this.costTypes, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderCostTypeTable();
    },
    renderCostTypeTable: function () {
        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".cost-types-table"),
            data: this.costTypes.models,
            order: [1, 'asc'],
            onRowDoubleClick: _.bind(function (row) {
                this.editCostType(row.data());
            }, this),
            rowId: 'cid',
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editCostType(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            if (this.budget) {
                                return null == this.budget.lineItems.findWhere({costTypeId: row.data().id});
                            } else {
                                return true;
                            }
                        },
                        onClick: (row) => {
                            this.deleteCostType(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "title": "",
                    "data": "attributes.externalObject",
                    "width": "5%",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (data) {
                            return '<i class="fas fa-link-simple fs-14 text-success" title="Synced to ERP"></i>';
                        }
                        return '';
                    }
                },
                {
                    "data": "attributes.code",
                    "title": "Code",
                    "width": "15%"
                },
                {
                    "data": "attributes.name",
                    "title": "Name"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "className": "p-2",
                    "width": "100px",
                    "render": (data, type, model) => {
                        let canDelete = null == this.budget || null == this.budget.lineItems.findWhere({costTypeId: model.id}),
                            res = '<div class="text-align-right show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-edit-cost-type ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-cost-type ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This cost code has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ],
            language: {
                zeroRecords: 'Click "Add Cost Type" to create a new Cost Type'
            }
        });
    },
    renderERP: function () {
        if (this.erpIntegration == null) {
            return;
        }

        let hasStaleCostTypes = null != _.find(this.costTypes.models, function (costType) {
                return costType.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.PENDING
                    || costType.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.STALE;
            }),
            pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COST_TYPES),
            status = pushSupported && hasStaleCostTypes ? PJQ.constants.integrations.erp.syncStatuses.STALE : PJQ.constants.integrations.erp.syncStatuses.SYNCED,
            pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COST_TYPES);
        this.erpButtons = PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            canPush: hasStaleCostTypes,
            disablePushReason: !hasStaleCostTypes ? 'All cost type changes have been pushed to ERP' : '',
            pullSupported: pullSupported,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pushERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_COST_TYPES)) {
            this.erpButtons?.pushing(true);
            this.erpIntegration.pushCostTypes((res, err) => {
                this.erpButtons?.pushing(false);
                if (res == null) {
                    return;
                }

                this.costTypes.reset(res);
                PJQ.notifications.notify.successNotify({
                    message: 'Cost Types successfully pushed to ERP'
                });
                this.render();
            });
        }
    },
    pullERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COST_TYPES)) {
            this.erpButtons?.pulling(true);
            this.erpIntegration.pullCostTypes((res, err) => {
                this.erpButtons?.pulling(false);
                if (res == null) {
                    return;
                }

                this.costTypes.reset(res);
                PJQ.notifications.notify.successNotify({
                    message: _.size(res).toString() + ' Cost Types pulled from ERP'
                });
                if (typeof this.options.onPullERP === 'function') {
                    this.options.onPullERP();
                } else {
                    this.render();
                }
            });
        }
    },
    addClicked: function () {
        this.editCostType(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let costType = this.costTypes.get(id);
            if (costType != null) {
                this.editCostType(costType);
            }
        }
    },
    editCostType: function (costType) {
        new PJQ.views.budget.EditCostTypeModal({
            model: costType,
            project: this.options.project,
            onSave: _.bind(function (costType) {
                this.costTypes.add(costType);
                if (this.options.project) {
                    this.options.project.costTypes.add(costType);
                }
                this.render();
            }, this),
            onDelete: _.bind(function (costType) {
                if (costType.id > 0) {
                    this.deleteCostType(costType, false);
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('tr').attr('id'),
            costCode = this.costTypes.get(cid);
        this.deleteCostType(costCode);
    },
    deleteAll: function () {
        let ct = _.size(this.costTypes.models);
        if (ct === 0) {
            return;
        }

        let msg = 'Are you sure you want to delete all <strong>' + ct + '</strong> Company Cost Types?';
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: msg,
            onDelete: _.bind(function () {

            }, this)
        });
    },
    deleteCostType: function (costType, showDialogue = true) {
        if (showDialogue) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this Cost Type?",
                onDelete: _.bind(function () {
                    costType.destroy({
                        notify: false,
                        success: _.bind(function () {
                            this.costTypes.remove(costType);
                            this.render();
                        }, this),
                        error: function (model, xhr) {
                            if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_type_with_line_item') {
                                PJQ.notifications.notify.warningNotify({
                                    message: 'This cost type cannot be deleted because it is being used on budget line items.'
                                });
                            }
                        }
                    });
                }, this)
            });
        } else {
            costType.destroy({
                notify: false,
                success: _.bind(function () {
                    this.costTypes.remove(costType);
                    this.render();
                }, this)
            });
        }
    }
});

PJQ.views.budget.EditCostTypeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-cost-type'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.model == null) {
            this.model = new PJQ.models.budget.CostType();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.costTypes = await PJQ.app.session.fetchCostTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            costTypes: this.costTypes,
            erpIntegration: this.erpIntegration,
            externalObject: this.model.get('externalObject'),
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input',
                'select'
            ]
        });

        this.$(".input-name").inputmask({
            "mask": "a".repeat(50),
            placeholder: "",
            definitions: {
                'a': {
                    validator: ".",
                    cardinality: 1
                }
            }
        });

        this.$(".input-code").inputmask({
            "mask": "a".repeat(20),
            placeholder: "",
            definitions: {
                'a': {
                    validator: "[0-9a-zA-Z]",
                    cardinality: 1
                }
            }
        });

        if (this.erpIntegration != null) {
            this.renderIntegrationFields();
        }
    },
    renderIntegrationFields: function () {
        if (this.erpIntegration == null) {
            return;
        }

        switch (this.erpIntegration.get('name')) {
            case PJQ.constants.integrations.providers.ACUMATICA.name:
                let defaultNonStockItem = this.erpIntegration.getSetting('defaultNonStockItem'),
                    externalObj = this.model.get('externalObject');

                let nonStockItem = defaultNonStockItem;
                if (externalObj != null && externalObj.data?.nonStockItem != null) {
                    nonStockItem = externalObj.data?.nonStockItem;
                }

                new PJQ.inputs.SelectPickerEditorInput({
                    el: this.$('.edit-non-stock'),
                    isFormInput: true,
                    editButtonText: "Change",
                    label: 'Non-Stock Item',
                    title: 'The Non-Stock Item used when syncing Commitments to Acumatica Subcontract and Purchase Order lines which use this cost type',
                    showSaveButton: false,
                    defaultDisplayValue: nonStockItem != null ? nonStockItem.inventoryID : null,
                    value: nonStockItem != null ? nonStockItem.id : null,
                    getChoices: (cb) => {
                        let fnCallback = () => {
                            cb(_.map(this.erpIntegration.settingsData.nonStockItems, function (item) {
                                return {
                                    id: item.id,
                                    name: item.inventoryID
                                };
                            }));
                        };
                        if (this.erpIntegration.settingsData?.nonStockItems != null) {
                            fnCallback();
                            return;
                        }

                        this.erpIntegration.fetchSettingsData((data) => {
                            fnCallback();
                        }, {
                            type: 'non_stock_items'
                        });
                    },
                    onChange: (value) => {
                        let item = this.erpIntegration.settingsData.nonStockItems.find((item) => item.id === value);
                        if (item != null) {
                            this.erpIntegration.setSetting('nonStockItem', item);
                        }

                        let exObj = this.model.get('externalObject');
                        exObj.data.nonStockItem = item;
                        exObj.isDirty = true;
                        this.model.set('externalObject', exObj);
                    }
                });
                break;
        }
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let isValid = true;

        let $name = this.$('.input-name');
        PJQ.helpers.inputHelpers.setInputError($name, true);
        if (this.model.get('name') == null || this.model.get('name').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($name, false);
            isValid = false;
        }

        let $code = this.$('.input-code');
        PJQ.helpers.inputHelpers.setInputError($code, true);
        if (this.model.get('code') == null || this.model.get('code').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($code, false);
            isValid = false;
        }

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        let fnSaveERPObj = (cb) => {
            let exObj = this.model.get('externalObject');
            if (this.erpIntegration == null || exObj == null || !exObj.isDirty) {
                cb();
                return;
            }

            this.erpIntegration.updateCostTypeData(exObj, (res, err) => {
                cb();
            });
        }

        fnSaveERPObj(() => {
            this.model.save(null, {
                success: () => {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.costTypes.add(this.model);

                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Cost Type saved'
                    });
                }
            });
        });
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Cost Type?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});
PJQ.collections.erpAdmin = PJQ.collections.erpAdmin  ?? {};
PJQ.models.erpAdmin = PJQ.models.erpAdmin  ?? {};
PJQ.views.erpAdmin = PJQ.views.erpAdmin  ?? {};
PJQ.constants.erpAdmin = PJQ.constants.erpAdmin ?? {};

PJQ.modules.erpAdmin = {
    routes: [
        {
            route: "erpadmin",
            name: 'erpadmin',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin"
                });
            }
        },
        {
            route: "erpadmin/project",
            name: 'erpadmin-project',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'project'
                    }
                });
            }
        },
        {
            route: "erpadmin/costcode",
            name: 'erpadmin-costcode',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'costcode'
                    }
                });
            }
        },
        {
            route: "erpadmin/subjob",
            name: 'erpadmin-subjob',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'subjob'
                    }
                });
            }
        },
        {
            route: "erpadmin/cont_comp",
            name: 'erpadmin-company',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'cont_comp'
                    }
                });
            }
        },
        {
            route: "erpadmin/budget",
            name: 'erpadmin-budget',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'budget'
                    }
                });
            }
        },
        {
            route: "erpadmin/commitment",
            name: 'erpadmin-commitment',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'commitment'
                    }
                });
            }
        },
        {
            route: "erpadmin/cco",
            name: 'erpadmin-cco',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'cco'
                    }
                });
            }
        },
        {
            route: "erpadmin/ap_inv",
            name: 'erpadmin-payableinvoices',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'ap_inv'
                    }
                });
            }
        },
        {
            route: "erpadmin/ar_inv",
            name: 'erpadmin-receivableinvoices',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'ar_inv'
                    }
                });
            }
        },
        {
            route: "erpadmin/contract",
            name: 'erpadmin-contract',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'contract'
                    }
                });
            }
        },
        {
            route: "erpadmin/pcco",
            name: 'erpadmin-pcco',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'pcco'
                    }
                });
            }
        },
        {
            route: "erpadmin/d_cost",
            name: 'erpadmin-directcosts',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'd_cost'
                    }
                });
            }
        },
        {
            route: "erpadmin/timecard",
            name: 'erpadmin-timecards',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "erpadmin",
                    viewOptions: {
                        feature: 'timecard'
                    }
                });
            }
        },
    ]
};

PJQ.app.addRoutes(PJQ.modules.erpAdmin.routes);

// Models
PJQ.models.erpAdmin.ERPObject = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'erp'
            },
            {
                endpoint: 'objects',
                value: this.erpObject.id
            }
        ]);
    },
    parse: function (model) {
        model = model ? model : {};

        model.id = model.erpObject.id;
        this.erpObject = model.erpObject;
        if (model.relatedObjects) {
            this.relatedItem = model.relatedObjects.relatedItem;
            this.project = model.relatedObjects.project;
        }

        return model;
    },
    createNewContactCompany: function (externalId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors'
                },
                {
                    endpoint: 'pull',
                    value: externalId
                }]),
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    },
    approve: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/approve',
            data: data,
            isAPIv2: true
        }).post().done((res) => {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            callback(null, err);
        });
    },
    reject: function (rejectReason, callback) {
        this.erpObject.rejectReason = rejectReason;
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/reject',
            data: this.erpObject,
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    },
    pull: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/pull',
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    },
    linkContactCompany: function (company, externalId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors'
                },
                {
                    endpoint: 'link',
                    value: externalId
                }]),
            data: company,
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    },
    archive: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/archive',
            data: this.erpObject,
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    },
    removeFromArchive: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unarchive',
            data: this.erpObject,
            isAPIv2: true
        }).post().done(_.bind(function (res) {
            if (res && !res.error) {
                this.erpObject = res;
            }

            if (typeof callback === 'function') {
                callback(res);
            }
        }, this));
    }
});

//Collections
PJQ.collections.erpAdmin.ERPObjects = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.erpAdmin.ERPObject,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'erp'
            },
            {
                endpoint: 'objects',
                value: this.options.internalModel
            }
        ], [
            {
                parameter: 'statusIds',
                value: this.options.statusIds
            }
        ]);
    },
    parse: function (models) {
        if (models == null || models.objects == null) {
            return models;
        }

        _.each(models.objects, function (model) {
            model.id = model.erpObject.id;
            if (models.projects != null && model.erpObject && model.erpObject.projectId > 0 && model.relatedObjects != null) {
                model.relatedObjects.project = _.findWhere(models.projects, {id: model.erpObject.projectId});
            }
        });

        return models.objects;
    },
    getFeatureCounts: function (externalModel, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'objects',
                        value: this.options.internalModel
                    },
                    {
                        endpoint: 'count'
                    }], [
                    {
                        parameter: 'externalModel',
                        value: externalModel
                    }
                ]),
                isAPIv2: true,
            }).get().done(_.bind(function (res) {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }, this)).fail(_.bind(function (error) {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(new Error("Failed to fetch erp integration sync data"));
            }, this));
        });
    },
    pushFailedObjects: function(callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'objects',
                        value: this.options.internalModel
                    },
                    {
                        endpoint: 'pushfailed'
                    }]),
                isAPIv2: true,
            }).put().done(_.bind(function (res) {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }, this)).fail(_.bind(function (error) {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(new Error("Failed to push failed objects"));
            }, this));
        });
    },
    setInternalModel: function (internalModel) {
        this.options.internalModel = internalModel;
    },
    setStatusIds: function (statusIds) {
        this.options.statusIds = statusIds;
    },
    refreshModels: function (type, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: type
                    },
                    {
                        endpoint: 'refresh'
                    }]),
                isAPIv2: true,
            }).post().done(_.bind(function () {
                if (typeof callback === 'function') {
                    callback(true);
                }
                resolve(true);
            }, this)).fail(_.bind(function (error) {
                if (typeof callback === 'function') {
                    callback(false);
                }
                reject(error);
            }, this));
        });
    },
    linkSuggested: function (externalModel, objs, callback) {
        return new Promise((resolve, reject) => {
            if (objs != null && _.size(objs) === 0) {
                if (typeof callback === 'function') {
                    callback([]);
                }
                resolve([]);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: externalModel + 's'
                    },
                    {
                        endpoint: 'linksuggested'
                    }
                ]),
                data: _.size(objs) > 0 ? _.map(objs, (obj) => {
                    return {
                        id: obj.erpObject.id
                    };
                }) : null,
                isAPIv2: true
            }).post().done((res) => {
                if (res && !res.error) {
                    let objs = [];
                    _.each(res, (model) => {
                        objs.push({
                            id: model.id,
                            erpObject: model,
                            relatedObjects: {
                                relatedItem: Object.assign({}, model.data)
                            }
                        });
                    });

                    this.add(objs, {merge: true});
                }

                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((error) => {
                if (typeof callback === 'function') {
                    callback(null);
                }
                reject(error);
            });
        });
    },
});
PJQ.constants.erpAdmin.features = {
    cont_comp: {
        canSuggestMatches: true,
        columns: (filter, provider, options) => {
            let columns;
            if (filter === 'readyToImport' || filter === 'archived') {
                columns = [
                    {
                        "data": "attributes.erpObject.data",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, a, row) => {
                            return data?.externalNumber ?? data?.id ?? "";
                        }
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.companyName",
                        "title": "Company",
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.address1",
                        "title": "Address",
                        "width": "20%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.city",
                        "title": "City",
                        "width": "10%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.state",
                        "title": "State",
                        "width": "5%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.zip",
                        "title": "Zip",
                        "width": "10%"
                    }
                ];

                if (options.suggestMatches) {
                    columns = _.union([{
                        "title": '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-erp-items" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                        "orderable": false,
                        "searchable": false,
                        "data": "attributes.erpObject",
                        "visible": filter !== 'archived',
                        "render": _.bind(function (erpObj, type, row) {
                            let checkedText = _.contains(options.selectedERPItems, row.cid) ? "checked" : "";

                            if (erpObj.internalId > 0) {
                                return "";
                            }

                            return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-erp-item" ' + checkedText + ' data-cid="' + row.cid + '"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                        }, this),
                        "width": '2%'
                    },], columns, [{
                        "data": "attributes.erpObject.data",
                        "title": "JobPlanner Company",
                        // "width": "10%",
                        "render": (data, a, row) => {
                            if (data.suggestedId > 0) {
                                return '<b>' + data.companyName + ' (' + data.suggestedId.toString() + ')' + '</b>';
                            }
                            return '';
                        }
                    }])
                }

                columns.push({
                    "data": "attributes",
                    "title": "",
                    "orderable": false,
                    "width": "10%",
                    "render": (attr, a, row) => {
                        if (attr.erpObject.internalId > 0) {
                            return "<div class='text-align-center text-success'>Linked!</div>";
                        } else if (options.suggestMatches) {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-link-suggested">Link</button></div>';
                        } else if (filter === 'archived') {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-remove-from-archive">Restore</button></div>';
                        } else {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container">' +
                                '<div class="btn-group vendor-group"> ' +
                                '<button type="button" class="btn btn-outline-primary dropdown-toggle mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Import</button> ' +
                                '<div class="dropdown-menu">' +
                                '<a class="dropdown-item btn-link-vendor" href="javascript:void(0)">Link to Existing Company</a> ' +
                                '<a class="dropdown-item btn-add-vendor" href="javascript:void(0)">Create New Company</a> ' +
                                '</div>' +
                                '</div>' +
                                '<div class="btn-group btn-extra-actions"> ' +
                                '<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-vertical mr-1"></i></button> ' +
                                '<div class="dropdown-menu">' +
                                '<a class="dropdown-item btn-archive" href="javascript:void(0)">Archive</a> ' +
                                '</div>' +
                                '</div>' +
                                '</div>';
                        }
                    },
                });
                if (provider === PJQ.constants.integrations.providers.SAGE300) {
                    columns.unshift(
                        {
                            "data": "attributes.relatedObjects.relatedItem.externalNumber",
                            "title": "Code",
                            "width": "10%"
                        },
                    );
                }
            } else {
                columns = [
                    {
                        "data": "attributes.relatedObjects.relatedItem.companyName",
                        "title": "Company",
                        "width": "20%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.address1",
                        "title": "Address",
                        "width": "20%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.city",
                        "title": "City",
                        "width": "10%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.state",
                        "title": "State",
                        "width": "5%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.zip",
                        "title": "Zip",
                        "width": "10%"
                    }
                ]
            }
            return columns;
        }
    },
    project: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PROJECTS) !== false;
        },
        columns: (filter, provider) => {
            let columns;
            if (filter === 'readyToImport' || filter === 'archived') {
                columns = [
                    {
                        "data": "attributes.erpObject.data",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, a, row) => {
                            return data?.externalNumber ?? data?.id ?? "";
                        }
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.name",
                        "title": "Project Name",
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.city",
                        "title": "City",
                        "width": "25%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.state",
                        "title": "State",
                        "width": "10%"
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "width": "10%",
                        "render": (data, a, row) => {
                            if (filter === 'archived') {
                                return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-remove-from-archive">Restore</button></div>';
                            } else {
                                return '<div class="d-flex justify-content-center align-content-center action-button-container">' +
                                    '<div class="btn-group"> ' +
                                    '<button type="button" class="btn btn-outline-primary btn-add-project mr-1">Import</button>' +
                                    '</div>' +
                                    '<div class="btn-group btn-extra-actions"> ' +
                                    '<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-vertical mr-1"></i></button> ' +
                                    '<div class="dropdown-menu">' +
                                    '<a class="dropdown-item btn-archive" href="javascript:void(0)">Archive</a> ' +
                                    '</div>' +
                                    '</div>' +
                                    '</div>';
                            }
                        },
                    },
                ]

                if (provider === PJQ.constants.integrations.providers.SAGE300) {
                    columns.unshift(
                        {
                            "data": "attributes.relatedObjects.relatedItem.externalNumber",
                            "title": "Code",
                            "width": "10%"
                        },
                    );
                }
            } else {
                columns = [
                    {
                        "data": "attributes.relatedObjects.project.projectName",
                        "title": "Project",
                        "width": "25%",
                        "render": _.bind(function (data, a, row) {
                            return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                        }, this),
                    },
                    {
                        "data": "attributes.relatedObjects.project.city",
                        "title": "City",
                        "width": "25%"
                    },
                    {
                        "data": "attributes.relatedObjects.project.state",
                        "title": "State",
                        "width": "25%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.costCodeCount",
                        "title": "Cost Codes",
                        "width": "25%"
                    },
                ]
            }
            return columns;
        }
    },
    subjob: {
        columns: [
            {
                "data": "attributes.relatedObjects.relatedItem.externalNumber",
                "title": "Code",
                "width": "20%"
            },
            {
                "data": "attributes.relatedObjects.relatedItem.name",
                "title": "Name",
                "width": "30%"
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "50%"
            }
        ]
    },
    costcode: {
        columns: (filter, provider, options) => {
            return [
                {
                    "title": '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-erp-items" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                    "orderable": false,
                    "searchable": false,
                    "visible": filter !== 'archived',
                    "render": _.bind(function (data, type, row) {
                        let checkedText = _.contains(options.selectedERPItems, row.cid) ? "checked" : "";

                        if (row.isImported) {
                            return "";
                        }

                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-erp-item" ' + checkedText + ' data-cid="' + row.cid + '"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '2%'
                },
                {
                    "data": "attributes",
                    "title": "Code",
                    "width": "20%",
                    "render": function(data, type, row){
                        let item = row.attributes.relatedObjects.relatedItem;
                        return item?.externalNumber ?? item?.code ?? "";
                    }
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.name",
                    "title": "Name",
                    "width": "30%"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "width": "10%",
                    "render": _.bind(function (data, a, row) {
                        if (filter === 'archived') {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-remove-from-archive">Restore</button></div>';
                        } else {
                            if (row.isImported) {
                                return "<div class='text-align-center'><span class='text-success'>Cost Code Created!</span></div>"
                            }

                            return '<div class="d-flex justify-content-center align-content-center action-button-container">' +
                                '<div class="btn-group vendor-group"> ' +
                                '<button type="button" class="btn btn-outline-primary btn-add-cost-code mr-1">Import</button>' +
                                '</div>' +
                                '<div class="btn-group btn-extra-actions"> ' +
                                '<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-v mr-1"></i></button> ' +
                                '<div class="dropdown-menu">' +
                                '<a class="dropdown-item btn-archive" href="javascript:void(0)">Archive</a> ' +
                                '</div>' +
                                '</div>' +
                                '</div>';
                        }
                    }, this),
                }
            ];
        }
    },
    budget: {
        columns: [
            {
                "data": "attributes.relatedObjects.relatedItem.projectId",
                "title": "",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + data + '/budget"> View Budget </a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "25%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.estimateAmount",
                "title": "Total Estimate",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    contract: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Contract Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/contracts/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    pcco: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/contracts/changeorders/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.changeReason",
                "title": "Change Reason",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    ar_inv: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_RECEIVABLE_INVOICES) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/receivableinvoices/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.billingDate",
                "title": "Due Date",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    commitment: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Commitment Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/commitments/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.commitmentType",
                "title": "Type",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.constants.commitments.commitmentTypeNames[data];
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    cco: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENT_CHANGE_ORDERS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/commitments/changeorders/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.changeReason",
                "title": "Change Reason",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    ap_inv: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PAYABLE_INVOICES) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/payableinvoices/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.billingDate",
                "title": "Due Date",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                }, this),
            },
            {
                "data": "attributes.erpObject.action",
                "title": "Action",
                "render": (data, a, row) => {
                    if(data?.toLowerCase() === "releaseretainage"){
                        return "Release Retainage";
                    }
                    return "Push to ERP";
                }
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "15%",
                "render": (data, a, row) => {
                    if(row.erpObject.action?.toLowerCase() === "releaseretainage"){
                        return PJQ.helpers.formatHelpers.formatCurrency(row.relatedItem.workRetainage);
                    }
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                },
            }
        ]
    },
    d_cost: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_DIRECT_COSTS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.type",
                "title": "Type",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.constants.directcosts.directCostTypeNames[data]
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "15%"
            },
            {
                "data": "attributes.relatedObjects.relatedItem.amount",
                "title": "Amount",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    timecard: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_TIME_CARDS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/timecards">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem",
                "title": "Time Card",
                "width": "30%",
                "render": _.bind(function (data, a, row) {
                    // return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/timecards/' + row.attributes.relatedObjects.relatedItem.timeCardId + '">' + data + '</a>';
                    return `<div class="font-weight-bold">${data.contact?.contactName ?? data.equipment?.name}</div><div>${data.contact?.companyName ?? data.equipment?.type}</div>`;
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem",
                "title": "Date",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.dateHelpers.getDateString(new Date(data.date), PJQ.helpers.dateHelpers.dateFormats.DATE)
                }, this),
            },
        ]
    }
}

PJQ.views.erpAdmin.ERPAdminManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'erp-admin-management'),
        subTemplates: {
            approvalItem: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'erp-approval-item'),
            emptyQueue: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'empty-erp-queue'),
        },
    },
    events: {
        'click .btn-add-project': 'addProjectClicked',
        'click .btn-link-project': 'linkProjectClicked',
        'click .feature-nav-item a': 'featureChanged',
        'click .filter-nav-item a': 'filterChanged',
        'click .approve-button, .reject-button, .link-button': 'handleApprovalAction',
        'click .btn-submit-approve': 'approveItem',
        'click .btn-submit-reject': 'rejectItem',
        'click .btn-add-vendor': 'addVendorClicked',
        'click .btn-link-vendor': 'linkVendorClicked',
        'click .btn-refresh': 'refresh',
        'click .btn-archive': 'archiveClicked',
        'click .btn-remove-from-archive': 'removeFromArchiveClicked',
        'click .select-erp-item': 'erpItemSelected',
        'click .select-all-erp-items': 'selectAllERPItems',
        'click .btn-add-cost-code': 'addCostCodeClicked',
        'click .btn-import-items': 'addCostCodes',
        'change .cb-suggest-matches': 'suggestMatchesChanged',
        'click .btn-link-suggested': 'linkSuggestedClicked',
        'click .btn-link-all-suggested': 'linkAllSuggestedClicked',
        'click .btn-link-suggested-selected': 'linkSuggestedSelectedClicked',
        'click .btn-bulk-retry': 'retryAllFailed'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.syncData = await this.erpIntegration.fetchSyncData();

        let defaultFeature = 'project',
            feature = this.options.feature ? this.options.feature : defaultFeature;
        this.provider = this.erpIntegration.getProvider();
        if (this.provider == null) {
            this.isFetched = true;
            this.render();
        }

        if (this.provider.erpAdmin.features[feature] == null) {
            feature = defaultFeature;
        }
        await this.changeFeature(feature);

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            features: this.getFeatures(),
            feature: this.feature,
            filter: this.filter,
            provider: this.provider
        }
    },
    getFeatures: function () {
        if (this.provider == null) {
            return {};
        } else {
            let res = {};
            _.each(this.provider.erpAdmin.features, (ftr, key) => {
                let feature = PJQ.constants.erpAdmin.features[key];
                if (feature == null) {
                    return;
                }

                if (typeof feature.enabled !== 'function' || feature.enabled(this.erpIntegration)) {
                    res[key] = ftr;
                }
            });
            return res;
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderFeatureCounts();
        this.renderApprovalItems();
    },
    fetchERPObjects: async function () {
        return new Promise(async (resolve, reject) => {
            if (this.collection == null) {
                this.collection = new PJQ.collections.erpAdmin.ERPObjects();
            }
            this.collection.setInternalModel(this.feature);
            this.collection.setStatusIds(this.statusIds);

            await this.collection.fetch({
                data: {
                    externalModel: this.provider.erpAdmin.features[this.feature].externalModelName
                }
            }).fail((err) => {
                this.erpIntegration.handleError(err);
                reject(err);
            });
            resolve(true);
        });
    },
    featureChanged: async function (e) {
        let feature = $(e.currentTarget).data('feature');
        await this.changeFeature(feature);
        this.render();
    },
    retryAllFailed: async function() {
        let loader = new PJQ.Loader(this.$(`${this.feature}-pane`));

        await this.collection.pushFailedObjects((res) => {
            if (res) {
                _.each(res.objects, (obj) => {
                   let item = this.collection.get(obj.id);

                   if(item != null){
                       if(_.size(obj.error) === 0){
                           item.set('isApproved', true);
                           item.erpObject = obj;
                           this.renderApprovalItem(item);
                       } else {
                           item.erpObject = obj;
                           this.renderApprovalItem(item);
                       }
                   }
                });
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Encountered an error. Please contact customer service.'
                });
            }

            loader.remove();
        });
    },
    changeFeature: async function (feature) {
        return new Promise(async (resolve) => {
            if (this.feature !== feature) {
                this.options.suggestMatches = false;

                let filters = this.provider.erpAdmin.features[feature].filters;
                this.feature = feature;
                let filter = filters.readyToImport || filters.readyToExport || filters.failedToExport;
                this.filter = filter?.name;
                this.statusIds = filter === filters.readyToImport ? [PJQ.constants.integrations.erp.syncStatuses.CACHED] : filter?.statuses ?? [PJQ.constants.integrations.erp.syncStatuses.REVIEWING]

                PJQ.app.router.navigate('erpadmin/' + this.feature, {
                    trigger: false
                });

                await this.fetchERPObjects().catch((err) => {
                    return;
                });

                let externalModel = this.provider.erpAdmin.features[this.feature].externalModelName;
                this.counts = await this.collection.getFeatureCounts(externalModel);
            }
            resolve(true);
        });
    },
    renderFeatureCounts: function () {
        _.each(this.provider.erpAdmin.features[this.feature].filters, function (filter) {
            let $el = this.$('.filter-count[data-filter="' + filter.name + '"]');

            switch (filter.name) {
                case 'readyToExport':
                    $el.text('(' + this.counts.readyToExportCount + ')');
                    break;
                case 'readyToImport':
                    $el.text('(' + this.counts.readyToImportCount + ')');
                    break;
                case 'failedToExport':
                    $el.text('(' + this.counts.failedToExportCount + ')');
                    break;
                case 'archived':
                    $el.text('(' + this.counts.archivedCount + ')');
                    break;
                default:
                    $el.text('(0)');
            }
        }, this)
    },
    filterChanged: async function (e) {
        let filter = $(e.currentTarget).data('filter'),
            statusIds = [];

        if (this.filter !== filter) {
            switch (filter) {
                case 'readyToImport':
                    this.filter = 'readyToImport';
                    break;
                case 'readyToExport':
                    this.filter = 'readyToExport';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.REVIEWING)
                    break;
                case 'failedToExport':
                    this.filter = 'failedToExport';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.FAILED)
                    break;
                case 'synced':
                    this.filter = 'synced';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.SYNCED)
                    break;
                case 'archived':
                    this.filter = 'archived';
                    break;
                default:
                    this.filter = 'readyToExport';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.REVIEWING)
                    break;
            }
            this.statusIds = statusIds;
            await this.fetchERPObjects();
            this.render();
        }
    },
    renderApprovalItems: function () {
        let $featurePane = this.$('.' + this.feature + '-pane');

        $featurePane.empty();

        this.options.selectedERPItems = [];
        this.filteredModels = [];

        // Add View Header and additional buttons
        if (_.size(this.collection.models) > 0) {
            let featureName = this.provider.erpAdmin.features[this.feature].displayName,
                filterName = this.provider.erpAdmin.features[this.feature].filters[this.filter].displayName,
                providerName = this.provider.displayName;
            $featurePane.append($('<div>').addClass('fs-14 font-italic border-bottom border-light view-header mb-2').text(providerName + ': ' + featureName + ' ' + filterName));

            if(this.feature === 'timecard' && this.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.BULK_RETRY_FAILED_TIME_CARDS)){
                $featurePane.append(`<button class="btn btn-outline-dark btn-bulk-retry">Resync All</button>`)
            }
        }

        let fnRenderEmptyQueue = () => {
            this.renderSubTemplate(true, this.options.subTemplates.emptyQueue, $featurePane, {
                feature: this.feature,
                filter: this.filter,
                provider: this.provider
            }, () => {
            });
        }

        // Render View
        if (this.filter !== 'readyToImport' && this.filter !== 'archived' && _.size(this.collection.models) > 0) {
            // Group Models. Currently only supports grouping by project
            let groupedModels = _.groupBy(this.collection.models, model => {
                return model.project ? model.project.id : null;
            });

            _.each(groupedModels, (models, projectId) => {
                if (projectId !== 'null') {
                    let project = models[0].project;

                    $featurePane.append($('<div>').addClass('fs-18 font-weight-bold mt-3').text(project.projectName));
                }

                _.each(models, (model) => {
                    let $approvalItemOuter = $('<div>').addClass('approval-item-outer mb-2').attr('data-cid', model.cid);

                    $featurePane.append($approvalItemOuter);
                    this.renderApprovalItem(model);
                });
            });
        } else if (_.size(this.collection.models) > 0) {
            this.filteredModels = _.filter(this.collection.models, function (model) {
                let match = false,
                    statusId = model.get('erpObject').status;
                if (this.filter === 'archived') {
                    match = statusId === PJQ.constants.integrations.erp.syncStatuses.ARCHIVED;
                } else if (this.filter === 'readyToImport') {
                    match = statusId === PJQ.constants.integrations.erp.syncStatuses.CACHED;
                }

                if (this.options.suggestMatches) {
                    match = model.attributes.erpObject.data.suggestedId > 0;
                }

                return match;
            }, this);

            if (_.size(this.filteredModels) > 0 || this.options.suggestMatches) {
                this.renderSubTemplate(true, this.options.subTemplates.approvalItem, $featurePane, {
                    provider: this.provider,
                    feature: this.feature,
                    model: null,
                    relatedItem: null,
                    filter: this.filter,
                    inputs: null,
                    syncData: this.syncData,
                    options: this.options
                }, (item) => {
                    let columns = this.getColumns(),
                        ftr = this.provider.erpAdmin.features[this.feature];
                    this.itemTable = new PJQ.views.dataTables.DataTable({
                        el: this.$(item).find('.item-table'),
                        data: this.filteredModels,
                        rowId: "cid",
                        language: {
                            emptyTable: 'No ' + ftr.displayName + ' were found',
                            zeroRecords: 'No ' + ftr.displayName + ' matched the search criteria'
                        },
                        isHideSearch: false,
                        paging: true,
                        order: [1, 'asc'],
                        columns: columns,
                        contextMenuOptions: {
                            actions: this.filter !== 'archived' ? [
                                {
                                    name: 'Import',
                                    isShown: () => {
                                        return this.feature !== 'cont_comp' && this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        switch (this.feature) {
                                            case 'project':
                                                this.addProject(row.data());
                                                break;
                                            case 'costcode':
                                                this.addCostCode(row.data());
                                                break;
                                        }
                                    }
                                },
                                {
                                    name: 'Create New Company',
                                    isShown: () => {
                                        return this.feature === 'cont_comp' && this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        this.addVendor(row.data());
                                    }
                                },
                                {
                                    name: 'Link to Existing Company',
                                    isShown: () => {
                                        return this.feature === 'cont_comp' && this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        this.linkVendor(row.data());
                                    }
                                },
                                {
                                    name: 'Archive',
                                    isDanger: true,
                                    isShown: (row) => {
                                        return this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        this.archive(row.data());
                                    }
                                }
                            ] : [
                                {
                                    name: 'Restore',
                                    isShown: (row) => {
                                        return this.filter === 'archived';
                                    },
                                    onClick: (row) => {
                                        this.removeFromArchive(row.data());
                                    }
                                }
                            ]
                        },
                    });
                });
            } else {
                fnRenderEmptyQueue();
            }
        } else {
            fnRenderEmptyQueue();
        }
    },
    renderApprovalItem: function (model) {
        // Find the existing approval-item-outer div using the cid
        let $approvalItemOuter = this.$('.approval-item-outer[data-cid="' + model.cid + '"]');

        // If the div was found, proceed to render the item
        if ($approvalItemOuter.length > 0) {
            let inputs = this.provider.erpAdmin.features[this.feature].approvalInputs
            this.renderSubTemplate(false, this.options.subTemplates.approvalItem, $approvalItemOuter, {
                provider: this.provider,
                feature: this.feature,
                model: model,
                relatedItem: model.relatedItem,
                project: model.project,
                filter: this.filter,
                inputs: inputs,
                syncData: this.syncData,
            }, _.bind(function (item) {
                let columns = this.getColumns();
                item.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$(item).find('.item-table'),
                    data: [model],
                    rowId: "cid",
                    isHideSearch: true,
                    paging: false,
                    order: [0, 'asc'],
                    columns: columns
                });

                _.each(inputs, function (input) {
                    let field = this.$(item).find('.' + input.className);
                    if (input.type === 'date') {
                        new PJQ.inputs.Datepicker({
                            el: field,
                            datepickerOptions: {
                                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                                defaultDate: null
                            }
                        });
                    } else {
                        if (input.format) {
                            let mask = '';
                            if (input.prefix)
                                mask += "\\" + input.prefix;

                            if (input.format)
                                mask += input.format;

                            field.inputmask({
                                definitions: {
                                    '#': {
                                        validator: "[^]"
                                    }
                                },
                                mask: mask,
                                placeholder: ''
                            });
                        }
                    }
                }, this)
            }, this));
        }
    },
    handleApprovalAction: function (e) {
        let $target = $(e.currentTarget),
            value = $target.text().trim().toLowerCase(),
            $approvalItem = $target.closest('.approval-item'),
            cid = $approvalItem.data('cid'),
            model = this.collection.get(cid);

        // hide all context containers
        $approvalItem.find('.approve-context-container, .reject-context-container').hide().removeClass('d-flex');
        $approvalItem.find('.approve-button, .reject-button').addClass('inactive');

        // show the one that corresponds to the clicked button
        if (value === 'approve') {
            $target.removeClass('inactive');
            $approvalItem.find('.reject-button').addClass('inactive');
            $approvalItem.find('.link-button').addClass('inactive');
            let $approveContainer = $approvalItem.find('.approve-context-container');
            $approveContainer.addClass('d-flex').slideDown(200);
        } else if (value === 'reject') {
            $target.removeClass('inactive')
            $approvalItem.find('.approve-button').addClass('inactive');
            $approvalItem.find('.link-button').addClass('inactive');
            $approvalItem.find('.reject-context-container').slideDown(200);
        } else {
            $target.removeClass('inactive')
            $approvalItem.find('.approve-button').addClass('inactive');
            $approvalItem.find('.reject-button').addClass('inactive');

            new PJQ.views.erpAdmin.SelectImportVendorModal({
                isSingleChoice: true,
                provider: this.provider,
                onSave: _.bind(function (erpVendor) {
                    new PJQ.views.modals.YesNo({
                        header: "Link Vendor",
                        body: "Are you sure you would like to link this vendor to " + erpVendor.relatedItem.companyName + "?",
                        onYes: () => {
                            model.linkContactCompany(model.relatedItem, erpVendor.erpObject.externalId, _.bind(function (contactCompany, err) {
                                if (contactCompany && contactCompany.externalObject && contactCompany.externalObject.status === PJQ.constants.integrations.erp.syncStatuses.SYNCED) {
                                    contactCompany.erpObject = contactCompany.externalObject;
                                    model.set({
                                        isApproved: true
                                    });
                                    model.erpObject = contactCompany.externalObject;
                                    model.erpObject.successText = "Company Linked!";
                                    this.renderApprovalItem(model);
                                } else {
                                    model.erpObject.error = err ? err : contactCompany.error;
                                }
                                this.renderApprovalItem(model);
                            }, this));
                        },
                        onNo: () => {
                            $target.addClass('inactive')
                        },
                    });
                }, this)
            });
        }
    },
    approveItem: function (e) {
        let $target = $(e.currentTarget),
            approveContainer = $(e.target).closest('.approve-context-container'),
            cid = $target.closest('.approval-item').data('cid'),
            model = this.collection.get(cid),
            isValid = true,
            data = {};

        if (_.size(model.erpObject.externalId) === 0) {
            _.each(this.provider.erpAdmin.features[this.feature].approvalInputs, function (input) {
                let inputEl = approveContainer.find('.' + input.className),
                    inputValue = inputEl.val();
                if (_.size(inputValue) > 0) {
                    data[input.value] = inputValue
                } else if (input.required) {
                    isValid = false;
                    PJQ.helpers.inputHelpers.setInputError(inputEl, false);
                }
            }, this);
        } else {
            data = model.erpObject.data;
        }

        if (isValid) {
            let loader = new PJQ.Loader($target.closest('.approval-item'));
            model.approve(data, (res, err) => {
                loader.remove();
                if (res == null) {
                    this.erpIntegration.handleError(err);
                    return;
                }

                if (res && !res.error) {
                    model.set('isApproved', true);
                    this.renderApprovalItem(model);
                } else {
                    model.erpObject.error = res ? res.error : 'Something went wrong'
                    this.renderApprovalItem(model);
                }
            });
        }
    },
    rejectItem: function (e) {
        let $target = $(e.currentTarget),
            $approvalItem = $target.closest('.approval-item'),
            cid = $approvalItem.data('cid'),
            model = this.collection.get(cid),
            isValid = true,
            rejectReason = $approvalItem.find('.reject-reason').val();

        if (isValid) {
            let loader = new PJQ.Loader($approvalItem);
            model.reject(rejectReason, (res) => {
                loader.remove();
                this.renderApprovalItem(model);
            });
        }
    },
    getColumns: function () {
        let ftr = this.feature.toLowerCase(),
            cols = PJQ.constants.erpAdmin.features[ftr].columns;
        return typeof cols === 'function' ? cols(this.filter, this.provider, this.options) : cols;
    },
    erpItemSelected: function (e) {
        if (this.options.selectedERPItems == null) {
            this.options.selectedERPItems = [];
        }

        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            isChecked = $target.prop('checked');
        if (_.size(cid) > 0) {
            if (isChecked) {
                this.options.selectedERPItems.push(cid);
            } else {
                this.options.selectedERPItems = _.reject(this.options.selectedERPItems, function (sCid) {
                    return sCid === cid;
                });
            }
        }

        this.$('.select-all-erp-items').prop('checked', _.size(this.options.selectedERPItems) === _.size(this.filteredModels) && _.size(this.filteredModels) > 0);

        this.handleSelectedERPItemsButtons();
    },
    selectAllERPItems: function (e) {
        let $target = $(e.currentTarget),
            isChecked = $target.prop('checked');

        if (!isChecked || this.options.selectedERPItems == null) {
            this.options.selectedERPItems = [];
        }

        _.each(this.filteredModels, function (model) {
            let checkbox = this.$('.select-erp-item[data-cid="' + model.cid + '"]');

            if (!isChecked) {
                checkbox.prop('checked', false);
            } else {
                checkbox.prop('checked', true);

                if (!_.contains(this.options.selectedERPItems, model.cid)) {
                    this.options.selectedERPItems.push(model.cid);
                }
            }
        }, this);

        this.handleSelectedERPItemsButtons();
    },
    handleSelectedERPItemsButtons: function (alteredModel) {
        // if a model was passed in, it was archived, or imported, so remove it from the filtered models and selected items if it exists there.
        if (alteredModel) {
            this.filteredModels = _.reject(this.filteredModels, function (m) {
                return m === alteredModel;
            });
            this.options.selectedERPItems = _.reject(this.options.selectedERPItems, function (cid) {
                return cid === alteredModel.cid;
            });
        }

        this.$('.select-all-erp-items').prop('checked', _.size(this.options.selectedERPItems) === _.size(this.filteredModels) && _.size(this.filteredModels) > 0);
        this.$('.btn-for-selected').attr('disabled', _.size(this.options.selectedERPItems) === 0);
        this.$('.selected-items-count').text(_.size(this.options.selectedERPItems));
    },
    addVendorClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.addVendor(model);
    },
    addVendor: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container'),
            loader = new PJQ.Loader(actionButtonContainer),
            externalId = model.relatedItem.id;

        model.createNewContactCompany(externalId, _.bind(function (contactCompany, err) {
            loader.remove();
            if (contactCompany) {
                if (!contactCompany.error) {
                    actionButtonContainer.html("<span class='text-success'>Company Created!</span>");
                    this.counts.readyToImportCount--;
                    this.renderFeatureCounts();
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + err ? err : contactCompany.error + "</span>");
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Import Contact'
                });
            }
        }, this));
    },
    linkVendorClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.linkVendor(model);
    },
    linkVendor: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.COMPANIES,
            isSingleChoice: true,
            displayContactsBlock: true,
            onSave: _.bind(function (selectedCompany) {
                let loader = new PJQ.Loader(actionButtonContainer);
                selectedCompany.set('companyId', selectedCompany.get('contactCompanyId'));
                model.linkContactCompany(selectedCompany, model.erpObject.externalId, _.bind(function (contactCompany, err) {
                    loader.remove();
                    if (contactCompany) {
                        if (!contactCompany.error) {
                            actionButtonContainer.html("<span class='text-success'>Company Linked!</span>");
                            this.counts.readyToImportCount--;
                            this.renderFeatureCounts();
                        } else {
                            actionButtonContainer.html("<span class='text-danger'>" + err ? err : contactCompany.error + "</span>");
                        }
                    } else {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to Import Contact'
                        });
                    }
                }, this));
            }, this)
        });
    },
    suggestMatchesChanged: function (e) {
        this.options.suggestMatches = $(e.currentTarget).prop('checked');
        this.render();
    },
    linkSuggestedSelectedClicked: function () {
        this.linkSuggested(null, this.collection.get(this.options.selectedERPItems));
    },
    linkSuggestedClicked: function (e) {
        let target = $(e.currentTarget),
            $row = target.closest('tr'),
            row = this.itemTable.getRow($row[0].id);
        this.linkSuggested(row);
    },
    linkAllSuggestedClicked: function () {
        if (null == _.find(this.collection.models, (obj) => {
            return obj.erpObject.data.suggestedId > 0 && !(obj.erpObject.internalId > 0);
        })) {
            return;
        }
        this.linkSuggested();
    },
    toggleLoader: function (show) {
        if (show == null) {
            show = this.loader != null;
        }

        if (show && this.loader == null) {
            this.loader = new PJQ.Loader(this.$('.erp-admin-nav'));
        } else if (!show && this.loader != null) {
            this.loader.remove();
            this.loader = null;
        }
    },
    linkSuggested: function (row, objs) {
        let linkObjs = null;
        if (row != null) {
            linkObjs = [row.data()];
        } else if (objs != null) {
            linkObjs = objs;
        }

        this.toggleLoader(true);

        let externalModel = this.provider.erpAdmin.features[this.feature].externalModelName;
        this.collection.linkSuggested(externalModel, linkObjs, (res) => {
            if (res) {
                if (res.error) {
                    return;
                }

                this.toggleLoader(false);

                let linkedCount = _.size(res);
                this.counts.readyToImportCount = this.counts.readyToImportCount - linkedCount;
                this.renderFeatureCounts();

                PJQ.notifications.notify.successNotify({
                    message: linkedCount.toString() + ' Contacts Linked to ERP'
                });

                if (row != null) {
                    // Remove from filtered models and selected items
                    this.handleSelectedERPItemsButtons(row.data());
                    this.itemTable.refreshRow(row);
                } else {
                    this.render();
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Archive'
                });
            }
        });
    },
    archiveClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);
        this.archive(model);
    },
    archive: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        model.archive(_.bind(function (res) {
            if (res) {
                if (!res.error) {
                    actionButtonContainer.html("<span class='text-success'>Archived!</span>");
                    this.counts.readyToImportCount--;
                    this.counts.archivedCount++;
                    this.renderFeatureCounts();
                    // Remove from filtered models and selected items
                    this.handleSelectedERPItemsButtons(model);
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + res.error + "</span>");
                }
                rowEl.find('.select-erp-item').closest('.text-align-center').remove();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Archive'
                });
            }
        }, this));
    },
    removeFromArchiveClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.removeFromArchive(model);
    },
    removeFromArchive: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        model.removeFromArchive(_.bind(function (res) {
            if (res) {
                if (!res.error) {
                    actionButtonContainer.html("<span class='text-success'>Restored!</span>");
                    this.counts.readyToImportCount++;
                    this.counts.archivedCount--;
                    this.renderFeatureCounts();
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + res.error + "</span>");
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Restore'
                });
            }
        }, this));
    },
    addProjectClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.addProject(model);
    },
    addProject: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        let loader = new PJQ.Loader(actionButtonContainer);

        model.pull((res) => {
            loader.remove();
            if (res) {
                let project = new PJQ.models.projects.Project(res);
                if (project.id > 0) {
                    project.save(null, {
                        success: () => {
                            actionButtonContainer.html("<div><div class='text-success'>Project Created!</div>" +
                                "<div><a class='btn btn-link btn-sm ml-2' href='#projects/" + project.id + "'>View Project</a></div></div>");
                            this.counts.readyToImportCount--;
                            this.renderFeatureCounts();
                        }
                    })
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + res.error + "</span>");
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Import Project'
                });
            }
        });
    },
    linkProjectClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.linkProject(model);
    },
    linkProject: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');


        // new PJQ.views.contacts.SelectContactsModal({
        //     context: PJQ.constants.contacts.contexts.COMPANIES,
        //     isSingleChoice: true,
        //     displayContactsBlock: true,
        //     onSave: _.bind(function (selectedCompany) {
        //         let loader = new PJQ.Loader(actionButtonContainer);
        //         selectedCompany.set('companyId', selectedCompany.get('contactCompanyId'));
        //         model.linkContactCompany(selectedCompany, model.erpObject.externalId, _.bind(function (contactCompany, err) {
        //             loader.remove();
        //             if (contactCompany) {
        //                 if (!contactCompany.error) {
        //                     actionButtonContainer.html("<span class='text-success'>Company Linked!</span>");
        //                     this.counts.readyToImportCount--;
        //                     this.renderFeatureCounts();
        //                 } else {
        //                     actionButtonContainer.html("<span class='text-danger'>" + err ? err : contactCompany.error + "</span>");
        //                 }
        //             } else {
        //                 PJQ.notifications.notify.errorNotify({
        //                     message: 'Failed to Import Contact'
        //                 });
        //             }
        //         }, this));
        //     }, this)
        // });
    },
    addCostCodeClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.addCostCode(model);
    },
    addCostCode: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container'),
            loader = new PJQ.Loader(actionButtonContainer);

        this.createNewCostCodes([model.get('erpObject').externalId], (res) => {
            loader.remove();
            if (res) {
                actionButtonContainer.html("<span class='text-success'>Cost Code Created!</span>");
                this.counts.readyToImportCount--;

                this.renderFeatureCounts();
                this.handleSelectedERPItemsButtons(model);
                rowEl.find('.select-erp-item').closest('.text-align-center').remove();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Import Cost Code'
                });
            }
        });
    },
    addCostCodes: function () {
        let loader = new PJQ.Loader(this.$('.costcode-pane')),
            costCodes = [],
            costCodesExternalIds = [];

        _.each(this.options.selectedERPItems, _.bind(function (cid) {
            let model = this.collection.get(cid);
            costCodes.push(model);
            costCodesExternalIds.push(model.get('erpObject').externalId)
        }, this));


        this.createNewCostCodes(costCodesExternalIds, (res) => {
            _.each(costCodes, function (costCode) {
                this.filteredModels = _.reject(this.filteredModels, function (m) {
                    return m === costCode;
                });
                this.options.selectedERPItems = _.reject(this.options.selectedERPItems, function (cid) {
                    return cid === costCode.cid;
                });
                costCode.isImported = true;

                let rowEl = this.$('tr#' + costCode.cid);
                rowEl.find('.action-button-container').html("<span class='text-success'>Cost Code Created!</span>");
                rowEl.find('.select-erp-item').closest('.text-align-center').remove();
            }, this);
            loader.remove();
            this.handleSelectedERPItemsButtons();
        });

    },
    createNewCostCodes: function (externalIds, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'pull'
                }]),
            data: externalIds,
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    },
    refresh: async function () {
        this.toggleLoader(true);
        await this.collection.refreshModels(this.provider.erpAdmin.features[this.feature].externalModelName + 's').catch((err) => {
            this.erpIntegration.handleError(err);
            this.toggleLoader(false);
            return;
        });

        let date = new Date();
        if (this.feature === this.provider.erpAdmin.features.project.internalModelName) {
            this.syncData.projectsSyncedOn = date.toISOString();
        } else if (this.feature === this.provider.erpAdmin.features.cont_comp.internalModelName) {
            this.syncData.vendorsSyncedOn = date.toISOString();
        } else if (this.feature === this.provider.erpAdmin.features.costcode.internalModelName) {
            this.syncData.costCodesSyncedOn = date.toISOString();
        }

        this.toggleLoader(false);
        await this.fetchERPObjects().catch((err) => {
            return;
        });
        this.render();
    }
});

PJQ.views.erpAdmin.SelectImportVendorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-select-import-vendor'),
        width: '60%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-vendor": "selectVendor",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.hasPermission('settings.canManageERPAdmin');
        this.selectedVendors = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.erpAdmin.ERPObjects(null, {
                internalModel: this.options.provider.erpAdmin.features.cont_comp.internalModelName,
                statusIds: []
            });
        }

        if (this.collection.isFetched) {
            this.render();
        } else {
            this.collection.fetch({
                data: {
                    externalModel: this.options.provider.erpAdmin.features.cont_comp.externalModelName
                },
                success: _.bind(function () {
                    this.vendors = this.collection.models
                    this.render();
                }, this)
            });
        }
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.vendors-table'),
            data: this.vendors,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "width": "7%",
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-vendor"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.relatedObjects.relatedItem.companyName",
                    "title": "Company",
                    "width": "20%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.address1",
                    "title": "Address",
                    "width": "20%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.city",
                    "title": "City",
                    "width": "10%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.state",
                    "title": "State",
                    "width": "5%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.zip",
                    "title": "Zip",
                    "width": "10%"
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectVendor: function (e) {
        let target = $(e.currentTarget),
            vendor = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-vendor').not(target).text('Select').prop('checked', false);
            if (vendor.get('isSelected')) {
                vendor.set('isSelected', false);
                this.selectedVendor = null;
            } else {
                vendor.set('isSelected', true);
                this.selectedVendor = vendor;
                this.collection.get(vendor.id);
                _.each(this.collection.models, _.bind(function (dtVendor) {
                    if (vendor.id !== dtVendor.id)
                        dtVendor.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedVendor == null);

            if (typeof this.options.onVendorSelected === 'function') {
                this.options.onVendorSelected(this.selectedVendor);
            }
        } else {
            if (vendor.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                vendor.set('isSelected', false);
                this.selectedVendors = _.reject(this.selectedVendors, function (selVendor) {
                    return selVendor.id === vendor.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                vendor.set('isSelected', true);
                this.selectedVendors.push(vendor);
            }
            this.$('.btn-save').attr('disabled', this.selectedVendors == null);

            if (typeof this.options.onVendorSelected === 'function') {
                this.options.onVendorSelected(this.selectedVendors);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedVendor ? this.selectedVendor : this.selectedVendors);
            this.removeModal();
        }
    }
});
// Initialize
PJQ.financialMarkups = {
    models: {},
    collections: {},
    views: {}
};

// Models
PJQ.financialMarkups.models.FinancialMarkup = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {

    },
    calculate: function (lineItem, compoundAmt) {
        if (this.get('void') || this.get('isApplied') || this.lineItem != null) {
            return 0;
        }

        let amt;
        if (lineItem instanceof PJQ.models.changeRequests.ChangeRequestLineItem) {
            amt = lineItem.get('revenue') ?? 0;
        } else {
            amt = lineItem.get('amount') ?? 0;
        }

        if (_.size(this.get('costCodeIds')) > 0) {
            if (!_.contains(this.get('costCodeIds'), lineItem.get('costCodeId'))) {
                return 0;
            }
        }

        if (_.size(this.get('costTypeIds')) > 0) {
            if (!_.contains(this.get('costTypeIds'), lineItem.get('costTypeId'))) {
                return 0;
            }
        }

        if (this.get('isCompounding')) {
            amt += compoundAmt ?? 0;
        }

        return PJQ.helpers.mathHelpers.roundAwayFromZero(amt * (this.get('percent') / 10000));
    }
});

// Collections
PJQ.financialMarkups.collections.FinancialMarkups = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.financialMarkups.models.FinancialMarkup,
    endpoint: function () {

    },
    getMarkups: function (lineItems) {
        let result = [],
            sortedMarkups = _.sortBy(_.filter(this.models, (markup) => {
                return !markup.get('delete') && !markup.get('void')
            }), (model) => {
                return model.get('sortOrder');
            });

        let amts = {};
        _.each(lineItems.filter((lineItem) => {
            return !lineItem.get('delete');
        }), (lineItem) => {
            let liMarkup = 0,
                isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

            _.each(sortedMarkups, (markup) => {
                let amt = amts[markup.cid];
                if (amt == null) {
                    amt = 0;
                }
                let tMarkup = !isAppliedLineItem ? markup.calculate(lineItem, liMarkup) : 0;
                amts[markup.cid] = amt + tMarkup;
                liMarkup += tMarkup;
            });
        });

        _.each(sortedMarkups, (markup) => {
            let amt = amts[markup.cid];
            if (amt == null) {
                amt = 0;
            }
            result.push({
                cid: markup.cid,
                model: markup,
                name: markup.get('name'),
                amount: amt,
                isApplied: markup.get('appliedCostCodeId') != null && markup.get('appliedCostTypeId') != null,
                isVertical: markup.get('isVertical'),
                sortOrder: markup.get('sortOrder')
            });
        });
        return result;
    }
});

// Views
PJQ.financialMarkups.views.FinancialMarkupsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'financial-markups-list'),
        canEdit: true,
        canVoid: false,
        autoVoid: false
    },
    events: {
        'click .btn-add-markup': 'addMarkup',
        'click .btn-edit-markup': 'editMarkupClicked',
        'click .btn-delete-markup': 'deleteMarkupClicked'
    },
    beforeFirstRender: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.isFetched = false;

        this.subJobs = await this.options.project.fetchSubJobs();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        let tableData = _.map(this.collection.models, function (markup) {
            if (!markup.get('delete')) {
                return markup;
            }
        }, this)

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.markup-items-table'),
            data: tableData,
            rowId: "cid",
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add" to create a new Markup Item' : 'No markups have been added'
            },
            paging: false,
            isHideSearch: true,
            onRowDoubleClick: (row) => {
                if (this.options.canEdit) {
                    this.editMarkup(row.data());
                }
            },
            sortableOptions: this.options.canEdit ? {
                data: this.collection,
                stop: (a, b) => {
                    if (this.options.canEdit) {
                        let self = this;
                        self.$('tbody>tr').each(function (index, html) {
                            let row = $(html)[0].id,
                                rowData = self.collection.get(row);
                            rowData.set('sortOrder', index + 1);
                        });
                        this.collection.trigger('update');
                        this.dataTable.refresh();
                    }
                }
            } : null,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editMarkup(row.data());
                        },
                        isShown: (row) => {
                            return this.options.canEdit;
                        },
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteMarkup(row);
                        },
                        isShown: (row) => {
                            return this.options.canEdit;
                        },
                    }
                ]
            },
            order: [0, 'asc'],
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "width": '60px',
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false,
                    "render": (data, type, row) => {
                        return '<a href="javascript:void(0)" class="btn-edit-markup">' + data + '</a>'
                    }
                },
                {
                    "title": "Percent",
                    "data": "attributes.percent",
                    "orderable": false,
                    "width": '100px',
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatDecimal(data / 100, 2) + "%";
                    }
                },
                {
                    "title": "Compounding",
                    "data": "attributes.isCompounding",
                    "orderable": false,
                    "width": '120px',
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "title": "Vertical",
                    "data": "attributes.isVertical",
                    "orderable": false,
                    "width": '100px',
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "title": "Changes Only",
                    "data": "attributes.void",
                    "orderable": false,
                    "width": '100px',
                    "visible": this.options.canVoid,
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "title": "Applies To",
                    "data": "attributes.isApplied",
                    "orderable": false,
                    "render": (data, type, row) => {
                        let appliedCostCodeId = row.get('appliedCostCodeId');
                        if (!(appliedCostCodeId > 0)) {
                            return '';
                        }

                        let costCode = _.find(this.costCodes.models, (costCode) => {
                            return costCode.id === appliedCostCodeId;
                        });
                        return costCode?.getDisplayName() ?? '';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "visible": this.options.canEdit,
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": '100px',
                    "render": (data, type, row) => {
                        if (!this.options.canEdit) {
                            return '';
                        }
                        let res = '<div class="text-align-right show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-edit-markup wd-30p mr-1"><i class="fal fa-pencil"></i></button>';
                        if (!this.options.autoVoid || row.get('void')) {
                            res += '<button type="button" class="btn btn-danger btn-delete-markup wd-30p"><i class="fal fa-trash-alt"></i></button>';
                        }
                        res += '</div>';
                        return res;
                    }
                }
            ]
        });
    },
    addMarkup: function () {
        let markup = new PJQ.financialMarkups.models.FinancialMarkup({
            name: "",
            percent: 0,
            isCompounding: false,
            isVertical: false,
            sortOrder: this.collection.length + 1,
            costCodeIds: [],
            costTypeIds: [],
            void: this.options.autoVoid === true,
            isApplied: this.options.defaultToAppliedMarkups === true
        });

        this.editMarkup(markup);
    },
    editMarkupClicked: function (e) {
        let $target = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($target),
            markup = row.data();

        this.editMarkup(markup);
    },
    editMarkup: function (markup) {
        new PJQ.financialMarkups.views.EditFinancialMarkupModal({
            model: markup,
            canEdit: this.options.canEdit && (markup.get('void') || !this.options.autoVoid),
            canVoid: this.options.canVoid,
            autoVoid: this.options.autoVoid,
            onSave: (markup) => {
                if (markup.isNew() && !markup.hasBeenAdded) {
                    let makeSortable = _.size(_.filter(this.collection.models, (model) => {
                        return !model.get('delete')
                    })) === 0;
                    this.collection.add(markup);
                    this.dataTable.addRow(markup);
                    markup.hasBeenAdded = true;

                    if (makeSortable) {
                        this.dataTable.makeSortable(this.dataTable.options.sortableOptions);
                    }
                } else {
                    this.collection.trigger('update');
                    this.dataTable.refresh();
                }

                if (markup.get('appliedCostCodeId') && markup.get('appliedCostTypeId')) {
                    this.collection.trigger('appliedMarkupChanged', markup);
                }
            }
        });
    },
    deleteMarkupClicked: function (e) {
        let $target = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($target);

        this.deleteMarkup(row);
    },
    deleteMarkup: function (row) {
        let markup = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this markup?",
            onDelete: () => {
                markup.set('delete', true);
                this.dataTable.removeRow(row);
                this.collection.trigger('update', markup);
                _.each(this.collection.models, function (markupModel) {
                    if (!markupModel.get('delete') && markupModel.get('sortOrder') > markup.get('sortOrder')) {
                        markupModel.set('sortOrder', markupModel.get('sortOrder') - 1);
                    }
                }, this);

            }
        });
    }
});

PJQ.financialMarkups.views.EditFinancialMarkupModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-financial-markup'),
        maxWidth: 600,
        canVoid: false,
        autoVoid: false
    },
    events: {
        'focus .input-percent': 'selectInput',
        'click .btn-save': 'save',
        'click .applied-markup': 'toggleAppliedMarkup'
    },
    beforeModalCreated: async function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.isFetched = false;

        this.subJobs = await this.options.project.fetchSubJobs();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            canEdit: this.options.canEdit,
            canVoid: this.options.canVoid,
            autoVoid: this.options.autoVoid
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (_.size(this.model.get('name')) === 0) {
            this.$('.input-name').focus();
        }

        this.costCodePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-codes'),
            defaultValue: this.model.get('costCodeIds') ? this.model.get('costCodeIds') : [],
            noneSelectedText: _.size(this.costCodes.models) > 0 ? 'Select Cost Codes (Optional)' : 'No Cost Codes exist on this project',
            isDisabled: _.size(this.costCodes.models) === 0,
            isMultiple: true,
            isIntChoices: true,
            isLiveSearch: true,
            onChange: _.bind(function (value) {
                value = _.size(value) > 0 ? value : null;
                this.model.set('costCodeIds', value);
            }, this)
        });
        this.populateCostCodePicker();

        this.costTypePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-types'),
            isLiveSearch: true,
            isIntChoices: true,
            isDisabled: _.size(this.costTypes.models) === 0,
            noneSelectedText: _.size(this.costCodes.models) > 0 ? 'Select Cost Types (Optional)' : 'No Cost Types exist',
            isMultiple: true,
            choices: _.map(this.costTypes.models, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            }),
            defaultValue: this.model.get('costTypeIds') ? this.model.get('costTypeIds') : [],
            onChange: _.bind(function (value) {
                value = _.size(value) > 0 ? value : null;
                this.model.set('costTypeIds', value);
            }, this)
        });

        let costCode = this.model.get('appliedCostCodeId') ? _.find(this.costCodes.models, (costCode) => {
                return costCode.id === this.model.get('appliedCostCodeId');
            }) : null,
            appliedSubJobId = costCode != null ? costCode.get('subJobId') : null;
        // Applied Sub Job Picker
        if (_.size(this.subJobs.models) > 0) {
            this.appliedSubJobPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-applied-subjob'),
                isLiveSearch: true,
                isIntChoices: true,
                noneSelectedText: "Parent Job",
                choices: _.union([{
                    id: "",
                    name: 'Parent Job'
                }], _.map(this.subJobs.models, function (subJob) {
                    return {
                        id: subJob.id,
                        name: subJob.get('name')
                    };
                })),
                defaultValue: appliedSubJobId,
                onChange: (value) => {
                    this.model.set('appliedSubJobId', value > 0 ? value : null);
                    this.model.set('appliedCostCodeId', null);
                    this.model.set('appliedCostTypeId', null);

                    let filteredCostCodes = _.filter(this.costCodes.models, (costCode) => {
                        return costCode.get('subJobId') === value;
                    });
                    this.appliedCostCodePicker.updateChoices(_.map(filteredCostCodes, function (costCode) {
                        return {
                            id: costCode.id,
                            name: costCode.get('name')
                        };
                    }));
                    this.appliedCostCodePicker.setValue(null);
                    this.appliedCostTypePicker.setValue(null);
                    this.appliedCostTypePicker.disable();
                }
            });
        } else {
            this.$('.applied-subjob').addClass('hidden');
        }

        // Applied Cost Code Picker
        let filteredAppliedCostCodes = _.filter(this.costCodes.models, (costCode) => {
            return appliedSubJobId ? costCode.get('subJobId') === appliedSubJobId : costCode.get('subJobId') == null;
        });
        this.appliedCostCodePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-applied-cost-code'),
            isLiveSearch: true,
            isIntChoices: true,
            choices: _.map(filteredAppliedCostCodes, function (costCode) {
                return {
                    id: costCode.id,
                    name: costCode.getDisplayName()
                };
            }),
            defaultValue: this.model.get('appliedCostCodeId'),
            onChange: (value) => {
                this.model.set('appliedCostCodeId', value);
                this.model.set('appliedCostTypeId', null);

                let costCode = _.find(this.costCodes.models, (costCode) => {
                        return costCode.id === value;
                    }),
                    filteredCostTypes = costCode.get('costTypeIds') != null ? _.filter(this.costTypes.models, (costType) => {
                        return _.contains(costCode.get('costTypeIds'), costType.id);
                    }) : this.costTypes.models;

                this.appliedCostTypePicker.updateChoices(_.map(filteredCostTypes, function (costType) {
                    return {
                        id: costType.id,
                        name: costType.get('name')
                    };
                }));
                this.appliedCostTypePicker.setValue(null);
                this.appliedCostTypePicker.enable();
            }
        });

        // Applied Cost Type Picker
        let appliedCostCode = _.find(this.costCodes.models, (costCode) => {
                return costCode.id === this.model.get('appliedCostCodeId');
            }),
            filteredAppliedCostTypes = appliedCostCode != null && appliedCostCode.get('costTypeIds') != null ? _.filter(this.costTypes.models, (costType) => {
                return _.contains(appliedCostCode.get('costTypeIds'), costType.id);
            }) : this.costTypes.models;
        this.appliedCostTypePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-applied-cost-type'),
            isLiveSearch: true,
            isIntChoices: true,
            isDisabled: this.model.get('appliedCostCodeId') == null,
            choices: _.map(filteredAppliedCostTypes, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            }),
            defaultValue: this.model.get('appliedCostTypeId'),
            onChange: (value) => {
                this.model.set('appliedCostTypeId', value);
            }
        });

        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
        this.toggleAppliedMarkup();
    },
    selectInput: function (e) {
        let el = $(e.currentTarget)[0];
        if (this.focusInput !== el) {
            this.focusInput = el;
            setTimeout(_.bind(function () {
                this.focusInput.select();
            }, this), 100);
        }
    },
    toggleAppliedMarkup: function () {
        let $checkbox = this.$('.applied-markup'),
            $appliedMarkupContainer = this.$('.applied-markup-container'),
            isChecked = $checkbox.is(':checked'),
            isVerticalCheckbox = this.$('.is-vertical');

        if (isChecked) {
            $appliedMarkupContainer.removeClass('hidden');
            this.model.set('isVertical', false);
            isVerticalCheckbox.prop('checked', false);
            isVerticalCheckbox.prop('disabled', true);
        } else {
            $appliedMarkupContainer.addClass('hidden');
            isVerticalCheckbox.prop('disabled', !this.options.canEdit);
            this.model.set('appliedCostCodeId', null);
            this.model.set('appliedCostTypeId', null);
            if (this.appliedSubJobPicker) {
                this.appliedSubJobPicker.setValue(null);
            }
            this.appliedCostCodePicker.setValue(null);
            this.appliedCostTypePicker.setValue(null);
        }
    },
    populateCostCodePicker: function () {
        // Group the cost codes by their Sub Job
        let groupedCostCodes = _.groupBy(this.costCodes.models, function (costCode) {
            return costCode.get('subJobId');
        });

        // Convert groupedCostCodes to the format that updateChoices expects
        let choices = _.map(groupedCostCodes, function (costCodes, subJobId) {
            let subJob = _.find(this.subJobs.models, function (subJob) {
                return subJob.id === parseInt(subJobId);
            }, this);
            return {
                name: subJob != null ? subJob.get('name') : 'No Sub Job',
                choices: _.map(costCodes, function (costCode) {
                    return {
                        id: costCode.id,
                        name: costCode.get('name')
                    };
                })
            };
        }, this);

        if (this.costCodePicker != null) {
            this.costCodePicker.updateChoices(choices);
            this.costCodePicker.setValue(this.model.get('costCodeIds') ? this.model.get('costCodeIds') : []);
            if (_.size(this.costCodes.models) > 0 && this.options.canEdit) {
                this.costCodePicker.enable();
            } else {
                this.costCodePicker.disable();
            }
            this.costCodePicker.render();
        }
    },
    validate: function () {
        let isValid = true,
            isAppliedMarkup = this.$('.applied-markup').is(':checked');

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-name'), true);
        if (this.model.get('name') == null || this.model.get('name').trim().length === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-name'), false);
            isValid = false;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-percent'), true);
        if (this.model.get('percent') == null) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-percent'), false);
            isValid = false;
        }

        if (isAppliedMarkup) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-code'), true);
            if (this.model.get('appliedCostCodeId') == null) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-code'), false);
                isValid = false;
            }

            PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-type'), true);
            if (this.model.get('appliedCostTypeId') == null) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.select-applied-cost-type'), false);
                isValid = false;
            }
        }

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.model);
            this.removeModal();
        }
    }
});
PJQ.views.budget.AddBudgetLineItemForecastModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-add-forecast'),
		subTemplates: {
			lineItems: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'add-forecast-line-item')
		},
		maxWidth: 900,
		isShowCloseButton: true,
		onSave: _.noop,
		canEdit: true,
		isAdmin: true
	},
	events: {
		'keyup .input-quantity, .input-unit-price': 'calculateUnitTotal',
		'click .btn-add-line-item': 'addLineItem',
		'click .btn-delete-line-item': 'deleteLineItem',
		'click .btn-save': 'save',
		'click .btn-cancel': 'cancel',
		'click .btn-switch-method': 'switchMethod'
	},
	beforeModalCreated: function () {
		this.options.canEdit = PJQ.app.session.project.hasPermission('budget.canEdit');
		this.options.isAdmin = PJQ.app.session.project.hasPermission('budget.isAdmin');

		this.model.fetch({
			success: _.bind(function(){
				PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
					this.costTypes = costTypes;
					PJQ.app.session.project.fetchUnitsOfMeasure(_.bind(function (unitsOfMeasure) {
						this.unitsOfMeasure = unitsOfMeasure
						this.collection = new PJQ.collections.budget.ForecastLineItems(this.model.get('forecastLineItems'));
						this.render();
					}, this));
				}, this));
			}, this)
		})

	},
	renderData: function () {
		return {
			collection: this.collection,
			costTypes: this.costTypes != null ? this.costTypes.models : [],
			unitsOfMeasure: this.unitsOfMeasure != null ? this.unitsOfMeasure.models : [],
			accountingMethod: this.accountingMethod,
			model: this.model,
			canEdit: this.options.canEdit,
			isAdmin: this.options.isAdmin
		}
	},
	afterRender: function () {
		this.unitOfMeasureSelector = new PJQ.inputs.Selectpicker({
			el: this.$('.select-unit-of-measure'),
			defaultValue: this.unitsOfMeasure != null && _.size(this.unitsOfMeasure.models) > 0 ? this.unitsOfMeasure.models[0].id : null,
			onChange: _.bind(function (value) {
				this.validateForm();
			}, this),
			isIntChoices: true,
			hideDisabled: true
		});

		PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);

		this.renderLineItems();
	},
	validateForm: function () {
		let quantity = this.$('.input-quantity').val(),
			unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price')),
			valid = quantity > 0 && unitPrice > 0;
		this.$('.btn-add-line-item').prop('disabled', !valid);
	},
	calculateUnitTotal: function () {
		let quantity = parseInt(this.$('.input-quantity').val()),
			unitPrice = PJQ.helpers.formatHelpers.numbersOnly(this.$('.input-unit-price').val(), false, true);
		this.$('.unit-total').html(PJQ.helpers.formatHelpers.formatCurrency(quantity * unitPrice));
		this.validateForm();
	},
	setAccountingMethod: function (method) {
		this.accountingMethod = method;

		let $manual = this.$('.method-manual'),
			$calculated = this.$('.method-calculated');
		if (this.accountingMethod === 0) {
			$manual.removeClass('hidden');
			$calculated.addClass('hidden');
		}
		else if (this.accountingMethod === 1) {
			$manual.addClass('hidden');
			$calculated.removeClass('hidden');
		}
	},
	resetAddForm: function () {
		this.$('.input-budgeted-cost').val('');
		this.$('.description').val('');
		this.$('.input-unit-price').val('');
		this.$('.input-quantity').val('');
		this.validateForm();
	},
	deleteLineItem: function (e) {
		let $target = $(e.currentTarget).closest('.line-item'),
			cid = $target.data('cid'),
			item = this.collection.get(cid);

		item.set('delete', true);
		$target.closest('.line-item').remove();
		this.calculateSubTotal();
	},
	addLineItem: function () {
		let newLineItem = new PJQ.models.budget.ForecastLineItem({
			budgetId: this.options.budget.id,
			accountingMethod: this.accountingMethod
		});
			let quantity = this.$('.input-quantity').val(),
				unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price')),
				description = this.$('.description').val();
			newLineItem.set({
				unitId: this.unitOfMeasureSelector.getValue(),
				quantity: _.size(quantity) > 0 ? parseInt(quantity) : 0,
				unitPrice: unitPrice != null ? unitPrice : 0,
				description: description
			})

		this.$('.alert').prop('hidden', true);
		this.model.set('forecastMethod', 1);
		this.collection.add(newLineItem);
		this.renderLineItems();
		this.resetAddForm();
	},
	renderLineItems: function ($el, lineItem) {
		if(this.collection) {
			this.$('.no-items').addClass('hidden');
			this.renderSubTemplate(false, this.options.subTemplates.lineItems, this.$('.line-items'), {
				lineItems: this.collection.models,
				groups: this.groups,
				costTypes: this.costTypes,
				unitsOfMeasure: this.unitsOfMeasure
			}, _.bind(function (el) {
			}, this));

			this.calculateSubTotal();
		}
	},
	calculateSubTotal: function() {
		let subtotal = 0;
		_.each(this.collection.models, function (item) {
			subtotal += item.get('quantity') * item.get('unitPrice')
		}, this)
		this.$('.subtotal').html(PJQ.helpers.formatHelpers.formatCurrency(subtotal));
	},
	switchMethod: function() {
		if(this.model.get('forecastMethod') === 1) {
			new PJQ.views.modals.YesNo({
				header: "Set to Automatic Calculation?",
				body: "Forecast to Complete will no longer be manually calculated, however any existing line items will still be saved. Would you like to continue?",
				onYes: _.bind(function () {
					this.model.set('forecastMethod', 0);
					this.render();
				}, this)
			});
		}
		else{
			new PJQ.views.modals.YesNo({
				header: "Switch to Manual Calculation?",
				body: "Forecast to Complete will no longer be automatically calculated. Would you like to continue?",
				onYes: _.bind(function () {
					this.model.set('forecastMethod', 1);
					this.render();
				}, this)
			});
		}
	},
	save: function () {
		this.model.set('forecastLineItems', this.collection.toJSON());

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'budgets',
					value: this.options.budget.id
				},
				{
					endpoint: 'lineitems',
					value: this.model.id
				},
				{
					endpoint: 'forecast'
				}
			]),
			isAPIv2: true,
			data: this.model
		}).put().done(_.bind(function (data) {
			PJQ.notifications.notify.successNotify({
				message: 'Forecast Successfully Changed'
			});
			if(typeof this.options.onSave === 'function'){
				this.options.onSave(false);
			}
			this.removeModal();
		}, this)).fail(function() {
			PJQ.notifications.notify.errorNotify({
				message: 'Failed to modify Forecast'
			});
			if(typeof this.options.onSave === 'function'){
				this.options.onSave(false);
			}
		});
	},
	cancel: function () {
		if(this.model.hasChanged()){
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.save();
				}, this),
				onDontSave: _.bind(function () {
					this.model.restore();
					this.removeModal();
				}, this)
			});
		}
		else{
			this.removeModal();
		}
	}
});

PJQ.integrations = {
    views: {},
    models: {},
    collections: {}
}

PJQ.modules.budget = {
    routes: [
        {
            route: "budget",
            name: 'budget',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "budget"
                });
            }
        },
        {
            route: 'projects/:projectId/budget',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "budget");
            }
        },
        {
            route: 'projects/:projectId/costcodes',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "costcodes");
            }
        },
        {
            route: 'projects/:projectId/subjobs',
            name: 'budget',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "subjobs");
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.budget.routes);

PJQ.constants.integrations = {
    settings: {
        SYNC_PROJECTS: 'syncProjects',
        SYNC_VENDORS: 'syncVendors',
        SYNC_SUB_JOBS: 'syncSubJobs',
        SYNC_BUDGET: 'syncBudget',
        SYNC_DIRECT_COSTS: 'syncDirectCosts',
        SYNC_COMMITMENTS: 'syncCommitments',
        SYNC_COMMITMENT_CHANGE_ORDERS: 'syncCommitmentChangeOrders',
        SYNC_PRIME_CONTRACTS: 'syncPrimeContracts',
        SYNC_PRIME_CONTRACT_CHANGE_ORDERS: 'syncPrimeContractChangeOrders',
        SYNC_PAYABLE_INVOICES: 'syncPayableInvoices',
        SYNC_RECEIVABLE_INVOICES: 'syncReceivableInvoices',
        SYNC_TIME_CARDS: 'syncTimeCards',
    },
    actions: {
        CAN_ADD_MARKUPS_AFTER_SYNC: 'CAN_ADD_MARKUPS_AFTER_SYNC',
        PUSH_VENDORS: 'PUSH_VENDORS',
        UNLINK_VENDOR: 'UNLINK_VENDOR',
        PUSH_PROJECT: 'PUSH_PROJECT',
        LINK_PROJECT: 'LINK_PROJECT',
        UNLINK_PROJECT: 'UNLINK_PROJECT',
        PROJECT_SPECIFIC_COST_CODES: 'PROJECT_SPECIFIC_COST_CODES',
        PUSH_SUB_JOBS: 'PUSH_SUB_JOBS',
        PULL_SUB_JOBS: 'PULL_SUB_JOBS',
        PUSH_COMPANY_COST_CODES: 'PUSH_COMPANY_COST_CODES',
        PULL_COMPANY_COST_CODES: 'PULL_COMPANY_COST_CODES',
        PUSH_PROJECT_COST_CODES: 'PUSH_PROJECT_COST_CODES',
        PULL_PROJECT_COST_CODES: 'PULL_PROJECT_COST_CODES',
        PUSH_COMPANY_TAX_CODES: 'PUSH_COMPANY_TAX_CODES',
        PULL_COMPANY_TAX_CODES: 'PULL_COMPANY_TAX_CODES',
        PUSH_COST_TYPES: 'PUSH_COST_TYPES',
        PULL_COST_TYPES: 'PULL_COST_TYPES',
        PUSH_BUDGET: 'PUSH_BUDGET',
        PULL_BUDGET: 'PULL_BUDGET',
        PUSH_COMMITMENTS: 'PUSH_COMMITMENTS',
        PUSH_COMMITMENTS_WITH_VENDOR: 'PUSH_COMMITMENTS_WITH_VENDOR',
        PULL_COMMITMENTS: 'PULL_COMMITMENTS',
        PULL_COMMITMENTS_DOC_CLERK_REQUIRED: 'PULL_COMMITMENTS_DOC_CLERK_REQUIRED',
        UNLINK_COMMITMENTS: 'UNLINK_COMMITMENTS',
        PUSH_COMMITMENT_CHANGE_ORDERS: 'PUSH_COMMITMENT_CHANGE_ORDERS',
        PULL_COMMITMENT_CHANGE_ORDERS: 'PULL_COMMITMENT_CHANGE_ORDERS',
        COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV: 'COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV',
        UNLINK_COMMITMENT_CHANGE_ORDERS: 'UNLINK_COMMITMENT_CHANGE_ORDERS',
        PUSH_CHANGE_REQUESTS: 'PUSH_CHANGE_REQUESTS',
        PUSH_PRIME_CONTRACTS: 'PUSH_PRIME_CONTRACTS',
        PUSH_PRIME_CONTRACTS_WITH_CLIENT: 'PUSH_PRIME_CONTRACTS_WITH_CLIENT',
        PULL_PRIME_CONTRACTS: 'PULL_PRIME_CONTRACTS',
        PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED: 'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
        UNLINK_PRIME_CONTRACTS: 'UNLINK_PRIME_CONTRACTS',
        PUSH_PRIME_CONTRACT_CHANGE_ORDERS: 'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
        PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT: 'PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT',
        PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO: 'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
        PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED: 'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
        PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER: 'PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER',
        UNLINK_PRIME_CONTRACT_CHANGE_ORDERS: 'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
        CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM: 'CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM',
        PUSH_DIRECT_COSTS: 'PUSH_DIRECT_COSTS',
        PULL_DIRECT_COSTS: 'PULL_DIRECT_COSTS',
        UNLINK_DIRECT_COSTS: 'UNLINK_DIRECT_COSTS',
        PUSH_PAYABLE_INVOICES: 'PUSH_PAYABLE_INVOICES',
        PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT: 'PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT',
        PULL_PAYABLE_INVOICES: 'PULL_PAYABLE_INVOICES',
        PULL_RECEIVABLE_PAYMENTS: 'PULL_RECEIVABLE_PAYMENTS',
        PULL_PAYABLE_PAYMENTS: 'PULL_PAYABLE_PAYMENTS',
        UNLINK_PAYABLE_INVOICES: 'UNLINK_PAYABLE_INVOICES',
        REQUIRE_SYNCED_COST_TYPES: 'REQUIRE_SYNCED_COST_TYPES',
        REQUIRE_SYNCED_COST_CODES: 'REQUIRE_SYNCED_COST_CODES',
        PUSH_RECEIVABLE_INVOICES: 'PUSH_RECEIVABLE_INVOICES',
        PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT: 'PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT',
        PULL_RECEIVABLE_INVOICES: 'PULL_RECEIVABLE_INVOICES',
        UNLINK_RECEIVABLE_INVOICES: 'UNLINK_RECEIVABLE_INVOICES',
        CREATE_TAX_CODES: 'CREATE_TAX_CODES',
        DISABLE_EDIT_COST_CODE_TYPE_FILTER: 'DISABLE_EDIT_COST_CODE_TYPE_FILTER',
        RELATE_CCO_LINE_TO_COMMITMENT_LINE: 'RELATE_CCO_LINE_TO_COMMITMENT_LINE',
        CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE: 'CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE',
        CAN_RELEASE_COMMITMENT_RETAINAGE: 'CAN_RELEASE_COMMITMENT_RETAINAGE',
        BULK_RETRY_FAILED_TIME_CARDS: 'BULK_RETRY_FAILED_TIME_CARDS',
        DISABLE_UPDATE_PAYABLE_INVOICE_LINE_RETAINAGE: 'DISABLE_UPDATE_PAYABLE_INVOICE_LINE_RETAINAGE'
    },
    providers: {
        ACUMATICA: {
            logoURL: '/assets/modules2/global/images/acumatica.png',
            name: 'ACUMATICA',
            shortName: 'Acumatica',
            displayName: 'Acumatica Cloud ERP',
            description: 'Integrate Acumatica Cloud ERP to work with your job costing tools',
            supportedVersions: [
                {
                    apiVersion: '25.200.001',
                    name: '2025 R1'
                },
                {
                    apiVersion: '24.200.001',
                    name: '2024 R1/R2'
                },
                {
                    apiVersion: '23.200.001',
                    name: '2023 R1/R2'
                },
                {
                    apiVersion: '22.200.001',
                    name: '2022 R1/R2'
                }
            ],
            availableActions: [
                'PUSH_VENDORS',
                'UNLINK_VENDOR',
                'PUSH_PROJECT',
                'LINK_PROJECT',
                'UNLINK_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PUSH_SUB_JOBS',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACTS_WITH_CLIENT',
                'UNLINK_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
                'PULL_DIRECT_COSTS',
                'UNLINK_DIRECT_COSTS',
                'PUSH_COMMITMENTS',
                'UNLINK_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'UNLINK_COMMITMENT_CHANGE_ORDERS',
                'PUSH_PAYABLE_INVOICES',
                'UNLINK_PAYABLE_INVOICES',
                'CREATE_TAX_CODES',
                'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PUSH_CONTRACT_CO_WITHOUT_PRIME_CONTRACT',
                'PUSH_RECEIVABLE_INVOICES',
                'UNLINK_RECEIVABLE_INVOICES',
                'RELATE_CCO_LINE_TO_COMMITMENT_LINE',
                'BULK_RETRY_FAILED_TIME_CARDS'
            ],
            availableActionsFn: {
                DISABLE_UPDATE_PAYABLE_INVOICE_LINE_RETAINAGE: (integration, invoice, commitment) => {
                    let exObj = commitment?.get('externalObject'),
                        acumaticaManagedRetainage = (exObj?.status !== 4 && !integration.getSetting('jobPlannerManagedRetainage')) || exObj?.data?.acumaticaManagedRetainage === true;
                    return {
                        available: acumaticaManagedRetainage && (integration.getSetting('version') === '22.200.001' || integration.getSetting('version') === '23.200.001'),
                    };
                },
                CAN_RELEASE_COMMITMENT_RETAINAGE: (integration, commitment) => {
                    let exObj = commitment?.get('externalObject'),
                        isPushed = exObj?.status === 4,
                        available = (!isPushed && !integration.getSetting('jobPlannerManagedRetainage')) || exObj?.data?.acumaticaManagedRetainage === true,
                        hasUnreleasedRetainage = null != _.find(commitment.invoices.models, (invoice) => {
                            return invoice.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.SYNCED
                                && invoice.get('workRetainage') > 0;
                        }),
                        alertText = '';
                    if (isPushed && available && _.size(commitment.get('externalObject')?.externalId) > 0 && hasUnreleasedRetainage) {
                        alertText = "This commitment has it's retainage managed by Acumatica. To release retainage for this commitment's invoices you can use the <b>Release ERP Retainage</b> button";
                    } else if (isPushed && !available && hasUnreleasedRetainage) {
                        alertText = "This commitment has it's retainage managed by JobPlanner. To release retainage for this commitment's invoices you can create a new Payable Invoice for this commitment and enter retainage released for each line item.";
                    }
                    return {
                        available: available,
                        alert: _.size(alertText) === 0 ? null : {
                            text: alertText,
                            type: 'warning'
                        }
                    }
                },
                CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE: (integration, invoice, commitment) => {
                    let exObj = commitment?.get('externalObject'),
                        isPushed = exObj?.status === 4,
                        available = (!isPushed && !integration.getSetting('jobPlannerManagedRetainage')) || exObj?.data?.acumaticaManagedRetainage === true,
                        hasUnreleasedRetainage = (invoice.get('workRetainage') - invoice.get('workRetainageReleased')) > 0,
                        alertText = '';
                    if (isPushed && available && _.size(invoice.get('externalObject')?.externalId) > 0 && hasUnreleasedRetainage) {
                        alertText = "The commitment for this invoice has it's retainage managed by Acumatica. To release retainage for this invoice you can use the <b>Release ERP Retainage</b> button";
                    } else if (isPushed && available && _.size(invoice.get('externalObject')?.externalId) === 0) {
                        alertText = "The commitment for this invoice has it's retainage managed by Acumatica. To release retainage for this invoice you can use the <b>Release ERP Retainage</b> button after this invoice has been pushed to Acumatica";
                    } else if (isPushed && !available && hasUnreleasedRetainage) {
                        alertText = "The commitment for this invoice has it's retainage managed by JobPlanner. To release retainage for this invoice you can create a new Payable Invoice for this commitment and enter retainage released for each line item.";
                    }
                    return {
                        available: available,
                        alert: _.size(alertText) === 0 ? null : {
                            text: alertText,
                            type: 'warning'
                        }
                    }
                },
            },
            options: {
                linkProjectAlert: 'Linking to existing Jobs within Acumatica that have existing transactions is not supported. This may cause discrepancies in your Job Costing data.'
            },
            budgetColumns: [
                {
                    name: 'Revised Budgeted Amount',
                    source: 'erp:rev_b_amt',
                    canCalculate: true,
                    format: 'money',
                    isErp: true
                },
                {
                    name: 'Revised Budgeted Quantity',
                    source: 'erp:rev_b_qty',
                    canCalculate: true,
                    format: 'decimal',
                    isErp: true
                },
                {
                    name: 'Budgeted CO Amount',
                    source: 'erp:b_co_amt',
                    canCalculate: true,
                    format: 'money',
                    isErp: true
                },
                {
                    name: 'Budgeted CO Quantity',
                    source: 'erp:b_co_qty',
                    canCalculate: true,
                    format: 'decimal',
                    isErp: true
                },
                {
                    name: 'Pending Invoice Amount',
                    source: 'erp:pnd_inv_amt',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Committed Invoiced Amount',
                    source: 'erp:cm_inv_amt',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Actual Amount',
                    source: 'erp:act_amt',
                    canCalculate: true,
                    format: 'money'
                },
            ],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'project',
                        displayName: "Projects",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Project ID',
                                value: 'projectID',
                                required: true,
                                className: 'input-project-id'
                            }
                        ]
                    },
                    subjob: {
                        internalModelName: 'subjob',
                        externalModelName: 'subjob',
                        displayName: "Sub Jobs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        }
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Vendor ID',
                                value: 'externalNumber',
                                required: true,
                                format: '#{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'costbudget',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    contract: {
                        internalModelName: 'contract',
                        externalModelName: 'contract',
                        displayName: "Contracts",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        }
                    },
                    ar_inv: {
                        internalModelName: 'ar_inv',
                        externalModelName: 'ar_inv',
                        displayName: "Receivable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'co_commitment',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_bill',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    timecard: {
                        internalModelName: 'timecard',
                        externalModelName: '',
                        displayName: "Time Cards",
                        filters: {
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                    }
                }
            }
        },
        QBO: {
            logoURL: '/assets/modules2/global/images/QBO_logo.svg',
            buttonClass: 'btn-qbo-connect',
            name: 'QBO',
            shortName: 'QuickBooks',
            buttonText: 'Connect to QuickBooks',
            displayName: 'QuickBooks Online',
            description: 'Integrate QuickBooks Online to work with your job costing tools',
            availableActions: [
                'UNLINK_PROJECT',
                'PUSH_VENDORS',
                'UNLINK_VENDOR',
                'PROJECT_SPECIFIC_COST_CODES',
                'PUSH_COMPANY_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PUSH_COST_TYPES',
                'PULL_COST_TYPES',
                'PUSH_COMMITMENTS',
                'PUSH_COMMITMENTS_WITH_VENDOR',
                'UNLINK_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'UNLINK_COMMITMENT_CHANGE_ORDERS',
                'PUSH_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACTS_WITH_CLIENT',
                'UNLINK_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
                'PULL_BUDGET',
                'PULL_DIRECT_COSTS',
                'PUSH_DIRECT_COSTS',
                'UNLINK_DIRECT_COSTS',
                'PUSH_PAYABLE_INVOICES',
                'PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT',
                'UNLINK_PAYABLE_INVOICES',
                'PUSH_RECEIVABLE_INVOICES',
                'PUSH_RECEIVABLE_INVOICES_WO_SYNCED_CONTRACT',
                'UNLINK_RECEIVABLE_INVOICES',
                'PULL_COMPANY_TAX_CODES',
                'LINK_PROJECT'
            ],
            options: {
                linkProjectAlert: 'QuickBooks Online limits 3rd party visibility to the last <strong>30 days</strong> of expenses. It is strongly recommended that you do not link to a project which has expenses older than this to avoid inconsistencies.'
            },
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'project',
                        displayName: "Projects",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: []
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: []
                    },
                    contract: {
                        internalModelName: 'contract',
                        externalModelName: 'contract',
                        displayName: "Contracts",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ar_inv: {
                        internalModelName: 'ar_inv',
                        externalModelName: 'ar_inv',
                        displayName: "Receivable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    d_cost: {
                        internalModelName: 'd_cost',
                        externalModelName: 'd_cost',
                        displayName: "Direct Costs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    }
                }
            }
        },
        SAGE100: {
            logoURL: '/assets/modules2/global/images/sage100.png',
            name: 'SAGE100',
            shortName: 'Sage 100',
            displayName: 'Sage 100 Contractor',
            description: 'Integrate Sage 100 Contractor to work with your job costing tools',
            availableActionsFn: {
                PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED: (integration) => {
                    return true !== integration.getSetting('contractSOVBudgetCodeRequired');
                },
                PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED: (integration) => {
                    return true !== integration.getSetting('contractCOSOVBudgetCodeRequired');
                },
                CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM: (integration) => {
                    return true !== integration.getSetting('changeRequestSOVDisableLinkedContractItems');
                }
            },
            availableActions: [
                'PUSH_VENDORS',
                'PUSH_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PULL_COMPANY_TAX_CODES',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'PULL_DIRECT_COSTS',
                'PUSH_PAYABLE_INVOICES',
                'REQUIRE_SYNCED_COST_TYPES',
                'PULL_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
                'PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER',
            ],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'job',
                        displayName: "Jobs",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9{0,8}',
                                className: 'input-project-code'
                            }
                        ]

                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'estimate',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                // format: '99999',
                                format: '#{0,20}',
                                className: 'input-commitment-number'
                            }
                        ]
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                // format: '9999',
                                format: '#{0,20}',
                                required: true,
                                className: 'input-cco-number'
                            }
                        ]
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '*{0,5}',
                                className: 'input-payable-invoice-number'
                            },
                            {
                                type: 'date',
                                name: 'Approval Date',
                                value: 'approvalDate',
                                required: false,
                                className: 'input-payable-invoice-approval-date'
                            }
                        ]
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9999',
                                className: 'input-pcco-number'
                            }
                        ]
                    },
                }
            }
        },
        SAGE300: {
            logoURL: '/assets/modules2/global/images/sage300.png',
            name: 'SAGE300',
            shortName: 'Sage 300',
            displayName: 'Sage 300',
            description: 'Integrate Sage 300 CRE to work with your job costing tools',
            availableActionsFn: {
                PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED: (integration) => {
                    return true !== integration.getSetting('contractSOVBudgetCodeRequired');
                },
                PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED: (integration) => {
                    return true !== integration.getSetting('contractCOSOVBudgetCodeRequired');
                },
                CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM: (integration) => {
                    return true !== integration.getSetting('changeRequestSOVDisableLinkedContractItems');
                }
            },
            availableActions: [
                'PUSH_VENDORS',
                'PUSH_PROJECT',
                'LINK_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PULL_COST_TYPES',
                'PULL_COMPANY_TAX_CODES',
                'PUSH_SUB_JOBS',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_COMMITMENTS',
                'PULL_COMMITMENTS',
                'PULL_COMMITMENTS_DOC_CLERK_REQUIRED',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'PULL_PRIME_CONTRACTS',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'PULL_DIRECT_COSTS',
                'PUSH_PAYABLE_INVOICES',
                'REQUIRE_SYNCED_COST_TYPES',
                'CAN_ADD_MARKUPS_AFTER_SYNC',
                'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
                'PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER',
                'CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM'
            ],
            options: {
                linkProjectAlert: 'Linking to existing Jobs within Sage 300 that have existing Job Costs transactions is not supported. This may cause discrepancies in your Job Costing data.'
            },
            budgetColumns: [
                {
                    name: 'Original Commitment',
                    source: 'erp:originalCommitment',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Approved Commitment Changes',
                    source: 'erp:approvedCommitmentChanges',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Revised Commitment',
                    source: 'erp:revisedCommitment',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Commitment Invoiced',
                    source: 'erp:commitmentInvoiced',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Job to Date Cost',
                    source: 'erp:jobToDateCost',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Job to Date Units',
                    source: 'erp:jobToDateUnits',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Job to Date Dollars Paid',
                    source: 'erp:jobToDateDollarsPaid',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Month to Date Cost',
                    source: 'erp:monthToDateCost',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Month to Date Units',
                    source: 'erp:monthToDateUnits',
                    canCalculate: true,
                    format: 'money'
                },
                {
                    name: 'Month to Date Dollars Paid',
                    source: 'erp:monthToDateDollarsPaid',
                    canCalculate: true,
                    format: 'money'
                }
            ],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'job',
                        displayName: "Jobs",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '99-999',
                                className: 'input-project-code'
                            }
                        ]

                    },
                    subjob: {
                        internalModelName: 'subjob',
                        externalModelName: 'subjob',
                        displayName: "Sub Jobs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '99999',
                                className: 'input-subjob-number'
                            }
                        ]
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '#{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'estimate',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '9999',
                                className: 'input-pcco-number'
                            }
                        ]
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                className: 'input-commitment-number'
                            }
                        ]
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                format: '9999',
                                required: true,
                                className: 'input-cco-number'
                            }
                        ]
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: true,
                                format: '*{0,5}',
                                className: 'input-payable-invoice-number'
                            },
                            {
                                type: 'date',
                                name: 'Approval Date',
                                value: 'approvalDate',
                                required: false,
                                className: 'input-payable-invoice-approval-date'
                            }
                        ]
                    },
                }
            }
        },
        INTACCT: {
            logoURL: '/assets/modules2/global/images/sageintacct.png',
            name: 'INTACCT',
            shortName: 'Sage Intacct',
            displayName: 'Sage Intacct',
            description: 'Integrate Sage Intacct CRE to work with your job costing tools',
            availableActions: [
                'PUSH_VENDORS',
                'UNLINK_VENDOR',
                'PUSH_PROJECT',
                'UNLINK_PROJECT',
                'PULL_COMPANY_COST_CODES',
                'PULL_PROJECT_COST_CODES',
                'PUSH_PROJECT_COST_CODES',
                'PUSH_SUB_JOBS',
                'PULL_SUB_JOBS',
                'PUSH_BUDGET',
                'PULL_BUDGET',
                'PUSH_COMMITMENTS',
                'PUSH_COMMITMENT_CHANGE_ORDERS',
                'PULL_PRIME_CONTRACTS',
                'PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED',
                'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
                'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
                'PUSH_PAYABLE_INVOICES',
                'PULL_PAYABLE_PAYMENTS',
                'UNLINK_PRIME_CONTRACTS',
                'UNLINK_PRIME_CONTRACT_CHANGE_ORDERS',
                'UNLINK_COMMITMENT_CHANGE_ORDERS',
                'UNLINK_PAYABLE_INVOICES',
                'UNLINK_COMMITMENTS',
                'DISABLE_EDIT_COST_CODE_TYPE_FILTER',
                'PULL_DIRECT_COSTS'
            ],
            budgetColumns: [],
            erpAdmin: {
                features: {
                    project: {
                        internalModelName: 'project',
                        externalModelName: 'project',
                        displayName: "Projects",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Project ID',
                                value: 'id',
                                required: true,
                                format: '#{0,20}',
                                className: 'input-project-code'
                            }
                        ]

                    },
                    subjob: {
                        internalModelName: 'subjob',
                        externalModelName: 'subjob',
                        displayName: "Sub Jobs",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                    },
                    cont_comp: {
                        internalModelName: 'cont_comp',
                        externalModelName: 'vendor',
                        displayName: "Vendors",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Code',
                                value: 'code',
                                required: false,
                                format: '#{0,10}',
                                className: 'input-vendor-number'
                            }
                        ]
                    },
                    costcode: {
                        internalModelName: 'costcode',
                        externalModelName: 'costcode',
                        displayName: "Cost Codes",
                        filters: {
                            readyToImport: {
                                displayName: 'Ready to Import',
                                name: 'readyToImport',
                            },
                            archived: {
                                displayName: 'Archived',
                                name: 'archived'
                            }
                        }
                    },
                    budget: {
                        internalModelName: 'budget',
                        displayName: "Budget",
                        externalModelName: 'estimate',
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    pcco: {
                        internalModelName: 'pcco',
                        externalModelName: 'pcco',
                        displayName: "Contract Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: [
                            {
                                type: 'input',
                                name: 'Project Change Order ID',
                                value: 'projectChangeOrderId',
                                required: true,
                                format: '#{0,20}',
                                className: 'input-pcco-number'
                            }
                        ]
                    },
                    commitment: {
                        internalModelName: 'commitment',
                        externalModelName: 'commitment',
                        displayName: "Commitments",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    cco: {
                        internalModelName: 'cco',
                        externalModelName: 'cco',
                        displayName: "Commitment Change Orders",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    },
                    ap_inv: {
                        internalModelName: 'ap_inv',
                        externalModelName: 'ap_inv',
                        displayName: "Payable Invoices",
                        filters: {
                            readyToExport: {
                                displayName: 'Ready to Export',
                                name: 'readyToExport',
                                statuses: [1]
                            },
                            failedToExport: {
                                displayName: 'Failed to Export',
                                name: 'failedToExport',
                                statuses: [5]
                            }
                        },
                        approvalInputs: []
                    }
                }
            }
        },
        // VIEWPOINT_VISTA: {
        //     logoURL: '/assets/modules2/global/images/viewpoint_vista.png',
        //     name: 'VIEWPOINT_VISTA',
        //     displayName: 'Viewpoint Vista',
        //     description: 'Integrate Viewpoint Vista to work with your job costing tools',
        //     isAgave: true,
        //     agaveSourceSystem: 'vista-hosted',
        //     availableActions: [
        //         'PUSH_VENDORS',
        //         'PUSH_PROJECT',
        //         'PULL_COMPANY_COST_CODES',
        //         'PUSH_PROJECT_COST_CODES',
        //         'PULL_PROJECT_COST_CODES',
        //         'PULL_COMPANY_TAX_CODES',
        //         'PUSH_SUB_JOBS',
        //         'PULL_SUB_JOBS',
        //         'PUSH_BUDGET',
        //         'PULL_BUDGET',
        //         'PUSH_COMMITMENTS',
        //         'PUSH_COMMITMENT_CHANGE_ORDERS',
        //         'PULL_PRIME_CONTRACTS',
        //         'PUSH_PRIME_CONTRACT_CHANGE_ORDERS',
        //         'PULL_DIRECT_COSTS',
        //         'PUSH_PAYABLE_INVOICES',
        //         'REQUIRE_SYNCED_COST_TYPES',
        //         'PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO',
        //         'COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV'
        //     ],
        //     erpAdmin: {
        //         features: {
        //             project: {
        //                 internalModelName: 'project',
        //                 externalModelName: 'job',
        //                 refreshType: 'projects',
        //                 displayName: "Jobs",
        //                 filters: {
        //                     readyToImport: {
        //                         displayName: 'Ready to Import',
        //                         name: 'readyToImport',
        //                     },
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '99-999',
        //                         className: 'input-project-code'
        //                     }
        //                 ]
        //
        //             },
        //             cont_comp: {
        //                 internalModelName: 'cont_comp',
        //                 externalModelName: 'vendor',
        //                 refreshType: 'vendors',
        //                 displayName: "Vendors",
        //                 filters: {
        //                     readyToImport: {
        //                         displayName: 'Ready to Import',
        //                         name: 'readyToImport',
        //                     },
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '#{0,10}',
        //                         className: 'input-vendor-number'
        //                     }
        //                 ]
        //             },
        //             budget: {
        //                 internalModelName: 'budget',
        //                 displayName: "Budget",
        //                 externalModelName: 'estimate',
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: []
        //             },
        //             commitment: {
        //                 internalModelName: 'commitment',
        //                 externalModelName: 'commitment',
        //                 displayName: "Commitments",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '99999',
        //                         className: 'input-commitment-number'
        //                     }
        //                 ]
        //             },
        //             cco: {
        //                 internalModelName: 'cco',
        //                 externalModelName: 'cco',
        //                 displayName: "Commitment Change Orders",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         format: '9999',
        //                         required: true,
        //                         className: 'input-cco-number'
        //                     }
        //                 ]
        //             },
        //             ap_inv: {
        //                 internalModelName: 'ap_inv',
        //                 externalModelName: 'ap_inv',
        //                 displayName: "Payable Invoices",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '*{0,5}',
        //                         className: 'input-payable-invoice-number'
        //                     },
        //                     {
        //                         type: 'date',
        //                         name: 'Approval Date',
        //                         value: 'approvalDate',
        //                         required: false,
        //                         className: 'input-payable-invoice-approval-date'
        //                     }
        //                 ]
        //             },
        //             pcco: {
        //                 internalModelName: 'pcco',
        //                 externalModelName: 'pcco',
        //                 displayName: "Contract Change Orders",
        //                 filters: {
        //                     readyToExport: {
        //                         displayName: 'Ready to Export',
        //                         name: 'readyToExport',
        //                         statuses: [1]
        //                     },
        //                     failedToExport: {
        //                         displayName: 'Failed to Export',
        //                         name: 'failedToExport',
        //                         statuses: [5]
        //                     }
        //                 },
        //                 approvalInputs: [
        //                     {
        //                         type: 'input',
        //                         name: 'Code',
        //                         value: 'code',
        //                         required: true,
        //                         format: '9999',
        //                         className: 'input-pcco-number'
        //                     }
        //                 ]
        //             },
        //         }
        //     }
        // },
    },
    erp: {
        syncStatuses: {
            STALE: -2,
            CACHED: -1,
            PENDING: 0,
            REVIEWING: 1,
            REJECTED: 2,
            APPROVED: 3,
            SYNCED: 4,
            FAILED: 5,
            ARCHIVED: 6
        },
        syncStatusDescriptions: {
            '-2': 'Changes were made which have not been synced to your ERP system',
            0: 'ERP sync not started',
            1: 'ERP sync waiting for approval',
            2: 'ERP sync rejected',
            3: 'Approved - Sync to ERP in process',
            4: 'Synced to ERP',
            5: 'Sync to ERP failed',
            6: 'Archived'
        }
    }
};


//Models
PJQ.integrations.models.Integration = PJQ.models.BaseModel.extend({
    idAttribute: "id",
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let endpointArr,
            params = [];
        if (this.id > 0) {

            params.push({
                parameter: 'erp',
                value: this.get('erp')
            });

            endpointArr = [
                {
                    endpoint: 'integrations',
                    value: this.get('name')
                }
            ];
        } else {
            if (this.options.erp) {
                params.push({
                    parameter: 'erp',
                    value: true
                });

                if (_.size(this.get("name")) === 0) {
                    this.set('name', 'default');
                }
            }

            endpointArr = [
                {
                    endpoint: 'integrations',
                    value: this.get('name')
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint(endpointArr, params);
    },
    parse: function (model) {
        if (model == null) {
            model = {};
        }

        if (!model.settings) {
            model.settings = {};
        }
        return model;
    },
    getSetting: function (setting) {
        return this.attributes.settings ? this.attributes.settings[setting] : null;
    },
    setSetting: function (setting, value) {
        if (_.size(setting) === 0) {
            return false;
        }

        if (this.attributes.settings == null) {
            this.attributes.settings = {};
        }
        this.attributes.settings[setting] = value;
        return true;
    },
    undoPush: function (obj, callback) {
        let externalObj = obj.get('externalObject');
        if (externalObj == null || !(externalObj.id > 0) || externalObj.status !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            if (typeof callback === 'function') {
                callback(obj);
            }
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'objects',
                    value: externalObj.id
                },
                {
                    endpoint: 'undopush'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            obj.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(obj);
            }
        }).fail(function () {
            // todo: error
        });
    },
    fetchSyncData: function (callback) {
        return new Promise((resolve, reject) => {
            if (this.syncData != null) {
                if (typeof callback === 'function') {
                    callback(this.syncData);
                }
                resolve(this.syncData);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'syncdata'
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                this.syncData = res;
                if (typeof callback === 'function') {
                    callback(this.syncData);
                }
                resolve(this.syncData);
            }).fail(() => {
                reject(new Error("Failed to fetch erp integration sync data"));
            });
        });
    },
    fetchSettingsData: function (callback, options = null) {
        this.settingsData = {};
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'settingsdata'
                    }
                ], [
                    {
                        parameter: 'type',
                        value: options ? options.type : null
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                this.settingsData = _.extend(this.settingsData, res ?? {});
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((res) => {
                if (!this.handleError(res)) {
                    reject(res);
                }
            });
        });
    },
    pushVendor: function (contact, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors',
                    value: contact.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            contact.set({
                companyExternalObject: res,
                externalObject: res
            }, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(contact);
            }
        }).fail(function () {
            // todo: error
        });
    },
    unlinkVendor: function (contactCompany, callback) {
        let contactCompanyId = contactCompany.get('contactCompanyId');
        if (contactCompanyId == null) {
            contactCompanyId = contactCompany.id;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'vendors',
                    value: contactCompanyId
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            contactCompany.set({
                companyExternalObject: null,
                externalObject: null
            }, null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((xhr) => {
            // todo: error
        });
    },
    fetchUnlinkedProjects: async function () {
        return await this.fetchProjects(false);
    },
    fetchLinkedProjects: async function () {
        return await this.fetchProjects(true);
    },
    fetchProjects: async function (synced = false) {
        return new Promise((resolve, reject) => {
            if (this.erpProjects == null) {
                this.erpProjects = {};
            }

            let result = this.erpProjects[synced];
            if (result != null) {
                resolve(result);
                return;
            }

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'projects'
                    }
                ], [{
                    parameter: 'synced',
                    value: synced
                }]),
                isAPIv2: true
            }).get().done((res) => {
                this.erpProjects[synced] = res;
                resolve(this.erpProjects[synced]);
            }).fail(() => {
                reject(new Error("Failed to fetch erp projects"));
            });
        });
    },
    pushProject: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            project.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(project);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    linkProject: function (project, externalId, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'link'
                }
            ], [{
                parameter: 'externalId',
                value: externalId
            }]),
            isAPIv2: true
        }).post().done((res) => {
            project.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(project);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkProject: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            project.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushSubJobs: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'subjobs'
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullSubJobs: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'subjobs'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    updateCostTypeData: function (obj, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costtypes'
                },
                {
                    endpoint: 'data'
                }
            ]),
            isAPIv2: true,
            data: obj
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushCostTypes: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costtypes'
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCostTypes: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costtypes'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushCostCodes: function (options, callback) {
        let params = [];
        if (options) {
            if (options.project && options.project.id > 0) {
                params.push({
                    parameter: 'projectId',
                    value: options.project.id
                });
            }

            if (options.dryRun) {
                params.push({
                    parameter: 'dryRun',
                    value: true
                });
            }
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'push'
                }
            ], params),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCostCodes: function (project, callback) {
        let params = [];
        if (project != null) {
            params.push({
                parameter: 'projectId',
                value: project ? project.id : null
            });
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'pull'
                }
            ], params),
            isAPIv2: true,
            data: []
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    fetchCostCodes: function (callback, options = null) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                }
            ], [
                {
                    parameter: 'forLinking',
                    value: options && options.forLinking ? true : null
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullTaxCodes: function (project, callback) {
        let params = [];
        if (project != null) {
            params.push({
                parameter: 'projectId',
                value: project ? project.id : null
            });
        }
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'taxcodes'
                },
                {
                    endpoint: 'pull'
                }
            ], params),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushBudget: function (budget, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: budget.get('projectId')
                },
                {
                    endpoint: 'budget'
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            budget.set({
                externalObject: res,
                isLocked: true
            }, {
                silent: true
            })
            budget.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(budget);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullBudget: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'budget'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    releaseCommitmentRetainage: function (commitment, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitments',
                    value: commitment.id
                },
                {
                    endpoint: 'releaseretainage'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            if (typeof callback === 'function') {
                callback(commitment);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushCommitment: function (commitment, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitments',
                    value: commitment.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            commitment.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(commitment);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCommitments: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'commitments'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkCommitment: function (commitment, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitments',
                    value: commitment.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            commitment.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushChangeRequest: function (changeRequest, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'changerequests',
                    value: changeRequest.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            changeRequest.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(changeRequest);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkChangeRequest: function (changeRequest, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'changerequests',
                    value: changeRequest.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            changeRequest.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushCommitmentChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitmentchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            changeOrder.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(changeOrder);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullCommitmentChangeOrders: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'commitmentchangeorders'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkCommitmentChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'commitmentchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            changeOrder.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushPrimeContract: function (primeContract, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontracts',
                    value: primeContract.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            primeContract.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(primeContract);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullPrimeContracts: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'primecontracts'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkPrimeContract: function (contract, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontracts',
                    value: contract.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            contract.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushPrimeContractChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontractchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            changeOrder.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(changeOrder);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullPrimeContractChangeOrders: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'primecontractchangeorders'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkPrimeContractChangeOrder: function (changeOrder, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'primecontractchangeorders',
                    value: changeOrder.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            changeOrder.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushDirectCost: function (directcost, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'directcosts',
                    value: directcost.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            directcost.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(directcost);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullDirectCosts: function (project, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'projects',
                    value: project.id
                },
                {
                    endpoint: 'directcosts'
                },
                {
                    endpoint: 'pull'
                }
            ]),
            isAPIv2: true
        }).get().done((res) => {
            if (typeof callback === 'function') {
                callback(res, null);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    unlinkDirectCost: function (directCost, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'directcosts',
                    value: directCost.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            directCost.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    releasePayableInvoiceRetainage: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'payableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'releaseretainage'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            invoice.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(invoice);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pushPayableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'payableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            invoice.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(invoice);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullPayableInvoicePayments: function (invoice, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'payableinvoicepayments',
                        value: invoice.id
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((err) => {
                if (typeof callback === 'function') {
                    callback(null, err);
                }
                this.handleError(err);
                reject(new Error("Failed to fetch invoice payments"));
            });
        });
    },
    unlinkPayableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'payableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            invoice.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    pushReceivableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'receivableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'push'
                }
            ]),
            isAPIv2: true
        }).post().done((res) => {
            invoice.set('externalObject', res, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(invoice);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(null, err);
        });
    },
    pullReceivableInvoicePayments: function (invoice, callback) {
        return new Promise((resolve, reject) => {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'erp'
                    },
                    {
                        endpoint: 'receivableinvoicepayments',
                        value: invoice.id
                    }
                ]),
                isAPIv2: true
            }).get().done((res) => {
                if (typeof callback === 'function') {
                    callback(res);
                }
                resolve(res);
            }).fail((err) => {
                if (typeof callback === 'function') {
                    callback(null, err);
                }
                this.handleError(err);
                reject(new Error("Failed to fetch invoice payments"));
            });
        });
    },
    unlinkReceivableInvoice: function (invoice, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'receivableinvoices',
                    value: invoice.id
                },
                {
                    endpoint: 'unlink'
                }
            ]),
            isAPIv2: true,
        }).post().done(() => {
            invoice.set('externalObject', null, {
                silent: true
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((err) => {
            this.handleError(err);
            callback(false, err);
        });
    },
    getProvider: function () {
        return PJQ.constants.integrations.providers[this.get('name')];
    },
    getShortName: function () {
        let pvd = this.getProvider();
        if (pvd != null) {
            return _.size(pvd.shortName) > 0 ? pvd.shortName : '';
        }
        return '';
    },
    getBudgetColumns: function () {
        let pvd = this.getProvider();
        if (pvd != null) {
            return pvd.budgetColumns != null ? pvd.budgetColumns : [];
        }
        return [];
    },
    hasAvailableAction: function (action, ...args) {
        let pvd = this.getProvider();
        if (pvd != null) {
            if (pvd.availableActionsFn != null && typeof pvd.availableActionsFn[action] === 'function') {
                let res = pvd.availableActionsFn[action](this, ...args);
                return typeof res === 'object' ? (res.available ?? false) : (res === true);
            }
            return pvd.availableActions != null && pvd.availableActions.indexOf(action) !== -1;
        }
        return false;
    },
    checkAvailableAction: function (action, ...args) {
        let pvd = this.getProvider(),
            result = {
                available: false,
                alert: null
            };
        if (pvd != null) {
            if (pvd.availableActionsFn != null && typeof pvd.availableActionsFn[action] === 'function') {
                let fnRes = pvd.availableActionsFn[action](this, ...args);
                result.available = typeof fnRes === 'object' ? (fnRes.available ?? false) : (fnRes === true);
                result.alert = fnRes?.alert ?? result.alert;
            } else {
                result.available = pvd.availableActions != null && pvd.availableActions.indexOf(action) !== -1;
            }
        }
        return result;
    },
    authorize: function () {
        return new Promise((resolve, reject) => {
            let type = this.get('name'),
                provider = PJQ.constants.integrations.providers[type];
            if (provider && provider.isAgave) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'integrations'
                        },
                        {
                            endpoint: 'agave'
                        },
                        {
                            endpoint: 'linktoken'
                        }
                    ], [
                        {
                            parameter: 'name',
                            value: type
                        }
                    ]),
                    isAPIv2: true
                }).get().done((response) => {
                    if (_.size(response.linkToken) > 0) {
                        window.AgaveLink.openLink({
                            linkToken: response.linkToken,
                            sourceSystem: provider.agaveSourceSystem,
                            showSandboxSourceSystems: true,
                            onSuccess: (publicToken) => {
                                this.get('settings').publicToken = publicToken;
                                resolve(true);
                            }
                        });
                    } else {
                        reject(new Error('Failed to get Agave link token'));
                    }
                }).fail(function (err) {
                    reject(err)
                });
                return;
            }

            switch (type) {
                case PJQ.constants.integrations.providers.ACUMATICA.name:
                case PJQ.constants.integrations.providers.SAGE100.name:
                case PJQ.constants.integrations.providers.SAGE300.name:
                case PJQ.constants.integrations.providers.INTACCT.name:
                    resolve(true);
                    break;
                case PJQ.constants.integrations.providers.QBO.name:
                default:
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'integrations'
                            },
                            {
                                endpoint: 'authorize'
                            }
                        ], [
                            {
                                parameter: 'name',
                                value: type
                            }
                        ]),
                        isAPIv2: true
                    }).get().done((response) => {
                        document.location = response.url;
                        resolve(true);
                    }).fail(function (res) {
                        reject(res);
                    });
                    break;
            }
        });
    },
    handleError: function (res) {
        // if this function returns true, the error was handled
        // if it returns false, the error was not handled and the caller is expected to handle it
        // this is used to handle errors that are common to all ERP integrations - i.e. authentication for QBO
        if (res && res.responseJSON && res.responseJSON.type === "APP_NOT_AUTHORIZED" && this.get('name') === PJQ.constants.integrations.providers.QBO.name) {
            new PJQ.views.modals.YesNo({
                header: "Authorize QuickBooks Online",
                body: "Authorization for QuickBooks Online has expired. You must re-authorize to continue to use the integration features. Would you like to re-authorize now?",
                onYes: () => {
                    this.authorize().catch((err) => {

                    });
                }
            });
            return true;
        }
        return false;
    }
});

// Collections
PJQ.integrations.collections.Integrations = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.integrations.models.Integration,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'integrations'
            }
        ]);
    }
});

// Models
PJQ.integrations.models.LinkERPProjectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-erp-project-link'),
        onCancel: _.noop,
        onSave: _.noop,
        minWidth: '700px'
    },
    events: {
        "change .select-project": "selectProject",
        "click .btn-cancel": "cancel",
        "click .btn-save": "save"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        this.provider = this.erpIntegration.getProvider();

        this.projects = await this.erpIntegration.fetchUnlinkedProjects();

        this.isFetched = true;

        this.render();
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            provider: this.provider
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        let columns = [
            {
                "data": "id",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": (data, type, row) => {
                    let isSelected = this.selectedProject && this.selectedProject.id === row.id;
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (isSelected ? ' checked ' : '') + ' class="select-project"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }
            },
            {
                "data": "name",
                "title": "Name",
                "render": (data, type, row) => {
                    return row.data.name ?? "";
                }
            },
            {
                "data": "city",
                "title": "City",
                "render": (data, type, row) => {
                    return row.data.city ?? "";
                }
            },
            {
                "data": "state",
                "title": "State",
                "render": (data, type, row) => {
                    return row.data.state ?? "";
                }
            }];
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.projects-data-table'),
            data: this.projects,
            deferRender: true,
            order: [1, 'asc'],
            columns: columns,
            language: {
                emptyTable: "No projects were found",
                zeroRecords: "No projects match the search criteria"
            }
        });
    },
    selectProject: function (e) {
        let target = $(e.currentTarget),
            isSelected = target.prop('checked');
        this.$('.select-project').not(target).prop('checked', false);
        if (isSelected) {
            this.selectedProject = this.dataTable.dataTable.row(target.parents('tr')).data();
        } else {
            this.selectedProject = null;
        }
        this.$('.btn-save').prop('disabled', this.selectedProject == null)
    },
    save: function () {
        if (this.options.project != null && this.selectedProject != null && _.size(this.selectedProject.externalId) > 0) {
            this.erpIntegration.linkProject(this.options.project, this.selectedProject.externalId, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Project linked to ERP'
                });
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.options.project);
                }
            });
        }

        this.removeModal();
    },
    cancel: function () {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
    }
});
PJQ.integrations.views.IntegrationsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'integrations')
    },
    events: {
        'click .btn-settings': 'integrationClicked',
        'click .btn-connect': 'integrationClicked',
        'click .btn-disconnect': 'disconnectIntegration'
    },
    beforeFirstRender: function () {
        this.isFetched = false;
        PJQ.app.session.fetchIntegrations(_.bind(function (integrations) {
            this.integrations = integrations;
            this.isFetched = true;
            this.render();
        }, this))
    },
    renderData: function () {
        return {
            integrations: this.integrations,
            getIntegration: this.getIntegration
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.initOptions != null && _.size(this.options.initOptions.integrationName) > 0) {
            this.handleIntegrationType(this.options.initOptions.integrationName);
            this.options.initOptions = null;
        }
    },
    getIntegration: function (type) {
        if (this.integrations == null) {
            return null;
        }

        return this.integrations.find((ig) => {
            return ig.get('name') === type.toUpperCase()
        });
    },
    integrationClicked: function (e) {
        let $target = $(e.currentTarget),
            integrationType = $target.data('name');
        this.handleIntegrationType(integrationType);
    },
    handleIntegrationType: function (type, integration) {
        if (integration == null) {
            integration = this.getIntegration(type);
        }
        let enabled = integration != null;
        if (!enabled) {
            this.authorizeIntegration(type);
            return;
        }

        switch (type.toUpperCase()) {
            case PJQ.constants.integrations.providers.QBO.name:
                return new PJQ.integrations.views.QBOIntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions
                });
            case PJQ.constants.integrations.providers.SAGE100.name:
            case PJQ.constants.integrations.providers.SAGE300.name:
                return new PJQ.integrations.views.SageHH2IntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions,
                    onSave: _.bind(function (integration) {
                        this.integrations.add(integration);
                        PJQ.app.session.erpIntegration = integration;
                        PJQ.app.navigator.refreshCommands();
                        this.render();
                    }, this)
                });
            case PJQ.constants.integrations.providers.ACUMATICA.name:
                return new PJQ.integrations.views.AcumaticaIntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions,
                    onSave: _.bind(function (integration) {
                        if (integration.id > 0) {
                            this.integrations.add(integration);
                            PJQ.app.session.erpIntegration = integration;
                            PJQ.app.navigator.refreshCommands();
                        }
                        this.render();
                    }, this)
                });
            case PJQ.constants.integrations.providers.INTACCT.name:
                return new PJQ.integrations.views.SageIntacctIntegrationSettings({
                    model: integration,
                    initOptions: this.options.initOptions,
                    onSave: _.bind(function (integration) {
                        this.integrations.add(integration);
                        PJQ.app.session.erpIntegration = integration;
                        PJQ.app.navigator.refreshCommands();
                        this.render();
                    }, this)
                });

            // case PJQ.constants.integrations.providers.VIEWPOINT_VISTA.name:
            //     return new PJQ.integrations.views.VistaIntegrationSettings({
            //         model: integration,
            //         initOptions: this.options.initOptions,
            //         onSave: _.bind(function (integration) {
            //             this.integrations.add(integration);
            //             PJQ.app.session.erpIntegration = integration;
            //             PJQ.app.navigator.refreshCommands();
            //             this.render();
            //         }, this)
            //     });
        }
    },
    authorizeIntegration: function (type) {
        let integration = this.getIntegration(type);
        if (integration == null) {
            integration = new PJQ.integrations.models.Integration({
                name: type,
                erp: true
            });
        }

        integration.authorize().then((authorized) => {
            if (authorized) {
                this.handleIntegrationType(type, integration);
            }
        }).catch((err) => {

        });
    },
    disconnectIntegration: function (e) {
        let $target = $(e.currentTarget),
            name = $target.data('name'),
            integration = this.integrations.findWhere({
                name: name
            }),
            displayName = PJQ.constants.integrations.providers[integration.get('name')].displayName;
        new PJQ.views.modals.YesNo({
            header: "Disconnect Integration?",
            body: "Are you sure you want to disconnect your " + displayName + " integration?  <strong>This will unlink all synced items and cannot be undone.</strong> ",
            onYes: _.bind(function () {
                if (integration != null) {
                    integration.destroy({
                        success: _.bind(function () {
                            PJQ.app.session.erpIntegration = new PJQ.integrations.models.Integration({}, {
                                erp: true
                            });
                            PJQ.app.navigator.refreshCommands();
                            PJQ.notifications.notify.successNotify({
                                message: 'Integration successfully disconnected'
                            });
                            this.render();
                        }, this)
                    });
                }
            }, this)
        });
    }
});

PJQ.integrations.views.QBOIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-qbo'),
        minWidth: 500
    },
    events: {
        'change .input-projects': 'render',
        'change .input-import-single-item': 'render',
        'change .input-export-single-item': 'render',
        'change .input-sync-costs': 'render',
        'click .btn-re-auth': 'reAuthorize',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.costCodes = await PJQ.app.session.fetchCostCodes();
        this.costTypes = await PJQ.app.session.fetchCostTypes();
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            integrationName: PJQ.constants.integrations.providers[this.model.get('name')].displayName,
            model: this.model,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            settings: this.model.get('settings'),
            isFetched: this.isFetched,
            newAuth: this.options.initOptions && this.options.initOptions.authorized
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.initOptions && this.options.initOptions.authorized) {
            PJQ.notifications.notify.successNotify({
                message: 'QuickBooks Online Integration successfully authorized'
            });
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });

        let incomeAccount = this.model.getSetting('incomeAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Income Account ' + PJQ.constants.markup.requiredAst,
            title: 'The income account used when pushing Cost Codes to QuickBooks Online Products',
            showSaveButton: false,
            defaultDisplayValue: incomeAccount != null ? incomeAccount.name : null,
            value: incomeAccount != null ? incomeAccount.id : null,
            getChoices: (cb) => {
                this.fetchAccounts(() => {
                    cb(_.sortBy(_.map(this.incomeAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.name
                        };
                    }), (account) => {
                        return account.name;
                    }));
                });
            },
            onChange: (value) => {
                let account = this.incomeAccounts.find((item) => item.id === value);
                if (account != null) {
                    this.model.setSetting('incomeAccount', account);
                }
            }
        });

        let expenseAccount = this.model.getSetting('expenseAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-expense-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Expense Account ' + PJQ.constants.markup.requiredAst,
            title: 'The expense account used when pushing Cost Codes to QuickBooks Online Products',
            showSaveButton: false,
            defaultDisplayValue: expenseAccount != null ? expenseAccount.name : null,
            value: expenseAccount != null ? expenseAccount.id : null,
            getChoices: (cb) => {
                this.fetchAccounts(() => {
                    cb(_.sortBy(_.map(this.expenseAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.name
                        };
                    }), (account) => {
                        return account.name;
                    }));
                });
            },
            onChange: (value) => {
                let account = this.expenseAccounts.find((item) => item.id === value);
                if (account != null) {
                    this.model.setSetting('expenseAccount', account);
                }
            }
        });

        let paymentAccount = this.model.getSetting('paymentAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-payment-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Payment Account ' + PJQ.constants.markup.requiredAst,
            title: 'The payment account used when pushing Direct Costs to QuickBooks Online Purchases',
            showSaveButton: false,
            defaultDisplayValue: paymentAccount != null ? paymentAccount.name : null,
            value: paymentAccount != null ? paymentAccount.id : null,
            getChoices: (cb) => {
                this.fetchAccounts(() => {
                    cb(_.sortBy(_.map(this.paymentAccounts, function (account) {
                        return {
                            id: account.id,
                            name: account.name
                        };
                    }), (account) => {
                        return account.name;
                    }));
                });
            },
            onChange: (value) => {
                let account = this.paymentAccounts.find((item) => item.id === value);
                if (account != null) {
                    this.model.setSetting('paymentAccount', account);
                }
            }
        });

        let expenseRetainageDefaultItem = this.model.getSetting('expenseRetainageDefaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-expense-retainage-default-item'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Expense Retainage Product',
            selectPickerOptions: {
                isLiveSearch: true
            },
            title: 'When selected, this product will be used for all retainage held/released when pushing Payable Invoices to QuickBooks Online',
            showSaveButton: false,
            defaultDisplayValue: expenseRetainageDefaultItem != null ? (expenseRetainageDefaultItem.name + ' ' + expenseRetainageDefaultItem.description) : null,
            value: expenseRetainageDefaultItem != null ? expenseRetainageDefaultItem.id : null,
            getChoices: (cb) => {
                this.fetchProducts(() => {
                    cb(_.sortBy(_.map(_.filter(this.products, function (product) {
                        return product.forExpense;
                    }), function (product) {
                        return {
                            id: product.id,
                            name: product.name + ' ' + product.description
                        };
                    }), (product) => {
                        return product.name;
                    }));
                });
            },
            onChange: (value) => {
                let product = this.products.find((item) => item.id === value);
                if (product != null) {
                    this.model.setSetting('expenseRetainageDefaultItem', product);
                }
            }
        });

        let incomeRetainageDefaultItem = this.model.getSetting('incomeRetainageDefaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-retainage-default-item'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Income Retainage Product',
            selectPickerOptions: {
                isLiveSearch: true
            },
            title: 'When selected, this product will be used for all retainage held/released when pushing Receivable Invoices to QuickBooks Online',
            showSaveButton: false,
            defaultDisplayValue: incomeRetainageDefaultItem != null ? (incomeRetainageDefaultItem.name + ' ' + incomeRetainageDefaultItem.description) : null,
            value: incomeRetainageDefaultItem != null ? incomeRetainageDefaultItem.id : null,
            getChoices: (cb) => {
                this.fetchProducts(() => {
                    cb(_.sortBy(_.map(_.filter(this.products, function (product) {
                        return product.forIncome;
                    }), function (product) {
                        return {
                            id: product.id,
                            name: product.name + ' ' + product.description
                        };
                    }), (product) => {
                        return product.name;
                    }));
                });
            },
            onChange: (value) => {
                let product = this.products.find((item) => item.id === value);
                if (product != null) {
                    this.model.setSetting('incomeRetainageDefaultItem', product);
                }
            }
        });

        let incomeDefaultItem = this.model.getSetting('incomeDefaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-default-item'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Income Product ' + PJQ.constants.markup.requiredAst,
            title: 'The product used when syncing Contracts, Contract Change Orders, and Receivable Invoices to QuickBooks Online',
            showSaveButton: false,
            defaultDisplayValue: incomeDefaultItem != null ? (incomeDefaultItem.name + ' ' + incomeDefaultItem.description) : null,
            value: incomeDefaultItem != null ? incomeDefaultItem.id : null,
            getChoices: (cb) => {
                this.fetchProducts(() => {
                    cb(_.sortBy(_.map(_.filter(this.products, function (product) {
                        return product.forIncome;
                    }), function (product) {
                        return {
                            id: product.id,
                            name: product.name + ' ' + product.description
                        };
                    }), (product) => {
                        return product.name;
                    }));
                });
            },
            onChange: (value) => {
                let product = this.products.find((item) => item.id === value);
                if (product != null) {
                    this.model.setSetting('incomeDefaultItem', product);
                }
            }
        });

        let expenseDefaultItem = this.model.getSetting('expenseDefaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-expense-default-item'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Expense Product ' + PJQ.constants.markup.requiredAst,
            title: 'The product used when syncing Commitments, Commitment Change Orders, and Payable Invoices to QuickBooks Online',
            showSaveButton: false,
            defaultDisplayValue: expenseDefaultItem != null ? (expenseDefaultItem.name + ' ' + expenseDefaultItem.description) : null,
            value: expenseDefaultItem != null ? expenseDefaultItem.id : null,
            getChoices: (cb) => {
                this.fetchProducts(() => {
                    cb(_.sortBy(_.map(_.filter(this.products, function (product) {
                        return product.forExpense;
                    }), function (product) {
                        return {
                            id: product.id,
                            name: product.name + ' ' + product.description
                        };
                    }), (product) => {
                        return product.name;
                    }));
                });
            },
            onChange: (value) => {
                let product = this.products.find((item) => item.id === value);
                if (product != null) {
                    this.model.setSetting('expenseDefaultItem', product);
                }
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-default-group'),
            isLiveSearch: true,
            isIntChoices: true,
            choices: _.map(this.costCodes.models.sort(function (a, b) {
                return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('code'), b.get('code'));
            }), function (costCode) {
                return {
                    id: costCode.id,
                    name: costCode.getDisplayName()
                };
            }),
            defaultValue: this.model.get('settings').costDefaultGroupId,
            onChange: _.bind(function (value) {
                this.model.get('settings').costDefaultGroupId = value;
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-default-cost-type'),
            isLiveSearch: true,
            isIntChoices: true,
            choices: _.map(this.costTypes.models, function (costType) {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            }),
            defaultValue: this.model.get('settings').costDefaultCostTypeId,
            onChange: _.bind(function (value) {
                this.model.get('settings').costDefaultCostTypeId = value;
            }, this)
        });
    },
    fetchAccounts: function (callback) {
        if (this.expenseAccounts != null && this.incomeAccounts != null && this.paymentAccounts != null) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        this.model.fetchSettingsData(null, {
            type: 'accounts'
        }).then((data) => {
            if (data != null) {
                this.expenseAccounts = data.expenseAccounts ?? [];
                this.incomeAccounts = data.incomeAccounts ?? [];
                this.paymentAccounts = data.paymentAccounts ?? [];
            }
            if (typeof callback === 'function') {
                callback();
            }
        }).catch((err) => {

        });
    },
    fetchProducts: function (callback) {
        if (this.products != null) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        this.model.fetchSettingsData((data) => {
            if (data != null) {
                this.products = data.products ?? [];
            }
            if (typeof callback === 'function') {
                callback();
            }
        }, {
            type: 'products'
        });
    },
    reAuthorize: function () {
        new PJQ.views.modals.YesNo({
            header: "Re-Authorize QuickBooks Online Integration?",
            body: "Are you sure you want to re-authorize your QuickBooks Online integration? This is usually only necessary if you have made changes to the user you used during setup, or if you are experiencing issues with your integration.",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.model.authorize().then((authorized) => {
                    if (authorized) {
                        this.render();
                    }
                }).catch((err) => {
                    loader.remove();
                });
            }
        });
    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;

        if (settings.incomeAccount == null) {
            valid = false;
            this.$('.label-income-account').addClass('text-danger');
        }

        if (settings.expenseAccount == null) {
            valid = false;
            this.$('.label-expense-account').addClass('text-danger');
        }

        if (settings.paymentAccount == null) {
            valid = false;
            this.$('.label-payment-account').addClass('text-danger');
        }

        if (settings.exportSingleItem) {
            if (settings.incomeDefaultItem == null) {
                valid = false;
                this.$('.label-income-default-item').addClass('text-danger');
            }

            if (settings.expenseDefaultItem == null) {
                valid = false;
                this.$('.label-expense-default-item').addClass('text-danger');
            }
        }

        if (settings.syncProjects && settings.syncCosts) {
            if (settings.importSingleItem && settings.costDefaultGroupId == null) {
                valid = false;
                this.$('.label-cost-default-group').addClass('text-danger');
            }

            if (settings.costDefaultCostTypeId == null) {
                valid = false;
                this.$('.label-cost-default-cost-type').addClass('text-danger');
            }
        }

        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Settings updated successfully'
                    });
                    this.removeModal();
                }, this)
            })
        }
    },
    setSettings: function (callback) {
        if (typeof callback === 'function') {
            callback(settings);
        }
    },
});

PJQ.integrations.views.SageHH2IntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-sage-hh2'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save, .btn-authorize': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink',
        'click .btn-edit-auth': 'editAuthorization',
        'click .btn-cancel-auth': 'cancelEditingAuthorization'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes(_.bind(function (ct) {
                this.options.isAuthorized = true;
                this.options.editingAuthorization = false;

                if (this.model.id == null) {
                    this.options.editingAuthorization = true;
                    this.options.isAuthorized = false;
                }

                this.costTypes = ct;
                this.isFetched = true;
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            editingAuthorization: this.options.editingAuthorization,
            isAuthorized: this.options.isAuthorized,
            settings: this.model.get('settings'),
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.renderAlerts();
            }, this)
        });

        this.renderAlerts();
    },
    editAuthorization: function () {
        this.options.editingAuthorization = true;
        this.render();
    },
    cancelEditingAuthorization: function () {
        this.options.editingAuthorization = false;
        this.render();
    },
    renderAlerts: function () {

    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;
        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        if (!this.options.editingAuthorization) {
            this.model.setSetting("username", null);
            this.model.setSetting("password", null);
        }

        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.save(null, {
            success: () => {
                loader.remove();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                if (!this.options.editingAuthorization) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Settings updated successfully'
                    });
                    this.removeModal();
                } else {
                    PJQ.notifications.notify.successNotify({
                        message: 'Successfully Authorized'
                    });
                    this.options.editingAuthorization = false;
                    this.options.isAuthorized = true;
                    this.render();
                }
            }
        })
    }
});

PJQ.integrations.views.AcumaticaIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-acumatica'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save, .btn-authorize': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink',
        'change .input-export-single-item': 'render',
        'click .btn-edit-auth': 'editAuthorization',
        'click .btn-cancel-auth': 'cancelEditingAuthorization'
    },
    beforeModalCreated: function () {
        this.settingsData = {};

        this.isFetched = false;
        PJQ.app.session.fetchCostCodes((costCodes) => {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes((ct) => {
                this.costTypes = ct;
                this.options.isAuthorized = true;
                this.options.editingAuthorization = false;

                if (this.model.id == null) {
                    this.options.editingAuthorization = true;
                    this.options.isAuthorized = false;
                }

                if (null == this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS)) {
                    this.model.setSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS, this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS));
                }

                this.isFetched = true;
                this.render();
            });
        });
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched,
            editingAuthorization: this.options.editingAuthorization,
            isAuthorized: this.options.isAuthorized
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            inputs: {
                syncTimeCards: {
                    afterChange: (el, val) => {
                        let $tcs = this.$('.time-card-settings');
                        if (val) {
                            $tcs.removeClass('hidden');
                        } else {
                            $tcs.addClass('hidden');
                        }
                    }
                },
                createEmployees: {
                    afterChange: (el, val) => {
                        let $tcs = this.$('.time-card-employee-settings');
                        if (val) {
                            $tcs.removeClass('hidden');
                        } else {
                            $tcs.addClass('hidden');
                        }
                    }
                },
                timeCardWeekStartDay: {
                    selectPicker: {
                        defaultValue: this.model.getSetting('timeCardWeekStartDay') ?? 0,
                        isIntChoices: true
                    }
                }
            },
            afterChange: () => {
                this.renderAlerts();
            }
        });

        let version = this.model.get('settings').version != null ? this.model.get('settings').version : null;
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-api-version'),
            defaultValue: version ? version : '',
            onChange: (value) => {
                this.model.get('settings').version = value;
                this.renderCustomizationLink();
            }
        });
        this.renderCustomizationLink();

        let defaultIncomeAccountGroup = this.model.getSetting('defaultIncomeAccountGroup');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-income-account'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Income Account Group ' + PJQ.constants.markup.requiredAst,
            title: 'The account group used when syncing Contracts to Acumatica Project Revenue Budgets',
            showSaveButton: false,
            defaultDisplayValue: defaultIncomeAccountGroup != null ? defaultIncomeAccountGroup.accountGroupID : null,
            value: defaultIncomeAccountGroup != null ? defaultIncomeAccountGroup.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let incomeAccounts = _.filter(this.settingsData.accountGroups, function (account) {
                        return account.type.toLowerCase() === "income";
                    });
                    cb(_.map(incomeAccounts, function (account) {
                        return {
                            id: account.accountGroupID,
                            name: account.accountGroupID
                        };
                    }));
                };
                if (this.settingsData.accountGroups != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'account_groups'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.accountGroups.find((item) => item.accountGroupID === value);
                if (item != null) {
                    this.model.setSetting('defaultIncomeAccountGroup', item);
                }
            }
        });

        let defaultSalesSubaccount = this.model.getSetting('defaultSalesSubaccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-sales-subaccount'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Sales Subaccount',
            title: 'The subaccount used when syncing projects to Acumatica',
            showSaveButton: false,
            defaultDisplayValue: defaultSalesSubaccount != null ? defaultSalesSubaccount.subaccountID : null,
            value: defaultSalesSubaccount != null ? defaultSalesSubaccount.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let subaccounts = _.filter(this.settingsData.subaccounts, function (subaccount) {
                        return true;
                    })
                    cb(_.map(subaccounts, function (subaccount) {
                        return {
                            id: subaccount.subaccountID,
                            name: subaccount.subaccountID
                        };
                    }));
                };
                if (this.settingsData.subaccounts != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'sub_accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.subaccounts.find((item) => item.subaccountID === value);
                if (item != null) {
                    this.model.setSetting('defaultSalesSubaccount', item);
                }
            }
        });

        let defaultCreditTerms = this.model.getSetting('defaultCreditTerms');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-credit-terms'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Credit Terms ' + PJQ.constants.markup.requiredAst,
            title: 'The Credit Terms used when syncing Commitments to Acumatica Subcontracts and Purchase Orders',
            showSaveButton: false,
            defaultDisplayValue: defaultCreditTerms != null ? defaultCreditTerms.termsID : null,
            value: defaultCreditTerms != null ? defaultCreditTerms.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.creditTerms, function (cls) {
                        return {
                            id: cls.termsID,
                            name: cls.termsID
                        };
                    }));
                };
                if (this.settingsData.creditTerms != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'credit_terms'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.creditTerms.find((item) => item.termsID === value);
                if (item != null) {
                    this.model.setSetting('defaultCreditTerms', item);
                }
            }
        });

        let defaultNonStockItem = this.model.getSetting('defaultNonStockItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-nonstock'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Expense Non-Stock Item ' + PJQ.constants.markup.requiredAst,
            title: 'The Non-Stock Item used when syncing Commitments to Acumatica Subcontracts and Purchase Orders',
            showSaveButton: false,
            defaultDisplayValue: defaultNonStockItem != null ? defaultNonStockItem.inventoryID : null,
            value: defaultNonStockItem != null ? defaultNonStockItem.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.nonStockItems, function (item) {
                        return {
                            id: item.inventoryID,
                            name: item.inventoryID
                        };
                    }));
                };
                if (this.settingsData.nonStockItems != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'non_stock_items'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.nonStockItems.find((item) => item.inventoryID === value);
                if (item != null) {
                    this.model.setSetting('defaultNonStockItem', item);
                }
            }
        });

        let defaultRevenueNonStockItem = this.model.getSetting('defaultRevenueNonStockItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-revenue-nonstock'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Revenue Non-Stock Item ' + PJQ.constants.markup.requiredAst,
            title: 'The Non-Stock Item used when syncing Receivable Invoices to Acumatica AR Invoices',
            showSaveButton: false,
            defaultDisplayValue: defaultRevenueNonStockItem != null ? defaultRevenueNonStockItem.inventoryID : null,
            value: defaultRevenueNonStockItem != null ? defaultRevenueNonStockItem.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.nonStockItems, function (item) {
                        return {
                            id: item.inventoryID,
                            name: item.inventoryID
                        };
                    }));
                };
                if (this.settingsData.nonStockItems != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'non_stock_items'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.nonStockItems.find((item) => item.inventoryID === value);
                if (item != null) {
                    this.model.setSetting('defaultRevenueNonStockItem', item);
                }
            }
        });

        let primeContractCOClass = this.model.getSetting('primeContractCOClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-pcco-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Contract CO Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: primeContractCOClass != null ? primeContractCOClass.classID : null,
            value: primeContractCOClass != null ? primeContractCOClass.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.primeContractCOClasses, function (cls) {
                        return {
                            id: cls.classID,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.primeContractCOClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'change_order_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.primeContractCOClasses.find((item) => item.classID === value);
                if (item != null) {
                    this.model.setSetting('primeContractCOClass', item);
                }
            }
        });

        let commitmentCOClass = this.model.getSetting('commitmentCOClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-cco-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Commitment CO Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: commitmentCOClass != null ? commitmentCOClass.classID : null,
            value: commitmentCOClass != null ? commitmentCOClass.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.commitmentCOClasses, function (cls) {
                        return {
                            id: cls.classID,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.commitmentCOClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'change_order_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.commitmentCOClasses.find((item) => item.classID === value);
                if (item != null) {
                    this.model.setSetting('commitmentCOClass', item);
                }
            }
        });

        let vendorClass = this.model.getSetting('vendorClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-vendor-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Vendor Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: vendorClass != null ? vendorClass.classID : null,
            value: vendorClass != null ? vendorClass.id : null,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.vendorClasses, function (cls) {
                        return {
                            id: cls.classID,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.vendorClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'vendor_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.vendorClasses.find((item) => item.classID === value);
                if (item != null) {
                    this.model.setSetting('vendorClass', item);
                }
            }
        });

        let employeeClass = this.model.getSetting('employeeClass');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-employee-class'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Employee Class ' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: employeeClass?.classID,
            value: employeeClass?.classID,
            getChoices: (cb) => {
                let fnCallback = () => {
                    cb(_.map(this.settingsData.employeeClasses, function (cls) {
                        return {
                            id: cls.classID,
                            name: cls.classID
                        };
                    }));
                };
                if (this.settingsData.employeeClasses != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'employee_class'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.employeeClasses.find((item) => item.classID === value);
                if (item != null) {
                    this.model.setSetting('employeeClass', item);
                }
            }
        });

        let defaultEmployeeDept = this.model.getSetting('employeeDepartment');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-employee-dept'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Employee Department ' + PJQ.constants.markup.requiredAst,
            title: 'The department used when creating employees in Acumatica',
            showSaveButton: false,
            defaultDisplayValue: defaultEmployeeDept?.departmentID,
            value: defaultEmployeeDept?.departmentID,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let departments = _.filter(this.settingsData.departments, function (department) {
                        return true;
                    })
                    cb(_.map(departments, function (department) {
                        return {
                            id: department.departmentID,
                            name: department.departmentID
                        };
                    }));
                };
                if (this.settingsData.departments != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'departments'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.departments.find((item) => item.departmentID === value);
                if (item != null) {
                    this.model.setSetting('employeeDepartment', item);
                }
            }
        });

        let defaultEmployeeWorkCalendar = this.model.getSetting('employeeWorkCalendar');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-employee-calendar'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Employee Calendar ' + PJQ.constants.markup.requiredAst,
            title: 'The work calendar used when creating employees in Acumatica',
            showSaveButton: false,
            defaultDisplayValue: defaultEmployeeWorkCalendar?.workCalendarID,
            value: defaultEmployeeWorkCalendar?.workCalendarID,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let workCalendars = _.filter(this.settingsData.workCalendars, function (workCalendar) {
                        return true;
                    })
                    cb(_.map(workCalendars, function (workCalendar) {
                        return {
                            id: workCalendar.workCalendarID,
                            name: workCalendar.workCalendarID
                        };
                    }));
                };
                if (this.settingsData.workCalendars != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'work_calendars'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.workCalendars.find((item) => item.workCalendarID === value);
                if (item != null) {
                    this.model.setSetting('employeeWorkCalendar', item);
                }
            }
        });

        let defaultEmployeeExpenseAccount = this.model.getSetting('employeeExpenseAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-employee-expense-account'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Employee Expense Account ' + PJQ.constants.markup.requiredAst,
            title: 'The expense account used when creating employees in Acumatica',
            showSaveButton: false,
            defaultDisplayValue: defaultEmployeeExpenseAccount?.accountCD,
            value: defaultEmployeeExpenseAccount?.accountCD,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let expenseAccounts = _.filter(this.settingsData.accounts, function (account) {
                        return true;
                    })
                    cb(_.map(expenseAccounts, function (account) {
                        return {
                            id: account.accountCD,
                            name: account.accountCD
                        };
                    }));
                };
                if (this.settingsData.accounts != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.accounts.find((item) => item.accountCD === value);
                if (item != null) {
                    this.model.setSetting('employeeExpenseAccount', item);
                }
            }
        });

        let defaultEmployeeSalesAccount = this.model.getSetting('employeeSalesAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-employee-sales-account'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Default Employee Sales Account ' + PJQ.constants.markup.requiredAst,
            title: 'The sales account used when creating employees in Acumatica',
            showSaveButton: false,
            defaultDisplayValue: defaultEmployeeSalesAccount?.accountCD,
            value: defaultEmployeeSalesAccount?.accountCD,
            getChoices: (cb) => {
                let fnCallback = () => {
                    let salesAccounts = _.filter(this.settingsData.accounts, function (account) {
                        return true;
                    })
                    cb(_.map(salesAccounts, function (account) {
                        return {
                            id: account.accountCD,
                            name: account.accountCD
                        };
                    }));
                };
                if (this.settingsData.accounts != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.accounts.find((item) => item.accountCD === value);
                if (item != null) {
                    this.model.setSetting('employeeSalesAccount', item);
                }
            }
        });

        let submitDay = this.model.getSetting('submitDay'),
            days = _.map(PJQ.constants.date.WEEKDAYNAMES, (day) => {
                return {
                    id: day.bit,
                    name: day.long
                }
            });
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-time-card-submit-day'),
            isFormInput: true,
            canEdit: !this.options.editingAuthorization,
            editButtonText: "Change",
            label: 'Time Card Submission Day' + PJQ.constants.markup.requiredAst,
            showSaveButton: false,
            defaultDisplayValue: submitDay ? days[submitDay] : null,
            value: submitDay,
            choices: days,
            onChange: (value) => {
                this.model.setSetting('submitDay', value);
            }
        });

        this.renderAlerts();
    },
    renderCustomizationLink: function () {
        let ver = this.model.get('settings').version,
            fileName = '',
            $pkg = this.$('.customization-package');
        if (ver === '25.200.001') {
            fileName = 'JOBPLANNER[25.100.0054][2025.05.10]';
        } else if (ver === '24.200.001') {
            fileName = 'JOBPLANNER[24.206.0014][2025.05.10]';
        } else if (ver === '23.200.001') {
            fileName = 'JobPlanner2023R2';
        } else if (ver === '22.200.001') {
            fileName = 'JobPlanner2022R1';
        } else {
            $pkg.empty();
            return;
        }
        $pkg.html('<a class="fs-14" href="' + PJQ.app.options.apiV2Url + '/public/integrations/acumatica/' + fileName + '.zip" target="_blank">Download Customization Package</a>');
    },
    editAuthorization: function () {
        this.options.editingAuthorization = true;
        this.render();
    },
    cancelEditingAuthorization: function () {
        this.options.editingAuthorization = false;
        this.render();
    },
    renderAlerts: function () {

    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;

        if (this.options.editingAuthorization) {
            return valid;
        }

        if (settings.defaultIncomeAccountGroup == null) {
            valid = false;
            this.$('.edit-income-account .form-group > label').addClass('text-danger');
        } else {
            this.$('.edit-income-account .form-group > label').removeClass('text-danger');
        }

        if (settings.defaultCreditTerms == null) {
            valid = false;
            this.$('.edit-default-credit-terms .form-group > label').addClass('text-danger');
        } else {
            this.$('.edit-default-credit-terms .form-group > label').removeClass('text-danger');
        }

        if (settings.defaultNonStockItem == null) {
            valid = false;
            this.$('.edit-default-nonstock .form-group > label').addClass('text-danger');
        } else {
            this.$('.edit-default-nonstock .form-group > label').removeClass('text-danger');
        }

        if (settings.primeContractCOClass == null) {
            valid = false;
            this.$('.edit-pcco-class .form-group > label').addClass('text-danger');
        } else {
            this.$('.edit-pcco-class .form-group > label').removeClass('text-danger');
        }

        if (settings.commitmentCOClass == null) {
            valid = false;
            this.$('.edit-cco-class .form-group > label').addClass('text-danger');
        } else {
            this.$('.edit-cco-class .form-group > label').removeClass('text-danger');
        }

        if (settings.syncTimeCards && settings.createEmployees) {
            let isAdminDelegateValid = _.size(settings.adminEmployeeDelegate) > 0;
            valid = valid && isAdminDelegateValid;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-admin-delegate'), isAdminDelegateValid);

            if (settings.employeeClass == null) {
                valid = false;
                this.$('.edit-employee-class .form-group > label').addClass('text-danger');
            } else {
                this.$('.edit-employee-class .form-group > label').removeClass('text-danger');
            }

            if (settings.employeeDepartment == null) {
                valid = false;
                this.$('.edit-employee-dept .form-group > label').addClass('text-danger');
            } else {
                this.$('.edit-employee-dept .form-group > label').removeClass('text-danger');
            }

            if (settings.employeeWorkCalendar == null) {
                valid = false;
                this.$('.edit-employee-work-calendar .form-group > label').addClass('text-danger');
            } else {
                this.$('.edit-employee-work-calendar .form-group > label').removeClass('text-danger');
            }

            if (settings.employeeExpenseAccount == null) {
                valid = false;
                this.$('.edit-employee-expense-account .form-group > label').addClass('text-danger');
            } else {
                this.$('.edit-employee-expense-account .form-group > label').removeClass('text-danger');
            }

            if (settings.employeeSalesAccount == null) {
                valid = false;
                this.$('.edit-employee-sales-account .form-group > label').addClass('text-danger');
            } else {
                this.$('.edit-employee-sales-account .form-group > label').removeClass('text-danger');
            }
        }

        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    if (!this.options.editingAuthorization) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Settings updated successfully'
                        });
                        this.removeModal();
                    } else {
                        PJQ.notifications.notify.successNotify({
                            message: 'Successfully Authorized'
                        });
                        this.options.editingAuthorization = false;
                        this.options.isAuthorized = true;
                        this.render();
                    }
                },
                error: () => {
                    loader.remove();
                    this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                        type: 'danger',
                        text: 'Unable to validate the integration. Double check your information is correct.'
                    });
                }
            })
        }
    }
});

PJQ.integrations.views.VistaIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-viewpoint-vista'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes(_.bind(function (ct) {
                this.costTypes = ct;
                this.isFetched = true;
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
                this.renderAlerts();
            }, this)
        });

        this.renderAlerts();
    },
    renderAlerts: function () {

    },
    validate: function () {
        let settings = this.model.get('settings'),
            valid = true;
        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Settings updated successfully'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.removeModal();
                }
            })
        }
    }
});

PJQ.integrations.views.SageIntacctIntegrationSettings = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-integration-settings-sage-intacct'),
        minWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-save, .btn-authorize': 'save',
        'click .btn-cancel': 'cancel',
        'click .btn-unlink': 'unlink',
        'click .btn-edit-auth': 'editAuthorization',
        'click .btn-cancel-auth': 'cancelEditingAuthorization'
    },
    beforeModalCreated: function () {
        this.settingsData = {};

        this.isFetched = false;
        PJQ.app.session.fetchCostCodes(_.bind(function (costCodes) {
            this.costCodes = costCodes;
            PJQ.app.session.fetchCostTypes(_.bind(function (ct) {
                this.costTypes = ct;
                this.options.isAuthorized = true;
                this.options.editingAuthorization = false;

                if (this.model.id == null) {
                    this.options.editingAuthorization = true;
                    this.options.isAuthorized = false;
                }

                if (null == this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS)) {
                    this.model.setSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS, this.model.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS));
                }

                this.isFetched = true;
                this.render();
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            provider: PJQ.constants.integrations.providers[this.model.get('name')],
            model: this.model,
            settings: this.model.get('settings'),
            isFetched: this.isFetched,
            editingAuthorization: this.options.editingAuthorization,
            isAuthorized: this.options.isAuthorized
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$('.modal-body'), this.model.get('settings'), {
            setDefaultValues: true,
            watchElements: [
                'input'
            ],
            afterChange: _.bind(function () {
            }, this)
        });

        let fnGetAccounts = (cb, options) => {
                let accounts = _.filter(this.settingsData.glAccounts, function (glAccount) {
                    return true;
                })
                cb(_.map(_.filter(accounts, (account) => {
                    if (!options || !options.normalBalance) {
                        return true;
                    }

                    return account.normalBalance === options.normalBalance;
                }), function (account) {
                    return {
                        id: account.accountNo,
                        name: `${account.accountNo} - ${account.title}`
                    };
                }));
            },
            defaultPayableAccount = this.model.getSetting('defaultPayableAccount'),
            defaultReceivableAccount = this.model.getSetting('defaultReceivableAccount');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-receivable-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Receivable Account ' + PJQ.constants.markup.requiredAst,
            title: 'The default account used when pushing Contracts to Sage Intacct',
            showSaveButton: false,
            selectPickerOptions: {
                isLiveSearch: true
            },
            defaultDisplayValue: defaultReceivableAccount != null ? `${defaultReceivableAccount.accountNo} - ${defaultReceivableAccount.title}` : null,
            value: defaultReceivableAccount != null ? defaultReceivableAccount.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                if (this.settingsData.glAccounts != null) {
                    fnGetAccounts(cb, {
                        normalBalance: 'debit'
                    });
                    loader.remove();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnGetAccounts(cb, {
                        normalBalance: 'debit'
                    });
                    loader.remove();
                }, {
                    type: 'gl_accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.glAccounts.find((item) => item.accountNo === value);
                if (item != null) {
                    this.model.setSetting('defaultReceivableAccount', item);
                }
            }
        });

        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-payable-account'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Payable Account ' + PJQ.constants.markup.requiredAst,
            title: 'The default Account used when pushing Payable Invoices (Bills) to Sage Intacct',
            showSaveButton: false,
            selectPickerOptions: {
                isLiveSearch: true
            },
            defaultDisplayValue: defaultPayableAccount != null ? `${defaultPayableAccount.accountNo} - ${defaultPayableAccount.title}` : null,
            value: defaultPayableAccount != null ? defaultPayableAccount.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                if (this.settingsData.glAccounts != null) {
                    fnGetAccounts(cb, {
                        normalBalance: 'credit'
                    });
                    loader.remove();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnGetAccounts(cb, {
                        normalBalance: 'credit'
                    });
                    loader.remove();
                }, {
                    type: 'gl_accounts'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.glAccounts.find((item) => item.accountNo === value);
                if (item != null) {
                    this.model.setSetting('defaultPayableAccount', item);
                }
            }
        });

        let defaultItem = this.model.getSetting('defaultItem');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-item-id'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Item ' + PJQ.constants.markup.requiredAst,
            title: 'The default Item used when pushing Contracts to Sage Intacct',
            showSaveButton: false,
            defaultDisplayValue: defaultItem != null ? `${defaultItem.itemId} - ${defaultItem.name}` : null,
            value: defaultItem != null ? defaultItem.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                let fnCallback = () => {
                    loader.remove();
                    let items = _.filter(this.settingsData.items, function (glAccount) {
                        return true;
                    })
                    cb(_.map(items, function (item) {
                        return {
                            id: item.itemId,
                            name: `${item.itemId} - ${item.name}`
                        };
                    }));
                };
                if (this.settingsData.items != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'items'
                });
            },
            onChange: (value) => {
                let item = this.settingsData.items.find((item) => item.itemId === value);
                if (item != null) {
                    this.model.setSetting('defaultItem', item);
                }
            }
        });

        let defaultEntity = this.model.getSetting('defaultEntity');
        new PJQ.inputs.SelectPickerEditorInput({
            el: this.$('.edit-default-entity'),
            isFormInput: true,
            editButtonText: "Change",
            label: 'Default Entity',
            title: 'The default entity used when pushing new project locations to Sage Intacct',
            showSaveButton: false,
            defaultDisplayValue: defaultEntity != null ? `${defaultEntity.locationId} - ${defaultEntity.name}` : null,
            value: defaultEntity != null ? defaultEntity.recordNo : null,
            getChoices: (cb) => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                let fnCallback = () => {
                    loader.remove();
                    let entities = _.filter(this.settingsData.entities, function (glAccount) {
                        return true;
                    })
                    cb(_.map(entities, function (entity) {
                        return {
                            id: entity.locationId,
                            name: `${entity.locationId} - ${entity.name}`
                        };
                    }));
                };
                if (this.settingsData.entities != null) {
                    fnCallback();
                    return;
                }

                this.model.fetchSettingsData((data) => {
                    this.settingsData = _.extend(this.settingsData, data ?? {});
                    fnCallback();
                }, {
                    type: 'entities'
                });
            },
            onChange: (value) => {
                let entity = this.settingsData.entities.find((entity) => entity.locationId === value);
                if (entity != null) {
                    this.model.setSetting('defaultEntity', entity);
                }
            }
        });
    },
    editAuthorization: function () {
        this.options.editingAuthorization = true;
        this.render();
    },
    cancelEditingAuthorization: function () {
        this.options.editingAuthorization = false;
        this.render();
    },
    validate: function () {
        if (this.options.editingAuthorization) {
            return true;
        }

        let settings = this.model.get('settings'),
            valid = true;
        if (settings.defaultReceivableAccount == null) {
            valid = false;
            this.$('.edit-default-receivable-account .form-group > label').addClass('text-danger');
        }

        if (settings.defaultPayableAccount == null) {
            valid = false;
            this.$('.edit-default-payable-account .form-group > label').addClass('text-danger');
        }

        if (settings.defaultItem == null) {
            valid = false;
            this.$('.edit-default-item-id .form-group > label').addClass('text-danger');
        }
        return valid;
    },
    cancel: function () {
        if (this.model && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    save: function () {
        if (this.validate()) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.model.save(null, {
                success: () => {
                    loader.remove();

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    if (!this.options.editingAuthorization) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Settings updated successfully'
                        });
                        this.removeModal();
                    } else {
                        PJQ.notifications.notify.successNotify({
                            message: 'Successfully Authorized'
                        });
                        this.options.editingAuthorization = false;
                        this.options.isAuthorized = true;
                        this.render();
                    }
                },
                error: () => {
                    loader.remove();
                    this.errorAlert = new PJQ.Alert(this.$('.error-container'), {
                        type: 'danger',
                        text: 'Unable to validate the integration. Double check your information is correct.'
                    });
                }
            })
        }
    }
});
PJQ.views.budget.LineItemsView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'line-items-view'),
        subTemplates: {
            invoiceHeader: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'invoice-line-items-header'),
            changeRequestHeader: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'change-request-line-items-header'),
            actions: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'line-items-actions')
        },
        isSubmitting: false,
        canEdit: true,
        canDelete: true,
        isAdmin: true,
        isCostCodeRequired: true,
        isCostTypeRequired: true,
        filterToPrimeContractItems: false,
        canChangeAccountingMethod: false,
        canImportBudget: false,
        accountingMethod: PJQ.constants.budget.accountingMethod.AMOUNT,
        onAccountingMethodChanged: null,
        lineItemModel: PJQ.models.BaseModel,
        enableSelection: false,
        canSendRFQ: false,
        onLineItemAdd: null,
        onLineItemChange: null,
        onLineItemDelete: null,
        onTotalsChanged: null,
        enableStoredMaterials: true,
        enableRetainage: true,
        enableTax: false,
        billedToDate: null,
        approvedChanges: null,
        showMarkup: true,
        isBudget: false,
        showBilling: false,
        showSubTotal: false,
        showGrandTotal: false,
        showRevenue: false,
        copyCostToRevenue: false,
        canExportLineItems: false
    },
    events: {
        'click .btn-add-standard': 'addStandardCostCodes',
        'click .btn-add-cost-code': 'addCostCodeClicked',
        'click .btn-view-commitment': 'viewCommitment',
        'click .btn-view-change-order': 'viewChangeOrder',
        'click .btn-import-budget': 'importBudget',
        'click .btn-import-file': 'importFile',
        'click .btn-import-contracts': 'importContracts',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-add-all-line-items': 'addAllPossibleLineItems',
        'click .btn-autofill-amounts': 'autofillAmounts',
        'click .btn-save-line-item': 'saveLineItem',
        'click .btn-delete-line-item': 'deleteLineItemClicked',
        'focus .input-dollars-full,.input-percent,.input-hours': 'selectInput',
        'change .input-progress-percent': 'minimumProgressPercent',
        'click .btn-add-from-change-requests': 'addFromChangeRequests',
        'click .btn-add-from-commitments': 'addFromCommitments',
        'click .select-cr-li': 'lineItemSelected',
        'click .btn-new-commitment': 'createCommitmentFromLineItems',
        'click .btn-existing-commitment': 'addLineItemsToCommitment',
        'click .btn-new-pcco': 'createPCCOFromLineItems',
        'click .btn-existing-pcco': 'addLineItemsToPCCO',
        'click .btn-new-cco': 'createCCOFromLineItems',
        'click .btn-existing-cco': 'addLineItemsToCCO',
        'click .btn-total-fn': 'totalButtonClicked',
        'click .btn-edit-bulk': 'bulkEditLineItems',
        'click .btn-delete-bulk': 'bulkDeleteLineItems',
        'click .select-all-line-items': 'selectAllLineItems',
        'click .btn-edit-line-item-vendor': 'editLineItemVendor',
        'click .btn-send-rfq': 'sendRFQClicked',
        'keyup .input-budgeted-hours': 'lineItemHoursChanged',
        'click .btn-export-line-items': 'exportLineItems',
    },
    addStandardCostCodes: function (e) {
        let $btn = $(e.currentTarget),
            lineItem = this.getLineItemForInput($btn),
            subJobId = lineItem.get('subJobId'),
            title;
        if (subJobId != null) {
            title = 'Add Cost Codes To Sub Job';
        } else {
            title = 'Add Cost Codes To Project'
        }

        new PJQ.views.budget.CostCodePickerModal({
            title: title,
            pickerOptions: {
                showDisabledAsSelected: true,
                isCostCodeDisabled: _.bind(function (costCode) {
                    return null != _.find(this.costCodes.models, function (pCostCode) {
                        return (subJobId == null || pCostCode.get('subJobId') === subJobId) && pCostCode.get('code').toLowerCase() === costCode.get('code').toLowerCase();
                    })
                }, this)
            },
            onSave: _.bind(function (newCostCodes) {
                if (_.size(newCostCodes) > 0) {
                    this.costCodes.saveBulk(newCostCodes, subJobId, _.bind(function (savedCostCodes) {
                        if (savedCostCodes) {
                            if (this.options.project) {
                                this.options.project.costCodes.add(savedCostCodes);
                            }
                            this.renderLineItemsTable();
                            PJQ.notifications.notify.successNotify({
                                message: _.size(savedCostCodes).toString() + ' Company Cost Codes added to project'
                            });
                        } else {
                            // todo: error
                        }
                    }, this));
                }
            }, this)
        });
    },
    sendRFQClicked: function () {
        if (typeof this.options.onSendRFQ === 'function') {
            this.options.onSendRFQ({
                selectedIds: this.options.selectedLineItems,
                projectCommitments: this.projectCommitments
            });
        }
    },
    addCostCodeClicked: function (e) {
        let $btn = $(e.currentTarget),
            lineItem = this.getLineItemForInput($btn);
        new PJQ.views.budget.EditCostCodeModal({
            project: PJQ.app.session.project,
            onSave: _.bind(function (costCode) {
                this.costCodes.add(costCode);
                lineItem.set('costCodeId', costCode.id);
                this.renderLineItemsTable();
            }, this)
        });
    },
    beforeFirstRender: async function () {
        this.options.project = this.options.project != null ? this.options.project : PJQ.app.session.project;
        this.options.addingNewContractLineItems = [];
        this.isReceivableInvoices = this.options.lineItemModel === PJQ.models.invoicing.ReceivableInvoiceLineItem;
        this.isInvoices = this.options.lineItemModel === PJQ.models.invoicing.PayableInvoiceLineItem
            || this.isReceivableInvoices;
        this.isDirectCosts = this.options.lineItemModel === PJQ.models.directcosts.LineItem;
        this.isChangeRequests = this.options.lineItemModel === PJQ.models.changeRequests.ChangeRequestLineItem;
        this.isPCCO = this.options.lineItemModel === PJQ.models.primeContracts.ChangeOrderLineItem;
        this.isCCO = this.options.lineItemModel === PJQ.models.commitments.ChangeOrderLineItem;
        this.isCommitments = this.options.lineItemModel === PJQ.models.commitments.CommitmentLineItem;
        this.options.canExportLineItems = this.isInvoices;

        this.isFetched = false;
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.options.project.isERPSynced()) {
            if (this.options.lineItemModel === PJQ.models.commitments.ChangeOrderLineItem) {
                this.options.filterToCommitmentCostCodes = this.options.commitmentId > 0 && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.COMMITMENT_CO_SOV_FILTER_TO_COMMITMENT_SOV);
            }

            if (this.options.lineItemModel === PJQ.models.primeContracts.ChangeOrderLineItem) {
                this.options.filterToPrimeContractItems = this.options.requirePrimeContractItem = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_REQUIRE_LINKED_CONTRACT_CO);
                this.options.isCostCodeRequired = this.options.isCostTypeRequired = !(true === this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_BUDGET_CODE_NOT_REQUIRED));
            } else if (this.options.lineItemModel === PJQ.models.changeRequests.ChangeRequestLineItem) {
                this.options.filterToPrimeContractItems = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CHANGE_REQUEST_SOV_ENABLE_LINKED_CONTRACT_ITEM);
                this.options.requirePrimeContractItem = false;
            } else if (this.options.lineItemModel === PJQ.models.primeContracts.LineItem) {
                this.options.isCostCodeRequired = this.options.isCostTypeRequired = !(true === this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_SOV_BUDGET_CODE_NOT_REQUIRED));
            }
        }

        if (this.options.project.hasPermission('budget.canView')) {
            this.budget = await this.options.project.fetchBudget();
        }
        this.subJobs = await this.options.project.fetchSubJobs();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        if (this.options.enableTax) {
            this.taxCodes = await this.options.project.fetchTaxCodes();
            this.options.enableTax = _.size(this.taxCodes.models) > 0;
        }

        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.options.project && this.isChangeRequests && this.options.canEdit) {
            this.projectCommitments = new PJQ.collections.commitments.Commitments([], {
                projectId: this.options.project.id,
                withLineItems: true
            });
            await this.projectCommitments.fetch();
        }

        this.isFetched = true;
        this.render(true);
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.canEditRetainage = this.options.canEdit && !this.options.isSubmitting;
        this.canEditRetainageReleased = this.options.canEdit;
        this.options.enableRetainageRelease = true;
        if (this.options.lineItemModel === PJQ.models.invoicing.PayableInvoiceLineItem) {
            this.canEditRetainage = !PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.DISABLE_UPDATE_PAYABLE_INVOICE_LINE_RETAINAGE, this.model, this.options.commitment);

            if (PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.CAN_RELEASE_PAYABLE_INVOICE_RETAINAGE, this.model, this.options.commitment) === true) {
                this.canEditRetainageReleased = false;
                this.options.enableRetainageRelease = false;
            }
        }

        this.canAddCommitments = this.options.project.hasPermission('commitments.canAdd');
        this.canAddCommitmentChangeOrders = this.options.project.hasPermission('commitmentChangeOrders.canAdd');
        this.canAddContractChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.canAdd');
    },
    renderData: function () {
        return {
            project: PJQ.app.session.project,
            commitment: this.options.commitment,
            contract: this.options.contract,
            subJobs: this.subJobs,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            isInvoices: this.isInvoices,
            isDirectCosts: this.isDirectCosts,
            isChangeRequests: this.isChangeRequests,
            canApplyChangeRequestCosts: this.options.canApplyChangeRequestCosts,
            canApplyChangeRequestRevenue: this.options.canApplyChangeRequestRevenue,
            enableSelection: this.options.enableSelection,
            canSendRFQ: this.options.canSendRFQ,
            onSendRFQ: null,
            isReceivableInvoices: this.isReceivableInvoices,
            canImportBudget: this.options.canImportBudget,
            canChangeAccountingMethod: this.options.canChangeAccountingMethod,
            canEdit: this.options.canEdit,
            isBudget: this.options.isBudget,
            isFetched: this.isFetched,
            isCCO: this.isCCO,
            isPCCO: this.isPCCO,
            showRevenue: this.options.showRevenue,
            selectedLineItems: this.options.selectedLineItems,
            isCommitments: this.isCommitments,
            canAddCommitments: this.canAddCommitments,
            canAddCommitmentChangeOrders: this.canAddCommitmentChangeOrders,
            canAddContractChangeOrders: this.canAddContractChangeOrders,
            canExportLineItems: this.options.canExportLineItems
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.accountingMethodPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-accounting-method'),
            isIntChoices: true,
            defaultValue: this.options.accountingMethod,
            canEdit: this.options.canEdit && _.size(this.getVisibleLineItems()) === 0,
            onChange: _.bind(function (value) {
                this.options.accountingMethod = value;
                if (typeof this.options.onAccountingMethodChanged === 'function') {
                    this.options.onAccountingMethodChanged(value);
                }
                this.renderLineItemsTable();
            }, this)
        });
        this.renderActions();
        this.renderLineItemsTable();
        this.updateAccountingMethodSelector();
        this.renderTotals();
    },
    minimumProgressPercent: function (e) {
        let $input = $(e.currentTarget),
            lineItem = this.getLineItemForInput($input);
        if (lineItem != null) {
            let percent = lineItem.get('progressPercent'),
                totalProgressPercent = lineItem.get('progressPercentTotal');
            if (percent < totalProgressPercent) {
                $input.val(PJQ.helpers.formatHelpers.formatPercent(totalProgressPercent));
                lineItem.set('progressPercent', totalProgressPercent);
            }
        }
    },
    selectInput: function (e) {
        let el = $(e.currentTarget)[0];
        if (this.focusInput !== el) {
            this.focusInput = el;
            setTimeout(_.bind(function () {
                this.focusInput.select();
            }, this), 100);
        }
    },
    exportLineItems: function (data) {
        if (this.isInvoices) {
            let ep;
            if (this.options.lineItemModel === PJQ.models.invoicing.PayableInvoiceLineItem) {
                ep = 'payableinvoices'
            } else if (this.options.lineItemModel === PJQ.models.invoicing.ReceivableInvoiceLineItem) {
                ep = 'receivableinvoices'
            } else {
                return;
            }

            let order = this.dataTable ? _.map(this.dataTable.dataTable.rows({order: 'applied'}).data(), (lineItem) => {
                return lineItem.id;
            }) : null;
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: ep,
                    value: this.model.id
                },
                {
                    endpoint: 'lineItems',
                },
                {
                    endpoint: 'export'
                }
            ], [
                {
                    parameter: 'order',
                    value: _.size(order) > 0 ? order.join(',') : null
                }
            ]), {isAPIv2: true});
        }
    },
    importBudget: function () {
        PJQ.app.session.project.fetchBudget(_.bind(function (budget) {
            let newLineItems = [],
                counter = 1;
            _.each(_.sortBy(budget.lineItems.models, function (lineItem) {
                return lineItem.get('sortOrder');
            }), function (lineItem) {
                newLineItems.push(new this.options.lineItemModel({
                    subJobId: lineItem.get('subJobId'),
                    costCodeId: lineItem.get('costCodeId'),
                    costTypeId: lineItem.get('costTypeId'),
                    amount: lineItem.get('budgetedCost'),
                    description: '',
                    number: counter,
                    accountingMethod: this.options.accountingMethod
                }));
                counter++;
            }, this);
            this.collection.reset(newLineItems);
            this.renderLineItemsTable();
        }, this));
    },
    importFile: function () {
        this.renderUploader();
    },
    importContracts: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'budgets',
                    value: 'lineitems'
                },
                {
                    endpoint: 'import',
                    value: 'contracts'
                }
            ]),
            isAPIv2: true,
        }).get().done(_.bind(function (data) {
            this.collection.add(_.filter(data, (lineItem) => {
                return null == this.collection.findWhere({
                    costCodeId: lineItem.costCodeId,
                    costTypeId: lineItem.costTypeId
                });
            }));
            this.renderLineItemsTable();
            if (typeof this.options.onLineItemAdd === 'function') {
                this.options.onLineItemAdd();
            }
        }, this)).fail(_.bind(function (data) {

        }, this));
    },
    getVisibleLineItems: function () {
        return _.filter(this.collection.models, function (model) {
            return !model.get('delete');
        });
    },
    renderUploader: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'budgets'
                        },
                        {
                            endpoint: 'lineitems'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    let uploadId = file.uploadId;
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id,
                            },
                            {
                                endpoint: 'budgets'
                            },
                            {
                                endpoint: 'lineitems'
                            },
                            {
                                endpoint: 'import',
                                value: uploadId
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (result) {
                        loader.remove();
                        this.fileUploader.remove();
                        this.subJobs.add(result.subJobs);
                        this.costCodes.add(result.costCodes);
                        this.costTypes.add(result.costTypes);
                        this.collection.add(result.lineItems);
                        this.renderLineItemsTable();
                        if (typeof this.options.onLineItemAdd === 'function') {
                            this.options.onLineItemAdd();
                        }
                    }, this)).fail((err) => {
                        if (err && err.responseJSON) {
                            loader.remove();
                            let file = this.fileUploader.collection.models[0];
                            this.fileUploader.collection.remove(file);
                            this.fileUploader.render();
                            this.fileUploader.showError(err.responseJSON.message, 10000);
                        }
                    });
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
        let self = this;
        $uploader.find('.btn-download-template').off('click').on('click', self.downloadImportTemplate);
    },
    updateAccountingMethodSelector: function () {
        if (this.accountingMethodPicker != null) {
            if (!this.options.canEdit || _.size(this.getVisibleLineItems()) > 0) {
                this.accountingMethodPicker.disable();
            } else {
                this.accountingMethodPicker.enable();
            }
        }
    },
    renderTotals: function () {
        let amount = 0,
            billed = 0;
        _.each(this.collection.models.filter((lineItem) => {
            return !lineItem.get('delete');
        }), function (lineItem) {
            billed += lineItem.get('progressAmount');
            if (this.isInvoices) {
                amount += lineItem.get('progressAmount') + lineItem.get('materialsNew') - lineItem.get('workRetainage') - lineItem.get('materialRetainage') + lineItem.get('workRetainageReleased') + lineItem.get('materialRetainageReleased');
            } else if (this.options.isBudget) {
                amount += lineItem.get('budgetedCost');
            } else {
                amount += lineItem.get('amount');
            }
        }, this);

        this.$('.line-items-amount').text(PJQ.helpers.formatHelpers.formatCurrency(amount));
        if (!this.isInvoices) {
            let changes = null;
            if (this.options.contract != null) {
                changes = this.options.contract.get('approvedChanges');
                _.each(this.options.contract.changeOrders.models, function (co) {
                    billed += co.get('progressAmount');
                });
            } else if (this.options.commitment != null) {
                changes = this.options.commitment.get('approvedChanges');
                _.each(this.options.commitment.changeOrders.models, function (co) {
                    billed += co.get('progressAmount');
                });
            }

            if (changes != null) {
                this.$('.line-items-original').text(PJQ.helpers.formatHelpers.formatCurrency(amount));
                this.$('.line-items-changes').text(PJQ.helpers.formatHelpers.formatCurrency(changes));
                this.$('.line-items-total').text(PJQ.helpers.formatHelpers.formatCurrency(amount + changes));
            }

            this.$('.line-items-billed').text(PJQ.helpers.formatHelpers.formatCurrency(billed));
            this.$('.line-items-remaining').text(PJQ.helpers.formatHelpers.formatCurrency((amount + (changes ?? 0) - billed)));
        }

        if (typeof this.options.onTotalsChanged === 'function') {
            this.options.onTotalsChanged();
        }

        this.renderTableFooter();
    },
    getColumns: function () {
        let columns = [];
        if (this.options.enableSelection && (this.options.canApplyChangeRequestRevenue || this.options.canApplyChangeRequestCosts || this.options.canSendRFQ || this.isInvoices)) {
            columns.push({
                "title": '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-line-items" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>',
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let enable = !row.get('revenueLineItemId') || !row.get('costLineItemId');

                    if (!row.markup && !row.get('appliedMarkupId')) {
                        return ('<div class="text-align-center"><div title="' + (!enable ? 'This line item is already added to a Commitment/CO and Contract CO' : '') + '" class="pretty p-default p-smooth fs-18 m-0"><input ' + (!enable ? 'disabled' : '') + ' type="checkbox" class="select-cr-li" data-cid="' + row.cid + '"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    } else {
                        return '';
                    }
                }, this),
                "width": '4%'
            });
        }

        let fnBudgetCodeCols = () => {
            if (this.isInvoices) {
                return [
                    {
                        "columnData": "costCodeId",
                        "title": "Budget Code",
                        "titleSettings": "Budget Code",
                        "width": this.isChangeRequests ? '15%' : '20%',
                        "render": (data, type, row) => {
                            if (this.options.canEdit && row.get('lineItemId') == null) {
                                return '<select class="select-line-item form-control"></select>';
                            }

                            let costCode = this.costCodes.get(row.get('costCodeId')),
                                costType = this.costTypes.get(row.get('costTypeId'));
                            return '<div class="font-weight-bold min-wd-200p">' + (costCode ? costCode.getDisplayName() : '') + '</div>' + '<div class="text-muted fs-14">' + (costType ? costType.get('name') : '') + '</div>';
                        }
                    }];
            } else if (this.options.canEdit) {
                return [{
                    "columnData": "costCodeId",
                    "title": "Cost Code",
                    "width": "200px",
                    "render": (data, type, row) => {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && row.isNew() && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId')) && markup == null) {
                            let res = '<div class="d-flex"><select class="select-cost-code form-control"></select>';
                            if (PJQ.app.session.project.hasPermission('budget.isAdmin')) {
                                // res += `<button type="button" class="btn btn-xs btn-transparent-dark btn-add-cost-code text-info" title="New Cost Code">
                                //                 <i class="far fa-plus mr-1"></i>
                                //             </button>`

                                if ((PJQ.app.session.erpIntegration == null || (PJQ.app.session.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT_COST_CODES) && PJQ.app.session.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PROJECT_SPECIFIC_COST_CODES)))) {
                                    res += `<div class="btn-group">
                                        <button type="button" class="btn btn-link btn-link-bold dropdown-toggle no-after" data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                            <i class="far fa-plus"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item btn-add-cost-code" title="Create a new project-specific cost code"
                                               href="javascript:void(0)">New Project Cost Code</a>
                                            <a class="dropdown-item btn-add-standard"
                                               title="Add cost codes from your company cost codes"
                                               href="javascript:void(0)">From Company Cost Codes</a>
                                        </div>
                                    </div>`;
                                } else {
                                    res += `<button type="button" class="btn btn-link btn-link-bold btn-add-standard">
                                        <i class="far fa-plus"></i>
                                    </button>`;
                                }
                            }
                            res += '</div>';
                            return res;
                        } else {
                            let costCode = this.costCodes.get(row.get('costCodeId'));
                            return costCode ? costCode.getDisplayName() : '';
                        }
                    }
                },
                    {
                        "columnData": "costTypeId",
                        "title": "Type",
                        "titleSettings": "Cost Type",
                        "width": "100px",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && row.isNew() && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId')) && markup == null) {
                                return '<select class="select-cost-type form-control"></select>';
                            } else {
                                let costType = this.costTypes.get(row.get('costTypeId'));
                                return costType ? costType.get('name') : '';
                            }
                        }
                    }];
            } else {
                return [
                    {
                        "columnData": "costCodeId",
                        "title": "Budget Code",
                        "titleSettings": "Budget Code",
                        "width": this.isChangeRequests ? '15%' : '20%',
                        "render": (data, type, row) => {
                            if (this.isInvoices && row.get('lineItemId') == null) {
                                return ''
                            }

                            let costCode = this.costCodes.get(row.get('costCodeId')),
                                costType = this.costTypes.get(row.get('costTypeId'));
                            return '<div class="font-weight-bold min-wd-200p">' + (costCode ? costCode.getDisplayName() : '') + '</div>' + '<div class="text-muted fs-14">' + (costType ? costType.get('name') : '') + '</div>';
                        }
                    }];
            }
        }

        if (this.isInvoices) {
            columns.push(...[
                {
                    "columnData": "attributes.number",
                    "title": "#",
                    "width": "50px",
                    "render": (data, type, row, opt) => {
                        let self = this;

                        return `<div class=" text-align-center ${self.options.canEdit ? '' : 'p-1'}">${(opt.row + 1).toString()}</div>`;
                    }
                },
                {
                    "columnData": "attributes.id",
                    "title": "Source",
                    "render": _.bind(function (data, type, row) {
                        let result;
                        if (row.get('commitmentId') > 0) {
                            result = '<a href="javascript:void(0)" title="' + row.get('commitmentNumber') + '" class="btn-view-commitment" data-id="' + row.get('commitmentId') + '">' + row.get('commitmentNumber') + '</a>';
                        } else if (row.get('primeContractId') > 0) {
                            result = '<a href="javascript:void(0)" title="' + row.get('primeContractNumber') + '" class="btn-view-prime-contract" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                        } else if (row.get('changeOrderId') > 0) {
                            result = '<a href="javascript:void(0)" title="' + row.get('changeOrderNumber') + '" class="btn-view-change-order" data-id="' + row.get('changeOrderId') + '">' + row.get('changeOrderNumber') + '</a>';
                        } else {
                            result = '';
                        }
                        return '<div class="min-wd-120p">' + result + '</div>';
                    }, this)
                },
                {
                    "columnData": "subJobId",
                    "title": "Sub Job",
                    "visible": _.size(this.subJobs.models) > 0,
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        let subJob = this.subJobs.get(row.get('subJobId'));
                        return '<div class="min-wd-120p">' + (subJob ? subJob.get('name') : '') + '</div>';
                    }, this)
                },
                ...fnBudgetCodeCols(),
                {
                    "columnData": "description",
                    "data": "attributes.description",
                    "title": "Description",
                    "width": "200px",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-200p">' + row.get('description') + '</div>';
                    }, this)
                },
                {
                    "columnData": "committedAmount",
                    "data": "",
                    "title": "Scheduled Value",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-80p">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('committedAmount')) + '</div>'
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('committedAmount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "columnData": "progressAmountTotal",
                    "data": "attributes.progressAmountTotal",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-80p">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmountTotal')) + '</div>';
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('progressAmountTotal');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "columnData": "progressPercentTotal",
                    "data": "attributes.progressPercentTotal",
                    "title": "%",
                    "format": "percent",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        return '<div class="wd-80p">' + PJQ.helpers.formatHelpers.formatPercent(row.get('progressPercentTotal')) + '</div>';
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        if (_.size(data) > 0) {
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('progressPercentTotal');
                            });
                            amt = amt / _.size(data)
                        }
                        return PJQ.helpers.formatHelpers.formatPercent(amt);
                    }
                },
                {
                    "columnData": "progressAmount",
                    "data": "attributes.progressAmount",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control wd-120p text-align-right input-dollars-full input-progress-amount" data-p-bind="progressAmount" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount')) + '" data-p-bind="progressAmount" placeholder="0.00">';
                        } else {
                            return '<div class="text-align-center pr-1 wd-80p">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount')) + '</div>';
                        }
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('progressAmount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "columnData": "progressPercent",
                    "data": "attributes.progressPercent",
                    "title": "%",
                    "format": "percent",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text"\n class="form-control wd-80p text-align-right input-percent input-progress-percent" data-p-bind="progressPercent" placeholder="0" value="' + row.get('progressPercent') + '"/>'
                        } else {
                            result = PJQ.helpers.formatHelpers.formatPercent(row.get('progressPercent'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        if (_.size(data) > 0) {
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('progressPercent');
                            });
                            amt = amt / _.size(data)
                        }
                        return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                    }
                }]);
            if (this.options.enableStoredMaterials) {
                columns.push(...[{
                    "columnData": "materialsNew",
                    "data": "attributes.materialsNew",
                    "title": "New",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return ''
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text" class="form-control wd-80p text-align-right input-dollars-full input-materials-new" data-p-bind="materialsNew" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('materialsNew')) + '" data-p-bind="materialsNew" placeholder="0.00">';
                        } else {
                            result = PJQ.helpers.formatHelpers.formatCurrency(row.get('materialsNew'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('materialsNew');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                    {
                        "columnData": "materialsStored",
                        "data": "attributes.materialsStored",
                        "title": "Stored",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return ''
                            }

                            return '<div class="wd-80p label-materials-stored">' + PJQ.helpers.formatHelpers.formatCurrency(Math.max(0, row.getMaterialsStored(this.model))) + '</div>'
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('materialsStored');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    }]);
            }

            if (this.options.enableTax) {
                columns.push({
                    "columnData": "taxAmount",
                    "data": "attributes.taxAmount",
                    "width": "10%",
                    "title": "Tax",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (this.isInvoices && row.get('lineItemId') == null) {
                            return ''
                        }

                        let taxAmount = PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                        if (this.options.canEdit) {
                            return '<span class="label-tax-amount">' + taxAmount + '</span>';
                        }
                        return taxAmount;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('taxAmount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                });
            }

            columns.push(...[{
                "columnData": "",
                "data": "",
                "title": "Total Completed and Stored",
                "format": "money",
                "orderable": false,
                "searchable": false,
                "className": "text-align-center",
                "render": _.bind(function (data, type, row) {
                    if (row.get('lineItemId') == null) {
                        return ''
                    }

                    return '<div class="wd-80p label-total-completed">' + PJQ.helpers.formatHelpers.formatCurrency(row.getTotalCompleteAndStored(this.model)) + '</div>'
                }, this),
                "renderFooter": _.bind(function (data) {
                    let amt = 0;
                    _.each(data, function (lineItem) {
                        amt += lineItem.getTotalCompleteAndStored(this.model);
                    }, this);
                    return PJQ.helpers.formatHelpers.formatCurrency(amt);
                }, this)
            },
                {
                    "columnData": "",
                    "data": "",
                    "title": "Balance To Finish",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }
                        return '<div class="wd-80p label-balance-to-finish">' + PJQ.helpers.formatHelpers.formatCurrency(row.getBalanceToFinish(this.model)) + '</div>'
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.getBalanceToFinish(this.model);
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                }]);
            if (this.options.enableRetainage) {
                columns.push(...[{
                    "columnData": "",
                    "data": "attributes.workRetainage",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text"' + (this.canEditRetainage ? '' : 'disabled') + ' class="form-control wd-120p text-align-right input-dollars-full input-work-retainage-amount" data-p-bind="workRetainage" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainage')) + '" data-p-bind="workRetainage" placeholder="0.00">';
                        } else {
                            result = PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainage'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('workRetainage');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                    {
                        "columnData": "",
                        "data": "attributes.workRetainagePercent",
                        "title": "%",
                        "format": "percent",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit) {
                                result = '<input type="text"' + (this.canEditRetainage ? '' : 'disabled') + ' class="form-control wd-80p text-align-right input-percent input-work-retainage-percent" data-p-bind="workRetainagePercent" placeholder="0" value="' + (row.get('workRetainagePercent')) + '"/>'
                            } else {
                                result = PJQ.helpers.formatHelpers.formatPercent(row.get('workRetainagePercent'));
                            }
                            return result
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            if (_.size(data) > 0) {
                                _.each(data, function (lineItem) {
                                    amt += lineItem.get('workRetainagePercent');
                                });
                                amt = amt / _.size(data)
                            }
                            return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                        }
                    }]);
                if (this.options.enableStoredMaterials) {
                    columns.push(...[{
                        "columnData": "",
                        "data": "attributes.materialRetainage",
                        "title": "$",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit) {
                                result = '<input type="text"' + (this.canEditRetainage ? '' : 'disabled') + ' class="form-control wd-120p text-align-right input-dollars-full input-material-retainage-amount" data-p-bind="materialRetainage" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainage')) + '" data-p-bind="materialRetainage" placeholder="0.00">';
                            } else {
                                result = PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainage'));
                            }
                            return result
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('materialRetainage');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    },
                        {
                            "columnData": "",
                            "data": "attributes.materialRetainagePercent",
                            "title": "%",
                            "format": "percent",
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": _.bind(function (data, type, row) {
                                if (row.get('lineItemId') == null) {
                                    return '';
                                }

                                let result;
                                if (this.options.canEdit) {
                                    result = '<input type="text"' + (this.canEditRetainage ? '' : 'disabled') + ' class="form-control wd-80p text-align-right input-percent wd-100 input-material-retainage-percent" data-p-bind="materialRetainagePercent" placeholder="0" value="' + (row.get('materialRetainagePercent')) + '"/>'
                                } else {
                                    result = PJQ.helpers.formatHelpers.formatPercent(row.get('materialRetainagePercent'));
                                }
                                return result
                            }, this),
                            "renderFooter": function (data) {
                                let amt = 0;
                                if (_.size(data) > 0) {
                                    _.each(data, function (lineItem) {
                                        amt += lineItem.get('materialRetainagePercent');
                                    });
                                    amt = amt / _.size(data)
                                }
                                return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                            }
                        }]);
                }
                columns.push(...[{
                    "columnData": "",
                    "data": "attributes.workRetainageReleased",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "visible": this.options.enableRetainageRelease,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }

                        let result;
                        if (this.options.canEdit) {
                            result = '<input type="text"' + (this.canEditRetainageReleased ? '' : 'disabled') + ' class="form-control wd-120p text-align-right input-dollars-full input-work-retainage-released-amount" data-p-bind="workRetainageReleased" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainageReleased')) + '" data-p-bind="workRetainageReleased" placeholder="0.00">';
                        } else {
                            result = PJQ.helpers.formatHelpers.formatCurrency(row.get('workRetainageReleased'));
                        }
                        return result;
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('workRetainageReleased');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                    {
                        "columnData": "",
                        "data": "attributes.workRetainageReleasedPercent",
                        "title": "%",
                        "format": "percent",
                        "orderable": false,
                        "searchable": false,
                        "visible": this.options.enableRetainageRelease,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit) {
                                result = '<input type="text"' + (this.canEditRetainageReleased ? '' : 'disabled') + ' class="form-control wd-80p text-align-right input-percent wd-100 input-work-retainage-released-percent" data-p-bind="workRetainageReleasedPercent" placeholder="0" value="' + row.get('workRetainageReleasedPercent') + '"/>'
                            } else {
                                result = PJQ.helpers.formatHelpers.formatPercent(row.get('workRetainageReleasedPercent'));
                            }
                            return result;
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            if (_.size(data) > 0) {
                                _.each(data, function (lineItem) {
                                    amt += lineItem.get('workRetainageReleasedPercent');
                                });
                                amt = amt / _.size(data)
                            }
                            return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                        }
                    }]);
                if (this.options.enableStoredMaterials) {
                    columns.push(...[{
                        "columnData": "",
                        "data": "attributes.materialRetainageReleased",
                        "title": "$",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }

                            let result;
                            if (this.options.canEdit) {
                                result = '<input type="text"' + (this.canEditRetainageReleased ? '' : 'disabled') + ' class="form-control wd-120p text-align-right input-dollars-full input-material-retainage-released-amount" data-p-bind="materialRetainageReleased" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainageReleased')) + '" data-p-bind="materialRetainageReleased" placeholder="0.00">';
                            } else {
                                result = PJQ.helpers.formatHelpers.formatCurrency(row.get('materialRetainageReleased'));
                            }
                            return result;
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('materialRetainageReleased');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    },
                        {
                            "columnData": "",
                            "data": "attributes.materialRetainageReleasedPercent",
                            "title": "%",
                            "format": "percent",
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": _.bind(function (data, type, row) {
                                if (row.get('lineItemId') == null) {
                                    return '';
                                }

                                let result;
                                if (this.options.canEdit) {
                                    result = '<input type="text"' + (this.canEditRetainageReleased ? '' : 'disabled') + ' class="form-control wd-80p text-align-right input-percent wd-100 input-material-retainage-released-percent" data-p-bind="materialRetainageReleasedPercent" placeholder="0" value="' + row.get('materialRetainageReleasedPercent') + '"/>'
                                } else {
                                    result = PJQ.helpers.formatHelpers.formatPercent(row.get('materialRetainageReleasedPercent'));
                                }
                                return result;
                            }, this),
                            "renderFooter": function (data) {
                                let amt = 0;
                                if (_.size(data) > 0) {
                                    _.each(data, function (lineItem) {
                                        amt += lineItem.get('materialRetainageReleasedPercent');
                                    });
                                    amt = amt / _.size(data)
                                }
                                return PJQ.helpers.formatHelpers.formatPercent(Math.round(amt * 100) / 100);
                            }
                        }]);
                }
                columns.push({
                    "columnData": "",
                    "data": "attributes.workRetainageTotal",
                    "title": "$",
                    "format": "money",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('lineItemId') == null) {
                            return '';
                        }
                        return '<div class="wd-80p label-work-retainage-remaining">' + PJQ.helpers.formatHelpers.formatCurrency(row.getWorkRetainageRemaining(this.model)) + '</div>';
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.getWorkRetainageRemaining(this.model);
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                });
                if (this.options.enableStoredMaterials) {
                    columns.push({
                        "columnData": "",
                        "data": "attributes.materialRetainageTotal",
                        "title": "$",
                        "format": "money",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            if (row.get('lineItemId') == null) {
                                return '';
                            }
                            return '<div class="wd-80p label-material-retainage-remaining">' + PJQ.helpers.formatHelpers.formatCurrency(row.getMaterialRetainageRemaining(this.model)) + '</div>';
                        },
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.getMaterialRetainageRemaining(this.model);
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    });
                }
            }
        } else {
            columns.push(...[
                {
                    "columnData": "attributes.number",
                    "title": "#",
                    "width": `5%`,
                    "render": (data, type, row, opt) => {
                        let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null,
                            html = '<div class=" text-align-center mr-1' + (this.options.canEdit ? '' : 'p-1') + '">';
                        if (row.get('changeRequestLineItemId')) {
                            html += '<i class="fa-solid fa-asterisk text-primary mr-2" title="This line item was created from a change request line item"></i>'
                        }

                        if (isAppliedLineItem) {
                            html += '<i class="fa-solid fa-arrow-up text-primary mr-2" title="This line item was created from a markup"></i>'
                        }

                        html += (opt.row + 1).toString();

                        return `${html}</div>`;
                    }
                },
                {
                    "columnData": "attributes",
                    "title": "Contract Item #",
                    "visible": this.options.filterToPrimeContractItems && PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER),
                    "width": '120px',
                    "render": (data, type, row) => {
                        let description = row.get('description'),
                            descSplit = description.split(' - '),
                            itemNumber = '';
                        if (descSplit.length > 1) {
                            itemNumber = descSplit[0];
                        }
                        if (row.isNew() && this.options.canEdit) {
                            if (this.options.addingNewContractLineItems.includes(row.cid)) {
                                let contractItemNumberFormat = PJQ.app.session.erpIntegration?.getSetting('contractItemNumberFormat') ?? '';
                                return '<input type="text" class="form-control input-contract-item-number" placeholder="' + contractItemNumberFormat + '" value="' + itemNumber + '" data-p-bind="contractItemNumber">';
                            }
                            return '';
                        }
                        return itemNumber;
                    }
                },
                {
                    "columnData": "attributes",
                    "title": "Item Name",
                    "visible": this.options.filterToPrimeContractItems,
                    "width": '120px',
                    "render": (data, type, row) => {
                        let description = row.get('description');
                        if (PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER)) {
                            let descSplit = description.split(' - ');
                            if (descSplit.length > 1) {
                                description = descSplit[1];
                            }
                        }
                        if (row.isNew() && this.options.canEdit && (!this.isChangeRequests || (this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId')))) {
                            if (this.options.addingNewContractLineItems.includes(row.cid)) {
                                return '<input type="text" class="form-control input-contract-item" value="' + description + '" data-p-bind="contractItemName"></div>'
                            } else {
                                return '<select class="select-prime-contract-item form-control" ></select>';
                            }
                        }
                        return description;
                    }
                },
                {
                    "columnData": "attributes",
                    "title": "Commitment Line Item",
                    "width": '10%',
                    "visible": this.isCCO && PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.RELATE_CCO_LINE_TO_COMMITMENT_LINE) === true,
                    "render": (data, type, row) => {
                        let commitmentLineItemId = row.get('commitmentLineItemId'),
                            commitmentLineItem = commitmentLineItemId > 0 ? this.options.commitment?.lineItems.findWhere({id: commitmentLineItemId}) : null;
                        if (this.options.canEdit) {
                            return '<select class="form-control select-commitment-line"></select>';
                        } else {
                            if (commitmentLineItem != null) {
                                let costCode = this.costCodes.get(commitmentLineItem.get('costCodeId')),
                                    costType = this.costTypes.get(commitmentLineItem.get('costTypeId'));

                                return `<span class="font-weight-bold">${costCode.get('name')} - ${costType.get('name')}</span> | <span class="fs-12">${PJQ.helpers.formatHelpers.formatCurrency(commitmentLineItem.get('totalAmount'))}</span>`
                            } else {
                                return '';
                            }
                        }
                    }
                },
                {
                    "columnData": "subJobId",
                    "title": "Sub Job",
                    "visible": _.size(this.subJobs.models) > 0,
                    "width": this.isChangeRequests ? "10%" : "15%",
                    "render": (data, type, row) => {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && row.isNew() && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('costLineItemId') && !row.get('revenueLineItemId'))) && markup == null) {
                            return '<select class="select-sub-job form-control"></select>';
                        } else {
                            let subJob = this.subJobs.get(row.get('subJobId'));
                            return subJob ? (subJob.get('code') + ' - ' + subJob.get('name')) : '';
                        }
                    }
                },
                ...fnBudgetCodeCols()]);

            if (this.isChangeRequests) {
                if (this.options.showRevenue) {
                    columns.push({
                        "columnData": "pccoId",
                        "title": "Contract CO",
                        "width": "150px",
                        "visible": this.isChangeRequests,
                        "render": (data, type, row) => {
                            let pccoId = row.get('pccoId'),
                                html = '';

                            if (row.get('revenueLineItemId') > 0) {
                                html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a contract change order line item"></i>'
                            }

                            if (row.get('revenueLineItemId') > 0 && pccoId > 0) {
                                if (pccoId > 0) {
                                    html += '<div class="wd-150p"><a class="btn-view-change-order" href="javascript:void(0)" data-id="' + pccoId + '" data-type="pcco">' + row.get('pccoNumber') + '</a></div>';
                                }
                            }
                            return '<div class="d-flex">' + html + '</div>';
                        }
                    });
                }

                columns.push(...[
                    {
                        "columnData": "vendor",
                        "title": "Company",
                        "width": "150px",
                        "visible": this.isChangeRequests,
                        "render": (data, type, row) => {
                            let vendor = row.get('vendor') ?? null,
                                html = "",
                                markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && markup == null) {
                                html += '<select class="form-control select-vendor"></select>';
                            } else if (vendor != null) {
                                html += PJQ.helpers.contacts.getContactAnchor({contact: vendor, useCompanyName: true});
                            } else if (markup != null) {
                                html += '<div class="font-weight-medium"></div>';
                            } else {
                                html += '<div class="font-weight-medium">Not Assigned</div>';
                            }

                            return "<div class='d-flex align-items-center'>" + html + "</div>"
                        }
                    },
                    {
                        "columnData": "commitmentId",
                        "title": "Commitment",
                        "width": "150px",
                        "visible": this.isChangeRequests,
                        "render": (data, type, row) => {
                            let commitmentId = row.get('commitmentId'),
                                ccoId = row.get('ccoId'),
                                html = '',
                                markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});

                            if (row.get('costLineItemId') > 0) {
                                html += '<i class="fa-solid fa-check text-success mr-2" title="This line item is linked to a committed cost line item"></i>'
                            }

                            if (row.get('costLineItemId') > 0 || !this.options.canEdit || markup != null) {
                                if (commitmentId > 0) {
                                    html += '<div class="wd-150p"><a class="btn-view-commitment" href="javascript:void(0)" data-id="' + commitmentId + '">' + row.get('commitmentNumber') + '</a></div>';
                                } else if (ccoId > 0) {
                                    html += '<div class="wd-150p"><a class="btn-view-change-order" href="javascript:void(0)" data-id="' + ccoId + '" data-type="cco">' + row.get('ccoNumber') + '</a></div>';
                                }
                            } else if (this.options.canEdit) {
                                html += '<select class="form-control select-commitment"></select>';
                            }
                            return '<div class="d-flex">' + html + '</div>';
                        }
                    }
                ]);
            }

            columns.push(...[
                {
                    "columnData": "description",
                    "visible": !this.options.filterToPrimeContractItems,
                    "data": "attributes.description",
                    "width": this.isChangeRequests && this.options.canApplyChangeRequestRevenue ? "20%" : "200px",
                    "title": "Description",
                    "render": (data, type, row) => {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && markup == null) {
                            return '<input type="text" class="form-control input-description" maxlength="256" value="' + row.get('description').replace(/"/g, '&quot;') + '" data-p-bind="description">';
                        } else {
                            return row.get('description');
                        }
                    }
                }
            ]);

            if (this.options.isBudget) {
                columns.push({
                    "data": "attributes.budgetedHours",
                    "width": "120px",
                    "title": "Hours",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": (data, type, row) => {
                        let hrs = row.get('budgetedHours');
                        if (this.options.canEdit) {
                            return '<input type="text" class="form-control input-hours input-budgeted-hours" value="' + hrs / 60 + '" data-type="budgetedHours" placeholder="0">';
                        }
                        return hrs;
                    }
                },);
            }

            if ((this.options.showMarkup !== false || this.options.canEdit) && this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                columns.push(...[
                    {
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "width": "5%",
                        "title": "Quantity",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                                return '<input type="text" class="form-control input-decimal input-quantity" value="' + row.get('quantity') + '" data-p-bind="quantity" placeholder="0">';
                            } else {
                                return row.get('quantity');
                            }
                        }
                    },
                    {
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "title": "Unit",
                        "width": "5%",
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                                return '<select class="select-unit-type form-control"></select>';
                            } else {
                                let unitOfMeasure = this.unitsOfMeasure.get(row.get('unitId'));
                                return unitOfMeasure ? unitOfMeasure.get('name') : '';
                            }
                        }
                    },
                    {
                        "columnData": "unitPrice",
                        "data": "attributes.unitPrice",
                        "width": "10%",
                        "title": "Unit Price",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                            if (this.options.canEdit && (!this.isChangeRequests && !row.get('changeRequestLineItemId') || (this.isChangeRequests && !row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                                return '<input type="text" class="form-control text-align-right input-dollars-full input-unit-price" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice')) + '" data-p-bind="unitPrice" placeholder="0.00">';
                            } else {
                                return '<span class="label-unit-price">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice')) + '</span>';
                            }
                        }
                    }
                ]);
            } else if (this.options.showMarkup !== false || this.options.canEdit) {
                columns.push({
                    "columnData": "amount",
                    "data": "attributes.amount",
                    "width": "150px",
                    "title": this.isChangeRequests ? "Cost" : "Amount",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && (!this.isChangeRequests || (!row.get('revenueLineItemId') && !row.get('costLineItemId'))) && markup == null) {
                            if (this.options.accountingMethod === PJQ.constants.budget.accountingMethod.AMOUNT) {
                                if (this.options.isBudget) {
                                    return '<input type="text" class="form-control text-align-right input-dollars-full input-amount" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('budgetedCost')) + '" data-p-bind="budgetedCost" placeholder="0.00">';
                                } else {
                                    return '<input type="text" class="form-control text-align-right input-dollars-full input-amount" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('amount')) + '" data-p-bind="amount" placeholder="0.00">';
                                }
                            }
                            return '<span class="label-amount">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('amount')) + '</span>';
                        }

                        return '<span class="label-amount">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('amount')) + '</span>';
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            if (this.options.isBudget) {
                                amt += lineItem.get('budgetedCost')
                            } else {
                                amt += lineItem.get('amount')
                            }
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                });
            }

            if (this.isChangeRequests && this.options.showRevenue) {
                columns.push({
                    "columnData": "revenue",
                    "data": "attributes.revenue",
                    "width": "150px",
                    "title": "Revenue",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')});
                        if (this.options.canEdit && !row.get('revenueLineItemId') && markup == null) {
                            return '<input type="text" class="form-control text-align-right input-dollars-full input-revenue" value="' + PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue')) + '" data-p-bind="revenue" placeholder="0.00">';
                        }

                        return '<span class="label-revenue">' + PJQ.helpers.formatHelpers.formatCurrency(row.get('revenue')) + '</span>';
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += lineItem.get('revenue');
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                });

                columns.push({
                    "columnData": "",
                    "data": "",
                    "width": "10%",
                    "title": "Over/Under",
                    "orderable": false,
                    "searchable": false,
                    "className": "text-align-center",
                    "render": _.bind(function (data, type, row) {
                        let markup = row.markup ? row.markup : this.options.financialMarkups?.findWhere({id: row.get('appliedMarkupId')}),
                            value = row.get('revenue') - row.get('amount');

                        return '<span class="label-over-under">' + PJQ.helpers.formatHelpers.formatCurrency(value) + '</span>';
                    }, this),
                    "renderFooter": _.bind(function (data) {
                        let amt = 0;
                        _.each(data, function (lineItem) {
                            amt += (lineItem.get('revenue') - lineItem.get('amount'));
                        }, this);
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }, this)
                });
            }

            if (!this.options.isBudget && !this.isDirectCosts) {
                if (this.options.financialMarkups != null && this.options.showMarkup) {
                    _.each(this.options.financialMarkups.models, (markup) => {
                        if (markup.get('isVertical') || markup.get('delete') || markup.get('void') || (markup.get('appliedCostCodeId') && markup.get('appliedCostTypeId'))) {
                            return;
                        }

                        columns.push({
                            "columnData": "markupAmount",
                            "data": "attributes.markupAmount",
                            "title": markup.get('name') + ' (' + PJQ.helpers.formatHelpers.formatPercent(markup.get('percent') / 100) + ')',
                            "orderable": false,
                            "width": "120px",
                            "searchable": false,
                            "className": "text-align-center",
                            "render": (data, type, row) => {
                                let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null,
                                    amt = row.getMarkupAmount(this.options.financialMarkups, {
                                        cid: markup.cid,
                                        isAppliedLineItem: isAppliedLineItem
                                    });
                                return '<span class="label-markup-amount-' + markup.cid + '">' + PJQ.helpers.formatHelpers.formatCurrency(amt) + '</span>';
                            },
                            "renderFooter": (data) => {
                                let amt = 0;

                                _.each(data, (lineItem) => {
                                    let isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;
                                    amt += lineItem.getMarkupAmount(this.options.financialMarkups, {
                                        cid: markup.cid,
                                        isAppliedLineItem: isAppliedLineItem
                                    });
                                });
                                return PJQ.helpers.formatHelpers.formatCurrency(amt);
                            }
                        });
                    });
                }

                if (this.options.enableTax) {
                    columns.push(...[{
                        "columnData": "taxCode",
                        "data": "attributes.taxCodeId",
                        "width": "8%",
                        "title": "Tax Code",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null;

                            if (this.options.canEdit && !isAppliedLineItem) {
                                return '<div class="d-flex"><select class="select-tax-code form-control"></select></div>';
                            }

                            let taxCode = this.taxCodes.get(row.get('taxCodeId'));
                            if (taxCode != null) {
                                return taxCode.get('code') + ' (' + PJQ.helpers.formatHelpers.formatPercent(taxCode.get('rate') / 100) + ')'
                            }
                            return 'N/A';
                        },
                        "renderFooter": function (data) {
                            return '';
                        }
                    }, {
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "width": "10%",
                        "title": "Tax",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": _.bind(function (data, type, row) {
                            let taxAmount = PJQ.helpers.formatHelpers.formatCurrency(row.get('taxAmount'));
                            if (this.options.canEdit) {
                                return '<span class="label-tax-amount">' + taxAmount + '</span>';
                            }
                            return taxAmount;
                        }, this),
                        "renderFooter": function (data) {
                            let amt = 0;
                            _.each(data, function (lineItem) {
                                amt += lineItem.get('taxAmount');
                            });
                            return PJQ.helpers.formatHelpers.formatCurrency(amt);
                        }
                    }]);
                }

                if (!this.isChangeRequests && this.options.showBilling) {
                    columns.push(...[
                        {
                            "columnData": "billedToDate",
                            "data": "attributes.billedToDate",
                            "width": "10%",
                            "title": "Billed to Date",
                            "orderable": false,
                            "searchable": false,
                            "className": "text-align-center",
                            "render": _.bind(function (data, type, row) {
                                return PJQ.helpers.formatHelpers.formatCurrency(row.get('progressAmount'));
                            }, this),
                            "renderFooter": function (data) {
                                let amt = 0;
                                _.each(data, function (lineItem) {
                                    amt += lineItem.get('progressAmount');
                                });
                                return PJQ.helpers.formatHelpers.formatCurrency(amt);
                            }
                        }]);
                }

                columns.push({
                    "columnData": "subTotal",
                    "data": "attributes.amount",
                    "title": "Subtotal",
                    "orderable": false,
                    "searchable": false,
                    "width": "150px",
                    "className": "text-align-center",
                    "render": (data, type, row) => {
                        let isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null,
                            subtotal = PJQ.helpers.formatHelpers.formatCurrency(row.getSubTotal(this.options.financialMarkups, {
                                costs: this.isChangeRequests && !this.options.showRevenue,
                                isAppliedLineItem: isAppliedLineItem,
                                lineItems: this.collection
                            }));
                        if (this.options.canEdit) {
                            return '<span class="label-subtotal">' + subtotal + '</span>';
                        }
                        return subtotal;
                    },
                    "renderFooter": (data) => {
                        let amt = 0;
                        _.each(data, (lineItem) => {
                            let isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

                            amt += lineItem.getSubTotal(this.options.financialMarkups, {
                                costs: this.isChangeRequests && !this.options.showRevenue,
                                isAppliedLineItem: isAppliedLineItem,
                                lineItems: this.collection
                            });
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                });
            }
        }
        if (this.options.canEdit) {
            columns.push({
                data: "id",
                title: "",
                orderable: false,
                searchable: false,
                width: 50,
                className: 'text-align-center',
                render: _.bind(function (data, type, row) {
                    let html = '<div class="show-on-row-hover">',
                        isAppliedLineItem = row.markup != null || row.get('appliedMarkupId') != null
                    if (this.options.canDelete && !isAppliedLineItem && (!this.isChangeRequests || (!row.get('revenueLineItemId') && !row.get('costLineItemId')) || row.isNew())) {
                        html += '<button type="button" class="btn btn-danger btn-delete-line-item ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }
        return columns;
    },
    lineItemHoursChanged: function (e) {
        let $input = $(e.currentTarget),
            lineItem = this.getLineItemForInput($input);
        lineItem.set('budgetedHours', Math.ceil(parseFloat($input.val()) * 60));
    },
    renderLineItemsTable: function () {
        this.data = _.sortBy(_.filter(this.collection.models, (model) => {
            return !model.get('delete');
        }), (model) => {
            return model.get('appliedMarkupId') > 0 ? model.id + 100000 : model.id;
        });

        let fixedStart = 2;
        if (this.isInvoices || this.isChangeRequests) {
            fixedStart = this.options.canEdit ? 4 : 3;

            if (_.size(this.subJobs.models) > 0) {
                fixedStart++;
            }
        }

        let $dataTable = this.$('.line-items-table');
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: $dataTable,
            data: this.data,
            fixHeader: this.isInvoices,
            enableColumnResize: !this.isInvoices && !this.isChangeRequests,
            scrollY: '600px',
            scrollCollapse: true,
            hasFooter: false,
            fixedColumns: {
                start: fixedStart
            },
            extraClasses: this.isInvoices ? 'table-invoice-line-items' : '',
            isHideSearch: true,
            paging: false,
            scrollX: true,
            order: [],
            language: {
                emptyTable: this.options.canEdit ? 'Click "Add Line Item" to create a new Line item' : 'No line items have been added yet'
            },
            columns: this.getColumns(),
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
                if (this.isInvoices) {
                    this.renderSubTemplate(true, this.options.subTemplates.invoiceHeader, this.$('thead').first(), {
                        subJobs: this.subJobs,
                        enableStoredMaterials: this.options.enableStoredMaterials,
                        enableRetainage: this.options.enableRetainage,
                        enableRetainageRelease: this.options.enableRetainageRelease,
                        enableTax: this.options.enableTax,
                        canEdit: this.options.canEdit,
                        enableSelection: this.options.enableSelection
                    }, {
                        prepend: true
                    });
                } else if (this.isChangeRequests && this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                    this.renderSubTemplate(true, this.options.subTemplates.changeRequestHeader, this.$('thead').first(), {
                        subJobs: this.subJobs,
                        enableSelection: this.options.enableSelection,
                        canEdit: this.options.canEdit,
                        accountingMethod: this.options.accountingMethod
                    }, {
                        prepend: true
                    });
                }
                this.renderTableFooter(this.data);
            }, this),
            onTableDraw: () => {
                this.renderTableFooter();
            },
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteLineItem(row);
                        }, this),
                        isShown: _.bind(function (row) {
                            this.options.canEdit
                        }, this),
                    }
                ]
            },
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    totalButtonClicked: function (e) {
        let $btn = $(e.currentTarget),
            fnName = $btn.data('fn'),
            fn = this.options[fnName];
        if (typeof fn === 'function') {
            fn();
        }
    },
    renderTableFooter: function () {
        if (this.dataTable && this.data) {
            let visibleCols = _.filter(this.getColumns(), function (column) {
                return column.visible !== false;
            });

            if (this.$footerTbl?.length > 0) {
                this.$footerTbl.remove();
                this.$footerTbl = null;
            }
            this.$footerTbl = $('<table class="dataTable line-items-footer"><tfoot></tfoot></table>');
            let $footer = this.$footerTbl.find('tfoot').first();

            let totalRows = [],
                lineItems = this.collection.models.filter((lineItem) => {
                    return !lineItem.get('delete');
                });
            if (this.options.showSubTotal) {
                let sTotal = 0;
                _.each(lineItems, (lineItem) => {
                    let isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

                    sTotal += lineItem.getSubTotal(this.options.financialMarkups, {
                        costs: this.isChangeRequests && !this.options.showRevenue,
                        isAppliedLineItem: isAppliedLineItem,
                        lineItems: this.collection
                    });
                });
                totalRows.push({
                    label: 'Subtotal',
                    amount: sTotal
                });
            }

            if (this.options.financialMarkups != null && this.options.showMarkup) {
                let markups = this.options.financialMarkups.getMarkups(lineItems);
                _.each(_.sortBy(_.filter(markups, (markup) => {
                    return markup.isVertical;
                }), (markup) => {
                    return markup.sortOrder;
                }), (vMarkup) => {
                    totalRows.push({
                        label: vMarkup.name + ' (' + PJQ.helpers.formatHelpers.formatPercent(vMarkup.model.get('percent') / 100) + ')',
                        amount: vMarkup.amount
                    });
                });
            }

            if (this.isInvoices) {
                if (this.options.enableRetainage) {
                    let rtTotal = 0,
                        rrTotal = 0;
                    _.each(lineItems, (lineItem) => {
                        rtTotal += lineItem.getRetainage();
                        rrTotal += lineItem.getRetainageReleased();
                    });

                    if (rtTotal > 0) {
                        totalRows.push({
                            label: 'Retainage',
                            amount: -rtTotal,
                            extraClasses: 'text-danger'
                        });
                    }

                    if (rrTotal > 0) {
                        totalRows.push({
                            label: 'Retainage Released',
                            amount: rrTotal
                        });
                    }
                }
            }

            if (this.options.enableTax) {
                let tTotal = 0;
                _.each(lineItems, (lineItem) => {
                    tTotal += lineItem.getTaxAmount();
                });
                totalRows.push({
                    label: 'Tax',
                    amount: tTotal
                });
            }

            let grandTotal = 0;
            if (this.options.showGrandTotal) {
                _.each(lineItems, (lineItem) => {
                    grandTotal += lineItem.getGrandTotal(this.options.financialMarkups, {
                        totalMarkups: true,
                        costs: this.isChangeRequests && !this.options.showRevenue
                    });
                });
            }
            if (this.options.approvedChanges != null) {
                if (this.options.showGrandTotal) {
                    totalRows.push({
                        label: 'Original Contract',
                        amount: grandTotal
                    });
                }

                totalRows.push({
                    label: 'Approved Changes',
                    amount: this.options.approvedChanges,
                    clickFn: typeof this.options.onApprovedChangesClicked === 'function' ? 'onApprovedChangesClicked' : null
                });

                if (this.options.showGrandTotal) {
                    totalRows.push({
                        label: 'Contract Total',
                        amount: grandTotal + this.options.approvedChanges,
                        bold: true
                    });
                }
            } else if (this.options.showGrandTotal) {
                totalRows.push({
                    bold: true,
                    label: 'Grand Total',
                    amount: grandTotal
                });
            }

            if (this.options.billedToDate != null) {
                let billed = null;
                if (typeof this.options.billedToDate === 'function') {
                    billed = this.options.billedToDate();
                } else if (typeof this.options.billedToDate === 'number') {
                    billed = this.options.billedToDate;
                }
                if (billed != null) {
                    totalRows.push({
                        label: 'Billed to Date',
                        amount: billed,
                        clickFn: typeof this.options.onBilledToDateClicked === 'function' ? 'onBilledToDateClicked' : null
                    });

                    totalRows.push({
                        label: 'Amount Remaining',
                        amount: (grandTotal + (this.options.approvedChanges ?? 0)) - billed
                    });
                }

                let retainage = null;
                if (typeof this.options.billedToDate === 'function' && typeof this.options.retainage === 'function') {
                    retainage = this.options.retainage();
                } else if (typeof this.options.retainage === 'number') {
                    retainage = this.options.retainage;
                }
                if (retainage != null) {
                    totalRows.push({
                        label: 'Current Retainage',
                        amount: retainage
                    });
                }
            }

            let $hiddenRow = $('<tr style="background: transparent;"></tr>');
            _.each(visibleCols, (col) => {
                $hiddenRow.append(`<th style="background: transparent; border:none; padding-top: 0 !important; padding-bottom: 0 !important; width:${col.width ?? 'auto'}"></th>`);
            });
            $footer.append($hiddenRow);

            _.each(totalRows, (item) => {
                if (_.size(item.label) === 0) {
                    return;
                }

                let $totalRow = $('<tr class="total-row"></tr>'),
                    colOffset = this.options.canEdit ? 2 : 1;
                $totalRow.append('<th class="text-align-right" colspan="' + (_.size(visibleCols) - colOffset).toString() + '"><span class="pr-2 ' + (item.bold ? 'font-weight-bold' : 'font-weight-medium') + ' fs-15">' + item.label + ':</span></th>');

                let txt = '';
                if (_.size(item.clickFn) > 0) {
                    txt = '<a href="javascript:void(0)" data-fn="' + item.clickFn + '" class="btn-total-fn ' + (item.bold ? 'font-weight-bold' : 'font-weight-normal') + ' ' + item.extraClasses + '">' + PJQ.helpers.formatHelpers.formatCurrency(item.amount) + '</a>';
                } else {
                    txt = '<span class="' + (item.bold ? 'font-weight-bold' : 'font-weight-normal') + ' ' + item.extraClasses + '">' + PJQ.helpers.formatHelpers.formatCurrency(item.amount) + '</span>';
                }

                $totalRow.append('<th class="text-align-center' + (colOffset > 1 ? ' border-right-0' : '') + '">' + txt + '</th>');
                if (colOffset > 1) {
                    $totalRow.append('<th class="border-left-0"></th>');
                }

                $footer.append($totalRow);
            });

            this.$('.line-items-table').after(this.$footerTbl);
            this.dataTable.$dataTable.find('tfoot').first().remove();
        }
    },
    updateCommitmentForChangeRequestLineItem: function (lineItem, commitment) {
        if (!(lineItem.id > 0) && commitment != null && !(lineItem.get('costCodeId') > 0)) {
            let budgetCodes = _.uniq(_.map(commitment.lineItems.models, (lineItem) => {
                return lineItem.get('costCodeId') + '|' + lineItem.get('costTypeId');
            }));
            if (_.size(budgetCodes) === 1) {
                let bcSplit = budgetCodes[0].split('|'),
                    costCodeId = parseInt(bcSplit[0]),
                    costTypeId = parseInt(bcSplit[1]);
                lineItem.set({
                    costCodeId: costCodeId,
                    costTypeId: costTypeId
                })
            }
        }

        lineItem.set({
            vendor: commitment?.contractedContact?.toJSON(),
            vendorId: commitment?.contractedContact?.id,
            commitmentId: commitment?.id,
            commitmentNumber: commitment?.get('number')
        });

        lineItem.vendor = commitment?.contractedContact;
    },
    renderInputs: function () {
        let self = this;
        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-hours'), 1);

        let contractItemNumberRegex = PJQ.app.session.erpIntegration?.getSetting('contractItemNumberRegex');
        if (_.size(contractItemNumberRegex) > 0) {
            this.$('.input-contract-item-number').inputmask({
                regex: contractItemNumberRegex,
                rightAlign: false,
                showInputMaskOnHover: true
            });
        }

        this.addListeners();
        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$el, this.collection, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'cid',
                useDecimalPercentFields: true,
                watchElements: [
                    'input'
                ],
                inputs: {
                    contractItemNumber: {
                        afterChange: ($el, value, model) => {
                            let itemName = model.attributes.contractItemName ?? '';
                            if (_.size(value) > 0 && _.size(itemName) > 0) {
                                model.set('description', value + ' - ' + itemName);
                            }
                        },
                    },
                    contractItemName: {
                        afterChange: ($el, value, model) => {
                            let itemNumber = model.attributes.contractItemNumber ?? '';
                            if (_.size(value) > 0 && _.size(itemNumber) > 0) {
                                model.set('description', itemNumber + ' - ' + value);
                            }
                        },
                    }
                }
            });
        }

        if (this.isCCO && PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.RELATE_CCO_LINE_TO_COMMITMENT_LINE) === true) {
            let fnCommitmentLineToChoice = (lineItem) => {
                let costCode = this.costCodes.get(lineItem.get('costCodeId')),
                    costType = this.costTypes.get(lineItem.get('costTypeId'));
                return {
                    id: lineItem.id,
                    name: `<span class="font-weight-bold">${costCode.get('name')} - ${costType.get('name')}</span> | <span class="fs-12">${PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('totalAmount'))}</span>`
                };
            };
            this.commitmentLinePickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-commitment-line',
                valueAttribute: 'commitmentLineItemId',
                selectPickerOptions: {
                    isBlockSubtext: true,
                    appendContainer: self.$('.line-items-table'),
                    size: 5,
                    choices: (model) => {
                        if (model.get('costCodeId') > 0) {
                            let suggested = [],
                                others = [];
                            _.each(this.options.commitment.lineItems.models, (lineItem) => {
                                if (lineItem.get('costCodeId') === model.get('costCodeId')) {
                                    suggested.push(lineItem);
                                } else {
                                    others.push(lineItem);
                                }
                            });
                            if (_.size(suggested) > 0) {
                                return [{
                                    name: 'Suggested',
                                    choices: _.map(suggested, fnCommitmentLineToChoice)
                                }, {
                                    name: '',
                                    choices: _.map(others, fnCommitmentLineToChoice)
                                }];
                            }
                        }
                        return _.map(this.options.commitment.lineItems.models, fnCommitmentLineToChoice);
                    }
                },
                onChange: (model, value) => {
                    model.set('commitmentLineItemId', value);
                }
            });
        }

        if (this.isChangeRequests && this.options.canEdit) {
            let fnCommitmentToChoice = (commitment) => {
                return {
                    id: commitment.id,
                    name: '<strong>' + commitment.get('number') + '</strong>' + ' | <span class="fs-12">' + PJQ.helpers.formatHelpers.formatCurrency(commitment.getGrandTotal()) + '</span>',
                    subtext: commitment.contractedContact?.get('companyName') ?? ''
                };
            };
            this.commitmentPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-commitment',
                valueAttribute: 'commitmentId',
                selectPickerOptions: {
                    isBlockSubtext: true,
                    appendContainer: self.$('.line-items-table'),
                    size: 8,
                    choices: (model) => {
                        let costCodeId = model.get('costCodeId'),
                            vendorId = model.get('vendorId');
                        if (costCodeId > 0 || vendorId > 0) {
                            let suggested = [],
                                others = [];
                            _.each(this.projectCommitments.models, (commitment) => {
                                if (vendorId != null && commitment.contractedContact?.id !== vendorId) {
                                    return;
                                }

                                if (null != costCodeId &&
                                    null != commitment.lineItems.findWhere({costCodeId: costCodeId})) {
                                    suggested.push(commitment);
                                } else {
                                    others.push(commitment);
                                }
                            });
                            if (_.size(suggested) > 0) {
                                return [{
                                    name: 'Suggested',
                                    choices: _.map(suggested, fnCommitmentToChoice)
                                }, {
                                    name: '',
                                    choices: _.map(others, fnCommitmentToChoice)
                                }];
                            } else if (_.size(others) > 0) {
                                return _.map(others, fnCommitmentToChoice);
                            }
                        }
                        return _.map(this.projectCommitments.models, fnCommitmentToChoice);
                    }
                },
                onChange: (model, value) => {
                    let commitment = this.projectCommitments.get(value);
                    this.updateCommitmentForChangeRequestLineItem(model, commitment);

                    // let row = this.dataTable.getRow(model.cid);
                    // if (row) {
                    //     this.dataTable.refreshRow(row);
                    // }
                    //
                    // this.renderLineItemsTable();

                    let vendorPicker = this.vendorPickerCollection.pickers[model.cid];
                    vendorPicker.render();
                }
            });

            let fnVendorToChoice = (commitment) => {
                return {
                    id: commitment.contractedContact.id,
                    name: '<strong>' + commitment.contractedContact.get('companyName') + '</strong>',
                    subtext: commitment.contractedContact.get('contactName') ?? ''
                };
            };
            this.vendorPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-vendor',
                valueAttribute: 'vendorId',
                selectPickerOptions: {
                    // isBlockSubtext: true,
                    appendContainer: self.$('.line-items-table'),
                    size: 8,
                    isIntChoices: true,
                    choices: (model) => {
                        let foundIds = [],
                            suggested = [],
                            others = [],
                            costCodeId = model.get('costCodeId') > 0;
                        _.each(this.projectCommitments.models, (commitment) => {
                            if (commitment.contractedContact == null || -1 !== foundIds.indexOf(commitment.contractedContact.id)) {
                                return;
                            }

                            foundIds.push(commitment.contractedContact.id);
                            if (costCodeId > 0 && null != commitment.lineItems.findWhere({
                                costCodeId: costCodeId
                            })) {
                                suggested.push(commitment);
                            } else {
                                others.push(commitment);
                            }
                        });
                        if (_.size(suggested) > 0) {
                            return [{
                                name: 'Suggested',
                                choices: _.map(suggested, fnVendorToChoice)
                            }, {
                                name: '',
                                choices: _.map(others, fnVendorToChoice)
                            }];
                        }
                        return _.map(others, fnVendorToChoice);
                    }
                },
                onChange: (model, value) => {
                    let commitment = null,
                        currentCommitment = this.projectCommitments.get(model.get('commitmentId')),
                        matchCommitments;
                    if (currentCommitment && currentCommitment.contractedContact && currentCommitment.contractedContact.id === value) {
                        commitment = currentCommitment
                        matchCommitments = this.projectCommitments.filter((commitment) => {
                            return commitment.contractedContact && commitment.contractedContact.id === value;
                        });
                    } else {
                        matchCommitments = this.projectCommitments.filter((commitment) => {
                            return commitment.contractedContact && commitment.contractedContact.id === value;
                        });
                    }

                    this.updateCommitmentForChangeRequestLineItem(model, commitment);

                    if (_.size(matchCommitments) > 0) {
                        let vendor = matchCommitments[0].contractedContact;
                        model.set({
                            vendorId: value,
                            vendor: vendor?.toJSON()
                        });
                        model.vendor = vendor;
                    }

                    let commitmentPicker = this.commitmentPickerCollection.pickers[model.cid];
                    commitmentPicker.render();

                    this.nextInput('vendor', model);
                }
            });
        }

        if (this.isInvoices) {
            if (this.possibleLineItems != null) {
                this.lineItemPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                    pickerSelector: '.select-line-item',
                    valueAttribute: 'lineItemId',
                    selectPickerOptions: {
                        appendContainer: self.$('.line-items-table'),
                        isBlockSubtext: true,
                        choices: this.getPossibleLineItemOptions()
                    },
                    onChange: (model, value) => {
                        let selectedItem = this.possibleLineItems.get(value);
                        if (selectedItem != null) {
                            model.set(selectedItem.attributes, {
                                silent: true
                            });
                            let row = this.dataTable.getRow(model.cid);
                            this.dataTable.refreshRow(row);

                            this.nextInput('lineItem', model);
                        }
                    }
                });
            }
        } else {
            if (this.options.filterToPrimeContractItems && this.$('.select-prime-contract-item').length > 0) {
                this.fetchPrimeContract(() => {
                    this.primeContractLineItemPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                        pickerSelector: '.select-prime-contract-item',
                        valueAttribute: 'description',
                        selectPickerOptions: {
                            noneSelectedText: 'Select Item',
                            appendContainer: self.$('.line-items-table'),
                            isLiveSearch: true,
                            isIntChoices: false,
                            size: 8,
                            isDisabled: (model) => {
                                return !this.options.canEdit;
                            },
                            choices: this.getPrimeContractItemChoices()
                        },
                        onChange: (model, value) => {
                            if (value === "c652db68-5944-433e-99de-17c7d26bae45") {
                                this.options.addingNewContractLineItems.push(model.cid);
                                this.dataTable.render();

                                this.toggleInput('contractItem', model);
                            } else {
                                model.set('description', value);
                                this.nextInput('pc_lineItem', model);
                            }
                        }
                    });
                });
            }

            if (_.size(this.subJobs.models) > 0) {
                this.subJobPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                    pickerSelector: '.select-sub-job',
                    valueAttribute: 'subJobId',
                    selectPickerOptions: {
                        noneSelectedText: 'Parent Job',
                        appendContainer: self.$('.line-items-table'),
                        isLiveSearch: true,
                        isIntChoices: true,
                        size: 8,
                        isDisabled: _.bind(function (model) {
                            return !model.isNew() || !this.options.canEdit;
                        }, this),
                        choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                            name: 'Sub Jobs', choices: _.map(this.subJobs.models, function (subJob) {
                                return {
                                    id: subJob.id,
                                    name: subJob.get('code') + ' - ' + subJob.get('name')
                                }
                            }, this)
                        }])
                    },
                    onChange: _.bind(function (model, value) {
                        model.set('subJobId', value > 0 ? value : null);
                        model.set('costCodeId', 0);

                        let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid];
                        costCodePicker.render();

                        this.nextInput('subJob', model);
                    }, this)
                });
            }

            this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-cost-code',
                valueAttribute: 'costCodeId',
                selectPickerOptions: {
                    isLiveSearch: true,
                    isIntChoices: true,
                    hideDisabled: false,
                    appendContainer: self.$('.line-items-table'),
                    isDisabled: _.bind(function (model) {
                        return !model.isNew() || !this.options.canEdit;
                    }, this),
                    choices: _.bind(function (model) {
                        return this.getCostCodeOptions(model)
                    }, this)
                },
                onChange: _.bind(function (model, value) {
                    model.set('costCodeId', value);

                    let costCode = this.costCodes.get(value),
                        allowedCostTypeIds = costCode.get('costTypeIds');
                    if (_.size(allowedCostTypeIds) > 0 && allowedCostTypeIds.indexOf(model.get('costTypeId')) === -1) {
                        model.set('costTypeId', 0);
                    }

                    let costTypeSelector = this.costTypeSelectorCollection.pickers[model.cid];
                    costTypeSelector.render();

                    this.nextInput('costCode', model);
                }, this)
            });

            this.costTypeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-cost-type',
                valueAttribute: 'costTypeId',
                selectPickerOptions: {
                    appendContainer: self.$('.line-items-table'),
                    isIntChoices: true,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew() || !this.options.canEdit || !(model.get('costCodeId') > 0);
                    }, this),
                    choices: _.bind(function (model) {
                        return this.getCostTypeOptions(model)
                    }, this)
                },
                onChange: _.bind(function (model, value) {
                    model.set('costTypeId', value);

                    if (typeof model.resetMarkup === 'function') {
                        model.resetMarkup();
                    }

                    if (this.options.isBudget) {
                        let hasSubJobs = _.size(this.subJobs) > 0,
                            budgetLineItem = _.find(this.budget.lineItems.models, function (li) {
                                if (hasSubJobs && li.get('subJobId') !== model.get('subJobId')) {
                                    return false;
                                } else if (li.get('accountingMethod') === PJQ.constants.budget.accountingMethod.AMOUNT && this.options.accountingMethod !== li.get('accountingMethod')) {
                                    return false;
                                }
                                return li.get('costCodeId') === model.get('costCodeId')
                                    && li.get('costTypeId') === model.get('costTypeId');
                            }, this);
                        if (budgetLineItem != null) {
                            let $line = this.getLineItemElement(model),
                                budgetedCost = budgetLineItem.get('budgetedCost'),
                                description = budgetLineItem.get('description');
                            if (this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                                let quantity = budgetLineItem.get('quantity'),
                                    unitId = budgetLineItem.get('unitId'),
                                    unitPrice = budgetLineItem.get('unitPrice');
                                model.set({
                                    description: description,
                                    quantity: quantity,
                                    unitId: unitId,
                                    unitPrice: unitPrice,
                                    budgetedCost: budgetedCost
                                });
                                $line.find('.input-quantity').val(quantity);
                                $line.find('select.select-unit-type').val(unitId > 0 ? unitId.toString() : "").change();
                                $line.find('.input-unit-price').val(PJQ.helpers.formatHelpers.formatCurrency(unitPrice));
                            } else {
                                model.set({
                                    description: budgetLineItem.get('description'),
                                    budgetedCost: budgetedCost
                                });
                                $line.find('.input-amount').val(PJQ.helpers.formatHelpers.formatCurrency(model.get('budgetedCost')));
                            }
                            $line.find('.input-description').val(model.get('description'));
                        }
                    }
                    this.nextInput('costType', model);
                }, this)
            });

            this.taxCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-tax-code',
                valueAttribute: 'taxCodeId',
                selectPickerOptions: {
                    appendContainer: self.$('.line-items-table'),
                    isLiveSearch: true,
                    isIntChoices: true,
                    isDisabled: (model) => {
                        return !this.options.canEdit;
                    },
                    choices: (model) => {
                        return [{
                            id: 0,
                            name: 'N/A'
                        }, ..._.map(this.taxCodes.models, function (taxCode) {
                            return {
                                id: taxCode.id,
                                name: taxCode.get('code') + " (" + PJQ.helpers.formatHelpers.formatPercent(taxCode.get('rate') / 100) + ")"
                            }
                        }, this)];
                    }
                },
                onChange: _.bind(function (model, value) {
                    let taxCode = this.taxCodes.get(value);
                    model.set({
                        taxCodeId: taxCode ? taxCode.id : null,
                        taxRate: taxCode ? taxCode.get('rate') : 0
                    });

                    this.nextInput('taxCode', model);
                }, this)
            });

            new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-unit-type',
                valueAttribute: 'unitId',
                selectPickerOptions: {
                    appendContainer: self.$('.line-items-table'),
                    isIntChoices: true,
                    isDisabled: function (model) {
                        return !model.isNew();
                    },
                    choices: _.bind(function (model) {
                        return _.map(this.unitsOfMeasure.models, function (unit) {
                            return {
                                id: unit.id,
                                name: unit.get('name')
                            }
                        });
                    }, this)
                },
                onChange: _.bind(function (model, value) {
                    model.set('unitId', value);

                    this.nextInput('unitType', model);
                }, this)
            });
        }

        if (this.options.canEdit && this.focusLineItem != null) {
            if (this.isInvoices) {
                this.toggleInput('lineItem', this.focusLineItem);
            } else if (this.options.filterToPrimeContractItems) {
                this.toggleInput('pc_lineItem', this.focusLineItem);
            } else if (_.size(this.subJobs) > 0) {
                this.toggleInput('subJob', this.focusLineItem);
            } else {
                this.toggleInput('costCode', this.focusLineItem);
            }
            this.focusLineItem = null;
        }
    },
    updateLineItemRow: function (lineItem) {
        let $line = this.getLineItemElement(lineItem),
            isAppliedLineItem = lineItem.markup != null || lineItem.get('appliedMarkupId') != null;

        if (this.options.isBudget) {
            $line.find('.label-amount').text(PJQ.helpers.formatHelpers.formatCurrency(this.options.isBudget ? lineItem.get('budgetedCost') : lineItem.get('amount')));
            return;
        }

        let subTotal = lineItem.getSubTotal(this.options.financialMarkups, {
                costs: this.isChangeRequests && !this.options.showRevenue,
                isAppliedLineItem: isAppliedLineItem,
                lineItems: this.collection
            }),
            progress = lineItem.get('progressAmount');
        if (progress != null) {
            let amtRemain = subTotal - progress;
            $line.find('.label-amount-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(amtRemain));
        }

        if (this.options.financialMarkups != null) {
            _.each(this.options.financialMarkups.models, (markup) => {
                if (markup.get('void')) {
                    return;
                }

                let amt = lineItem.getMarkupAmount(this.options.financialMarkups, {
                    cid: markup.cid,
                    isAppliedLineItem: isAppliedLineItem
                });
                $line.find('.label-markup-amount-' + markup.cid.toString()).text(PJQ.helpers.formatHelpers.formatCurrency(amt));
            });
        }

        if (this.options.enableTax) {
            $line.find('.label-tax-amount').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('taxAmount')));
        }

        if (this.isChangeRequests) {
            let overUnder = lineItem.get('revenue') - lineItem.get('amount');
            $line.find('.label-over-under').text(PJQ.helpers.formatHelpers.formatCurrency(overUnder));
        }

        $line.find('.label-subtotal').text(PJQ.helpers.formatHelpers.formatCurrency(subTotal));
        $line.find('.label-amount').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('amount')));
        $line.find('.label-revenue').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('revenue')));
        $line.find('.label-unit-price').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('unitPrice')));
    },
    nextInput: function (prevInput, lineItem) {
        switch (prevInput) {
            case 'pc_lineItem':
                if (this.subJobPickerCollection != null) {
                    this.toggleInput('subJob', lineItem);
                } else {
                    this.toggleInput('costCode', lineItem);
                }
                break;
            case 'subJob':
                this.toggleInput('costCode', lineItem);
                break;
            case 'costCode':
                if (lineItem.get('costCodeId') > 0 && !(lineItem.get('costTypeId') > 0)) {
                    this.toggleInput('costType', lineItem);
                }
                break;
            case 'costType':
                if (this.isChangeRequests) {
                    this.toggleInput('vendor', lineItem);
                } else {
                    this.toggleInput('description', lineItem);
                }
                break;
            case 'vendor':
                if (lineItem.get('commitmentId') == null) {
                    this.toggleInput('commitment', lineItem);
                } else {
                    this.toggleInput('description', lineItem);
                }
                break;
            case 'commitment':
                this.toggleInput('description', lineItem);
                break;
            case 'taxCode':

                break;
            case 'unitType':

                break;
        }
    },
    getPrimeContractItemChoices: function () {
        let choices = _.map(_.uniq(_.map(_.union(this.options.primeContract.lineItems.models, _.filter(this.collection.models, (lineItem) => {
            return _.size(lineItem.get('description')) > 0;
        })), (lineItem) => {
            return lineItem.get('description');
        })).sort((a, b) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(a ?? "", b ?? "");
        }), (description) => {
            return {
                id: description,
                name: description
            };
        });

        choices.unshift({
            id: "c652db68-5944-433e-99de-17c7d26bae45",
            name: '<i class="fal fa-plus mr-1"></i>New Item'
        })

        return choices;
    },
    toggleInput: function (input, lineItem) {
        if (!this.options.canEdit) {
            return false;
        }

        let $line = this.getLineItemElement(lineItem);
        switch (input) {
            case 'lineItem':
                if (this.lineItemPickerCollection == null) {
                    return false;
                }

                let lineItemPicker = this.lineItemPickerCollection.getPickerForId(lineItem.cid);
                if (lineItemPicker != null) {
                    setTimeout(() => {
                        lineItemPicker.toggle();
                    }, 100);
                }
                break;
            case 'pc_lineItem':
                if (this.primeContractLineItemPickerCollection == null) {
                    return false;
                }

                let pcLineItemPicker = this.primeContractLineItemPickerCollection.getPickerForId(lineItem.cid);
                if (pcLineItemPicker != null) {
                    setTimeout(() => {
                        pcLineItemPicker.toggle();
                    }, 100);
                }
                break;
            case 'subJob':
                if (this.subJobPickerCollection == null) {
                    return false;
                }

                let subJobPicker = this.subJobPickerCollection.getPickerForId(lineItem.cid);
                if (subJobPicker != null) {
                    setTimeout(() => {
                        subJobPicker.toggle();
                    }, 100);
                }
                break;
            case 'costCode':
                if (this.costCodeSelectorCollection == null) {
                    return false;
                }

                let costCodePicker = this.costCodeSelectorCollection.getPickerForId(lineItem.cid);
                if (costCodePicker != null) {
                    setTimeout(() => {
                        costCodePicker.toggle();
                    }, 100);
                }
                break;
            case 'costType':
                if (this.costTypeSelectorCollection == null) {
                    return false;
                }

                let costTypePicker = this.costTypeSelectorCollection.getPickerForId(lineItem.cid);
                if (costTypePicker != null) {
                    setTimeout(() => {
                        costTypePicker.toggle();
                    }, 100);
                }
                break
            case 'vendor':
                if (this.vendorPickerCollection == null) {
                    return false;
                }

                let vendorPicker = this.vendorPickerCollection.getPickerForId(lineItem.cid);
                if (vendorPicker != null) {
                    setTimeout(() => {
                        vendorPicker.toggle();
                    }, 100)
                }
                break;
            case 'commitment':
                if (this.commitmentPickerCollection == null) {
                    return false;
                }

                let commitmentPicker = this.commitmentPickerCollection.getPickerForId(lineItem.cid);
                if (commitmentPicker != null) {
                    setTimeout(() => {
                        commitmentPicker.toggle();
                    }, 100)
                }
                break;
            case 'description':
                $line.find('.input-description').focus();
                break;
            case 'contractItem':
                $line.find('.input-contract-item').focus();
                break;
            case 'amount':
                $line.find('.input-amount').focus();
                break;
            case 'revenue':
                $line.find('.input-revenue').focus();
                break;
            case 'taxCode':

                break;
            case 'unitType':

                break;
        }

        return true;
    },
    addListeners: function () {
        this.stopListening(this.collection);
        this.stopListening(this.options.financialMarkups)
        if (!this.isInvoices) {
            this.listenTo(this.collection, 'change:amount change:taxRate change:costCodeId change:costTypeId', (lineItem) => {
                if (typeof lineItem.resetMarkup === 'function') {
                    lineItem.resetMarkup();
                }

                if (lineItem.get('taxRate') > 0 || lineItem.get('taxAmount') > 0) {
                    lineItem.set('taxAmount', lineItem.getTaxAmount());
                }

                this.updateLineItemRow(lineItem);

                _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                    let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                    if (lineItem) {
                        this.updateLineItemRow(lineItem);
                    }
                });

                this.renderTotals();
            });

            this.listenTo(this.collection, 'change', _.bind(function (lineItem) {
                this.updateAccountingMethodSelector();
                this.updateLineItemRow(lineItem);

                _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                    let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                    if (lineItem) {
                        this.updateLineItemRow(lineItem);
                    }
                });
            }, this));

            this.listenTo(this.collection, 'change:quantity change:unitPrice', _.bind(function (lineItem) {
                let amount = lineItem.get('unitPrice') * lineItem.get('quantity');
                if (this.options.isBudget) {
                    lineItem.set({
                        budgetedCost: amount
                    });
                } else {
                    lineItem.set({
                        amount: amount
                    });
                }
                this.updateLineItemRow(lineItem);

                _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                    let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                    if (lineItem) {
                        this.updateLineItemRow(lineItem);
                    }
                });
            }, this));

            if (this.isChangeRequests) {
                this.listenTo(this.collection, 'change:revenue', (lineItem) => {
                    this.updateLineItemRow(lineItem);

                    _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                        let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});
                        if (lineItem) {
                            this.updateLineItemRow(lineItem);
                        }
                    });
                    this.renderTotals();
                });

                this.listenTo(this.collection, 'change:amount', (lineItem) => {
                    let cost = lineItem.get('amount');
                    if (this.options.copyCostToRevenue && lineItem.get('costLineItemId') == null && !(lineItem.get('appliedMarkupId') > 0)) {
                        lineItem.set({
                            revenue: cost ?? 0
                        });

                        let $line = this.getLineItemElement(lineItem);
                        $line.find('.input-revenue').val(PJQ.helpers.formatHelpers.formatCurrency(cost));
                    }

                    this.updateLineItemRow(lineItem);

                    _.each(this.options.financialMarkups?.models ?? [], (markup) => {
                        let lineItem = markup.isNew() || markup.lineItem ? markup.lineItem : this.collection.findWhere({appliedMarkupId: markup.id});

                        if (lineItem) {
                            this.updateLineItemRow(lineItem);
                        }
                    });

                    this.renderTotals();
                });
            }
        } else {
            if (this.options.enableTax) {
                this.listenTo(this.collection, 'change', _.bind(function (lineItem) {
                    let $line = this.getLineItemElement(lineItem);
                    $line.find('.label-tax-amount').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.get('taxAmount')));
                }, this));
            }

            this.listenTo(this.collection, 'change:workRetainage change:materialRetainage change:workRetainageReleased change:materialRetainageReleased', _.bind(function (lineItem) {
                let $line = this.getLineItemElement(lineItem);
                $line.find('.label-work-retainage-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getWorkRetainageRemaining(this.model)));
                $line.find('.label-material-retainage-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getMaterialRetainageRemaining(this.model)));
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialsNew change:progressAmount', _.bind(function (lineItem) {
                let $line = this.getLineItemElement(lineItem);
                $line.find('.label-total-completed').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getTotalCompleteAndStored(this.model)));
                $line.find('.label-balance-to-finish').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.getBalanceToFinish(this.model)));
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:progressAmount', _.bind(function (lineItem, id, opts) {
                if (opts && opts.percentUpdate) {
                    return;
                }

                let $line = this.getLineItemElement(lineItem),
                    amount = lineItem.get('progressAmount'),
                    stored = lineItem.get('materialsStoredTotal'),
                    nem = lineItem.get('materialsNew'),
                    committed = lineItem.get('committedAmount'),
                    totalProgress = amount + lineItem.get('progressAmountTotal');
                if (totalProgress > committed) {
                    amount = committed - lineItem.get('progressAmountTotal') - stored - nem;
                    lineItem.set('progressAmount', amount);

                    totalProgress = amount + lineItem.get('progressAmountTotal');

                    $line.find('.input-progress-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                }

                let percent = (totalProgress / (committed - stored - nem)) * 100;
                percent = Math.round(percent * 100) / 100;

                $line.find('.input-progress-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set('progressPercent', percent, {
                    silent: true
                });

                if (lineItem.get('taxRate') > 0 || lineItem.get('taxAmount') > 0) {
                    lineItem.set('taxAmount', lineItem.getTaxAmount());
                }

                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:progressPercent change:materialsNew', _.bind(function (lineItem) {
                let percent = lineItem.get('progressPercent'),
                    // totalProgressPercent = lineItem.get('progressPercentTotal'),
                    $line = this.getLineItemElement(lineItem);

                if (percent > 100) {
                    percent = 100;
                    lineItem.set('progressPercent', percent);
                    $line.find('.input-progress-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                }

                let committed = lineItem.get('committedAmount'),
                    totalProgress = lineItem.get('progressAmountTotal'),
                    stored = lineItem.get('materialsStoredTotal'),
                    nem = lineItem.get('materialsNew'),
                    amount = Math.round(((committed - stored - nem) * (percent / 100)) - totalProgress);

                let billableNow = committed - stored - nem - totalProgress;
                if ((billableNow < 0 && amount < billableNow) || (billableNow > 0 && amount > billableNow)) {
                    amount = 0;
                }

                if (lineItem.get('taxRate') > 0 || lineItem.get('taxAmount') > 0) {
                    lineItem.set('taxAmount', lineItem.getTaxAmount());
                }

                $line.find('.input-progress-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    progressAmount: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialsNew', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let stored = lineItem.get('materialsStoredTotal'),
                    nem = lineItem.get('materialsNew'),
                    percent = lineItem.get('materialRetainagePercent'),
                    materialRetainage = (stored + nem) * (percent / 100);


                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-amount').val(materialRetainage / 100);
                lineItem.set({
                    materialRetainage: materialRetainage
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainage', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('workRetainage'),
                    percent = (amount / lineItem.get('progressAmount')) * 100;
                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    workRetainagePercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainagePercent change:progressAmount', _.bind(function (lineItem) {
                let percent = lineItem.get('workRetainagePercent'),
                    amount = Math.round(lineItem.get('progressAmount') * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    workRetainage: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainage', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('materialRetainage'),
                    percent = (amount / lineItem.get('materialsNew')) * 100;
                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    materialRetainagePercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainagePercent', _.bind(function (lineItem) {
                let percent = lineItem.get('materialRetainagePercent'),
                    amount = Math.round(lineItem.get('materialsNew') * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    materialRetainage: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainageReleased', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('workRetainageReleased'),
                    retainage = lineItem.getWorkRetainageTotal(),
                    percent = (amount / retainage) * 100;
                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-released-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    workRetainageReleasedPercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:workRetainageReleasedPercent change:workRetainage', _.bind(function (lineItem) {
                let percent = lineItem.get('workRetainageReleasedPercent'),
                    retainage = lineItem.getWorkRetainageTotal(),
                    amount = Math.round(retainage * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-work-retainage-released-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    workRetainageReleased: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainageReleased', _.bind(function (lineItem, id, opts) {
                if (opts.percentUpdate) {
                    return;
                }

                let amount = lineItem.get('materialRetainageReleased'),
                    retainage = lineItem.getMaterialRetainageTotal(),
                    percent = (amount / retainage) * 100;

                percent = Math.round(percent * 100) / 100;

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-released-percent').val(PJQ.helpers.formatHelpers.formatPercent(percent));
                lineItem.set({
                    materialRetainageReleasedPercent: percent
                }, {
                    silent: true
                });
                this.renderTotals();
            }, this));

            this.listenTo(this.collection, 'change:materialRetainageReleasedPercent change:materialRetainage', _.bind(function (lineItem) {
                let percent = lineItem.get('materialRetainageReleasedPercent'),
                    retainage = lineItem.getMaterialRetainageTotal(),
                    amount = Math.round(retainage * (percent / 100));

                let $line = this.getLineItemElement(lineItem);
                $line.find('.input-material-retainage-released-amount').val(PJQ.helpers.formatHelpers.formatCurrency(amount));
                lineItem.set({
                    materialRetainageReleased: amount
                }, {
                    percentUpdate: true
                });
                this.renderTotals();
            }, this));
        }

        if (this.options.financialMarkups) {
            this.listenTo(this.options.financialMarkups, 'appliedMarkupChanged', (markup) => {
                if (!markup.get('void') && !markup.get('lineItemId') && !markup.lineItem) {
                    markup.lineItem = new this.collection.model({
                        subJobId: markup.get('appliedSubJobId'),
                        costCodeId: markup.get('appliedCostCodeId'),
                        costTypeId: markup.get('appliedCostTypeId'),
                        description: markup.get('name'),
                        quantity: 1,
                        unitPrice: 0
                    });
                    markup.lineItem.markup = markup;

                    this.collection.add(markup.lineItem);
                    this.renderLineItemsTable();
                    if (typeof this.options.onLineItemAdd === 'function') {
                        this.options.onLineItemAdd(markup.lineItem);
                    }
                    this.updateLineItemRow(markup.lineItem);
                } else {
                    let lineItem = markup.lineItem;
                    if (lineItem == null) {
                        lineItem = this.collection.get(markup.get('lineItemId'));
                    }

                    if (markup.get('void')) {
                        let row = this.dataTable.getRow(lineItem.cid);
                        if (row) {
                            this.dataTable.removeRow(row);
                        }
                        this.collection.remove(lineItem);
                        this.renderTotals();
                    } else {
                        this.updateLineItemRow(lineItem);
                    }
                }
            });
        }
    },
    getPossibleLineItems: function () {
        let result = [];
        _.each(this.possibleLineItems.models, function (pLineItem) {
            let exists = null != _.find(this.model.lineItems.models, function (li) {
                return !li.get('delete') && li.get('lineItemId') === pLineItem.get('lineItemId')
                    && (li.get('commitmentId') === pLineItem.get('commitmentId')
                        || li.get('changeOrderId') === pLineItem.get('changeOrderId'));
            });
            if (!exists) {
                result.push(pLineItem);
            }
        }, this);
        return result;
    },
    getPossibleLineItemOptions: function () {
        let contractNumber = '',
            contractLines = [],
            changes = {};
        _.each(this.getPossibleLineItems(), function (pLineItem) {
            let costCode = this.costCodes.get(pLineItem.get('costCodeId')),
                costType = this.costTypes.get(pLineItem.get('costTypeId'));
            if (costCode != null && costType != null) {
                let choice = {
                    id: pLineItem.cid,
                    name: '<b>' + costCode.getDisplayName() + '</b>' + ' - ' + costType.get('name'),
                    subtext: PJQ.helpers.formatHelpers.formatCurrency(pLineItem.get('committedAmount'))
                };
                let changeOrderId = pLineItem.get('changeOrderId');
                if (changeOrderId > 0) {
                    if (changes[changeOrderId] == null) {
                        changes[changeOrderId] = {
                            name: pLineItem.get('changeOrderNumber'),
                            choices: []
                        };
                    }
                    changes[changeOrderId].choices.push(choice);
                } else {
                    contractNumber = _.size(pLineItem.get('commitmentNumber')) > 0 ? pLineItem.get('commitmentNumber') : pLineItem.get('primeContractNumber');
                    contractLines.push(choice);
                }
            }
        }, this);
        return [
            {
                name: contractNumber ?? "",
                choices: contractLines
            },
            ..._.map(changes, (obj) => {
                return obj;
            })
        ];
    },
    getCostCodeOptions: function (model) {
        let subJob = this.subJobs.get(model.get('subJobId')),
            budgeted = [],
            unBudgeted = [],
            filteredCostCodes = _.filter(this.costCodes.models, function (costCode) {
                if (subJob == null) {
                    return costCode.get('subJobId') == null
                }
                return costCode.get('subJobId') === subJob.id;
            });

        if (this.options.filterToCommitmentCostCodes && this.options.commitment != null) {
            filteredCostCodes = _.filter(filteredCostCodes, (costCode) => {
                return null != this.options.commitment.lineItems.findWhere({costCodeId: costCode.id});
            });
        }

        if (_.size(filteredCostCodes) === 0) {
            return [{
                id: 0,
                name: 'No cost codes found',
                disabled: true
            }];
        }

        _.each(filteredCostCodes.sort((c1, c2) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
        }), function (costCode) {
            let choice = {
                id: costCode.id,
                name: costCode.getDisplayName()
            };
            if (this.budget != null && null == _.find(this.budget.lineItems.models, function (lineItem) {
                return !lineItem.get('isUnBudgeted') && lineItem.get('costCodeId') === costCode.id
                    && ((subJob == null && !(lineItem.get('subJobId') > 0)) || lineItem.get('subJobId') === subJob.id);
            })) {
                unBudgeted.push(choice);
            } else {
                budgeted.push(choice);
            }
        }, this);
        return [
            {
                name: "Budgeted",
                choices: budgeted
            },
            {
                name: "Un-Budgeted",
                choices: unBudgeted
            }
        ];
    },
    getCostTypeOptions: function (model) {
        let costCode = this.costCodes.get(model.get('costCodeId'));
        if (costCode == null) {
            return [];
        }

        let budgeted = [],
            unBudgeted = [],
            allowedCostTypes = costCode.get('costTypeIds'),
            filteredCostTypes = _.filter(this.costTypes.models, function (costType) {
                return (_.size(allowedCostTypes) === 0 || allowedCostTypes.indexOf(costType.id) !== -1);
            });

        if (this.options.filterToCommitmentCostCodes && this.options.commitment != null) {
            filteredCostTypes = _.filter(this.costTypes.models, (costType) => {
                return null != this.options.commitment.lineItems.findWhere({costTypeId: costType.id});
            });
        }

        if (this.options.project
            && PJQ.app.session.erpIntegration
            && PJQ.app.session.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.REQUIRE_SYNCED_COST_TYPES)) {
            let filterUnsyncedCostTypes = _.bind(function () {
                if (this.options.project.get('externalObject') != null) {
                    filteredCostTypes = _.filter(filteredCostTypes, (costType) => {
                        return costType.get('externalObject') != null;
                    })
                }
            }, this)

            if (!this.options.project.erpObjectFetched) {
                this.options.project.fetchERPObject(filterUnsyncedCostTypes());
            } else {
                filterUnsyncedCostTypes();
            }
        }

        if (this.budget == null) {
            return _.map(filteredCostTypes, (costType) => {
                return {
                    id: costType.id,
                    name: costType.get('name')
                };
            });
        }

        _.each(filteredCostTypes, function (costType) {
            let choice = {
                id: costType.id,
                name: costType.get('name')
            };
            if (null == _.find(this.budget.lineItems.models, function (lineItem) {
                return !lineItem.get('isUnBudgeted') && lineItem.get('costCodeId') === costCode.id
                    && lineItem.get('costTypeId') === costType.id;
            })) {
                unBudgeted.push(choice);
            } else {
                budgeted.push(choice);
            }
        }, this);
        return [
            {
                name: "Budgeted",
                choices: budgeted
            },
            {
                name: "Un-Budgeted",
                choices: unBudgeted
            }
        ];
    },
    getLineItemForInput: function ($input) {
        if ($input == null || this.dataTable == null) {
            return null;
        }
        let row = this.dataTable.getRow($input.closest('tr'));
        if (row) {
            return row.data();
        }
        return null;
    },
    getLineItemRow: function (lineItem) {
        if (lineItem == null || this.dataTable == null) {
            return null;
        }
        return this.dataTable.getRow(lineItem.cid);
    },
    getLineItemElement: function (lineItem) {
        let row = this.getLineItemRow(lineItem);
        if (row) {
            return $(row.node());
        }
        return null;
    },
    addLineItem: function (e) {
        let newLineItem = new this.options.lineItemModel({
            description: '',
            quantity: 0,
            unitPrice: 0,
            amount: 0,
            taxAmount: 0,
            budgetedHours: 0,
            taxRate: 0,
            amountRemaining: 0,
            billedToDate: 0,
            accountingMethod: this.options.accountingMethod
        });

        let fnAdd = () => {
            this.focusLineItem = newLineItem;
            this.collection.add(newLineItem);
            this.renderLineItemsTable();
            if (typeof this.options.onLineItemAdd === 'function') {
                this.options.onLineItemAdd(newLineItem);
            }
        }
        if (this.isInvoices) {
            this.model.fetchPossibleLineItems(_.bind(function (pLineItems) {
                this.possibleLineItems = pLineItems;

                if (_.size(this.getPossibleLineItems()) === 0) {
                    new PJQ.Alert(this.$('.line-items-table'), {
                        type: 'warning',
                        text: 'All line items from the related commitment and change orders are already added',
                        timeout: 3000,
                        extraClasses: ['mt-2'],
                        isPrepend: true
                    });
                    this.$('.btn-grp-add-line-item').prop('disabled', true);
                } else {
                    fnAdd();
                }
            }, this));
        } else if (this.options.filterToCommitmentCostCodes && (this.options.commitment != null || this.options.commitmentId > 0)) {
            if (this.options.commitment == null) {
                this.options.commitment = new PJQ.models.commitments.Commitment({
                    id: this.options.commitmentId
                });
            }

            if (!this.options.commitment.isFetched) {
                this.options.commitment.fetch({
                    success: _.bind(function () {
                        fnAdd();
                    }, this)
                });
            } else {
                fnAdd();
            }
        } else if (this.options.filterToPrimeContractItems && (this.options.primeContract != null || this.options.primeContractId > 0)) {
            this.fetchPrimeContract(fnAdd);
        } else {
            fnAdd();
        }
    },
    fetchPrimeContract: function (callback) {
        if (this.options.primeContract == null) {
            this.options.primeContract = new PJQ.models.primeContracts.PrimeContract({
                id: this.options.primeContractId
            });
        }

        if (!this.options.primeContract.isFetched) {
            this.options.primeContract.fetch({
                success: () => {
                    callback();
                }
            });
        } else {
            callback();
        }
    },
    addFromChangeRequests: function () {
        new PJQ.views.changeRequests.SelectChangeRequestsModal({
            isSingleChoice: false,
            project: this.options.project,
            primeContractId: this.options.primeContractId,
            headerSubText: 'Select the Change Requests you would like to add line items from.',
            filterStatuses: PJQ.constants.changeRequests.changeRequestStatus.APPROVED,
            onSave: _.bind(function (changeRequests) {
                let changeRequestIds = _.map(changeRequests, function (model) {
                    return model.id;
                }, this);

                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'changerequests'
                        },
                        {
                            endpoint: 'lineitems'
                        }
                    ]),
                    data: changeRequestIds,
                    isAPIv2: true
                }).post().done((lineItems) => {
                    let availableLineItems = _.filter(lineItems, function (lineItem) {
                        if (null != this.collection.findWhere((li) => {
                            return li.get('changeRequestLineItemId') === lineItem.id;
                        })) {
                            return false;
                        } else if (this.isCCO || this.isCommitments) {
                            return lineItem.costLineItemId == null
                        } else {
                            return lineItem.revenueLineItemId == null;
                        }
                    }, this);

                    if (_.size(availableLineItems) > 0) {
                        _.each(availableLineItems, function (lineItem) {
                            let amount = !(this.isCCO || this.isCommitments) ? lineItem.revenue : lineItem.amount;
                            if (amount === 0) {
                                return;
                            }

                            let lineItemModel = new this.options.lineItemModel({
                                changeRequestLineItemId: lineItem.id,
                                amount: amount,
                                markupAmount: lineItem.markupAmount,
                                taxAmount: lineItem.taxAmount,
                                number: lineItem.number,
                                costCodeId: lineItem.costCodeId,
                                costTypeId: lineItem.costTypeId,
                                subJobId: lineItem.subJobId,
                                description: lineItem.description,
                                unitId: lineItem.unitId,
                                quantity: lineItem.quantity,
                                unitPrice: lineItem.unitPrice,
                                progressQuantity: lineItem.progressQuantity,
                                progressPercent: lineItem.progressPercent,
                                progressAmount: lineItem.progressAmount,
                                workRetainage: lineItem.workRetainage,
                                workRetainageReleased: lineItem.workRetainageReleased,
                                materialRetainage: lineItem.materialRetainage,
                                materialRetainageReleased: lineItem.materialRetainageReleased,
                                taxCodeId: lineItem.taxCodeId
                            });
                            this.collection.add(lineItemModel);

                            if (typeof this.options.onLineItemAdd === 'function') {
                                this.options.onLineItemAdd(lineItemModel);
                            }
                        }, this);

                        this.renderLineItemsTable();
                        this.renderTotals();
                    } else {
                        new PJQ.Alert(this.$('.line-items-table'), {
                            type: 'warning',
                            text: 'All line items from the selected Change Requests have already been assigned',
                            timeout: 5000,
                            extraClasses: ['mt-2'],
                            isPrepend: true
                        });
                    }
                });
            }, this)
        });
    },
    addFromCommitments: function () {
        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: false,
            project: this.options.project,
            headerSubText: 'Select the Commitments you would like to add line items from.',
            filterStatuses: PJQ.constants.commitments.commitmentStatus.APPROVED,
            onSave: (commitments) => {
                let commitmentIds = _.map(commitments, function (model) {
                    return model.id;
                }, this);

                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'commitments'
                        },
                        {
                            endpoint: 'lineitems'
                        }
                    ]),
                    data: commitmentIds,
                    isAPIv2: true
                }).post().done(_.bind(function (lineItems) {
                    let availableLineItems = _.filter(lineItems, function (lineItem) {
                        return lineItem.changeRequestLineItemId == null;
                    }, this);

                    if (_.size(availableLineItems) > 0) {
                        _.each(availableLineItems, function (lineItem) {
                            let lineItemModel = new this.options.lineItemModel({
                                commitmentId: lineItem.commitmentId,
                                amount: lineItem.amount,
                                number: lineItem.number,
                                costCodeId: lineItem.costCodeId,
                                costTypeId: lineItem.costTypeId,
                                subJobId: lineItem.subJobId,
                                description: lineItem.description,
                                unitId: lineItem.unitId,
                                quantity: lineItem.quantity,
                                unitPrice: lineItem.unitPrice,
                                markup: lineItem.markup,
                                progressQuantity: lineItem.progressQuantity,
                                progressPercent: lineItem.progressPercent,
                                progressAmount: lineItem.progressAmount,
                                workRetainage: lineItem.workRetainage,
                                workRetainageReleased: lineItem.workRetainageReleased,
                                materialRetainage: lineItem.materialRetainage,
                                materialRetainageReleased: lineItem.materialRetainageReleased,
                                taxCodeId: lineItem.taxCodeId
                            });
                            this.collection.add(lineItemModel);

                            if (typeof this.options.onLineItemAdd === 'function') {
                                this.options.onLineItemAdd(lineItemModel);
                            }
                        }, this);

                        this.renderLineItemsTable();
                        this.renderTotals();
                    } else {
                        new PJQ.Alert(this.$('.line-items-table'), {
                            type: 'warning',
                            text: 'All line items from the selected Commitment have already been assigned',
                            timeout: 5000,
                            extraClasses: ['mt-2'],
                            isPrepend: true
                        });
                    }
                }, this));
            }
        });
    },
    addAllPossibleLineItems: function () {
        this.model.fetchPossibleLineItems(_.bind(function (pLineItems) {
            this.possibleLineItems = pLineItems;
            let changed = false,
                newLineItems = [];
            _.each(this.possibleLineItems.models, function (pLineItem) {
                let existingLineItem = _.find(this.model.lineItems.models, function (li) {
                    return li.get('lineItemId') === pLineItem.get('lineItemId')
                        && ((li.get('commitmentId') === pLineItem.get('commitmentId'))
                            || (li.get('changeOrderId') === pLineItem.get('changeOrderId')))
                });
                if (existingLineItem) {
                    if (existingLineItem.get('delete')) {
                        existingLineItem.set('delete', false);
                        changed = true;
                    }
                } else {
                    newLineItems.push(pLineItem);
                    changed = true;
                }
            }, this)
            if (changed) {
                if (_.size(newLineItems) > 0) {
                    this.collection.add(newLineItems);
                }
                this.renderLineItemsTable();
            }
        }, this));
    },
    autofillAmounts: function () {
        if (typeof this.model.getAutofillAmounts === 'function') {
            this.model.getAutofillAmounts((lineItems) => {
                if (lineItems != null && _.size(lineItems.models) > 0) {
                    _.each(lineItems.models, function (autoFillItem) {
                        let invoiceItem = _.find(this.collection.models, function (li) {
                            return li.get('costCodeId') === autoFillItem.get('costCodeId')
                                && li.get('costTypeId') === autoFillItem.get('costTypeId');
                        });
                        if (invoiceItem != null) {
                            invoiceItem.set({
                                progressAmount: autoFillItem.get('progressAmount'),
                                progressPercent: autoFillItem.get('progressPercent'),
                                materialsNew: autoFillItem.get('materialsNew'),
                                workRetainage: autoFillItem.get('workRetainage'),
                                workRetainagePercent: autoFillItem.get('workRetainagePercent'),
                                materialRetainage: autoFillItem.get('materialRetainage'),
                                materialRetainagePercent: autoFillItem.get('materialRetainagePercent')
                            })
                        } else {
                            this.collection.add(autoFillItem);
                        }
                    }, this);
                    this.renderLineItemsTable();

                    PJQ.notifications.notify.successNotify({
                        message: 'Line items auto-filled successfully'
                    });
                } else {
                    PJQ.notifications.notify.warningNotify({
                        message: 'Found 0 line items to auto-fill'
                    });
                }
            });
        }
    },
    validateLineItem: function (lineItem) {
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(lineItem.cid),
            data = row.data(),
            result = true,
            updateCell = ($cell, isValid) => {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            };

        if (data == null || data.get('delete')) {
            return true;
        }

        if (!this.isInvoices) {
            let costCodeCol = 1,
                costTypeCol = 2,
                uomCol = 5;
            if (_.size(this.subJobs) > 0) {
                costCodeCol++;
                costTypeCol++;
                uomCol++;
            }

            if (this.options.enableSelection) {
                costCodeCol++;
                costTypeCol++;
                uomCol++;
            }

            let contractItemNumberCol = null,
                contractItemNameCol = null;
            if (this.options.filterToPrimeContractItems) {
                costCodeCol++;
                costTypeCol++;
                uomCol++;

                contractItemNameCol = this.options.enableSelection ? 2 : 1;
                if (PJQ.app.session.erpIntegration?.hasAvailableAction(PJQ.constants.integrations.actions.PRIME_CONTRACT_CO_SOV_LINKED_CONTRACT_LINE_REQ_ITEM_NUMBER)) {
                    costCodeCol++;
                    costTypeCol++;
                    uomCol++;
                    contractItemNameCol++;
                    contractItemNumberCol = this.options.enableSelection ? 2 : 1;
                    contractItemNameCol = contractItemNumberCol + 1;
                } else {
                    contractItemNameCol = this.options.enableSelection ? 2 : 1;
                }
            }

            let description = lineItem.get('description') ?? '',
                descSplit = description.split(' - '),
                itemNumber = '';
            if (descSplit.length > 1) {
                itemNumber = descSplit[0];
                description = descSplit[1];
            }
            if (this.options.requirePrimeContractItem && contractItemNameCol != null) {
                updateCell($(row.node()).find('td:eq(' + contractItemNameCol + ')'), _.size(description) > 0);
            }

            let itemNameValid = _.size(description) > 0;
            if (this.options.requirePrimeContractItem && contractItemNumberCol != null) {
                let contractItemNumberRegex = PJQ.app.session.erpIntegration?.getSetting('contractItemNumberRegex'),
                    isContractItemNumberValid = _.size(itemNumber) > 0,
                    ciReg = new RegExp(contractItemNumberRegex);
                if (_.size(contractItemNumberRegex) > 0) {
                    isContractItemNumberValid = ciReg.test(itemNumber);
                    itemNameValid = _.size(description.match(ciReg)) === 0;
                }
                updateCell($(row.node()).find('td:eq(' + contractItemNumberCol + ')'), isContractItemNumberValid);

                updateCell($(row.node()).find('td:eq(' + contractItemNameCol + ')'), itemNameValid);
            } else if (this.options.requirePrimeContractItem && contractItemNameCol != null) {
                updateCell($(row.node()).find('td:eq(' + contractItemNameCol + ')'), itemNameValid);
            }

            if (this.options.isCostCodeRequired !== false) {
                updateCell($(row.node()).find('td:eq(' + costCodeCol + ')'), !lineItem.isNew() || lineItem.get('costCodeId') > 0);
            }

            if (this.options.isCostTypeRequired !== false) {
                updateCell($(row.node()).find('td:eq(' + costTypeCol + ')'), !lineItem.isNew() || lineItem.get('costTypeId') > 0);
            }

            if (this.options.accountingMethod === PJQ.constants.budget.accountingMethod.UNIT_QUANTITY) {
                updateCell($(row.node()).find('td:eq(' + uomCol + ')'), lineItem.get('unitId') > 0 || lineItem.markup || lineItem.get('appliedMarkupId') > 0);
            }
        } else {

        }
        return result;
    },
    validate: function () {
        this.wasValidated = true;

        let result = true;
        _.each(this.collection.models, function (lineItem) {
            result = result && this.validateLineItem(lineItem);
        }, this);
        return result;
    },
    saveLineItem: function (e) {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        }
    },
    deleteLineItem: function (row) {
        if (row == null) {
            return;
        }

        let item = row.data();
        if (this.collection != null) {
            if (item.isNew()) {
                this.collection.remove(item);
            } else {
                item.set('delete', true);
            }
            this.dataTable.removeRow(row);
            this.renderTotals();
            this.$('.btn-grp-add-line-item').prop('disabled', false);
        }

        if (typeof this.options.onLineItemDelete === 'function') {
            this.options.onLineItemDelete(item);
        }
    },
    deleteLineItemClicked: function (e) {
        e.stopPropagation();
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        if (row != null) {
            let item = row.data();
            if (item && item.get('changeRequestLineItemId') && !item.isNew()) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "This line item was created from a Change Request. This line item will still exist on the Change Request, but it will no longer be assigned. Are you sure you want to delete this line item?",
                    onDelete: _.bind(function () {
                        this.deleteLineItem(row);
                    }, this)
                });
            } else {
                this.deleteLineItem(row);
            }
        }
    },
    bulkDeleteLineItems: function () {
        let lineItems = _.map(this.options.selectedLineItems, (cid) => {
            return this.collection.get(cid);
        });
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "You're about to delete " + _.size(lineItems) + " line items. Are you sure you want to delete these line items?",
            onDelete: _.bind(function () {
                _.each(lineItems, (lineItem) => {
                    this.deleteLineItem(this.getLineItemRow(lineItem));
                })
            }, this)
        });
    },
    bulkEditLineItems: function () {
        let lineItems = _.map(this.options.selectedLineItems, (cid) => {
            return this.collection.get(cid);
        });

        new PJQ.views.budget.BulkEditLineItemsModal({
            lineItems: lineItems,
            enableRetainage: this.options.enableRetainage,
            enableStoredMaterials: this.options.enableStoredMaterials,
            onSave: () => {
                this.options.selectedLineItems = [];
                this.renderActions();
                this.renderLineItemsTable();
                this.renderTotals();
            }
        })
    },
    viewCommitment: function (e) {
        let id = $(e.currentTarget).data('id');
        if (typeof this.options.onCommitmentView === 'function') {
            this.options.onCommitmentView(id);
        }
        if (id > 0) {
            new PJQ.views.commitments.CommitmentEditModal({
                model: new PJQ.models.commitments.Commitment({
                    id: id
                })
            });
        }
    },
    viewChangeOrder: function (e) {
        let id = $(e.currentTarget).data('id'),
            type = $(e.currentTarget).data('type');
        if (typeof this.options.onChangeOrderView === 'function') {
            this.options.onChangeOrderView(id);
        }

        if (id > 0 && _.size(type) > 0) {
            if (this.isReceivableInvoices || type === 'pcco') {
                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: new PJQ.models.primeContracts.ChangeOrder({
                        id: id
                    })
                });
            } else {
                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: new PJQ.models.commitments.ChangeOrder({
                        id: id
                    })
                });
            }
        }
    },
    lineItemSelected: function (e) {
        if (this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            isChecked = $target.prop('checked');
        if (_.size(cid) === 0) {
            return;
        }

        if (!isChecked) {
            this.options.selectedLineItems = _.reject(this.options.selectedLineItems, function (sCid) {
                return sCid === cid;
            });
        } else if (!_.contains(this.options.selectedLineItems, cid)) {
            this.options.selectedLineItems.push(cid);
        }

        this.$('.select-all-line-items').prop('checked', _.size(this.options.selectedLineItems) === _.size(this.collection.models));

        this.renderActions();
    },
    selectAllLineItems: function (e) {
        let $target = $(e.currentTarget),
            isChecked = $target.prop('checked');

        if (!isChecked || this.options.selectedLineItems == null) {
            this.options.selectedLineItems = [];
        }

        _.each(this.collection.models, function (model) {
            if (model.markup || model.get('appliedMarkupId') > 0) {
                return;
            }

            let checkbox = this.$('.select-cr-li[data-cid="' + model.cid + '"]');

            if (!isChecked) {
                checkbox.prop('checked', false);
            } else {
                checkbox.prop('checked', true);

                if (!_.contains(this.options.selectedLineItems, model.cid)) {
                    this.options.selectedLineItems.push(model.cid);
                }
            }
        }, this);

        this.renderActions();
    },
    renderActions: function () {
        let disableCommitmentsButtons = true,
            disableContractsButtons = true;
        if (_.size(this.options.selectedLineItems) > 0) {
            this.$('.btn-create-new').removeClass('disabled');

            _.each(this.collection.get(this.options.selectedLineItems), (lineItem) => {
                if (!(lineItem.get('costLineItemId') > 0)) {
                    disableCommitmentsButtons = false;
                }

                if (!(lineItem.get('revenueLineItemId') > 0)) {
                    disableContractsButtons = false;
                }
            });
        }
        this.renderSubTemplate(false, this.options.subTemplates.actions, this.$('.line-items-actions'), _.extend(this.renderData(), {
            disableCommitmentsButtons: disableCommitmentsButtons,
            disableContractsButtons: disableContractsButtons
        }), () => {
            if (this.accountingMethodPicker) {
                this.accountingMethodPicker.remove();
            }
            this.accountingMethodPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-accounting-method'),
                isIntChoices: true,
                defaultValue: this.options.accountingMethod,
                canEdit: this.options.canEdit && _.size(this.getVisibleLineItems()) === 0,
                onChange: _.bind(function (value) {
                    this.options.accountingMethod = value;
                    if (typeof this.options.onAccountingMethodChanged === 'function') {
                        this.options.onAccountingMethodChanged(value);
                    }
                    this.renderLineItemsTable();
                }, this)
            });
        });
    },
    addLineItemsToCommitment: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            headerSubText: 'Select the Commitment you would like to add these line items to',
            filterStatuses: [
                PJQ.constants.commitments.commitmentStatus.DRAFT,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PROCESSING,
                PJQ.constants.commitments.commitmentStatus.SUBCONTRACT_OUT_FOR_BID,
                PJQ.constants.commitments.commitmentStatus.OUT_FOR_SIGNATURE,
                PJQ.constants.commitments.commitmentStatus.SUBMITTED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_PARTIALLY_RECEIVED,
                PJQ.constants.commitments.commitmentStatus.PURCHASE_ORDER_RECEIVED
            ],
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems);
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        commitment.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            commitmentId: commitment.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.CommitmentEditModal({
                    model: commitment,
                    fetch: false,
                    onSave: _.bind(function (commitment) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    createCommitmentFromLineItems: function (e) {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentType = $(e.currentTarget).hasClass('new-po') ? PJQ.constants.commitments.commitmentType.PURCHASE_ORDER : PJQ.constants.commitments.commitmentType.SUBCONTRACT,
            lineItems = [],
            selLineItems = this.collection.get(this.options.selectedLineItems),
            vendors = [],
            vendorIds = [];
        _.each(selLineItems, function (lineItem) {
            if (lineItem.get('costLineItemId') == null) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    changeRequestLineItemId: lineItem.id
                }));

                let liVendor = lineItem.get('vendor');
                if (vendors == null) {
                    return;
                } else if (liVendor && vendorIds.indexOf(liVendor.id) === -1) {
                    vendors.length > 0 ? null : vendors.push(liVendor);
                }
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.commitments.CommitmentEditModal({
                model: null,
                fromChangeRequest: this.model,
                contractedContact: vendors.length > 0 ? vendors[0] : null,
                commitmentType: commitmentType,
                lineItems: lineItems,
                onSave: _.bind(function (commitment) {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                }, this),
            });
        }
    },
    addLineItemsToPCCO: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.primeContracts.SelectChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Contract Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.primeContracts.changeOrderStatus.DRAFT,
                PJQ.constants.primeContracts.changeOrderStatus.NO_CHARGE,
                PJQ.constants.primeContracts.changeOrderStatus.IN_REVIEW,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.PRICING,
                PJQ.constants.primeContracts.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.PROCEEDING,
                PJQ.constants.primeContracts.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems);
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('revenueLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    createPCCOFromLineItems: async function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let primeContract = new PJQ.models.primeContracts.PrimeContract({
            id: this.options.changeRequest.get('primeContractId')
        });
        await primeContract.fetch();

        let lineItems = [],
            selLineItems = this.collection.get(this.options.selectedLineItems);
        _.each(selLineItems, function (lineItem) {
            if (!lineItem.get('revenueLineItemId')) {
                lineItems.push(_.extend(lineItem.attributes, {
                    id: null,
                    amount: lineItem.get('revenue'),
                    changeRequestLineItemId: lineItem.id
                }));
            }
        }, this);

        if (_.size(lineItems) > 0) {
            new PJQ.views.primeContracts.ChangeOrderEditModal({
                primeContract: primeContract,
                lineItems: lineItems,
                onSave: _.bind(function (commitment) {
                    if (typeof this.options.onCreateFromLineItems === 'function') {
                        this.options.onCreateFromLineItems();
                    }
                }, this),
            });
        }
    },
    addLineItemsToCCO: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        new PJQ.views.commitments.SelectCommitmentChangeOrdersModal({
            isSingleChoice: true,
            project: this.options.project,
            headerSubText: 'Select the Commitment Change Orders you would like to add these line items to.',
            filterStatuses: [
                PJQ.constants.commitments.changeOrderStatus.DRAFT,
                PJQ.constants.commitments.changeOrderStatus.NO_CHARGE,
                PJQ.constants.commitments.changeOrderStatus.IN_REVIEW,
                PJQ.constants.commitments.changeOrderStatus.NOT_PRICING,
                PJQ.constants.commitments.changeOrderStatus.PRICING,
                PJQ.constants.commitments.changeOrderStatus.NOT_PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.PROCEEDING,
                PJQ.constants.commitments.changeOrderStatus.REVISED
            ],
            onSave: async (changeOrder) => {
                if (changeOrder == null) {
                    return;
                }

                await changeOrder.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems);
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        changeOrder.lineItems.add(_.extend(lineItem.attributes, {
                            id: null,
                            changeOrderId: changeOrder.id,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: changeOrder,
                    onSave: _.bind(function (changeOrder) {
                        if (typeof this.options.onCreateFromLineItems === 'function') {
                            this.options.onCreateFromLineItems();
                        }
                    }, this),
                });
            }
        });
    },
    getSelectedCommitmentIds: function () {
        let commitmentIds = _.uniq(_.map(this.options.selectedLineItems, (liCid) => {
            let lineItem = this.collection.get(liCid);
            return lineItem.get('commitmentId');
        }));
        return commitmentIds;
    },
    createCCOFromLineItems: function () {
        if (_.size(this.options.selectedLineItems) === 0) {
            return;
        }

        let commitmentIds = this.getSelectedCommitmentIds(),
            selCommitmentId = null;
        if (_.size(commitmentIds) === 1) {
            selCommitmentId = commitmentIds[0];
        }

        new PJQ.views.commitments.SelectCommitmentsModal({
            isSingleChoice: true,
            project: this.options.project,
            selectedCommitmentId: selCommitmentId,
            filterStatuses: PJQ.constants.commitments.commitmentStatus.APPROVED,
            headerSubText: 'Select the Commitment you would like to create a Change Order for.',
            onSave: async (commitment) => {
                if (commitment == null) {
                    return;
                }

                await commitment.fetch();

                let selLineItems = this.collection.get(this.options.selectedLineItems),
                    lineItems = [];
                _.each(selLineItems, function (lineItem) {
                    if (lineItem.get('costLineItemId') == null) {
                        lineItems.push(_.extend(lineItem.attributes, {
                            id: null,
                            changeRequestLineItemId: lineItem.id
                        }));
                    }
                }, this);

                if (_.size(lineItems) > 0) {
                    new PJQ.views.commitments.ChangeOrderEditModal({
                        commitment: commitment,
                        fromChangeRequest: this.model,
                        lineItems: lineItems,
                        onSave: _.bind(function (changeOrder) {
                            if (typeof this.options.onCreateFromLineItems === 'function') {
                                this.options.onCreateFromLineItems();
                            }
                        }, this),
                    });
                }
            }
        });
    }
});
PJQ.collections.productionQuantities = PJQ.collections.productionQuantities ? PJQ.collections.productionQuantities : {};
PJQ.models.productionQuantities = PJQ.models.productionQuantities ? PJQ.models.productionQuantities : {};
PJQ.views.productionQuantities = PJQ.views.productionQuantities ? PJQ.views.productionQuantities : {};

PJQ.modules.productionQuantities = {
    routes: [
        {
            route: 'projects/:projectId/productionquantities',
            name: 'productionquantities',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "productionquantities");
            }
        },
        {
            route: 'projects/:projectId/productionquantities/:productionQuantityId',
            name: 'productionquantity',
            callback: function (projectId, productionQuantityId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "productionquantities", {
                    productionQuantityId: parseInt(productionQuantityId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.productionQuantities.routes);
PJQ.views.productionQuantities.ProductionQuantitiesAddModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-production-quantities-add'),
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-cancel': 'close',
        'click .btn-add-production-quantity': 'addProductionQuantity',
        'click .btn-save': 'saveProductionQuantities',
        'click .btn-import': 'importFile'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            });
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.dataTable = new PJQ.views.productionQuantities.AddProductionQuantitiesDatatable({
            el: this.$('.add-production-quantities-data'),
            rowId: "cid",
            columns: this.getColumns(),
            data: this.collection.models,
            costCodes: this.costCodes,
            unitsOfMeasure: this.unitsOfMeasure,
            subJobs: this.subJobs,
            paging: false,
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            headerData: _.bind(function () {
                return {
                    project: this.options.project
                };
            }, this),
            onDeleteProductionQuantity: (row) => {
                this.deleteProductionQuantity(row);
            },
            order: [[1, 'asc']],
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        onClick: (row) => {
                            this.deleteProductionQuantity(row.data());
                        },
                        isDanger: true
                    }
                ]
            }
        });
    },
    getColumns: function (includeAllColumns = false) {
        return [
            {
                "columnData": "subJobId",
                "title": "Sub Job",
                "visible": _.size(this.subJobs.models) > 0,
                "width": "15%",
                "render": _.bind(function (data, type, row) {
                    return '<select class="select-sub-job form-control"></select>';
                }, this)
            },
            {
                "columnData": "costCodeId",
                "title": "Cost Code",
                "width": '15%',
                "render": (data, type, row) => {
                    let res = '<div class="d-flex"><select class="select-cost-code form-control"></select>';

                    res += '</div>';
                    return res;
                }
            },
            {
                "columnData": "description",
                "data": "attributes.description",
                "width": '20%',
                "title": "Description",
                "render": _.bind(function (data, type, row) {
                    return '<input type="text" class="form-control input-description" maxlength="256" value="' + row.get('description').replace(/"/g, '&quot;') + '" data-p-bind="description">';
                }, this)
            },
            {
                "columnData": "unitOfMeasure",
                "data": "attributes.unitId",
                "title": "Unit",
                "width": "20%",
                "className": "text-align-center",
                "render": (data, type, row) => {
                    return '<select class="select-unit-type form-control"></select>';
                }
            },
            {
                "columnData": "quantity",
                "data": "attributes.quantity",
                "width": "10%",
                "title": "Quantity",
                "orderable": false,
                "searchable": false,
                "className": "text-align-center",
                "render": (data, type, row) => {
                    return '<input type="text" class="form-control input-decimal input-quantity" value="' + row.get('quantity') + '" data-p-bind="quantity" placeholder="0">';
                }
            },
            {
                "title": '',
                "orderable": false,
                "searchable": false,
                resizable: false,
                "width": "40px",
                "className": "text-center",
                "visible": true,
                "render": _.bind(function (data, type, row) {
                    return `<div class="text-align-right show-on-row-hover" style="min-width:40px;"><button type="button" class="btn btn-danger btn-delete-production-quantity ml-1 fs-14"><span class="fal fa-trash"></span></button></div>`;
                }, this)
            }
        ];
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);

        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$el, this.collection, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'cid',
                useDecimalPercentFields: true,
                watchElements: [
                    'input'
                ]
            });
        }

        if (_.size(this.subJobs.models) > 0) {
            this.subJobPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-sub-job',
                valueAttribute: 'subJobId',
                selectPickerOptions: {
                    noneSelectedText: 'Parent Job',
                    isLiveSearch: true,
                    isIntChoices: true,
                    size: 8,
                    isDisabled: _.bind(function (model) {
                        return false;
                    }, this),
                    choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                        name: 'Sub Jobs', choices: _.map(this.subJobs.models, function (subJob) {
                            return {
                                id: subJob.id,
                                name: subJob.get('name'),
                                subtext: subJob.get('code')
                            }
                        }, this)
                    }])
                },
                onChange: _.bind(function (model, value) {
                    model.set('subJobId', value > 0 ? value : null);
                    model.set('costCodeId', 0);

                    let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid];
                    costCodePicker.render();

                    // this.nextInput('subJob', model);
                }, this)
            });
        }

        this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-cost-code',
            valueAttribute: 'costCodeId',
            selectPickerOptions: {
                isLiveSearch: true,
                isIntChoices: true,
                hideDisabled: false,
                isDisabled: _.bind(function (model) {
                    return false;
                }, this),
                choices: _.bind(function (model) {
                    return this.getCostCodeOptions(model)
                }, this)
            },
            onChange: _.bind(function (model, value) {
                model.set('costCodeId', value);

                // this.nextInput('costCode', model);
            }, this)
        });

        new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-unit-type',
            valueAttribute: 'unitId',
            selectPickerOptions: {
                isIntChoices: true,
                isDisabled: function (model) {
                    return !model.isNew();
                },
                choices: _.bind(function (model) {
                    return _.map(this.unitsOfMeasure.models, function (unit) {
                        return {
                            id: unit.id,
                            name: unit.get('name')
                        }
                    });
                }, this)
            },
            onChange: _.bind(function (model, value) {
                model.set('unitId', value);

                // this.nextInput('unitType', model);
            }, this)
        });
    },
    getCostCodeOptions: function (model) {
        let subJob = this.subJobs.get(model.get('subJobId')),
            costCodes = [],
            filteredCostCodes = _.filter(this.costCodes.models, function (costCode) {
                if (subJob == null) {
                    return costCode.get('subJobId') == null
                }
                return costCode.get('subJobId') === subJob.id;
            });

        if (_.size(filteredCostCodes) === 0) {
            return [{
                id: 0,
                name: 'No cost codes found',
                disabled: true
            }];
        }

        _.each(filteredCostCodes.sort((c1, c2) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
        }), function (costCode) {
            let choice = {
                id: costCode.id,
                name: costCode.getDisplayName()
            };
            costCodes.push(choice);
        }, this);
        return costCodes
    },
    addProductionQuantity: function () {
        let newModel = new PJQ.models.productionQuantities.ProductionQuantity({
            projectId: this.options.project.id,
            quantity: 0,
            description: ''
        });
        this.collection.add(newModel);
        this.dataTable.addRow(newModel)
        this.dataTable.render();
    },
    saveProductionQuantities: function () {
        if (!this.validate())
            return;
        let loader = new PJQ.Loader(this.$('.modal-body'));

        let newModels = _.filter(this.collection.models, (model) => model.isNew()),
            newModelsJSON = _.map(newModels, (model) => model.toJSON());

        this.collection.saveBulk(newModelsJSON, (newProductionQuantities) => {
            if (typeof this.options.onSave == 'function') {
                this.options.onSave(newProductionQuantities);
            }
            loader.remove();
            this.removeModal();
        })
    },
    importFile: function () {
        this.renderUploader();
    },
    renderUploader: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'productionquantities'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    let uploadId = file.uploadId;
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id,
                            },
                            {
                                endpoint: 'productionquantities'
                            },
                            {
                                endpoint: 'import',
                                value: uploadId
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (result) {
                        loader.remove();
                        this.fileUploader.remove();
                        this.subJobs.add(result.subJobs);
                        this.costCodes.add(result.costCodes);
                        this.collection.add(result.lineItems);
                        this.dataTable.render();
                    }, this)).fail((err) => {
                        if (err && err.responseJSON) {
                            loader.remove();
                            let file = this.fileUploader.collection.models[0];
                            this.fileUploader.collection.remove(file);
                            this.fileUploader.render();
                            this.fileUploader.showError(err.responseJSON.message, 10000);
                        }
                    });
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
        let self = this;
        $uploader.find('.btn-download-template').off('click').on('click', self.downloadImportTemplate);
    },
    validate: function () {
        let isValid = true;

        _.each(this.collection.models, (model) => {
            isValid = isValid && this.validateProductionQuantity(model);
        })

        return isValid;
    },
    validateProductionQuantity: function (productionQuantity) {
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(productionQuantity.cid),
            data = row?.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null || data.get('delete')) {
            return true;
        }

        if (row != null) {
            let costCodeCol = 0,
                uomCol = 2;
            if (_.size(this.subJobs.models) > 0) {
                costCodeCol++;
                uomCol++;
            }

            updateCell($(row.node()).find('td:eq(' + costCodeCol + ')'), productionQuantity.get('costCodeId') > 0);
            updateCell($(row.node()).find('td:eq(' + uomCol + ')'), productionQuantity.get('unitId') > 0);
        }
        return result;
    },
    deleteProductionQuantity: function (row) {
        let productionQuantity = row.data();
        productionQuantity.destroy();
        this.dataTable.removeRow(row);
    },
    close: function () {
        if (_.size(this.collection.models) > 0) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveProductionQuantities();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.productionQuantities.InstalledQuantitiesAddModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-installed-quantities-add'),
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-cancel': 'close',
        'click .btn-save': 'save'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.InstalledQuantities(null, {
                projectId: this.options.project.id
            });
        }

        if (this.options.productionQuantities == null) {
            this.options.productionQuantities = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            })
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        if (!this.options.productionQuantities.isFetched) {
            this.options.productionQuantities.fetch({
                success: _.bind(function () {
                    if (this.options.productionQuantityId > 0) {
                        this.productionQuantity = this.options.productionQuantities.get(this.options.productionQuantityId);
                    }

                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            productionQuantities: this.options.productionQuantities,
            productionQuantity: this.productionQuantity,
            costCodes: this.costCodes,
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.addInstalledQuantitiesView = new PJQ.views.productionQuantities.InstalledQuantitiesAdd({
            el: this.$('.installed-quantities-view'),
            collection: this.collection,
            productionQuantityId: this.options.productionQuantityId,
            productionQuantities: this.options.productionQuantities,
            timeCardId: this.options.timeCardId,
            project: this.options.project,
            onSave: (newQuantities) => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(newQuantities);
                }

                this.removeModal();
            }
        })
    },
    save: function () {
        this.addInstalledQuantitiesView.saveQuantities();
    },
    close: function () {
        if (_.size(this.collection.models) > 0 && (this.options.canAdd || this.options.canEdit)) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.addInstalledQuantitiesView.saveQuantities();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.productionQuantities.TimeCardQuantitiesAddModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-time-card-quantities-add'),
        subTemplates: {
            timeCardQuantities: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'time-card-quantities')
        },
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-cancel': 'close',
        'click .btn-save': 'save'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.InstalledQuantities(null, {
                projectId: this.options.project.id
            });
        }

        if (this.options.productionQuantities == null) {
            this.options.productionQuantities = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            });
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        if (!this.options.productionQuantities.isFetched) {
            this.options.productionQuantities.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            productionQuantities: this.options.productionQuantities,
            productionQuantity: this.productionQuantity,
            costCodes: this.costCodes,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.quantityViews = [];

        let $outer = this.$('.time-card-quantity-views');
        $outer.empty();
        _.each(this.options.timeCards.models, (timeCard) => {
            this.renderSubTemplate(true, this.options.subTemplates.timeCardQuantities, $outer, {
                timeCard: timeCard,
                collapse: _.size(this.options.timeCards.models) > 2,
                contact: timeCard.get('contact')
            }, _.bind(function (el) {
                let quantitiesView = new PJQ.views.productionQuantities.InstalledQuantitiesAdd({
                    el: el.find('.quantities-outer'),
                    project: this.options.project,
                    timeCardId: timeCard.id
                });

                this.quantityViews.push(quantitiesView);
            }, this));
        });
    },
    validate: function () {
        let isValid = true;
        _.each(this.quantityViews, (view) => {
            isValid = isValid && view.validate();
        });

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        _.each(this.quantityViews, (view) => {
            if (_.size(view.collection.models) > 0) {
                this.collection.add(view.collection.models);
            }
        });

        if (_.size(this.collection.models) > 0) {
            this.collection.saveBulk(_.map(this.collection.models, (model) => model.toJSON()), (newQuantities) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Quantities saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(newQuantities);
                }
                this.removeModal();
            });
        }
    },
    close: function () {
        let isDirty = _.find(this.quantityViews, (view) => {
            return _.size(view.collection.models) > 0;
        });
        if (isDirty) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.productionQuantities.InstalledQuantitiesAdd = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'installed-quantities-add'),
        model: null,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-add-quantity': 'addQuantity',
        'click .btn-delete-quantity': 'deleteQuantityClicked',
        'click .btn-import': 'importFile'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.InstalledQuantities(null, {
                projectId: this.options.project.id
            });
        }

        if (this.options.productionQuantities == null) {
            this.options.productionQuantities = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            })
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        if (!this.options.productionQuantities.isFetched) {
            this.options.productionQuantities.fetch({
                success: _.bind(function () {
                    if (this.options.productionQuantityId > 0) {
                        this.productionQuantity = this.options.productionQuantities.get(this.options.productionQuantityId);
                    }

                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
    },
    renderData: function () {
        return {
            canAdd: this.options.canAdd
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderDatatable();
    },
    renderDatatable: function () {
        this.dataTable = new PJQ.views.productionQuantities.AddInstalledQuantitiesDatatable({
            el: this.$('.add-production-quantity-installed-quantities-data'),
            rowId: "cid",
            columns: this.getColumns(),
            data: this.collection.models.filter((model) => !model.get('delete')),
            costCodes: this.costCodes,
            unitsOfMeasure: this.unitsOfMeasure,
            subJobs: this.subJobs,
            paging: false,
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            headerData: _.bind(function () {
                return {
                    project: this.options.project
                };
            }, this),
            order: [[1, 'asc']],
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        onClick: (row) => {
                            this.deleteQuantity(row.data());
                        },
                        isDanger: true
                    }
                ]
            }
        });
    },
    getColumns: function () {
        let includedColumns = ['subJobId', 'costCodeId', 'unitOfMeasure', 'quantity', 'description', 'installedOn'],
            columns = [];

        if (this.options.productionQuantityId > 0) {
            includedColumns = ['quantity', 'description', 'installedOn'];
        }

        _.each(includedColumns, (column) => {
            switch (column) {
                case 'subJobId':
                    columns.push({
                        "columnData": "subJobId",
                        "title": "Sub Job",
                        "visible": _.size(this.subJobs.models) > 0,
                        "width": "15%",
                        "render": _.bind(function (data, type, row) {
                            return '<select class="select-sub-job form-control"></select>';
                        }, this)
                    });
                    break;
                case 'costCodeId':
                    columns.push({
                        "columnData": "costCodeId",
                        "title": "Cost Code",
                        "width": '25%',
                        "render": (data, type, row) => {
                            let res = '<div class="d-flex"><select class="select-cost-code form-control"></select>';

                            res += '</div>';
                            return res;
                        }
                    });
                    break;
                case 'unitOfMeasure':
                    columns.push({
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "title": "Unit",
                        "width": "100px",
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            return '<select class="select-unit-type form-control"></select>';
                        }
                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "title": "Quantity Installed",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            return '<input type="text" class="form-control input-decimal input-quantity" value="' + row.get('quantity') + '" data-p-bind="quantity" placeholder="0" ' + (!row.isNew() && !this.options.canEdit ? 'disabled' : '') + '>';
                        }
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "width": '20%',
                        "title": "Description",
                        "render": _.bind(function (data, type, row) {
                            return '<input type="text" class="form-control input-description" maxlength="256" value="' + row.get('description').replace(/"/g, '&quot;') + '" data-p-bind="description" ' + (!row.isNew() && !this.options.canEdit ? 'disabled' : '') + '>';
                        }, this)
                    });
                    break;
                case 'installedOn':
                    columns.push({
                        "columnData": "installedOn",
                        "data": "attributes.installedOn",
                        "title": "Installed On",
                        "width": '120px',
                        "render": (data, type, row) => {
                            return '<div class="input-group"><input type="text" class="form-control input-installed-on" ' + (!row.isNew() && !this.options.canEdit ? 'disabled' : '') + '/></div>';
                        }
                    });
                    break;
            }
        });

        columns.push({
            "title": '',
            "orderable": false,
            "searchable": false,
            "width": "80px",
            "className": "text-center",
            "visible": true,
            "render": _.bind(function (data, type, row) {
                if (row.isNew() || this.options.isAdmin) {
                    return `<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-quantity ml-1 fs-14"><span class="fal fa-trash"></span></button></div>`;
                }

                return '';
            }, this)
        })

        return columns;
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);

        let filteredCostCodes = _.filter(this.costCodes.models, (costCode) => {
            return this.options.productionQuantities.findWhere({costCodeId: costCode.get('id')}) != null;
        });

        let filteredSubJobs = _.filter(this.subJobs.models, (subJob) => {
            return _.find(filteredCostCodes, (costCode) => {
                return costCode.get('subJobId') === subJob.get('id');
            });
        });

        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$el, this.collection, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'cid',
                useDecimalPercentFields: true,
                watchElements: [
                    'input'
                ]
            });
        }

        if (_.size(this.subJobs.models) > 0) {
            this.subJobPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-sub-job',
                valueAttribute: 'subJobId',
                selectPickerOptions: {
                    noneSelectedText: 'Parent Job',
                    isLiveSearch: true,
                    isIntChoices: true,
                    defaultValue: (model) => {
                        if (model.get('subJobId') > 0) {
                            return model.get('subJobId');
                        }
                        let productionQuantity = this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')}),
                            costCode = this.costCodes.get(productionQuantity?.get('costCodeId'));

                        return costCode?.get('subJobId');
                    },
                    size: 8,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew();
                    }, this),
                    choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                        name: 'Sub Jobs', choices: _.map(filteredSubJobs, function (subJob) {
                            return {
                                id: subJob.id,
                                name: subJob.get('name'),
                                subtext: subJob.get('code')
                            }
                        }, this)
                    }])
                },
                onChange: _.bind(function (model, value) {
                    model.set('subJobId', value > 0 ? value : null);
                    model.set('costCodeId', 0);
                    model.set('unitId', 0);
                    model.set('productionQuantityId', 0);

                    let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid],
                        uomPicker = this.uomSelectorCollection.pickers[model.cid];
                    costCodePicker.render();
                    uomPicker.render();

                    // this.nextInput('subJob', model);
                }, this)
            });
        }

        this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-cost-code',
            valueAttribute: 'costCodeId',
            selectPickerOptions: {
                isLiveSearch: true,
                isIntChoices: true,
                hideDisabled: false,
                defaultValue: (model) => {
                    if (model.get('costCodeId') > 0) {
                        return model.get('costCodeId');
                    }
                    let productionQuantity = this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')});

                    return productionQuantity?.get('costCodeId');
                },
                isDisabled: _.bind(function (model) {
                    return !model.isNew();
                }, this),
                choices: _.bind(function (model) {
                    return this.getCostCodeOptions(model)
                }, this)
            },
            onChange: _.bind(function (model, value) {
                model.set('costCodeId', value);
                model.set('unitId', 0);
                model.set('productionQuantityId', 0);

                let uomPicker = this.uomSelectorCollection.pickers[model.cid];
                uomPicker.render();

                // this.nextInput('costCode', model);
            }, this)
        });

        this.uomSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-unit-type',
            valueAttribute: 'unitId',
            selectPickerOptions: {
                isIntChoices: true,
                isDisabled: function (model) {
                    return !model.isNew();
                },
                defaultValue: (model) => {
                    if (model.get('unitId') > 0) {
                        return model.get('unitId');
                    }

                    let productionQuantity = this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')});

                    return productionQuantity?.get('unitId');
                },
                choices: _.bind(function (model) {
                    let productionQuantity = model.get('productionQuantityId') > 0 ? this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')}) : null,
                        selectedCostCode = this.costCodes.get(productionQuantity ? productionQuantity.get('costCodeId') : model.get('costCodeId'));

                    if (selectedCostCode == null) {
                        return [];
                    }

                    let filteredUOM = _.filter(this.unitsOfMeasure.models, (unit) => {
                        let productionQuantity = this.options.productionQuantities.findWhere({
                            costCodeId: selectedCostCode.get('id'),
                            unitId: unit.get('id')
                        });

                        return productionQuantity != null;
                    });

                    return _.map(filteredUOM, function (unit) {
                        return {
                            id: unit.id,
                            name: unit.get('name')
                        };
                    });
                }, this)
            },
            onChange: _.bind(function (model, value) {
                let productionQuantity = this.options.productionQuantities.findWhere({
                    costCodeId: model.get('costCodeId'),
                    unitId: value
                });
                model.set('unitId', value);
                model.set('productionQuantityId', productionQuantity.id);

                // this.nextInput('unitType', model);
            }, this)
        });

        new PJQ.inputs.DatePickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.input-installed-on',
            valueAttribute: 'installedOn',
            datePickerOptions: {
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
                },
            },
            onChange: _.bind(function (model, value) {
                model.set('installedOn', value);
                ``
                // this.nextInput('unitType', model);
            }, this)
        });
    },
    importFile: function () {
        this.renderUploader();
    },
    renderUploader: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'projects',
                            value: PJQ.app.session.project.id,
                        },
                        {
                            endpoint: 'productionquantities'
                        },
                        {
                            endpoint: 'installed'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    let uploadId = file.uploadId;
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id,
                            },
                            {
                                endpoint: 'productionquantities'
                            },
                            {
                                endpoint: 'installed'
                            },
                            {
                                endpoint: 'import',
                                value: uploadId
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (result) {
                        loader.remove();
                        this.fileUploader.remove();
                        this.collection.add(result.lineItems);
                        this.renderDatatable();
                    }, this)).fail((err) => {
                        if (err && err.responseJSON) {
                            loader.remove();
                            let file = this.fileUploader.collection.models[0];
                            this.fileUploader.collection.remove(file);
                            this.fileUploader.render();
                            this.fileUploader.showError(err.responseJSON.message, 10000);
                        }
                    });
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
        let self = this;
        $uploader.find('.btn-download-template').off('click').on('click', self.downloadImportTemplate);
    },
    getCostCodeOptions: function (model) {
        let subJob = this.subJobs.get(model.get('subJobId')),
            costCodes = [],
            filteredCostCodes = _.filter(this.costCodes.models, (costCode) => {
                let productionQuantity = this.options.productionQuantities.findWhere({costCodeId: costCode.get('id')});
                if (subJob == null) {
                    return costCode.get('subJobId') == null && productionQuantity != null;
                }
                return costCode.get('subJobId') === subJob.id && productionQuantity != null;
            });

        if (_.size(filteredCostCodes) === 0) {
            return [{
                id: 0,
                name: 'No cost codes found',
                disabled: true
            }];
        }

        _.each(filteredCostCodes.sort((c1, c2) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
        }), function (costCode) {
            let choice = {
                id: costCode.id,
                name: costCode.getDisplayName()
            };
            costCodes.push(choice);
        }, this);
        return costCodes
    },
    addQuantity: function () {
        let newModel = new PJQ.models.productionQuantities.InstalledQuantity({
            projectId: this.options.project.id,
            quantity: 0,
            description: '',
            productionQuantityId: this.options.productionQuantityId,
            timeCardId: this.options.timeCardId,
            installedOn: new Date()
        });
        this.collection.add(newModel);
        this.renderDatatable();
    },
    saveQuantities: function () {
        if (!this.validate())
            return;

        let modelsToSave = _.filter(this.collection.models, (model) => {
            return model.isNew() || model.hasChanged();
        });

        let modelsToSaveJSON = _.map(modelsToSave, (model) => model.toJSON());

        if (_.size(modelsToSaveJSON) > 0) {
            this.collection.saveBulk(modelsToSaveJSON, (savedQuantities) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Quantities saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(savedQuantities);
                }
            });
        } else {
            if (typeof this.options.onSave === 'function') {
                this.options.onSave([]);
            }
        }
    },

    validate: function () {
        let isValid = true;

        _.each(this.collection.models, (model) => {
            isValid = isValid && this.validateQuantity(model);
        })

        return isValid;
    },
    validateQuantity: function (quantity) {
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(quantity.cid),
            data = row?.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null || data.get('delete')) {
            return true;
        }

        if (row != null) {
            let costCodeCol = 0,
                uomCol = 1,
                installedOnCol = 4;
            if (_.size(this.subJobs.models) > 0) {
                costCodeCol++;
                uomCol++;
                installedOnCol++;
            }

            if (this.options.productionQuantityId > 0 && quantity.get('productionQuantityId') == null) {
                quantity.set('productionQuantityId', this.options.productionQuantityId);
            }

            if (this.options.timeCardId > 0 && quantity.get('timeCardId') == null) {
                quantity.set('timeCardId', this.options.timeCardId);
            }

            let productionQuantity = this.options.productionQuantities.findWhere({id: quantity.get('productionQuantityId')});
            if (this.options.productionQuantityId > 0) {
                installedOnCol = installedOnCol - (_.size(this.subJobs.models) > 0 ? 3 : 2);
            } else if (productionQuantity == null) {
                updateCell($(row.node()).find('td:eq(' + costCodeCol + ')'), quantity.get('costCodeId') > 0);
                updateCell($(row.node()).find('td:eq(' + uomCol + ')'), quantity.get('unitId') > 0);
            }

            updateCell($(row.node()).find('td:eq(' + installedOnCol + ')'), quantity.get('installedOn') != null);
        }
        return result;
    },
    deleteQuantityClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteQuantity(row.data());
    },
    deleteQuantity: function (quantity) {
        let row = this.dataTable.getRow(quantity.cid);

        if (quantity.isNew()) {
            quantity.destroy();
        } else {
            quantity.set('delete', true);
        }
        this.dataTable.removeRow(row);
    }
});
PJQ.views.productionQuantities.ProductionQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Production Quantities have been created yet',
            zeroRecords: "No Production Quantities matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-production-quantities')
        },
        toggleRowClass: '.production-quantity-toggle-row'
    },
    events: {
        'click .btn-edit-production-quantity': 'viewProductionQuantityClicked',
        'click .btn-delete-production-quantity': 'deleteProductionQuantityClicked'
    },
    beforeRender: function () {
        this.options.order = _.size(this.options.subJobs) > 0 ? [[1, 'asc']] : [[0, 'asc']];
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['subJob', 'costCode', 'quantity', 'installedQuantity', 'remainingQuantity', 'description'];

        if (this.options.subJobs == null || _.size(this.options.subJobs) === 0) {
            includeColumns = _.without(includeColumns, 'subJob');
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'subJob':
                    columns.push({
                        "columnData": "subJob",
                        "data": "attributes.costCodeId",
                        "title": "Sub Job",
                        "width": "15%",
                        "render": _.bind(function (data, type, row) {
                            let costCode = this.options.costCodes.get(row.get('costCodeId')),
                                subJob;

                            if (costCode.get('subJobId')) {
                                subJob = this.options.subJobs.get(costCode.get('subJobId'));
                            }

                            return subJob ? subJob.get('name') : "";
                        }, this)
                    })
                    break;
                case 'costCode':
                    columns.push({
                        "columnData": "costCode",
                        "data": "attributes.costCodeId",
                        "title": "Cost Code",
                        "width": "300px",
                        "render": _.bind(function (data, type, row) {
                            let costCode = this.options.costCodes.get(data);
                            return costCode ? `${costCode.get('code')} - ${costCode.get('name')}` : "";
                        }, this)
                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "title": "Budgeted",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let unit = this.options.unitsOfMeasure.get(row.get('unitId')),
                                uom = unit != null ? unit.get('code') : "",
                                res = (data ?? 0).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            return res + " " + (uom ?? "");
                        }, this)
                    });
                    break;
                case 'installedQuantity':
                    columns.push({
                        "columnData": "installedQuantity",
                        "data": "",
                        "title": "Installed",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let unit = this.options.unitsOfMeasure.get(row.get('unitId')),
                                uom = unit != null ? unit.get('code') : "",
                                total = 0;

                            _.each(row.installedQuantities.models, (installedQuantity) => {
                                total += installedQuantity.get('quantity');
                            })

                            let res = total.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            return res + " " + (uom ?? "");
                        }, this)
                    });
                    break;
                case 'remainingQuantity':
                    columns.push({
                        "columnData": "remainingQuantity",
                        "data": "",
                        "title": "Remaining",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            let installed = 0;
                            _.each(row.installedQuantities.models, (installedQuantity) => {
                                installed += installedQuantity.get('quantity');
                            });

                            let total = ((row.get('quantity') ?? 0) - installed)

                            if (total < 0) {
                                total = 0;
                            }

                            let unit = this.options.unitsOfMeasure.get(row.get('unitId')),
                                uom = unit != null ? unit.get('code') : "",
                                res = total.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            return res + " " + (uom ?? "");
                        }, this)
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description",
                        "render": _.bind(function (data, type, row) {
                            return data;
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    let canDelete = this.options.isAdmin,
                        res = '<div class="text-align-right show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-edit-production-quantity ml-1 fs-14"><span class="fal fa-pencil"></span></button>';

                    if (canDelete) {
                        res += '<button type="button" class="btn btn-danger btn-delete-production-quantity ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                    }

                    return `${res}</div>`;
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "100px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewProductionQuantityClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewProductionQuantity(row.data());
    },
    viewProductionQuantity: function (productionQuantity) {
        if (productionQuantity == null) {
            return;
        }

        if (typeof this.options.onViewProductionQuantity === 'function') {
            this.options.onViewProductionQuantity(productionQuantity);
        }
    },
    deleteProductionQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteProductionQuantity(row.data());
    },
    deleteProductionQuantity: function (productionQuantity) {
        if (productionQuantity == null) {
            return;
        }

        if (typeof this.options.onDeleteProductionQuantity === 'function') {
            this.options.onDeleteProductionQuantity(productionQuantity);
        }
    }
});

PJQ.views.productionQuantities.AddProductionQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Click "Add Budgeted Quantity" to create a new Budgeted Quantity'
        }
    },
    events: {
        'click .btn-delete-production-quantity': 'deleteProductionQuantityClicked'
    },
    beforeRender: function () {
        this.options.isHideSearch = true;
    },
    deleteProductionQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteProductionQuantity(row);
    },
    deleteProductionQuantity: function (row) {
        if (row == null) {
            return;
        }

        if (typeof this.options.onDeleteProductionQuantity === 'function') {
            this.options.onDeleteProductionQuantity(row);
        }
    }
});

PJQ.views.productionQuantities.InstalledQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Installed Quantities have been added yet',
            zeroRecords: "No Installed Quantities matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-installed-quantities')
        },
    },
    events: {
        'click .btn-view-quantity': 'viewQuantityClicked',
        'click .btn-delete-quantity': 'deleteQuantityClicked',
        'click .btn-view-time-card': 'viewTimeCardClicked'
    },
    beforeRender: function () {
        this.options.project = this.options.project ?? PJQ.app.session.project;

        this.canViewTimeCard = this.options.project.permissions.hasPermission('timeCards.canView');
        this.timeCardSettings = new PJQ.models.timecards.TimeCardSettings(null, {
            project: PJQ.app.session.project
        });
    },
    afterSearch: function () {
        if (typeof this.options.afterSearch === 'function') {
            this.options.afterSearch();
        }
    },
    getColumns: function () {
        let columns = [],
            includeColumns = ['description', 'quantity', 'installedOn', 'source'];

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description",
                        "render": _.bind(function (data, type, row) {
                            return data;
                        }, this)
                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "title": "Installed Quantity",
                        "width": "80px",
                        "render": _.bind(function (data, type, row) {
                            let total = 0;
                            total += data;

                            return total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        }, this)
                    });
                    break;
                case 'installedOn':
                    columns.push({
                        "columnData": "installedOn",
                        "data": "attributes.installedOn",
                        "title": "Installed On",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return data ? moment(data).format('MM/DD/YYYY') : "N/A";
                        }, this)
                    });
                    break;
                case 'source':
                    columns.push({
                        "columnData": "source",
                        "data": "",
                        "title": "Source",
                        "width": "80px",
                        "render": _.bind(function (data, type, row) {
                            let timeCardId = row.get('timeCardId'),
                                html;

                            if (timeCardId > 0 && this.canViewTimeCard) {
                                html = '<button type="button" class="btn btn-link btn-view-time-card fs-14">View</button>'
                            } else {
                                html = 'Manual Entry';
                            }

                            return '<div class="text-align-center">' + html + '</div>';
                        }, this)
                    });
            }
        }, this));

        return columns;
    },
    viewTimeCardClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewTimeCard(row.data());
    },
    viewTimeCard: function (quantity) {
        let timeCardId = quantity.get('timeCardId');

        if (!timeCardId || !this.canViewTimeCard) {
            return;
        }

        let fnRenderTimeCard = () => {
            let model = new PJQ.models.timecards.TimeCard({
                timeCardId: timeCardId
            });

            model.fetch({
                success: () => {
                    new PJQ.views.timecards.TimeCardDetailsModal({
                        project: this.options.project,
                        model: model,
                        settings: this.timeCardSettings
                    });
                }
            });
        }

        if (!this.timeCardSettings.isFetched) {
            this.timeCardSettings.fetch({
                success: () => {
                    fnRenderTimeCard();
                }
            });
        } else {
            fnRenderTimeCard();
        }
    },
    viewQuantityClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewQuantity(row.data());
    },
    viewQuantity: function (quantity) {
        if (quantity == null) {
            return;
        }

        if (typeof this.options.onViewQuantity === 'function') {
            this.options.onViewQuantity(quantity);
        }
    },
    deleteQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteQuantity(row.data());
    },
    deleteQuantity: function (quantity) {
        if (quantity == null) {
            return;
        }

        if (typeof this.options.onDeleteQuantity === 'function') {
            this.options.onDeleteQuantity(quantity);
        }
    }
});

PJQ.views.productionQuantities.AddInstalledQuantitiesDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Click "Add Quantity" to create a new Installed Quantity'
        }
    },
    beforeRender: function () {
        this.options.isHideSearch = true;
    },
    deleteQuantityClicked: function (e) {
        let row = this.getRow($(e.currentTarget).closest('tr'));
        this.deleteQuantity(row);
    },
    deleteQuantity: function (row) {
        if (row == null) {
            return;
        }

        if (typeof this.options.onDeleteQuantity === 'function') {
            this.options.onDeleteQuantity(row);
        }
    }
});
PJQ.views.productionQuantities.ProductionQuantityEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-production-quantity-edit'),
        width: '95%',
        maxWidth: 600,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'saveProductionQuantity',
        'click .btn-delete': 'deleteProductionQuantity',
        'click .btn-add-installed-quantities': 'addInstalledQuantities'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.model == null) {
            this.model = new PJQ.models.productionQuantities.ProductionQuantity({
                projectId: PJQ.app.session.project.id,
                quantity: 0,
                description: ''
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
        this.options.canDelete = this.options.isAdmin;

        if (!this.isFetched || this.model.isNew()) {
            return;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        this.costCodePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-cost-code'),
            defaultValue: this.model.get('costCodeId'),
            noneSelectedText: 'Select Cost Code',
            isDisabled: _.size(this.costCodes.models) === 0 || !this.model.isNew() || !this.options.canEdit,
            isMultiple: false,
            isIntChoices: true,
            isLiveSearch: true,
            onChange: _.bind(function (value) {
                value = value > 0 ? value : null;
                this.model.set('costCodeId', value);
            }, this)
        });
        this.populateCostCodePicker();

        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-quantity'), 2);

        this.unitOfMeasureSelector = new PJQ.inputs.Selectpicker({
            el: this.$('.select-unit-of-measure'),
            defaultValue: this.model.get('unitId'),
            isDisabled: !this.model.isNew() || !this.options.canEdit,
            choices: _.map(this.unitsOfMeasure.models, function (unit) {
                return {
                    name: unit.get('name'),
                    id: unit.id
                };
            }),
            onChange: _.bind(function (value) {
                this.model.set('unitId', value);
            }, this),
            isIntChoices: true,
            hideDisabled: true
        });

        this.dataTable = new PJQ.views.productionQuantities.InstalledQuantitiesDatatable({
            el: this.$('.installed-quantities-data'),
            rowId: "cid",
            project: this.options.project,
            data: this.model.installedQuantities.models,
            isAdmin: false,
            order: [2, 'desc'],
            canAdd: false,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin,
                    canAdd: this.options.canAdd,
                    model: this.model
                };
            }, this)
        });
    },
    addInstalledQuantities: function () {
        new PJQ.views.productionQuantities.InstalledQuantitiesAddModal({
            project: this.options.project,
            productionQuantityId: this.model.id,
            onSave: (newQuantities) => {
                this.model.installedQuantities?.add(newQuantities);
                this.dataTable.render();
            }
        });
    },
    populateCostCodePicker: function () {
        // Group the cost codes by their Sub Job
        let groupedCostCodes = _.groupBy(this.costCodes.models, function (costCode) {
            return costCode.get('subJobId');
        });

        // Convert groupedCostCodes to the format that updateChoices expects
        let choices = _.map(groupedCostCodes, function (costCodes, subJobId) {
            let subJob = _.find(this.subJobs.models, function (subJob) {
                return subJob.id === parseInt(subJobId);
            }, this);
            return {
                name: subJob != null ? subJob.get('name') : 'No Sub Job',
                choices: _.map(costCodes, function (costCode) {
                    return {
                        id: costCode.id,
                        name: costCode.get('name')
                    };
                })
            };
        }, this);

        if (this.costCodePicker != null) {
            this.costCodePicker.updateChoices(choices);
            this.costCodePicker.setValue(this.model.get('costCodeIds') ? this.model.get('costCodeIds') : []);
            if (_.size(this.costCodes.models) > 0 && this.options.canEdit && this.model.isNew()) {
                this.costCodePicker.enable();
            } else {
                this.costCodePicker.disable();
            }
            this.costCodePicker.render();
        }
    },
    saveProductionQuantity: function () {
        let isNew = this.model.isNew();
        this.save(() => {
            PJQ.notifications.notify.successNotify({
                message: 'Production Quantity saved successfully'
            });

            if (!isNew) {
                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (this.model.get('costCodeId') == null) {
            this.costCodePicker.showError("Cost Code is required");
            isValid = false;
        }

        if (this.model.get('unitId') == null) {
            this.unitOfMeasureSelector.showError("Unit of Measure is required");
            isValid = false;
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('productionQuantityChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    deleteProductionQuantity: function () {
        let productionQuantityId = this.model.id
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this Production Quantity?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Production Quantity deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(productionQuantityId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveProductionQuantity();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.productionQuantities.ProductionQuantitiesList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'production-quantities-list'),
        productionQuantityId: null
    },
    events: {
        'click .btn-add-production-quantity': 'addProductionQuantity',
        'click .add-budgeted-quantities': 'addBudgetedQuantities',
        'click .add-installed-quantities': 'addInstalledQuantities',
        'click .btn-delete-production-quantity': 'deleteProductionQuantityClicked',
        'click .btn-export': 'export'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('productionQuantityChanged');
        PJQ.app.session.project.on('productionQuantityChanged', function (productionQuantity) {
            this.collection.add(productionQuantity);
            this.render();
        }, this);

        if (this.options.productionQuantityId > 0) {
            let initProductionQuantity = this.collection.get(this.options.productionQuantityId);
            if (initProductionQuantity != null) {
                this.viewProductionQuantity(initProductionQuantity);
                this.options.productionQuantityId = null;
            }
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.productionQuantities.ProductionQuantitiesDatatable({
            el: this.$('.production-quantities-data'),
            rowId: "cid",
            data: this.collection.models,
            paging: false,
            isAdmin: this.options.isAdmin,
            orderCookie: PJQ.constants.cookies.PRODUCTION_QUANTITIES_ORDER_COOKIE,
            columnWidthCookie: PJQ.constants.cookies.PRODUCTION_QUANTITIES_COLUMNS_WIDTH,
            costCodes: this.costCodes,
            unitsOfMeasure: this.unitsOfMeasure,
            subJobs: this.subJobs,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin,
                    canAdd: this.options.canAdd,
                    canEdit: this.options.canEdit
                };
            }, this),
            onDeleteProductionQuantity: (productionQuantity) => {
                this.deleteProductionQuantity(productionQuantity);
            },
            order: [[1, 'asc']],
            onViewProductionQuantity: (productionQuantity) => {
                this.viewProductionQuantity(productionQuantity);
            },
            onRowDoubleClick: (row) => {
                this.viewProductionQuantity(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewProductionQuantity(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        onClick: (row) => {
                            this.deleteProductionQuantity(row.data());
                        },
                        isDanger: true,
                        isShown: (row) => {
                            return this.options.isAdmin;
                        }
                    }
                ]
            }
        });
    },
    export: function (e) {
        let $target = $(e.currentTarget),
            type = $target.data('type');

        if (this.options.project == null) {
            return;
        }

        let orderCookie = PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.PRODUCTION_QUANTITIES_ORDER_COOKIE),
            order = orderCookie != null ? JSON.parse(orderCookie) : null,
            report = new PJQ.models.reports.NewReport({
            type: PJQ.constants.reports.reportTypes.PRODUCTION_QUANTITIES.type,
            projectId: this.options.project ? this.options.project.id : null,
            options: {
                columns: ["subJob", "costCode", "quantity", "installedQuantity", "unit", "description"],
                columnOrder: order,
            }
        });

        report.export({format: type?.toLowerCase() ?? "pdf" });
    },
    viewProductionQuantityClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewProductionQuantity(row.data());
    },
    viewProductionQuantity: function (productionQuantity) {
        let isNew = productionQuantity == null;

        new PJQ.views.productionQuantities.ProductionQuantityEditModal({
            model: productionQuantity,
            onSave: _.bind(function (productionQuantity) {
                if (isNew) {
                    this.collection.add(productionQuantity);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (productionQuantity) {
                this.collection.remove(productionQuantity);
                this.renderView();
            }, this)
        });
    },
    addBudgetedQuantities: function () {
        new PJQ.views.productionQuantities.ProductionQuantitiesAddModal({
            project: this.options.project,
            onSave: (productionQuantities) => {
                this.collection.add(productionQuantities);
                this.renderView();
            }
        });
    },
    addInstalledQuantities: function () {
        new PJQ.views.productionQuantities.InstalledQuantitiesAddModal({
            project: this.options.project,
            onSave: (newQuantities) => {
                _.each(newQuantities, (quantity) => {
                    let productionQuantity = this.collection.get(quantity.productionQuantityId);

                    if(productionQuantity != null){
                        productionQuantity.installedQuantities.add(quantity);
                    }
                });

                this.renderView();
            }
        });
    },
    deleteProductionQuantityClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteProductionQuantity(row.data());
    },
    deleteProductionQuantity: function (productionQuantity) {
        let row = this.dataTable.getRow(productionQuantity.cid);

        if (row != null) {
            new PJQ.views.modals.DeleteCancel({
                header: "Delete Production Quantity",
                body: "Are you sure you want to delete this Production Quantity?",
                onDelete: _.bind(function () {
                    productionQuantity.destroy({
                        success: _.bind(function () {
                            this.dataTable.removeRow(row);
                            if (typeof this.options.onDelete === 'function') {
                                this.options.onDelete(productionQuantity);
                            }
                        }, this)
                    });
                }, this)
            });
        }
    }
});
//Models
PJQ.models.productionQuantities.ProductionQuantity = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'productionquantities',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;


        this.installedQuantities = new PJQ.collections.productionQuantities.InstalledQuantities(model.installedQuantities);

        return model;
    },
    beforeSave: function () {
        this.set({
            installedQuantities: this.installedQuantities.toJSON()
        });
    }
});

PJQ.models.productionQuantities.InstalledQuantity = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

//Collections
PJQ.collections.productionQuantities.ProductionQuantities = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.productionQuantities.ProductionQuantity,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'productionquantities'
            }
        ]);
    },
    saveBulk: function(productionQuantities, callback) {
        let endpoint = `${this.endpoint()}/bulk`;

        new PJQ.ajax.Request({
            endpoint: endpoint,
            isAPIv2: true,
            data: productionQuantities
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    }
});

PJQ.collections.productionQuantities.InstalledQuantities = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.productionQuantities.InstalledQuantity,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'productionquantities',
                value: this.options.productionQuantityId
            },
            {
                endpoint: 'installed'
            }
        ], params);
    },
    saveBulk: function(installedQuantities, callback) {
        let endpoint = `${this.endpoint()}/bulk`;

        new PJQ.ajax.Request({
            endpoint: endpoint,
            isAPIv2: true,
            data: installedQuantities
        }).post().done(_.bind(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(null);
            }
        });
    }
});
PJQ.views.budget.ProjectBudgetDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-budget')
        },
        language: {
            zeroRecords: '',
            emptyTable: ''
        }
    },
});

PJQ.views.budget.ProjectBudget = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'project-budget'),
        canEdit: true,
        isAdmin: true,
        groupByCookie: 'budget_group_by',
        groupBy: ['division', 'costcode']
    },
    events: {
        // 'click .expand-item': 'expandTableClicked',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-pull-erp': 'pullERP',
        'click .btn-link-erp': 'linkERP',
        'click .btn-add-line-items': 'addLineItems',
        'click .btn-edit-budget': 'editLineItemBudgetClicked',
        'click .btn-edit-forecast': 'editLineItemForecastClicked',
        'click .btn-view-modifications': 'viewLineItemModificationsClicked',
        'click .btn-view-prime-contracts': 'viewLineItemPrimeContractsClicked',
        'click .btn-view-commitments': 'viewLineItemCommitmentsClicked',
        'click .btn-view-cco': 'viewLineItemCommitmentChangeOrdersClicked',
        'click .btn-view-pcco': 'viewLineItemPrimeContractChangeOrdersClicked',
        'click .btn-view-receivable-invoices': 'viewLineItemReceivableInvoicesClicked',
        'click .btn-view-payable-invoices': 'viewLineItemPayableInvoicesClicked',
        'click .btn-view-direct-costs': 'viewLineItemDirectCostsClicked',
        'click .btn-add-modification': 'addBudgetModifications',
        'click .btn-lock-budget': 'lockBudget',
        'click .btn-unlock-budget': 'unlockBudget',
        'keyup .budget-search': 'searchBudget',
        'click .btn-export': 'exportBudget',
        'click .expand-all-items': 'expandAllClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project != null ? this.options.project : PJQ.app.session.project;

        this.options.canEdit = this.options.project.hasPermission('budget.canEdit');
        this.options.isAdmin = this.options.project.hasPermission('budget.isAdmin');

        let gbCookie = PJQ.helpers.cookieHelpers.getCookie(this.options.groupByCookie);
        if (gbCookie != null) {
            this.options.groupBy = _.size(gbCookie) > 0 ? gbCookie.split(',') : [];
        }

        this.expandedItems = [-1];

        this.subJobs = await this.options.project.fetchSubJobs();

        this.costCodes = await this.options.project.fetchCostCodes();
        this.options.hasDivisions = this.costCodes.hasDivisions();

        this.costTypes = await this.options.project.fetchCostTypes();

        this.budget = await this.options.project.fetchBudget(null, {
            force: true
        });
        this.currentBudget = this.budget;

        this.snapshots = await this.options.project.fetchBudgetSnapshots();

        this.budgetViews = await this.options.project.fetchBudgetViews();
        this.setActiveView();

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        await this.options.project.fetchERPObject();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.childDataTables = [];
    },
    renderData: function () {
        return {
            model: this.model,
            canUnlock: this.canUnlock,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderERP();

        this.options.groupBy = _.without(this.options.groupBy, 'subjob');
        if (_.size(this.subJobs.models) > 0) {
            this.options.groupBy = _.union(['subjob'], this.options.groupBy);
        }

        if (!this.options.hasDivisions && this.options.groupBy.indexOf('division') !== -1) {
            this.options.groupBy = _.without(this.options.groupBy, 'division');
        }

        this.fetchBudgetForActiveView(_.bind(function () {
            let data = this.getDataForLevel(0);
            this.renderDatatable(this.$(".budget-table"), data);
        }, this));
    },
    renderERP: function () {
        if (!this.options.project.isERPSynced() || this.budget.get('snapshotOfId') != null || !this.options.isAdmin) {
            return;
        }

        let hasUnsynced = false,
            lastSync = null;
        _.each(this.budget.lineItems.models, function (lineItem) {
            let status = lineItem.erpSyncStatus();
            if (status !== PJQ.constants.integrations.erp.syncStatuses.APPROVED && status !== PJQ.constants.integrations.erp.syncStatuses.SYNCED) {
                hasUnsynced = true;
            }
            let exObj = lineItem.get('externalObject');
            if (_.size(exObj?.lastSync) > 0) {
                let ls = new Date(exObj.lastSync);
                if (lastSync == null || ls > lastSync) {
                    lastSync = ls;
                }
            }
        });

        let $erp = this.$('.erp-sync'),
            budgetStatus = this.budget.erpSyncStatus(),
            reviewing = PJQ.constants.integrations.erp.syncStatuses.REVIEWING,
            synced = PJQ.constants.integrations.erp.syncStatuses.SYNCED,
            approved = PJQ.constants.integrations.erp.syncStatuses.APPROVED,
            status;
        if (budgetStatus === reviewing) {
            status = reviewing;
        } else if (hasUnsynced && budgetStatus === synced) {
            status = PJQ.constants.integrations.erp.syncStatuses.STALE;
        } else {
            status = budgetStatus;
        }

        if (budgetStatus == null) {
            budgetStatus = PJQ.constants.integrations.erp.syncStatuses.PENDING;
        }

        this.erpButtons = PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_BUDGET),
            canPush: hasUnsynced && budgetStatus !== reviewing,
            disablePushReason: !hasUnsynced ? 'All budget updates have been pushed to ERP' : '',
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_BUDGET),
            canPull: budgetStatus !== approved,
            status: status,
            lastSync: lastSync
        });

        let badge = PJQ.helpers.erp.getERPBadge(status, this.budget.get('externalObject'));
        if (_.size(badge) > 0) {
            this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
        }
    },
    setActiveView: function (viewId) {
        this.view = _.find(this.budgetViews.models, function (budgetView) {
            if (viewId == null) {
                return budgetView.get('isDefault');
            }
            return budgetView.id === viewId;
        });

        if (this.view == null) {
            // we didn't find a default view or a view matching the argument viewId
            // here we use the standard budget view
            this.view = _.find(this.budgetViews.models, function (budgetView) {
                return budgetView.get('companyId') === -1;
            });
        }
        this.budgetView = null;
    },
    fetchBudgetForActiveView: function (callback) {
        if (this.budgetView == null) {
            this.budget.fetchForView(this.view.id, _.bind(function (res) {
                this.budgetView = res;
                callback(this.budgetView);
            }, this));
        } else {
            if (typeof callback === 'function') {
                callback(this.budgetView);
            }
        }
    },
    getDataForLevel: function (level, parentData = null) {
        let groupByLevel = _.size(this.options.groupBy) >= level + 1 ? this.options.groupBy[level] : null;
        if (groupByLevel == null) {
            let groupByCostCode = this.options.groupBy.indexOf('costcode') !== -1;
            return _.map(_.filter(this.budgetView.lineItems, function (lineItem) {
                return parentData == null || parentData.lineItemIds.indexOf(lineItem.id) !== -1;
            }), function (lineItem) {
                let costCode = this.costCodes.get(lineItem.costCodeId),
                    costType = this.costTypes.get(lineItem.costTypeId),
                    budgetCode;
                if (groupByCostCode) {
                    budgetCode = costType.get('name');
                } else {
                    budgetCode = '<div>' + costCode.getDisplayName() + '</div><div class="fs-13 text-muted">' + costType.get('name') + '</div>'
                }
                return _.defaults({
                    costCode: costCode,
                    costType: costType,
                    budgetCode: budgetCode
                }, lineItem);
            }, this);
        } else {
            let parents = {};
            _.each(this.budgetView.lineItems, function (lineItem) {
                if (parentData != null && parentData.lineItemIds.indexOf(lineItem.id) === -1) {
                    return;
                }

                let parent;
                if (groupByLevel === 'subjob') {
                    let subJob = this.subJobs.get(lineItem.subJobId),
                        subJobId = subJob ? subJob.id : -1;
                    if (parents[subJobId] != null) {
                        parents[subJobId].lineItemIds.push(lineItem.id);
                    } else {
                        parents[subJobId] = ({
                            id: PJQ.helpers.guid(),
                            budgetCode: subJob ? (subJob.get('code') + " - " + subJob.get('name')) : this.options.project.get('projectName'),
                            lineItemIds: [lineItem.id],
                            columnData: []
                        });
                    }

                    parent = parents[subJobId];
                } else if (groupByLevel === 'division') {
                    let costCode = this.costCodes.get(lineItem.costCodeId);
                    if (parents[costCode.get('division')] != null) {
                        parents[costCode.get('division')].lineItemIds.push(lineItem.id);
                    } else {
                        parents[costCode.get('division')] = ({
                            id: PJQ.helpers.guid(),
                            budgetCode: costCode.get('division'),
                            lineItemIds: [lineItem.id],
                            columnData: []
                        });
                    }

                    parent = parents[costCode.get('division')];
                } else if (groupByLevel === 'costcode') {
                    let costCode = this.costCodes.get(lineItem.costCodeId);
                    if (parents[costCode.id] != null) {
                        parents[costCode.id].lineItemIds.push(lineItem.id);
                    } else {
                        parents[costCode.id] = ({
                            id: PJQ.helpers.guid(),
                            budgetCode: costCode.getDisplayName(),
                            costCode: costCode,
                            costCodeId: lineItem.costCodeId,
                            lineItemIds: [lineItem.id],
                            columnData: []
                        });
                    }

                    parent = parents[costCode.id];
                }

                if (parent != null) {
                    _.each(this.budgetView.columns, function (column, index) {
                        let val;
                        if (column.format === 'money' || column.format === 'decimal' || column.format === 'integer' || column.format === 'percent' || column.format === 'time') {
                            if (_.size(parent.columnData) >= index + 1) {
                                val = parent.columnData[index];
                            } else {
                                val = 0;
                            }

                            let liVal = lineItem.columnData[index] ?? 0;
                            if (column.format === 'money') {
                                val += parseInt(PJQ.helpers.formatHelpers.numbersOnly(liVal, false, true));
                            } else if (column.source === 'TimeCardValues') {
                                if (!Array.isArray(val)) {
                                    val = [];
                                }

                                val.push(liVal);
                            } else {
                                val += liVal;
                            }
                        } else {
                            val = '';
                        }
                        parent.columnData[index] = val;
                    });
                }
            }, this);

            _.each(parents, function (parent) {
                _.each(this.budgetView.columns, function (column, index) {
                    if (column.format === 'money') {
                        parent.columnData[index] = PJQ.helpers.formatHelpers.formatCurrency(parent.columnData[index]);
                    } else if (column.format === 'integer' || column.format === 'decimal' || column.format === 'percent' || column.format === 'time') {
                        parent.columnData[index] = parent.columnData[index];
                    }
                });
            }, this);

            let data = [];
            _.each(parents, function (lineItem) {
                data.push(lineItem);
            })

            if (this.rowData == null) {
                this.rowData = {};
            }

            this.rowData[parentData?.id ?? 0] = data;

            return data;
        }
    },
    isLastLevel: function (level) {
        return level === _.size(this.options.groupBy);
    },
    renderDatatable: function ($element, data, level = 0, parentTable = null) {
        let contextMenuActions = [],
            isLastLevel = this.isLastLevel(level);
        contextMenuActions = [
            {
                name: 'Add to Budget',
                isShown: _.bind(function (row) {
                    let lineItem = this.budget.lineItems.get(row.data().id);
                    return lineItem.get('isUnBudgeted');
                }, this),
                onClick: _.bind(function (row) {
                    let lineItem = this.budget.lineItems.get(row.data().id);
                    this.addLineItemToBudget(lineItem);
                }, this)
            },
            {
                name: 'Edit Original Budget',
                isShown: _.bind(function (row) {
                    return !this.budget.get('isLocked') && this.options.canEdit;
                }, this),
                onClick: _.bind(function (row) {
                    this.editLineItemBudget(row.data().id);
                }, this)
            },
            {
                name: 'View Modifications',
                isShown: _.bind(function (row) {
                    return this.budget.get('isLocked');
                }, this),
                onClick: _.bind(function (row) {
                    let lineItem = this.budget.lineItems.get(row.data().id);
                    this.viewLineItemModifications(lineItem);
                }, this)
            },
            {
                name: 'Edit Forecast',
                // isShown: _.bind(function (row) {
                // 	return this.budget.get('isLocked');
                // }, this),
                onClick: _.bind(function (row) {
                    this.editLineItemForecast(row.data().id)
                }, this),
                isShown: _.bind(function (row) {
                    return !this.budget.get('isLocked') && this.options.canEdit;
                }, this)

            },
            {
                name: 'Delete',
                isShown: _.bind(function (row) {
                    return !this.budget.get('isLocked') && this.options.isAdmin;
                }, this),
                onClick: _.bind(function (row) {
                    let lineItem = this.budget.lineItems.get(row.data().id);
                    this.deleteLineItem(lineItem);
                }, this)
            }
        ];

        let dt = new PJQ.views.budget.ProjectBudgetDataTable({
            rowId: "id",
            el: $element,
            data: data,
            isHideSearch: level > 0,
            paging: false,
            order: [1, 'asc'],
            toggleRowClass: '.expand-item',
            // fixedColumns: {
            //     start: 2
            // },
            scrollY: 'auto',
            scrollCollapse: true,
            scrollX: true,
            expandAll: true,
            // enableColumnResize: false,
            extraClasses: !isLastLevel ? 'rows-muted' : '',
            rowCallback: function (row, data) {
                if (data.isUnBudgeted) {
                    $(row).attr('style', 'background-color: #ffefbe !important');
                }
            },
            getChildRowClasses: (item, level) => {
                // let isLastLevel = (level ?? 0) === _.size(this.options.groupBy);
                // return !isLastLevel ? 'row-muted' : '';
            },
            getChildRowStyles: (item, level) => {
                return item.isUnBudgeted ? "background-color: #ffefbe !important" : "";
            },
            isLastLevel: _.bind(this.isLastLevel, this),
            getRowChildData: (row, level) => {
                let data = this.rowData[row.data().id];

                return data ?? this.getDataForLevel(level, row.data());
            },
            getRowChildColumns: (opts) => {
                return this.getColumns(opts.level);
            },
            getChildRowData: (parentId, id, level) => {
                let isLastLevel = (level ?? 0) === _.size(this.options.groupBy);
                if (isLastLevel) {
                    return this.budget.lineItems.get(id);
                } else {
                    return Object.values(this.rowData).flat().find(row => row.id === id);
                }
            },
            drawCallback: _.bind(function (settings) {
                if (parentTable != null) {
                    // If you open up a bunch of child rows, an ugly border starts to form between them all growing with every new child row opened.
                    // need to collapse the group-start every time to prevent this
                    this.$('.group-start').attr('style', 'visibility: collapse;');
                    // Remove child tables header
                    $element.find('thead').attr('style', 'visibility: collapse;');
                }

                if (level === 0) {
                    this.snapshotSelect = new PJQ.inputs.Selectpicker({
                        el: this.$('.select-snapshot'),
                        defaultValue: this.budget === this.currentBudget ? -1 : this.budget.get('id'),
                        isIntChoices: true,
                        onChange: _.bind(function (value) {
                            if (value === -2) {
                                this.createSnapshot();
                                this.snapshotSelect.setValue(-1)
                            } else if (value === -1) {
                                this.budget = this.currentBudget;
                                this.budgetView = null;
                                this.render();
                            } else {
                                this.budget = new PJQ.models.budget.Budget({id: value});
                                this.budget.fetch({
                                    success: _.bind(function () {
                                        this.budgetView = null;
                                        this.render();
                                    }, this)
                                })
                            }
                        }, this)
                    });

                    this.groupBySelector = new PJQ.inputs.Selectpicker({
                        el: this.$('.budget-group-by'),
                        hideDisabled: false,
                        isMultiple: true,
                        noneSelectedText: 'No Grouping',
                        defaultValue: this.options.groupBy,
                        onChange: _.bind(function (value) {
                            this.setGroupBy(value);
                        }, this)
                    });

                    this.viewSelector = new PJQ.inputs.Selectpicker({
                        el: this.$('.budget-view-select'),
                        defaultValue: this.view.id,
                        isIntChoices: true,
                        onChange: _.bind(function (value) {
                            if (value === -1) {
                                this.viewSelector.setValue(this.view.id);
                                this.manageViews();
                            } else {
                                this.setActiveView(value);
                                this.budgetView = null;
                                this.render();
                            }
                        }, this)
                    });
                }
            }, this),
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-budget')
            },
            headerData: _.bind(function () {
                let erpStatus = this.budget.erpSyncStatus(),
                    erpReviewing = erpStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED || erpStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING;
                return {
                    subJobs: this.subJobs,
                    hasDivisions: this.options.hasDivisions,
                    isLocked: this.budget.get('isLocked'),
                    erpReviewing: erpReviewing,
                    views: this.budgetViews,
                    snapshots: this.snapshots,
                    isAdmin: this.options.isAdmin,
                    canEdit: this.options.canEdit,
                    isSnapshot: this.budget.get('snapshotOfId') != null,
                    erpIntegration: this.erpIntegration,
                    project: PJQ.app.session.project
                };
            }, this),
            hasFooter: level === 0,
            afterDataTableRender: _.bind(function () {
                this.renderTableFooter();
            }, this),
            onTableDraw: () => {
                this.renderTableFooter();
            },
            afterHeaderRender: () => {
                this.renderERP();
            },
            contextMenuOptions: {
                selector: _.size(this.options.groupBy) > 0 ? `tr[id][data-level="${_.size(this.options.groupBy)}"]` : 'tr[id]',
                actions: contextMenuActions
            },
            columns: this.getColumns(level)
        });

        if (parentTable != null) {
            parentTable.options.childDataTables.push(dt);
        } else {
            this.dataTable = dt;
        }
    },
    setGroupBy: function (value) {
        this.options.groupBy = value;
        PJQ.helpers.cookieHelpers.setCookie(this.options.groupByCookie, _.size(value) > 0 ? value.join(',') : '');

        if (this.dataTable != null) {
            this.render();
        }
    },
    renderTableFooter: function () {
        let $footer = this.$('.dt-scroll-foot').find('tfoot').first(),
            $totalTextCol = $footer.find('th').eq(0);

        $totalTextCol.html("<div class='font-weight-bold text-align-right'>Grand Total</div>");
        _.each(this.budgetView.columns, function (column, index) {
            if (column.format == null) {
                return;
            }

            let format = column.format.toLowerCase();
            if (format === 'money' || format === 'decimal' || format === 'integer' || format === 'percent' || format === 'time') {
                let total = 0;
                _.each(this.budgetView.lineItems, function (lineItem) {
                    if (lineItem.columnData != null) {
                        if (column.source === 'TimeCardValues') {
                            let minutes = PJQ.helpers.dateHelpers.getMinutesFromHoursDecimal(lineItem.columnData[index] / 100);
                            total += minutes;
                        } else {
                            let cVal = lineItem.columnData[index];
                            if (typeof cVal === 'string') {
                                cVal = PJQ.helpers.formatHelpers.numbersOnly(cVal, true, true);
                            }
                            total += parseFloat(cVal);
                        }
                    }
                });

                // we add a +2 offset because there is always a"Description" column on the left
                let $footerCol = $footer.find('th').eq(index + 1);
                $footerCol.addClass('text-align-right');
                if (format === 'money') {
                    $footerCol.text(PJQ.helpers.formatHelpers.formatCurrency(total));
                } else if (format === 'integer') {
                    $footerCol.text(total);
                } else if (format === 'decimal') {
                    if (column.source === 'TimeCardValues') {
                        $footerCol.text(PJQ.helpers.timecards.getFormattedTime(total));
                    } else {
                        $footerCol.text((total).toFixed(2));
                    }
                } else if (format === 'time') {
                    $footerCol.text(PJQ.helpers.timecards.getFormattedTime(total));
                } else if (format === 'percent') {
                    $footerCol.text((total / 100).toFixed(2) + '%');
                }
            }
            if (this.dataTable?.$dataTable) {
                this.dataTable.$dataTable.find('tfoot').first().remove();
            }
        }, this);
    },
    lockBudget: function () {
        this.budget.updateLocked(true, _.bind(function (success) {
            if (success) {
                this.render();
            }
        }, this));
    },
    linkERP: function () {
        new PJQ.integrations.models.LinkERPProjectModal({
            project: PJQ.app.session.project,
            onSave: _.bind(function (erpProject) {
                if (erpProject != null && _.size(erpProject.id) > 0) {
                    PJQ.app.session.project.linkERP(erpProject.id, _.bind(function (res) {
                        if (res != null) {
                            this.render();
                        }
                    }, this));
                }
            }, this)
        });
    },
    pushERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_BUDGET)) {
            this.erpButtons?.pushing(true);
            this.erpIntegration.pushBudget(this.budget, _.bind(function () {
                this.erpButtons?.pushing(false);
                PJQ.notifications.notify.successNotify({
                    message: 'Budget pushed to ERP'
                });
                this.render();
            }, this));
        }
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_BUDGET)) {
            this.erpButtons?.pulling(true);

            this.erpIntegration.pullBudget(this.options.project, (res, err) => {
                this.erpButtons?.pulling(false);

                if (res == null) {
                    return;
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Budget pulled from ERP'
                });

                this.budgetView = null;
                PJQ.app.session.project.fetchCostCodes(_.bind(function (costCodes) {
                    this.costCodes = costCodes;
                    this.options.hasDivisions = this.costCodes.hasDivisions();
                    PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
                        this.costTypes = costTypes;
                        this.render();
                    }, this), true);
                }, this), true);
            });
        }
    },
    undoPushERP: function () {
        if (this.budget.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.budget, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Budget removed from ERP approval'
                });
                this.render();
            }, this));
        }
    },
    exportBudget: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'budgets',
                value: this.budget.get('id')
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'viewId',
                value: this.view.id
            }
        ]), {isAPIv2: true});
    },
    searchBudget: function () {
        let searchVal = this.$('.budget-search').val();

        this.dataTable.search(searchVal);
    },
    unlockBudget: function () {
        // deleteModifications
        this.budget.updateLocked(false, _.bind(function (success) {
            if (success) {
                this.render();
            }
        }, this));
    },
    getColumns: function (level) {
        let levels = _.size(this.options.groupBy),
            isLastLevel = level === levels,
            columns = [
                // {
                //     // "data": "",
                //     "title": '',
                //     "orderable": false,
                //     "render": _.bind(function (data, type, row) {
                //         // budgetId is an attribute that only exists if it's a line item
                //         let html = '';
                //         if (!isLastLevel) {
                //             html = '<i class="fal fa-plus-circle expand-item" data-type="" data-id="' + row.id + '" style="cursor: pointer"></i>';
                //         } else if (row.isUnBudgeted) {
                //             html = '<i class="fas fs-18 text-warning fa-exclamation-circle" title="Line item was added automatically and has not been budgeted yet."></i> '
                //         }
                //
                //         return '<div class="wd-15p">' + html + '</div>';
                //     }, this)
                // }
            ],
            canClickColumnData = _.size(this.options.groupBy) === level;
        columns.push({
            "title": '<i class="fal mr-2 ' + (_.size(this.expandedItems) > 0 ? 'fa-minus-circle' : 'fa-plus-circle') + ' toggle-all-rows" style="cursor: pointer"></i> Budget Code',
            "width": "400px",
            "data": "budgetCode",
            "type": 'num',
            "render": (data, type, row) => {
                if (type === 'sort') {
                    let sValue = row.costCode ? row.costCode.get('code') : row.budgetCode,
                        numOnly = PJQ.helpers.formatHelpers.numbersOnly(sValue, false);
                    return _.size(numOnly) > 0 ? parseInt(numOnly) : sValue;
                }

                let classes = '';
                if (!isLastLevel) {
                    classes = 'font-weight-bold';
                }

                data = data ?? row.budgetCode
                let padding = level * 5,
                    budgetCode = '<div class="flex-fill ' + classes + '">' + data + '</div>',
                    expandBtn = '';

                if (levels > 0 && isLastLevel) {
                    padding += 15;
                }

                if (!isLastLevel) {
                    expandBtn = '<i class="fal fa-plus-circle expand-item mr-2" data-type="" data-id="' + row.id + '" style="cursor: pointer"></i>';
                } else if (row.isUnBudgeted) {
                    expandBtn = '<i class="fas fs-18 text-warning fa-exclamation-circle mr-2" title="Line item was added automatically and has not been budgeted yet."></i> '
                }

                return `<div class="d-flex align-items-center" style="min-width:250px;padding-left:${padding}px;">${expandBtn}${budgetCode}</div>`;
            }
        });

        _.each(this.budgetView.columns, function (column, index) {
            columns.push({
                "data": "",
                "title": column.name,
                "className": column.format === 'money' || column.format === 'decimal' || column.format === 'integer' || column.format === 'percent' || column.format === 'time' ? 'text-right' : '',
                "render": _.bind(function (data, type, row) {
                    let val = row.columnData[index],
                        extraClasses = '';
                    if (column.format === 'money') {
                        let rawVal = PJQ.helpers.formatHelpers.numbersOnly(val, false, true);
                        // extraClasses += 'wd-80p '
                        if (rawVal < 0) {
                            extraClasses += 'text-danger ';
                        }
                    } else if (column.format === 'decimal' || column.format === 'percent') {
                        if ((column.source === 'TimeCardValues') && Array.isArray(val)) {
                            let totalMinutes = _.reduce(val, function (total, timeValue) {
                                let timeDecimal = Math.floor(timeValue / 100) + (timeValue % 100) / 100;

                                let hours = Math.floor(timeDecimal);
                                let minutes = Math.round((timeDecimal - hours) * 100 * 60 / 100);

                                return total + (hours * 60) + minutes;
                            }, 0);

                            val = totalMinutes / 60;
                        } else if (column.source === 'TimeCardValues') {
                            val = ((val ?? 0) / 100).toFixed(2);
                        } else {
                            val = (val ?? 0).toFixed(2);
                            if (column.format === 'percent') {
                                val = val + '%';
                            }
                        }
                    } else if (column.format === 'time') {
                        val = PJQ.helpers.timecards.getFormattedTime(val);
                    }

                    if (column.source === 'TimeCardValues') {
                        let minutes = PJQ.helpers.dateHelpers.getMinutesFromHoursDecimal(val);
                        val = PJQ.helpers.timecards.getFormattedTime(minutes);
                    }

                    if (canClickColumnData) {
                        let statuses = column.options && column.options.statuses ? column.options.statuses.join(',') : '',
                            result = val;
                        switch (column.source) {
                            case "CommitmentValues":
                                result = '<a href="javascript:void(0)" class="btn-view-commitments" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                break;
                            case "BudgetedCost":
                                if (this.options.canEdit) {
                                    result = '<a href="javascript:void(0)" class="btn-edit-budget" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "BudgetedHours":
                                if (this.options.canEdit) {
                                    result = '<a href="javascript:void(0)" class="btn-edit-budget" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "ForecastToComplete":
                                if (this.options.canEdit) {
                                    result = '<a href="javascript:void(0)" class="btn-edit-forecast" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "BudgetModification":
                                result = '<a href="javascript:void(0)" class="btn-view-modifications" data-id="' + row.id + '">' + val.toString() + '</a>';
                                break;
                            case "PrimeContractValues":
                                if (this.options.project.hasPermission('primeContracts.canView')) {
                                    result = '<a href="javascript:void(0)" class="btn-view-prime-contracts" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "CommitmentChangeOrderValues":
                                if (this.options.project.hasPermission('commitmentChangeOrders.canView')) {
                                    result = '<a href="javascript:void(0)" class="btn-view-cco" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "PrimeContractChangeOrderValues":
                                if (this.options.project.hasPermission('primeContractChangeOrders.canView')) {
                                    result = '<a href="javascript:void(0)" class="btn-view-pcco" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "DirectCostValues":
                                if (this.options.project.hasPermission('directCosts.canView')) {
                                    result = '<a href="javascript:void(0)" class="btn-view-direct-costs" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "PayableInvoiceValues":
                                if (this.options.project.hasPermission('payableInvoices.canView')) {
                                    result = '<a href="javascript:void(0)" class="btn-view-payable-invoices" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "ReceivableInvoiceValues":
                                if (this.options.project.hasPermission('receivableInvoices.canView')) {
                                    result = '<a href="javascript:void(0)" class="btn-view-receivable-invoices" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>';
                                } else {
                                    result = val.toString();
                                }
                                break;
                        }
                        return '<span class="' + extraClasses + '">' + result + '</span>';
                    } else {
                        return '<span class="font-weight-bold ' + extraClasses + '">' + val + '</span>';
                    }
                }, this)
            })
        }, this)
        return columns;
    },
    createSnapshot: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.budget.get('id')
                },
                {
                    endpoint: 'snapshot'
                }
            ]),
            isAPIv2: true,
        }).post().done(_.bind(function (data) {
            data.createdOn = new Date()
            this.snapshots.add(data);
            this.render();
            PJQ.notifications.notify.successNotify({
                message: 'Snapshot successfully created'
            });
        }, this));
    },
    editLineItemBudgetClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id');
        this.editLineItemBudget(id);
    },
    editLineItemBudget: function (id) {
        let lineItem = this.budget.lineItems.get(id);
        new PJQ.views.budget.EditLineItemBudgetModal({
            model: lineItem,
            budget: this.budget,
            onSave: _.bind(function () {
                lineItem.set('modifiedOn', new Date());
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    addLineItemToBudget: function (lineItem) {
        lineItem.save(null, {
            success: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        })
    },
    editLineItemForecastClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id');
        this.editLineItemForecast(id);
    },
    editLineItemForecast: function (lineItemId) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.budget.AddBudgetLineItemForecastModal({
            model: lineItem,
            budget: this.budget,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemReceivableInvoicesClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemReceivableInvoices(id, statusIds);
    },
    viewLineItemReceivableInvoices: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.invoicing.ModalViewReceivableInvoices({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            showAllBillingPeriods: true,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemPayableInvoicesClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemPayableInvoices(id, statusIds);
    },
    viewLineItemPayableInvoices: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.invoicing.ModalViewPayableInvoices({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            showAllBillingPeriods: true,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemPrimeContractsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemPrimeContracts(id, statusIds);
    },
    viewLineItemPrimeContracts: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.primeContracts.ModalViewPrimeContracts({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemPrimeContractChangeOrdersClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemPrimeContractChangeOrders(id, statusIds);
    },
    viewLineItemPrimeContractChangeOrders: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.primeContracts.ModalViewChangeOrders({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemCommitmentChangeOrdersClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemCommitmentChangeOrders(id, statusIds);
    },
    viewLineItemCommitmentChangeOrders: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.commitments.ModalViewChangeOrders({
            model: lineItem,
            statusIds: statusIds,
            budget: this.budget,
            project: this.options.project,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemCommitmentsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemCommitments(id, statusIds);
    },
    viewLineItemCommitments: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.commitments.ModalViewCommitments({
            model: lineItem,
            budget: this.budget,
            statusIds: statusIds,
            project: this.options.project,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemDirectCostsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemDirectCosts(id, statusIds);
    },
    viewLineItemDirectCosts: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.directcosts.ModalViewDirectCosts({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    addLineItems: function () {
        new PJQ.views.budget.AddBudgetLineItemsModal({
            budget: this.budget,
            costCodes: this.costCodes,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    filterLineItems: function (lineItemIds, filterText) {
        if (_.size(lineItemIds) > 0 || _.size(filterText) > 0) {
            return _.filter(this.budgetView.lineItems, function (lineItem) {
                let costCode = this.costCodes.get(lineItem.costCodeId);
                return (_.size(lineItemIds) === 0 || lineItemIds.indexOf(lineItem.id) !== -1) &&
                    (_.size(filterText) === 0 || costCode.getDisplayName().indexOf(filterText) !== -1 || costCode.get('division').indexOf(filterText) !== -1);
            }, this)
        }

        return this.budgetView.lineItems;
    },
    deleteLineItem: function (lineItem) {
        lineItem.destroy({
            wait: true,
            notify: false,
            success: _.bind(function () {
                this.budgetView.lineItems = _.filter(this.budgetView.lineItems, function (itm) {
                    return itm.id !== lineItem.id;
                })
                this.render();
            }, this),
            error: function (model, xhr) {
                if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_line_item_with_costs') {
                    PJQ.notifications.notify.warningNotify({
                        message: 'You can not delete line items with committed or pending costs or contracts'
                    });
                }
            }
        });
    },
    addBudgetModifications: function () {
        new PJQ.views.budget.AddBudgetModificationsModal({
            budget: this.budget,
            onSave: _.bind(function (modifications) {
                _.each(modifications, (modification) => {
                    let fromLine = this.budget.lineItems.get(modification.get('fromLineItemId'));
                    if (fromLine != null) {
                        fromLine.set('modifiedOn', new Date());
                    }

                    let toLine = this.budget.lineItems.get(modification.get('toLineItemId'));
                    if (toLine != null) {
                        toLine.set('modifiedOn', new Date());
                    }
                });
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemModificationsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            lineItem = this.budget.lineItems.get(id);
        this.viewLineItemModifications(lineItem);
    },
    viewLineItemModifications: function (lineItem) {
        new PJQ.views.budget.ViewBudgetModificationsModal({
            budget: this.budget,
            lineItem: lineItem
        });
    },
    manageViews: function () {
        let fnUpdateChoices = _.bind(function (views) {
            this.budgetViews = views;
            if (this.viewSelector != null) {
                this.viewSelector.updateChoices(_.map(this.budgetViews.models, function (bv) {
                    return {
                        value: bv.id,
                        name: bv.get('name')
                    }
                }));
            }
        }, this)
        new PJQ.views.budget.BudgetsViewsEditorModal({
            budget: this.budget,
            budgetViews: this.budgetViews,
            onSave: _.bind(function (vw, views) {
                this.budgetViews = views;
                // fnUpdateChoices(views);
                if (vw.id === this.view.id) {
                    this.setActiveView(vw.id);
                    // this.render();
                }
                this.render();
            }, this),
            onDelete: _.bind(function (vw, views) {
                this.budgetViews = views;
                // fnUpdateChoices(views);
                if (vw.id === this.view.id) {
                    this.setActiveView();
                    // this.render();
                }
                this.render();
            }, this)
        });
    }
});

PJQ.collections.rfq = PJQ.collections.rfq ? PJQ.collections.rfq : {};
PJQ.models.rfq = PJQ.models.rfq ? PJQ.models.rfq : {};
PJQ.views.rfq = PJQ.views.rfq ? PJQ.views.rfq : {};
PJQ.views.rfq.RFQBatchModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-rfq-batch'),
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save',
        'click .cb-send': 'sendChanged',
        'click .cb-send-all': 'sendAllChanged',
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.batch = {
            changeRequestId: this.options.changeRequest?.id ?? 0,
            title: this.options.changeRequest ? (this.options.changeRequest.get('number') + ' - ' + this.options.changeRequest.get('title')) : '',
            description: this.options.changeRequest?.get('description') ?? '',
            dueDate: new Date(),
            attachments: new PJQ.collections.rfq.Attachments(),
            requests: _.map(this.options.lineItems ?? [], (lineItem) => {
                let vendor = lineItem.get('vendor');
                return {
                    id: lineItem.id,
                    changeRequestId: lineItem.get('changeRequestId'),
                    lineItem: lineItem,
                    lineItemId: lineItem.id,
                    scope: lineItem.get('description'),
                    contractedContact: vendor,
                    contractedContactId: vendor?.id,
                    assignees: vendor != null ? [vendor] : [],
                    assigneeIds: vendor != null ? [vendor.id] : [],
                    distributeToIds: PJQ.app.session.user != null ? [-PJQ.app.session.user.id] : [],
                    commitmentId: lineItem.get('commitmentId'),
                    commitmentNumber: lineItem.get('commitmentNumber'),
                    send: true
                };
            })
        }

        this.isFetched = true;
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            batch: this.batch,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderForm();

        this.renderDataTable();
    },
    sendAllChanged: function (e) {
        let $target = $(e.currentTarget),
            checked = $target.prop('checked');
        _.each(this.batch.requests, (request) => {
            let checkbox = this.$('.cb-send[data-id="' + request.id + '"]');
            checkbox.prop('checked', checked);
            request.send = checked;
        });
    },
    renderForm: function () {
        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$('.details-outer'), this.batch, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        new PJQ.inputs.Datepicker({
            el: this.$('.input-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.batch.dueDate
            },
            onChange: (newDate) => {
                this.batch.dueDate = newDate;
            }
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfq-file-uploader'),
            collection: this.batch.attachments,
            useApiV2: true,
            onDelete: (attachment, callback) => {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                callback();
            }
        });
    },
    renderInputs: function () {
        if (!this.lineBinder) {
            this.lineBinder = new PJQ.Binder(this.$el, this.batch.requests, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'id',
                watchElements: [
                    'input'
                ],
                afterChange: (el, attribute, value) => {
                    let $el = $(el),
                        id = $el.data('id'),
                        model = _.findWhere(this.batch.requests, {
                            id: id
                        });

                    if (model) {
                        model[attribute] = value;
                    }
                }
            });
        }
        let fnCommitmentToChoice = (commitment) => {
            return {
                id: commitment.id,
                name: '<strong>' + commitment.get('number') + '</strong>' + ' | ' + PJQ.helpers.formatHelpers.formatCurrency(commitment.getGrandTotal()),
                subtext: commitment.contractedContact?.get('companyName') ?? ''
            };
        };
        this.commitmentPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.batch.requests, {
            pickerSelector: '.select-commitment',
            valueAttribute: 'commitmentId',
            idAttribute: 'id',
            selectPickerOptions: {
                isBlockSubtext: true,
                size: 5,
                choices: (model) => {
                    if (model.lineItem.get('costCodeId') > 0) {
                        let suggested = [],
                            others = [];
                        _.each(this.options.projectCommitments.models, (commitment) => {
                            if (null != commitment.lineItems.findWhere({
                                costCodeId: model.lineItem.get('costCodeId')
                            })) {
                                suggested.push(commitment);
                            } else {
                                others.push(commitment);
                            }
                        });
                        if (_.size(suggested) > 0) {
                            return [{
                                name: 'Suggested',
                                choices: _.map(suggested, fnCommitmentToChoice)
                            }, {
                                name: '',
                                choices: _.map(others, fnCommitmentToChoice)
                            }];
                        }
                    }
                    return _.map(this.options.projectCommitments.models, fnCommitmentToChoice);
                }
            },
            onChange: (model, value) => {
                let commitment = this.options.projectCommitments.get(value);
                model.commitment = commitment;
                model.commitmentId = commitment?.id;
                model.commitmentNumber = model.commitment?.get('number');
                model.contractedContact = commitment.contractedContact;
                model.contractedContactId = model.contractedContact?.id;
                model.assignees = commitment.contractedContact ? [commitment.contractedContact] : [];
                model.assigneeIds = commitment.contractedContact ? [commitment.contractedContact?.id] : [];
                this.renderDataTable();
            }
        });

        let fnVendorToChoice = (commitment) => {
            return {
                id: commitment.contractedContact.id,
                name: '<strong>' + commitment.contractedContact.get('companyName') + '</strong>',
                subtext: commitment.contractedContact.get('contactName') ?? ''
            };
        };
        this.companyPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.batch.requests, {
            pickerSelector: '.select-company',
            valueAttribute: 'contractedContactId',
            idAttribute: 'id',
            selectPickerOptions: {
                isBlockSubtext: true,
                size: 5,
                isIntChoices: true,
                choices: (model) => {
                    let foundIds = [],
                        suggested = [],
                        others = [],
                        costCodeId = model.lineItem.get('costCodeId') > 0;
                    _.each(this.options.projectCommitments.models, (commitment) => {
                        if (commitment.contractedContact == null || -1 !== foundIds.indexOf(commitment.contractedContact.id)) {
                            return;
                        }

                        if (costCodeId > 0 && null != commitment.lineItems.findWhere({
                            costCodeId: costCodeId
                        })) {
                            suggested.push(commitment);
                        } else {
                            others.push(commitment);
                        }
                    });
                    if (_.size(suggested) > 0) {
                        return [{
                            name: 'Suggested',
                            choices: _.map(suggested, fnVendorToChoice)
                        }, {
                            name: '',
                            choices: _.map(others, fnVendorToChoice)
                        }];
                    }
                    return _.map(others, fnVendorToChoice);
                }
            },
            onChange: (model, value) => {
                let commitment = null,
                    currentCommitment = this.options.projectCommitments.get(model.commitmentId),
                    matchCommitments;
                if (currentCommitment?.contractedContact?.id === value) {
                    commitment = currentCommitment
                    matchCommitments = this.options.projectCommitments.filter((commitment) => {
                        return commitment.contractedContact && commitment.contractedContact.id === value;
                    });
                } else {
                    matchCommitments = this.options.projectCommitments.filter((commitment) => {
                        return commitment.contractedContact && commitment.contractedContact.id === value;
                    });
                }

                let contractedContact = null;
                if (_.size(matchCommitments) > 0) {
                    contractedContact = matchCommitments[0].contractedContact ?? matchCommitments[0].invoiceContact;
                }
                model.commitment = commitment;
                model.commitmentId = commitment?.id;
                model.commitmentNumber = model.commitment?.get('number');
                model.contractedContact = contractedContact;
                model.assignees = contractedContact ? [contractedContact] : [];
                model.assigneeIds = contractedContact? [contractedContact.id] : [];
                model.contractedContactId = model.contractedContact?.id;

                this.renderDataTable();
            }
        });
    },
    getColumns: function () {
        return [
            {
                "data": "send",
                "columnData": "send",
                "title": 'Send',
                "orderable": false,
                "searchable": false,
                "render": (data, type, row) => {
                    if (type === 'sort') {
                        return data.id;
                    }

                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' data-p-bind="send" data-id="' + row.id + '" class="cb-send"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                },
                "width": '4%'
            },
            {
                "columnData": "scope",
                "data": "scope",
                "title": "Scope",
                "render": (data, type, row) => {
                    return '<input type="text" class="form-control" data-id="' + row.id + '" value="' + data.replace(/"/g, '&quot;') + '" data-p-bind="scope">';
                }
            },
            {
                "columnData": "contractedContact",
                "title": `Company ${PJQ.constants.markup.requiredAst}`,
                "width": "15%",
                "render": (data, type, row) => {
                    return "<div class='d-flex align-items-center'><select class='form-control select-company'></select></div>";
                }
            },
            {
                "columnData": "commitmentId",
                "title": `Commitment ${PJQ.constants.markup.requiredAst}`,
                "width": "20%",
                "render": (data, type, row) => {
                    return '<div class="d-flex"><select class="form-control select-commitment"></select></div>';
                }
            },
            {
                "columnData": "assignees",
                "title": "Assignees",
                "width": "20%",
                "visible": false,
                "render": (data, type, row) => {
                    return '<div class="d-flex"><select class="form-control select-assignees"></select></div>';
                }
            },
            {
                data: "id",
                title: "",
                orderable: false,
                searchable: false,
                resizable: false,
                width: '40px',
                className: 'text-align-center',
                render: (data, type, row) => {
                    return '<div class="show-on-row-hover" style="min-width:40px;"><button type="button" class="btn btn-danger btn-delete-line-item ml-1"><i class="fal fa-trash"></i></button></div>';
                }
            }
        ];
    },
    sendChanged: function(e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            request = _.findWhere(this.batch.requests, {
                id: id
            });

        if(request){
            request.send = $target.prop('checked');
        }
    },
    renderDataTable: function () {
        let data = _.sortBy(this.batch.requests, (model) => {
            return model.id;
        });
        let $dataTable = this.$('.line-items-table')
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: $dataTable,
            data: data,
            rowId: 'id',
            order: [],
            // autoWidth: false,
            // fixedHeader: {
            //     header: false,
            //     footer: false
            // },
            // hasFooter: true,
            // extraClasses: this.isInvoices ? 'table-invoice-line-items' : '',
            isHideSearch: true,
            paging: false,
            // order: [],
            // language: {
            //     emptyTable: this.options.canEdit ? 'Click "Add Line Item" to create a new Line item' : 'No line items have been added yet'
            // },
            columns: this.getColumns(),
            afterDataTableRender: () => {
                this.renderInputs();
            },
            onRowRemoved: () => {
                this.renderInputs();
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteLineItem(row);
                        }
                    }
                ]
            },
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    deleteLineItem: function (row) {
        if (row == null) {
            return;
        }

        let item = row.data();
        this.batch.requests = _.reject(this.batch.requests, (request) => {
            return request.id === item.id;
        });
        this.render();
    },
    validateBatchItem: function(batchItem){
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(batchItem.cid),
            data = row.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null) {
            return true;
        }
        if (row != null) {
            let companyCol = 2,
                commitmentCol = 3,
                companyNode = $(row.node()).find(`td:eq(${companyCol})`),
                commitmentNode = $(row.node()).find(`td:eq(${commitmentCol})`);

            updateCell(companyNode, data.contractedContact != null);
            updateCell(commitmentNode, data.commitmentId != null);
        }

        return result;
    },
    validate: function () {
        let isValid = true;

        _.each(this.batch.requests, function (request) {
            isValid = isValid && this.validateBatchItem(request);
        }, this);

        return isValid;
    },
    save: function () {
        if (!this.validate()) {
            return;
        }

        let loader = new PJQ.Loader(this.$('.modal-content'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'rfq'
                },
                {
                    endpoint: 'batch'
                }]),
            isAPIv2: true,
            data: {
                changeRequestId: this.batch.changeRequestId,
                attachments: this.batch.attachments.toJSON(),
                requests: _.map(this.batch.requests, (req) => {
                    return _.defaults({
                        id: null,
                        title: this.batch.title,
                        description: this.batch.description,
                        dueDate: this.batch.dueDate
                    }, req);
                })
            }
        }).post().done((batchRes) => {
            if (_.size(batchRes.requests) > 0) {
                PJQ.notifications.notify.successNotify({
                    message: _.size(batchRes.requests).toString() + ' RFQs were created'
                });
            } else {
                PJQ.notifications.notify.warningNotify({
                    message: 'No RFQs were created'
                });
            }
            if (typeof this.options.onSave === 'function') {
                this.options.onSave(batchRes);
            }
            this.removeModal();
        }).fail((err) => {
            loader.remove();
            PJQ.notifications.notify.warningNotify({
                message: 'Encountered an error while creating RFQs. Please contact customer service.'
            });
        });
    },
    close: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel creating RFQs?",
            body: "Are you sure you want to cancel creating RFQs? All unsaved changes will be lost.",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});
PJQ.views.rfq.RFQDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No RFQs have been created yet',
            zeroRecords: "No RFQs matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-rfq')
        },
        toggleRowClass: '.rfq-toggle-row',
        onViewChangeRequest: null
    },
    events: {
        'click .btn-view-rfq': 'viewRFQClicked',
        'click .btn-view-change-request': 'viewChangeRequestClicked'
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter = [];
        return defaultFilter;
    },
    afterSearch: function () {
        if(typeof this.options.afterSearch === 'function'){
            this.options.afterSearch();
        }
    },
    afterHeaderRender: function (){
        new PJQ.inputs.Selectpicker({
            el: this.$('.rfq-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.rfq.filterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.rfq.filterType.STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.rfq.filterType.STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewChangeRequests = PJQ.app.session.project.hasPermission('changeRequests.canView');

        let columns = [],
            includeColumns = ['status', 'changeRequest', 'title', 'number', 'description', 'assignees', 'amount'];

        columns.push({
            "columnData": "childData",
            "data": null,
            "title": "",
            "width": "20px",
            "orderable": false,
            "searchable": false,
            "defaultContent": '',
            "render": function (data, type, row) {
                let exObj = row.get('externalObject');
                if (exObj == null) {
                    return '';
                }

                return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
            }
        });

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.rfq.rfqStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'changeRequest':
                    columns.push({
                        "columnData": "changeRequest",
                        "title": "Change Request",
                        "data": "attributes.changeRequestId",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if(this.options.canViewChangeRequests){
                                return '<a class="btn-view-change-request" href="javascript:void(0)" data-id="' + row.get('changeRequestId') + '">' + row.get('changeRequestNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            return '<a class="btn-view-rfq" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('number') + '</a>';
                        }, this)
                    });
                    break;
                case 'title':
                    columns.push({
                        "columnData": "title",
                        "data": "attributes.title",
                        "title": "Title"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if(_.size(data) === 0){
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'assignees':
                    columns.push({
                        "columnData": "assignees",
                        "title": "Assigned To",
                        "titleSettings": "Assigned To",
                        "render": _.bind(function (data, type, row) {
                            if (_.size(row.assignees.models) === 0) {
                                return 'Nobody';
                            }

                            return _.map(row.assignees.models, function (assignee) {
                                let res = assignee.get('contactName');
                                return _.size(res) > 0 ? res : assignee.get('companyName');
                            }).join(', ');
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-rfq ml-1" title="View RFQ"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewRFQClicked: function (e){
        if(typeof(this.options.onViewRFQ) === 'function'){
            let row = this.getRow((e.currentTarget).closest('tr')),
                rfq = row.data();
            if(rfq != null){
                this.options.onViewRFQ(rfq);
            }
        }
    },
    viewChangeRequestClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewChangeRequest(row.data().get('changeRequestId'));
    },
    viewChangeRequest: function(changeRequestId) {
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            model: new PJQ.models.changeRequests.ChangeRequest({
                id: changeRequestId
            })
        });
    }
});
PJQ.views.rfq.RFQEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-rfq-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-change-request': 'viewChangeRequest',
        'click .btn-close': 'close',
        'click .btn-save': 'saveRFQ',
        'click .btn-delete': 'deleteRFQ',
        'click .btn-send-request': 'sendRequest',
        'click .btn-update-response': 'updateResponseClicked',
        'click .impact-response>button': 'impactResponseChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.options.changeRequest == null) {
            this.options.changeRequest = new PJQ.models.changeRequests.ChangeRequest({
                id: this.model.get('changeRequestId')
            });
        }

        if (this.model == null) {
            if (!this.options.changeRequest.isFetched) {
                await this.options.changeRequest.fetch();
            }

            this.model = new PJQ.models.rfq.RFQ({
                title: "",
                description: this.options.changeRequest.get('description'),
                changeRequestId: this.options.changeRequest.id,
                changeRequestNumber: this.options.changeRequest.get('number'),
                projectId: this.options.changeRequest.get('projectId'),
                statusId: PJQ.constants.rfq.rfqStatus.DRAFT,
                amount: 0
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        let pContactId = this.options.project.permissions?.get('contactId');
        this.options.isAssignee = pContactId > 0 && (this.model.contractedContact?.id === pContactId || this.model.assignees.get(this.options.project.get('contactId')));
        this.options.canAdd = this.options.project.hasPermission('changeRequests.canAdd');
        this.options.isAdmin = this.options.project.hasPermission('changeRequests.isAdmin');
        this.options.canViewChangeRequests = this.options.isAdmin;
        this.options.canEdit = this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.CLOSED;
        this.options.canRespond = (this.options.isAdmin || this.options.isAssignee) && (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.PRICING || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.REVISE);
        this.options.canDelete = this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED;
        this.options.canEditStatus = this.options.isAdmin && !this.model.isNew();
        this.options.canSendRequest = this.options.isAdmin && !this.model.isNew() && (this.options.canEdit || this.options.canRespond) && (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.DRAFT || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.PRICING || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.REVISE);

        if (!this.isFetched || this.model.isNew()) {
            return;
        }

        let status = this.model.get('statusId');
        if (status === PJQ.constants.rfq.rfqStatus.APPROVED
            || status === PJQ.constants.rfq.rfqStatus.VOID) {
            this.options.canEdit = false;
            this.options.canDelete = false;
        } else if (status == PJQ.constants.rfq.rfqStatus.PRICING
            || status == PJQ.constants.rfq.rfqStatus.REVISE) {
            this.options.canEdit = false;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            isAssignee: this.options.isAssignee,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canRespond: this.options.canRespond,
            canViewChangeRequests: this.options.canViewChangeRequests,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            canSendRequest: this.options.canSendRequest,
            views: this.views
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderGeneral();
        this.renderResponse();
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);

        let choices = _.map(PJQ.constants.rfq.rfqStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.rfq.rfqStatusNames[st],
                disabled: false
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: (value) => {
                let newStatus = value,
                    fnSave = () => {
                        this.model.set('statusId', newStatus);
                        if (!this.model.isNew()) {
                            this.model.save(null, {
                                success: _.bind(function () {
                                    this.model.dirtyAttributes = {};
                                    if (typeof this.options.onSave === 'function')
                                        this.options.onSave(this.model, false);
                                    this.render();
                                    PJQ.notifications.notify.successNotify({
                                        message: 'RFQ saved successfully'
                                    });

                                    if (newStatus === PJQ.constants.rfq.rfqStatus.PRICING || newStatus === PJQ.constants.rfq.rfqStatus.REVISE) {
                                        this.sendRequest();
                                    }
                                }, this)
                            })
                        }
                    };

                if (newStatus === PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('hasCostImpact')) {
                    let oldStatus = this.model.get('statusId');

                    new PJQ.views.modals.YesNo({
                        header: "Approve RFQ?",
                        body: "Approving this RFQ will apply the quote amount to it's related change request item revenue and cost. Would you like to continue?",
                        onYes: () => {
                            fnSave();
                        },
                        onNo: () => {
                            this.model.set('statusId', oldStatus);
                            this.render();
                        }
                    });
                    return;
                }

                fnSave();
            }
        });

        this.companyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contracted-contact'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.contractedContact,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.model.isNew() || this.model.contractedContact == null,
            onChange: (selectedContact) => {
                this.model.contractedContact = selectedContact;
                this.model.set('contractedContactId', selectedContact?.id);

                this.render();
            }
        });

        this.assigneePicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.assigned-to'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.assignees.models,
            isSingleChoice: false,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: (selectedContacts) => {
                this.model.assignees.reset(selectedContacts);
                this.model.set('assigneeIds', _.pluck(selectedContacts || [], 'id'));
            }
        });

        this.distributeToPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.distribute-to'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.distributeTo.models,
            isSingleChoice: false,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: (selectedContacts) => {
                this.model.distributeTo.reset(selectedContacts);
                this.model.set('distributeToIds', _.pluck(selectedContacts || [], 'id'));
            }
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('dueDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        if (_.size(this.model.dirtyAttributes) === 1 && this.model.dirtyAttributes.hasOwnProperty('dueDate')) {
            this.model.dirtyAttributes = {};
            this.model.isDirty = false;
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfq-file-uploader'),
            collection: this.model.attachments,
            canUpload: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.CLOSED,
            useApiV2: true,
            canDelete: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.CLOSED,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    renderResponse: function () {
        if (!this.model.get('hasCostImpact')) {
            return;
        }

        if (_.size(this.model.responseAttachments.models) > 0) {
            new PJQ.views.files.FileUploaderGrid({
                el: this.$('.rfq-response-file-uploader'),
                collection: this.model.responseAttachments,
                canUpload: false,
                useApiV2: true,
                canDelete: false
            });
        }
    },
    updateResponseClicked: function () {
        this.updateResponse();
    },
    updateResponse: function (hasCostImpact = null) {
        new PJQ.views.rfq.RFQResponseModal({
            model: this.model,
            hasCostImpact: hasCostImpact,
            onSubmit: (data) => {
                this.model.set(data.response);
                this.model.responseAttachments = data.attachments;
                this.submitResponse(() => {
                    this.render();
                });
            }
        });
    },
    impactResponseChanged: function (e) {
        let hasCostImpact = $(e.currentTarget).data('value');
        if (!hasCostImpact) {
            new PJQ.views.modals.YesNo({
                header: "Submit Response?",
                body: "Are you sure you want to submit the response of <strong>no impact</strong> for this RFQ?",
                onYes: () => {
                    this.model.set('hasCostImpact', hasCostImpact);
                    this.submitResponse(() => {
                        this.render();
                    });
                }
            });
            return;
        }

        this.updateResponse(hasCostImpact);
    },
    submitResponse: function (callback) {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.respond((result) => {
            loader.remove();
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'RFQ response submitted'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('rfqChanged', this.model);

                this.render();

                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    },
    sendRequest: function () {
        let message = "Would you like to send this RFQ to the assigned contact?";
        if (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.DRAFT) {
            message += ' This will also set the status to ' + PJQ.constants.rfq.rfqStatusNames[PJQ.constants.rfq.rfqStatus.PRICING] + '.';
        }

        new PJQ.views.modals.YesNo({
            header: "Send Request?",
            body: message,
            onYes: () => {
                this.model.sendQuoteRequest((success) => {
                    if (success) {
                        PJQ.notifications.notify.successNotify({
                            message: 'RFQ sent successfully'
                        });
                        this.model.set('requestLastSentOn', new Date());
                        this.render();
                    } else {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to send RFQ'
                        });
                    }
                });
            }
        });
    },
    viewChangeRequest: function () {
        this.removeModal();
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            model: this.options.changeRequest
        });
    },
    saveRFQ: function () {
        let isNew = this.model.isNew(),
            quoteAmount = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-quote-amount'));
        this.model.set('amount', quoteAmount != null ? quoteAmount : 0);
        this.save(() => {
            PJQ.notifications.notify.successNotify({
                message: 'RFQ saved successfully'
            });

            if (!isNew) {
                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (!this.assigneePicker.validate()) {
            isValid = false;
        }

        if (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.PRICING || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.REVISE) {
            let quoteAmount = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-quote-amount'));
            if (quoteAmount == null || quoteAmount.trim() === '') {
                isValid = false;
                PJQ.helpers.inputHelpers.setInputError(this.$('.input-quote-amount'), false);
            }
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('rfqChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    deleteRFQ: function () {
        let rfqId = this.model.id
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this RFQ?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'RFQ deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(rfqId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveRFQ();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});
PJQ.views.rfq.RFQList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'rfq-list'),
        rfqId: null
    },
    events: {
        'click .btn-add-rfq': 'addRFQ',
        'click .btn-delete-rfq': 'deleteRFQClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.rfq.RFQs(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if(!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function(){
        if (!this.isFetched) {
            return;
        }

        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('rfqChanged');
        PJQ.app.session.project.on('rfqChanged', function (rfq) {
            this.collection.add(rfq);
            this.render();
        }, this);

        if (this.options.rfqId > 0) {
            let initRFQ = this.collection.get(this.options.rfqId);
            if (initRFQ != null) {
                this.viewRFQ(initRFQ);
                this.options.rfqId = null;
            }
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.rfq.RFQDataTable({
            el: this.$('.rfq-data'),
            rowId: "cid",
            data: this.collection.models,
            isAdmin: this.options.isAdmin,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            order: [[1, 'asc']],
            onViewRFQ: (rfq) => {
                this.viewRFQ(rfq);
            },
            onRowDoubleClick: (row) => {
                this.viewRFQ(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewRFQ(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    viewRFQClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewRFQ(row.data());
    },
    viewRFQ: function (rfq) {
        isNew = rfq == null;
        new PJQ.views.rfq.RFQEditModal({
            model: rfq,
            changeRequest: this.options.changeRequest,
            onSave: _.bind(function (rfq) {
                if (isNew) {
                    this.collection.add(rfq);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (rfq) {
                this.collection.remove(rfq);
                this.renderView();
            }, this)
        });
    },
    addRFQ: function() {
        this.viewRFQ();
    },
    deleteRFQClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteRFQ(row);
    },
    deleteRFQ: function (row) {
        if (row != null) {
            let rfq = row.data();
            if (rfq != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete RFQ",
                    body: "Are you sure you want to delete this RFQ?",
                    onDelete: _.bind(function () {
                        rfq.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(rfq);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});

PJQ.views.rfq.SelectRFQModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-select-rfqs'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {
        "change .select-rfq": "selectRFQ",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
        this.selectedRFQs = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.rfq.RFQs();
        }

        this.render()

    },
    renderData: function() {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.rfqs-table'),
            data: this.rfqs,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-rfq"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.client.companyName",
                    "title": "Client",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(data);
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectRFQ: function (e) {
        let target = $(e.currentTarget),
            rfq = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-rfq').not(target).text('Select').prop('checked', false);
            if (rfq.get('isSelected')) {
                rfq.set('isSelected', false);
                this.selectedRFQ = null;
            } else {
                rfq.set('isSelected', true);
                this.selectedRFQ = rfq;
                this.collection.get(rfq.id);
                _.each(this.collection.models, _.bind(function (dtRFQ) {
                    if (rfq.id !== dtRFQ.id)
                        dtRFQ.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedRFQ == null);

            if(typeof this.options.onRFQSelected === 'function') {
                this.options.onRFQSelected(this.selectedRFQ);
            }
        } else {
            if (rfq.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                rfq.set('isSelected', false);
                this.selectedRFQs = _.reject(this.selectedRFQs, function (selRFQ) {
                    return selRFQ.id === rfq.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                rfq.set('isSelected', true);
                this.selectedRFQ.push(rfq);
            }
            this.$('.btn-save').attr('disabled', this.selectedRFQs == null);

            if(typeof this.options.onRFQSelected === 'function') {
                this.options.onRFQSelected(this.selectedRFQs);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedRFQ ? this.selectedRFQ : this.selectedRFQs);
            this.removeModal();
        }
    }
});
// Models
PJQ.models.rfq.RFQ = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'rfq',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.rfq.Attachments(model.attachments);
        this.responseAttachments = new PJQ.collections.rfq.Attachments(model.responseAttachments);

        if (model && model.contractedContact) {
            this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
        } else {
            this.contractedContact = null;
        }

        if (model && model.responseBy) {
            this.responseBy = new PJQ.models.contacts.Contact(model.responseBy);
        } else {
            this.responseBy = null;
        }

        this.assignees = new PJQ.collections.contacts.Contacts(model.assignees);

        this.distributeTo = new PJQ.collections.contacts.Contacts(model.distributeTo);

        return model;
    },
    beforeSave: function () {
        this.set({
            assignees: this.assignees.toJSON(),
            contractedContactId: this.contractedContact?.get('id'),
            contractedContact: this.contractedContact ? this.contractedContact.toJSON() : null,
            attachments: this.attachments.toJSON(),
            responseAttachments: this.responseAttachments.toJSON()
        });
    },
    sendQuoteRequest: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/send',
            isAPIv2: true,
        }).post().done((response) => {
            this.set(this.parse(response));
            if (typeof callback === 'function') {
                callback(true);
            }
        }).fail((response) => {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    respond: function (callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/respond',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                this.set(this.parse(response));
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (res && _.size(res.externalId) > 0) {
                this.set('externalObject', res);
            }
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if (typeof callback === 'function') {
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                // TODO: QBO Integration URL
                return 'https://app.sandbox.qbo.intuit.com/app/purchaseorder?txnId=' + externalId;
            default:
                return '';
        }
    }
});

PJQ.models.rfq.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

// Collections
PJQ.collections.rfq.RFQs = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let params = [];
        if (this.options.changeRequestId > 0) {
            params.push({
                parameter: 'changeRequestId',
                value: this.options.changeRequestId
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'rfq'
            }
        ], params);
    },
    model: PJQ.models.rfq.RFQ
});

PJQ.collections.rfq.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.rfq.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'rfq',
                value: this.options.rfqId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});
PJQ.views.rfq.RFQResponseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-rfq-response'),
        maxWidth: 600,
        isShowCloseButton: true,
        onSubmit: _.noop()
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-submit': 'submitResponse',
        'click .impact-response>button': 'impactResponseChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.options.isAdmin = this.options.project.hasPermission('changeRequests.isAdmin');

        this.hasChanged = false;
        this.response = {
            hasCostImpact: this.options.hasCostImpact ?? this.model.get('hasCostImpact'),
            amount: this.model.get('amount') ?? null,
            comment: this.model.get('comment') ?? null
        };
        this.attachments = this.model.responseAttachments.clone();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            model: this.model,
            response: this.response,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched || !this.response.hasCostImpact)
            return;

        new PJQ.Binder(this.$el, this.response, {
            watchElements: [
                'input'
            ],
            afterChange: () => {
                this.hasChanged = true;
            }
        });

        new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfq-response-file-uploader'),
            collection: this.attachments,
            useApiV2: true,
            canDelete: this.options.isAdmin,
            onSuccess: (file) => {
                this.hasChanged = true;
            },
            onDelete: (attachment, callback) => {
                this.hasChanged = true;

                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                callback();
            }
        });

        let self = this;
        this.$('.impact-response>button').each(function () {
            if ($(this).data('value') === self.response.hasCostImpact) {
                $(this).removeClass('inactive').addClass('font-weight-normal');
            } else {
                $(this).addClass('inactive').removeClass('font-weight-normal');
            }
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
    },
    impactResponseChanged: function (e) {
        this.response.hasCostImpact = $(e.currentTarget).data('value');
        this.render();
    },
    validate: function () {
        let err = null;
        if (this.response.hasCostImpact == null) {
            err = 'Please select a response';
        }

        this.$('.error-outer').html(err);

        return err == null;
    },
    submitResponse: function () {
        if (!this.validate()) {
            return;
        }

        if(!this.response.hasCostImpact){
            this.response.amount = null;
            this.response.comment = null;
        }

        this.options.onSubmit({
            response: this.response,
            attachments: this.attachments
        })
        this.removeModal();
    },
    close: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel Response?",
            body: "Are you sure you want to cancel your response?",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});
PJQ.models.budget.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    parseNumberFormat: function (numberFormat, project, additionalData) {
        let result = '';

        _.each(numberFormat, _.bind(function (token) {
            if (token.isText)
                result += token.label;
            else if (token.token === 'today')
                result += this.parseDateFormatToken(new Date(), token.dateFormatId);
            else if (token.token === 'project.projectId')
                result += project.get('projectId').toString();
            else if (token.token === 'project.startDate')
                result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(project.get('startDate'), false), token.dateFormatId);
            else if (token.token === 'counter')
                result += additionalData.counter.toString().padStart(4, '0');
            else if (token.token.startsWith('fieldValue')) {
                let fieldNumber = parseInt(token.token.substr(10));
                _.each(PJQ.app.session.project.customFields.models, _.bind(function (customField) {
                    if (customField.get('fieldNumber') === fieldNumber) {
                        _.each(PJQ.app.session.project.get('customFields'), _.bind(function (fieldValue) {
                            if (fieldValue.fieldNumber === fieldNumber) {
                                switch (customField.get('fieldType')) {
                                    case PJQ.constants.customFields.fieldTypes.TEXT:
                                    case PJQ.constants.customFields.fieldTypes.INT:
                                        result += fieldValue.value.toString();
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.CHOICE:
                                        _.each(customField.get('choices'), _.bind(function (choice) {
                                            if (choice.id === fieldValue.value)
                                                result += choice.choiceName;
                                        }, this));
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATE:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, false), token.dateFormatId);
                                        break;
                                    case PJQ.constants.customFields.fieldTypes.DATETIME:
                                        result += this.parseDateFormatToken(PJQ.helpers.dateHelpers.parseDateString(fieldValue.value, true), token.dateFormatId);
                                        break;
                                }
                            }
                        }, this));
                    }
                }, this));
            }
        }, this));

        return result.replaceAll(' ', '');
    },
    parseDateFormatToken: function (input, dateFormatId) {
        let result = null;

        switch (dateFormatId) {
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.DD:
                result = input.getDate().toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MM:
                result = (input.getMonth() + 1).toString().padStart(2, '0');
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YY:
                result = input.getFullYear().toString().substr(2);
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.YYYY:
                result = input.getFullYear().toString();
                break;
            case PJQ.constants.commitments.commitmentNumberTokenDateFormat.MMDDYYYY:
                //PJQ.helpers.dateHelpers.getDateString(startDate, PJQ.helpers.dateHelpers.dateFormats.DATE_YMD, false) + ' 00:00:00');
                result = PJQ.helpers.dateHelpers.getDateString(input, PJQ.helpers.dateHelpers.dateFormats.URL_DATE, false).replaceAll('-', '');
                break;
        }

        return result;
    }
});
PJQ.views.budget.SubJobSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'sub-job-settings'),
        enableSubJobsChanged: null
    },
    events: {
        'click .btn-add-sub-job': 'addClicked',
        'click .btn-edit-sub-job': 'editClicked',
        'click .btn-delete-sub-job': 'deleteClicked',
        'click .btn-edit-cost-codes': 'editCostCodesClicked',
        'click .btn-push-erp': 'pushERP',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: function () {
        this.isFetched = false;

        let fnRender = _.bind(function () {
            this.isFetched = true;
            this.render();
        }, this);
        if (this.options.project != null) {
            this.options.project.fetchBudget(_.bind(function (budget) {
                this.budget = budget;
                PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
                    this.erpIntegration = erp;
                    this.options.project.fetchSubJobs(_.bind(function (subJobs) {
                        this.subJobs = subJobs;
                        this.options.project.fetchCostCodes(_.bind(function (costCodes) {
                            this.costCodes = costCodes;
                            if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
                                this.options.project.fetchERPObject(_.bind(function () {
                                    fnRender();
                                }, this));
                            } else {
                                fnRender();
                            }
                        }, this));
                    }, this));
                }, this));
            }, this));
        }
    },
    renderData: function () {
        return {
            erpIntegration: this.erpIntegration,
            project: this.options.project,
            subJobs: this.subJobs,
            costCodes: this.costCodes,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }
        this.renderERP();
        this.renderSubJobTable();
    },
    renderERP: function () {
        if (this.erpIntegration == null || (this.options.project != null && !this.options.project.isERPSynced())) {
            return;
        }

        let pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_SUB_JOBS),
            pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_SUB_JOBS),
            hasUnsynced = null != _.find(this.subJobs.models, function (subJob) {
                let st = subJob.erpSyncStatus();
                return st !== PJQ.constants.integrations.erp.syncStatuses.APPROVED && st !== PJQ.constants.integrations.erp.syncStatuses.SYNCED;
            }), btn = '';
        this.erpButtons = PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            canPush: hasUnsynced,
            disablePushReason: !hasUnsynced ? 'All sub jobs have been pushed to ERP' : '',
            pullSupported: pullSupported,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pushERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_SUB_JOBS)) {
            this.erpButtons.pushing(true);
            this.erpIntegration.pushSubJobs(this.options.project, _.bind(function (subJobs) {
                this.erpButtons.pushing(false);
                PJQ.notifications.notify.successNotify({
                    message: _.size(subJobs).toString() + ' Sub Jobs pushed to ERP'
                });
                this.render();
            }, this));
        }
    },
    pullERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_SUB_JOBS)) {
            this.erpButtons.pulling(true);
            this.erpIntegration.pullSubJobs(this.options.project, (subJobs, err) => {
                this.erpButtons.pulling(false);
                if (subJobs == null) {
                    return;
                }

                let newSubJobsCount = _.size(subJobs) - _.size(this.subJobs.models);
                this.subJobs.reset(subJobs);
                PJQ.notifications.notify.successNotify({
                    message: newSubJobsCount.toString() + ' Sub Jobs pulled from ERP'
                });
                this.render();
            });
        }
    },
    renderSubJobTable: function () {
        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".sub-jobs-table"),
            data: this.subJobs.models,
            rowId: "cid",
            language: {
                zeroRecords: 'Click "Add Sub Job" to create a new Sub Job'
            },
            order: [1, 'asc'],
            onRowDoubleClick: _.bind(function (row) {
                this.editSubJob(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editSubJob(row.data());
                        }
                    },
                    {
                        name: 'Edit Cost Codes',
                        onClick: (row) => {
                            this.editCostCodes(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return null == this.budget.lineItems.findWhere({subJobId: row.data().id});
                        },
                        onClick: (row) => {
                            this.deleteSubJob(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "width": "15px",
                    "columnData": "division",
                    "data": null,
                    "title": "",
                    "className": "dt-center",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (row.isERPSynced()) {
                            return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                        }
                        return '';
                    }
                },
                {
                    "data": "attributes.name",
                    "title": "Name",
                    "render": (data, type, model) => {
                        return '<a class="btn-edit-sub-job" href="javascript:void(0)">' + data + '</a>';
                    }
                },
                {
                    "data": "attributes.code",
                    "title": "Code"
                },
                {
                    "data": "attributes.description",
                    "title": "Description"
                },
                {
                    "data": "id",
                    "title": "Cost Codes",
                    "render": (data, type, model) => {
                        let costCodeCount = _.size(this.costCodes.where({subJobId: model.id}));
                        return '<a class="btn-edit-cost-codes" href="javascript:void(0)">' + costCodeCount.toString() + ' Cost Codes</a>';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "className": "p-2",
                    "width": "100px",
                    "render": (data, type, model) => {
                        let canDelete = null == this.budget.lineItems.findWhere({subJobId: model.id}),
                            res = '<div class="text-align-right show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-edit-sub-job ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-sub-job ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This sub job has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ]
        });
    },
    addClicked: function () {
        this.editSubJob(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let subJob = this.subJobs.get(id);
            if (subJob != null) {
                this.editSubJob(subJob);
            }
        }
    },
    editSubJob: function (subJob) {
        new PJQ.views.budget.EditSubJobModal({
            model: subJob,
            project: this.options.project,
            subJobs: this.subJobs,
            onSave: _.bind(function (subJob) {
                this.subJobs.add(subJob);
                this.renderSubJobTable();
            }, this),
            onDelete: _.bind(function (subJob) {
                this.deleteSubJob(subJob);
            }, this)
        });
    },
    editCostCodesClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            subJob = row.data();
        this.editCostCodes(subJob);
    },
    editCostCodes: function (subJob) {
        new PJQ.views.budget.CostCodeSettingsModal({
            project: this.options.project,
            subJob: subJob
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteSubJob(row.data());
    },
    deleteSubJob: function (subJob) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Sub Job?",
            onDelete: _.bind(function () {
                subJob.destroy({
                    notify: false,
                    success: _.bind(function () {
                        this.subJobs.remove(subJob);
                        this.renderSubJobTable();
                    }, this),
                    error: function (model, xhr) {
                        if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_sub_job_with_line_item') {
                            PJQ.notifications.notify.warningNotify({
                                message: 'This sub job cannot be deleted because it has budget line items associated with it.'
                            });
                        }
                    }
                });
            }, this)
        });
    }
});

PJQ.views.budget.EditSubJobModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-sub-job'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.budget.SubJob({
                projectId: this.options.project ? this.options.project.id : null
            });
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input',
                'select'
            ]
        });
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let $name = this.$('.input-name'),
            name = $name.val(),
            isNameValid = true,
            errorText = '';
        if (_.size(name) === 0) {
            isNameValid = false;
        } else if (null != _.find(this.options.subJobs.models, function (sj) {
            return sj.id !== this.model.id && sj.get('name').toLowerCase() === name.toLowerCase();
        }, this)) {
            isNameValid = false;
            errorText = 'This sub job name already exists'
        }
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid, {
            errorText: errorText
        });
        return isNameValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    if (this.options.project != null) {
                        if (this.options.project.subJobs != null) {
                            this.options.project.subJobs.add(this.model);
                        }
                    }
                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Sub Job saved'
                    });
                }, this)
            });
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Sub Job?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});
PJQ.views.budget.TaxCodeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'tax-code-settings')
    },
    events: {
        'click .btn-pull-erp': 'pullERP',
        'click .btn-add-tax-code': 'addClicked',
        'click .btn-edit-tax-code': 'editClicked',
        'click .btn-delete-tax-code': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.isFetched = false;
        PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
            this.erpIntegration = erp;
            PJQ.app.session.fetchTaxCodes(_.bind(function (taxCodes) {
                this.taxCodes = taxCodes;

                this.isFetched = true;
                this.render();
            }, this));
        }, this));
        return false;
    },
    renderData: function () {
        return {
            project: this.options.project,
            taxCodes: this.taxCodes,
            isFetched: this.isFetched,
            erpIntegration: this.erpIntegration
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }
        this.renderTaxCodeTable();
        this.renderERP();
    },
    renderTaxCodeTable: function () {
        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".tax-codes-table"),
            data: this.taxCodes.models,
            order: [1, 'asc'],
            onRowDoubleClick: _.bind(function (row) {
                this.editTaxCode(row.data());
            }, this),
            rowId: 'cid',
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editTaxCode(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return false;
                        },
                        onClick: (row) => {
                            this.deleteTaxCode(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "title": "",
                    "data": "attributes.externalObject",
                    "width": "5%",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (data) {
                            return '<i class="fas fa-link-simple fs-14 text-success" title="Synced to ERP"></i>';
                        }
                        return '';
                    }
                },
                {
                    "data": "attributes.code",
                    "title": "Code",
                    "width": "15%"
                },
                {
                    "data": "attributes.description",
                    "title": "Description"
                },
                {
                    "data": "attributes.rate",
                    "title": "Rate",
                    "render": (data, type, model) => {
                        return PJQ.helpers.formatHelpers.formatPercent(data/100);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "className": "p-2",
                    "width": "100px",
                    "render": (data, type, model) => {
                        let canDelete = false,
                            res = '<div class="text-align-right show-on-row-hover" style="min-width:80px;"><button type="button" class="btn btn-info btn-edit-tax-code ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-tax-code ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            // res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This cost code has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ],
            language: {
                zeroRecords: 'Click "Add Tax Code" to create a new Tax Code'
            }
        });
    },
    addClicked: function () {
        this.editTaxCode(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let taxCode = this.taxCodes.get(id);
            if (taxCode != null) {
                this.editTaxCode(taxCode);
            }
        }
    },
    editTaxCode: function (taxCode) {
        new PJQ.views.budget.EditTaxCodeModal({
            model: taxCode,
            project: this.options.project,
            onSave: _.bind(function (taxCode) {
                this.taxCodes.add(taxCode);
                this.render();
            }, this),
            onDelete: _.bind(function (taxCode) {
                if (taxCode.id > 0) {
                    this.deleteTaxCode(taxCode, false);
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('tr').attr('id'),
            taxCode = this.taxCodes.get(cid);
        this.deleteTaxCode(taxCode);
    },
    deleteTaxCode: function (taxCode, showDialogue = true) {
        if(showDialogue) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this Tax Code?",
                onDelete: _.bind(function () {
                    taxCode.destroy({
                        notify: false,
                        success: _.bind(function () {
                            this.taxCodes.remove(taxCode);
                            this.render();
                        }, this)
                    });
                }, this)
            });
        }
        else{
            taxCode.destroy({
                notify: false,
                success: _.bind(function () {
                    this.taxCodes.remove(taxCode);
                    this.render();
                }, this)
            });
        }
    },
    renderERP: function () {
        if (this.erpIntegration == null) {
            return;
        }

        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: false,
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_TAX_CODES),
            status: PJQ.constants.integrations.erp.syncStatuses.SYNCED
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pullERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_COMPANY_TAX_CODES)) {
            this.erpIntegration.pullTaxCodes(this.options.project, (newTaxCodes, err) => {
                if(newTaxCodes == null){
                    return;
                }

                this.taxCodes.reset(newTaxCodes);
                PJQ.notifications.notify.successNotify({
                    message: _.size(newTaxCodes).toString() + ' Tax Codes pulled from ERP'
                });
                this.render();
            });
        }
    }
});

PJQ.views.budget.EditTaxCodeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-tax-code'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.budget.TaxCode({
                projectId: this.options.project ? this.options.project.id : null,
                rate: 0
            });
        }

        this.isFetched = true;
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input',
                'select'
            ]
        });

        this.$(".input-name").inputmask({
            "mask": "a".repeat(50),
            placeholder: "",
            definitions: {
                'a': {
                    validator: ".",
                    cardinality: 1
                }
            }
        });

        this.$(".input-code").inputmask({
            "mask": "a".repeat(20),
            placeholder: "",
            definitions: {
                'a': {
                    validator: "[0-9a-zA-Z]",
                    cardinality: 1
                }
            }
        });

        PJQ.helpers.inputHelpers.inputMaskPercent(this.$('.input-percent'), 2, true);
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let isValid = true;

        let $code = this.$('.input-code');
        PJQ.helpers.inputHelpers.setInputError($code, true);
        if (this.model.get('code') == null || this.model.get('code').length === 0) {
            PJQ.helpers.inputHelpers.setInputError($code, false);
            isValid = false;
        }

        return isValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Tax Code saved'
                    });
                }, this)
            });
        }
    },
    delete: function () {
        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(this.model);
        }
        this.removeModal();
    }
});